"use strict";
var _typeof =
  "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
    ? function (e) {
        return typeof e;
      }
    : function (e) {
        return e &&
          "function" == typeof Symbol &&
          e.constructor === Symbol &&
          e !== Symbol.prototype
          ? "symbol"
          : typeof e;
      }; /**
 Cylindo 360 HD Viewer v4.6.2
https://www.cylindo.com/

Notes on usage
1) Cylindo 360 HD Viewer will not work without viewer.css stylesheet.

Any additional questions about usage please contact support@cylindo.com

Copyright Cylindo ApS
*/
(function () {
  function e() {
    (function () {
      function e(e) {
        "undefined" == typeof window.console && (window.console = {}),
          "undefined" == typeof window.console.log &&
            (e
              ? (window.console.log = function (e) {
                  alert(e);
                })
              : (window.console.log = function () {})),
          "undefined" == typeof window.console.error &&
            (e
              ? (window.console.error = function (e) {
                  alert(e);
                })
              : (window.console.error = function () {})),
          "undefined" == typeof window.console.warn &&
            (e
              ? (window.console.warn = function (e) {
                  alert(e);
                })
              : (window.console.warn = function () {})),
          "undefined" == typeof window.console.dir &&
            (e
              ? (window.console.dir = function (e) {
                  alert("DIR: " + e);
                })
              : (window.console.dir = function () {}));
      }
      e(!1),
        Array.prototype.includes ||
          Object.defineProperty(Array.prototype, "includes", {
            value: function (e, t) {
              function n(e, t) {
                return (
                  e === t ||
                  ("number" == typeof e &&
                    "number" == typeof t &&
                    isNaN(e) &&
                    isNaN(t))
                );
              }
              if (null === this)
                throw new TypeError('"this" is null or not defined');
              var i = Object(this),
                o = i.length >>> 0;
              if (0 === o) return !1;
              for (
                var r = 0 | t, s = Math.max(r >= 0 ? r : o - Math.abs(r), 0);
                s < o;

              ) {
                if (n(i[s], e)) return !0;
                s++;
              }
              return !1;
            },
          }),
        String.prototype.includes ||
          (String.prototype.includes = function (e, t) {
            return (
              "number" != typeof t && (t = 0),
              !(t + e.length > this.length) && this.indexOf(e, t) !== -1
            );
          }),
        (function () {
          var e = Array.prototype.slice;
          try {
            e.call(document.documentElement);
          } catch (t) {
            Array.prototype.slice = function (t, n) {
              if (
                ((n = "undefined" != typeof n ? n : this.length),
                "[object Array]" === Object.prototype.toString.call(this))
              )
                return e.call(this, t, n);
              var i,
                o,
                r = [],
                s = this.length,
                a = t || 0;
              a = a >= 0 ? a : Math.max(0, s + a);
              var l = "number" == typeof n ? Math.min(n, s) : s;
              if ((n < 0 && (l = s + n), (o = l - a), o > 0))
                if (((r = new Array(o)), this.charAt))
                  for (i = 0; i < o; i++) r[i] = this.charAt(a + i);
                else for (i = 0; i < o; i++) r[i] = this[a + i];
              return r;
            };
          }
        })(),
        "document" in self &&
          (("classList" in document.createElement("_") &&
            (!document.createElementNS ||
              "classList" in
                document.createElementNS("http://www.w3.org/2000/svg", "g"))) ||
            !(function (e) {
              if ("Element" in e) {
                var t = "classList",
                  n = "prototype",
                  i = e.Element[n],
                  o = Object,
                  r =
                    String[n].trim ||
                    function () {
                      return this.replace(/^\s+|\s+$/g, "");
                    },
                  s =
                    Array[n].indexOf ||
                    function (e) {
                      for (var t = 0, n = this.length; n > t; t++)
                        if (t in this && this[t] === e) return t;
                      return -1;
                    },
                  a = function (e, t) {
                    (this.name = e),
                      (this.code = DOMException[e]),
                      (this.message = t);
                  },
                  l = function (e, t) {
                    if ("" === t)
                      throw new a(
                        "SYNTAX_ERR",
                        "An invalid or illegal string was specified"
                      );
                    if (/\s/.test(t))
                      throw new a(
                        "INVALID_CHARACTER_ERR",
                        "String contains an invalid character"
                      );
                    return s.call(e, t);
                  },
                  d = function (e) {
                    for (
                      var t = r.call(e.getAttribute("class") || ""),
                        n = t ? t.split(/\s+/) : [],
                        i = 0,
                        o = n.length;
                      o > i;
                      i++
                    )
                      this.push(n[i]);
                    this._updateClassName = function () {
                      e.setAttribute("class", "" + this);
                    };
                  },
                  c = (d[n] = []),
                  u = function () {
                    return new d(this);
                  };
                if (
                  ((a[n] = Error[n]),
                  (c.item = function (e) {
                    return this[e] || null;
                  }),
                  (c.contains = function (e) {
                    return (e += ""), -1 !== l(this, e);
                  }),
                  (c.add = function () {
                    var e,
                      t = arguments,
                      n = 0,
                      i = t.length,
                      o = !1;
                    do
                      (e = t[n] + ""),
                        -1 === l(this, e) && (this.push(e), (o = !0));
                    while (++n < i);
                    o && this._updateClassName();
                  }),
                  (c.remove = function () {
                    var e,
                      t,
                      n = arguments,
                      i = 0,
                      o = n.length,
                      r = !1;
                    do
                      for (e = n[i] + "", t = l(this, e); -1 !== t; )
                        this.splice(t, 1), (r = !0), (t = l(this, e));
                    while (++i < o);
                    r && this._updateClassName();
                  }),
                  (c.toggle = function (e, t) {
                    e += "";
                    var n = this.contains(e),
                      i = n ? t !== !0 && "remove" : t !== !1 && "add";
                    return i && this[i](e), t === !0 || t === !1 ? t : !n;
                  }),
                  (c.toString = function () {
                    return this.join(" ");
                  }),
                  o.defineProperty)
                ) {
                  var h = { get: u, enumerable: !0, configurable: !0 };
                  try {
                    o.defineProperty(i, t, h);
                  } catch (m) {
                    (void 0 === m.number || -2146823252 === m.number) &&
                      ((h.enumerable = !1), o.defineProperty(i, t, h));
                  }
                } else o[n].__defineGetter__ && i.__defineGetter__(t, u);
              }
            })(self),
          (function () {
            var e = document.createElement("_");
            if ((e.classList.add("c1", "c2"), !e.classList.contains("c2"))) {
              var t = function i(e) {
                var i = DOMTokenList.prototype[e];
                DOMTokenList.prototype[e] = function (e) {
                  var t,
                    n = arguments.length;
                  for (t = 0; n > t; t++) (e = arguments[t]), i.call(this, e);
                };
              };
              t("add"), t("remove");
            }
            if ((e.classList.toggle("c3", !1), e.classList.contains("c3"))) {
              var n = DOMTokenList.prototype.toggle;
              DOMTokenList.prototype.toggle = function (e, t) {
                return 1 in arguments && !this.contains(e) == !t
                  ? t
                  : n.call(this, e);
              };
            }
            e = null;
          })()),
        (function () {
          for (
            var e = 0, t = ["ms", "moz", "webkit", "o"], n = 0;
            n < t.length && !window.requestAnimationFrame;
            ++n
          )
            (window.requestAnimationFrame =
              window[t[n] + "RequestAnimationFrame"]),
              (window.cancelAnimationFrame =
                window[t[n] + "CancelAnimationFrame"] ||
                window[t[n] + "CancelRequestAnimationFrame"]);
          window.requestAnimationFrame ||
            (window.requestAnimationFrame = function (t, n) {
              var i = new Date().getTime(),
                o = Math.max(0, 16 - (i - e)),
                r = window.setTimeout(function () {
                  t(i + o);
                }, o);
              return (e = i + o), r;
            }),
            window.cancelAnimationFrame ||
              (window.cancelAnimationFrame = function (e) {
                clearTimeout(e);
              });
        })(),
        "nextElementSibling" in document.documentElement ||
          Object.defineProperty(Element.prototype, "nextElementSibling", {
            get: function () {
              for (var e = this.nextSibling; e && 1 !== e.nodeType; )
                e = e.nextSibling;
              return e;
            },
          }),
        "previousElementSibling" in document.documentElement ||
          Object.defineProperty(Element.prototype, "previousElementSibling", {
            get: function () {
              for (var e = this.previousSibling; e && 1 !== e.nodeType; )
                e = e.previousSibling;
              return e;
            },
          }),
        "firstElementChild" in document.documentElement ||
          Object.defineProperty(Element.prototype, "firstElementChild", {
            get: function () {
              for (var e, t = this.children, n = 0, i = t.length; n < i; ++n)
                if (((e = t[n]), 1 === e.nodeType)) return e;
              return null;
            },
          }),
        "lastElementChild" in document.documentElement ||
          Object.defineProperty(Element.prototype, "lastElementChild", {
            get: function () {
              for (var e, t = this.children, n = t.length - 1; n >= 0; --n)
                if (((e = t[n]), 1 === e.nodeType)) return e;
              return null;
            },
          }),
        (function (e) {
          function t(e) {
            setTimeout(e, 0);
          }
          function n(e, t) {
            return function () {
              for (var n; (n = e.shift()); ) n(t);
            };
          }
          function i(e, t, n, r) {
            var s;
            if (t === e)
              throw new TypeError(
                "A promise's fulfillment handler cannot return the same promise"
              );
            if (t instanceof o) t.then(n, r);
            else if (
              !t ||
              ("object" !==
                ("undefined" == typeof t ? "undefined" : _typeof(t)) &&
                "function" != typeof t)
            )
              n(t);
            else {
              try {
                s = t.then;
              } catch (a) {
                return void r(a);
              }
              if ("function" == typeof s) {
                var l, d, c;
                (d = function (t) {
                  l || ((l = !0), i(e, t, n, r));
                }),
                  (c = function (e) {
                    l || ((l = !0), r(e));
                  });
                try {
                  s.call(t, d, c);
                } catch (a) {
                  if (!l) return r(a), void (l = !0);
                }
              } else n(t);
            }
          }
          var o,
            r = {},
            s = {},
            a = {};
          "function" == typeof e.Promise
            ? (o = e.Promise)
            : ((o = (function (e) {
                function t(t) {
                  return e.apply(this, arguments);
                }
                return (
                  (t.toString = function () {
                    return e.toString();
                  }),
                  t
                );
              })(function (e) {
                var l,
                  d,
                  c,
                  u,
                  h,
                  m,
                  p = [],
                  f = [],
                  g = r;
                return (
                  (c = function (e) {
                    return function (i) {
                      g === r &&
                        ((l = i), (g = e), (d = n(g === s ? p : f, l)), t(d));
                    };
                  }),
                  (u = c(s)),
                  (h = c(a)),
                  e(u, h),
                  (m = {
                    then: function (e, n) {
                      var s = new o(function (o, a) {
                        var l = function (e, t, n) {
                          "function" == typeof e
                            ? t.push(function (t) {
                                var n;
                                try {
                                  (n = e(t)), i(s, n, o, a);
                                } catch (r) {
                                  a(r);
                                }
                              })
                            : t.push(n);
                        };
                        l(e, p, o), l(n, f, a), g !== r && t(d);
                      });
                      return s;
                    },
                  }),
                  (m["catch"] = function (e) {
                    return this.then(null, e);
                  }),
                  m
                );
              })),
              (o.all = function (e) {
                return new o(function (t, n) {
                  var i,
                    o,
                    r,
                    s = [];
                  if (!e.length) return void t(s);
                  for (
                    r = function (o) {
                      e[o].then(function (e) {
                        (s[o] = e), --i || t(s);
                      }, n);
                    },
                      i = o = e.length;
                    o--;

                  )
                    r(o);
                });
              }),
              (o.race = function (e) {
                return new o(function (t, n) {
                  e.forEach(function (e) {
                    e.then(t, n);
                  });
                });
              }),
              (o.resolve = function (e) {
                return new o(function (t) {
                  t(e);
                });
              }),
              (o.reject = function (e) {
                return new o(function (t, n) {
                  n(e);
                });
              })),
            (e.Promise = o);
        })("undefined" != typeof window ? window : this),
        (function (e, t) {
          function n() {
            if (!r) {
              r = !0;
              for (var e = 0; e < o.length; e++) o[e].fn.call(window, o[e].ctx);
              o = [];
            }
          }
          function i() {
            "complete" === document.readyState && n();
          }
          (e = e || "docReady"), (t = t || window);
          var o = [],
            r = !1,
            s = !1;
          t[e] = function (e, t) {
            if ("function" != typeof e)
              throw new TypeError(
                "Callback for docReady(fn) must be a function"
              );
            return r
              ? void setTimeout(function () {
                  e(t);
                }, 1)
              : (o.push({ fn: e, ctx: t }),
                void ("complete" === document.readyState
                  ? setTimeout(n, 1)
                  : s ||
                    (document.addEventListener
                      ? (document.addEventListener("DOMContentLoaded", n, !1),
                        window.addEventListener("load", n, !1))
                      : (document.attachEvent("onreadystatechange", i),
                        window.attachEvent("onload", n)),
                    (s = !0))));
          };
        })("docReady", window);
    }.call(this),
      function () {
        function e() {
          var n,
            o,
            r,
            s,
            a,
            l,
            d = arguments[0] || {},
            c = 1,
            u = arguments.length,
            h = !1;
          for (
            "boolean" == typeof d && ((h = d), (d = arguments[c] || {}), c++),
              "object" ===
                ("undefined" == typeof d ? "undefined" : _typeof(d)) ||
                i(d) ||
                (d = {});
            c < u;
            c++
          )
            if (((n = arguments[c]), "undefined" != typeof n && null !== n))
              for (o in n)
                (r = d[o]),
                  (s = n[o]),
                  d !== s &&
                    (h && s && (t(s) || (a = Array.isArray(s)))
                      ? (a
                          ? ((a = !1), (l = r && Array.isArray(r) ? r : []))
                          : (l = r && t(r) ? r : {}),
                        (d[o] = e(h, l, s)))
                      : "undefined" != typeof s && (d[o] = s));
          return d;
        }
        function t(e) {
          var t,
            n,
            i = {},
            o = i.toString,
            r = i.hasOwnProperty,
            s = r.toString;
          return (
            !(!e || "[object Object]" !== o.call(e)) &&
            (!(t = Object.getPrototypeOf(e)) ||
              ((n = r.call(t, "constructor") && t.constructor),
              "function" == typeof n && s.call(n) === s.call(Object)))
          );
        }
        function n(e) {
          var t;
          for (t in e) return !1;
          return !0;
        }
        function i(e) {
          return "function" == typeof e && "number" != typeof e.nodeType;
        }
        function o(t) {
          var n,
            i = {};
          if (t) {
            i = e(i, t.getBoundingClientRect());
            for (n in i) "number" == typeof i[n] && (i[n] = Math.round(i[n]));
          }
          return i;
        }
        var r = "cylindo.core.util",
          s = window.cylindo.getModule(r) || {};
        (s.object = {
          extend: e,
          isPlainObject: t,
          isEmptyObject: n,
          isFunction: i,
          getRectFixed: o,
        }),
          window.cylindo.addModule(r, s);
      }.call(this),
      function () {
        var e = "cylindo.core.util",
          t = window.cylindo.getModule(e) || {},
          n = function () {
            function e() {
              function e(e) {
                return (
                  (d || c) &&
                    ((e.isSafariOnIOS = !1),
                    (e.ios = !0),
                    R.test(i) && (e.iosVersion = i.match(R)[1])),
                  e
                );
              }
              return r
                ? {
                    name: "Internet Explorer",
                    msie: o,
                    version: i.match(/(msie |rv:)(\d+(\.\d+)?)/i)[2],
                  }
                : s
                ? {
                    name: "Microsoft Edge",
                    msedge: o,
                    version: i.match(/(edge)\/((\d+)?[\w\.]+)/i)[2],
                  }
                : f
                ? {
                    name: "Opera",
                    opera: o,
                    version: (i.match(y) ||
                      i.match(y) ||
                      i.match(T) ||
                      i.match(/opr\/(\d+(\.\d+)?)/i))[1],
                  }
                : a
                ? ((t = {
                    name: "Chrome",
                    webkit: o,
                    chrome: o,
                    version: i.match(T)[1],
                  }),
                  (t = e(t)))
                : l
                ? {
                    name: "PhantomJS",
                    webkit: o,
                    phantom: o,
                    version: i.match(/phantomjs\/(\d+(\.\d+)+)/i)[1],
                  }
                : u
                ? {
                    name: "TouchPad",
                    webkit: o,
                    touchpad: o,
                    version: i.match(/touchpad\/(\d+(\.\d+)?)/i)[1],
                  }
                : h
                ? {
                    name: "Amazon Silk",
                    webkit: o,
                    android: o,
                    mobile: o,
                    version: i.match(/silk\/(\d+(\.\d+)?)/i)[1],
                  }
                : d || c
                ? ((t = {
                    name: d ? "iPhone" : "iPad",
                    webkit: o,
                    mobile: o,
                    ios: o,
                    iphone: d,
                    ipad: c,
                  }),
                  y.test(i)
                    ? ((t.version = i.match(y)[1]),
                      (t.iosVersion = i.match(y)[1]))
                    : R.test(i) &&
                      ((t.version = i.match(R)[1]),
                      (t.iosVersion = i.match(R)[1])),
                  (t.isSafariOnIOS = !!/safari/i.test(i)),
                  t)
                : p
                ? {
                    name: "Android",
                    webkit: o,
                    android: o,
                    mobile: o,
                    version: (i.match(y) || i.match(A) || i.match(T))[1],
                  }
                : m
                ? {
                    name: "Safari",
                    webkit: o,
                    safari: o,
                    version: i.match(y)[1],
                  }
                : v
                ? ((t = {
                    name: "Gecko",
                    gecko: o,
                    mozilla: o,
                    version: i.match(A)[1],
                  }),
                  g && ((t.name = "Firefox"), (t.firefox = o)),
                  t)
                : b
                ? { name: "OculusBrowser", oculus: o, version: i.match(I)[1] }
                : E
                ? {
                    name: "SeaMonkey",
                    seamonkey: o,
                    version: i.match(/seamonkey\/(\d+(\.\d+)?)/i)[1],
                  }
                : {};
            }
            var t,
              n = this,
              i = navigator.userAgent,
              o = !0,
              r = /(msie|trident)/i.test(i),
              s = /(edge)\/((\d+)?[\w\.]+)/i.test(i),
              a = /chrome|crios/i.test(i),
              l = /phantom/i.test(i),
              d = /iphone/i.test(i),
              c = /ipad/i.test(i),
              u = /touchpad/i.test(i),
              h = /silk/i.test(i),
              m = /safari/i.test(i) && !a && !l && !h,
              p = /android/i.test(i),
              f = /opera/i.test(i) || /opr/i.test(i),
              g = /firefox/i.test(i),
              v = /gecko\//i.test(i),
              E = /seamonkey\//i.test(i),
              y = /version\/(\d+(\.\d+)?)/i,
              A = /firefox\/(\d+(\.\d+)?)/i,
              T = /(?:chrome|crios)\/(\d+(\.\d+)?)/i,
              R = /OS (\d+)_(\d+)_?(\d+)?/i,
              b = /OculusBrowser/i.test(i),
              I = /OculusBrowser\/(\d+(\.\d+)?)/i,
              L = null;
            (this.isEdge = function () {
              if (this.browser.msedge) return !0;
            }),
              (this.isIE = function () {
                if (this.browser.msie) return !0;
              }),
              (this.equalOrLessThanIE10 = function () {
                return this.browser.msie && this.browser.version <= 10;
              }),
              (this.equalOrLessThanSafari6 = function () {
                return (
                  !this.isMobile() &&
                  this.isSafari() &&
                  parseFloat(this.browser.version, 10) <= 6
                );
              }),
              (this.ff_true = function () {
                if (this.browser.firefox || this.browser.gecko) return !0;
              }),
              (this.mac_true = function () {
                var e = !!navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i);
                if (e) return !0;
              }),
              (this.isChrome = function () {
                return !!this.browser.chrome;
              }),
              (this.chromeVersion = function () {
                return this.browser.chrome ? this.browser.version : null;
              }),
              (this.isSafari = function () {
                return !!this.browser.safari;
              }),
              (this.isIOS = function () {
                return !!this.browser.ios;
              }),
              (this.getIOSVersion = function () {
                if ("undefined" != typeof this.browser.iosVersion)
                  return this.browser.iosVersion;
              }),
              (this.isSafariOnIOS = function () {
                return !(!this.browser.ios || !this.browser.isSafariOnIOS);
              }),
              (this.isAndroid = function () {
                var e = i.toLowerCase();
                return (
                  e.indexOf("android") > -1 && e.indexOf("windows phone") === -1
                );
              }),
              (this.isAndroidMobile = function () {
                var e = i.toLowerCase();
                return !!(n.isAndroid() && e.indexOf("mobile") > -1);
              }),
              (this.getAndroidVersion = function () {
                var e,
                  t,
                  o = i.toLowerCase();
                return (
                  n.isAndroid() &&
                    ((e =
                      o.match(/\bandroid ; release\/([\d\.]+)/) ||
                      o.match(/\bandroid\s+([\d\.]+)/)),
                    (t = e && e[1] ? e[1] : null)),
                  t
                );
              }),
              (this.getDPI = function () {
                if (L) return L;
                try {
                  L = window.devicePixelRatio;
                } catch (e) {
                  L = 1;
                }
                return L;
              }),
              (this.isMobile = function () {
                var e = !1;
                return (
                  (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
                    navigator.userAgent
                  ) ||
                    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                      navigator.userAgent.substr(0, 4)
                    )) &&
                    (e = !0),
                  e
                );
              }),
              (this.isGSA = function () {
                return !!i.match(/GSA\/(\d+)/g);
              }),
              (this.oculus_true = function () {
                if (this.browser.oculus) return !0;
              }),
              (this.isARQuickLookCandidate = function () {
                var e,
                  t =
                    (/iPad|iPhone|iPod/.test(navigator.userAgent) &&
                      !window.MSStream) ||
                    ("MacIntel" === navigator.platform &&
                      navigator.maxTouchPoints > 1),
                  n = !(!window.webkit || !window.webkit.messageHandlers);
                return (
                  !!t &&
                  (n
                    ? !!(
                        this.isChrome() &&
                        parseFloat(this.chromeVersion(), 10) >= 87
                      ) ||
                      !!/EdgiOS\/|FxiOS\/|GSA\/|DuckDuckGo\//.test(
                        navigator.userAgent
                      )
                    : ((e = document.createElement("a")),
                      (e.relList &&
                        e.relList.supports &&
                        e.relList.supports("ar")) ||
                        !1))
                );
              }),
              (this.isSceneViewerCandidate = function () {
                return this.isAndroid() && !g && !b;
              }),
              (this.browser = e());
          };
        (t.browser = new n()), window.cylindo.addModule(e, t);
      }.call(this),
      function () {
        function e() {
          return "cylindo.com";
        }
        var t = "4.6.2",
          n = "//content.cylindo.com",
          i = "v" + t,
          o = {
            urls: {
              SERVICES_BASE: n,
              CYLINDO_CLIENTS: "//viewer." + e() + "/" + i + "/",
              TRACKING_PAGE: "//track." + e() + "/pages/t.aspx",
              TRACKING_SERVICES_BASE: "//track." + e() + "/tracking/",
              GETTRACKINGID_SERVICE:
                "/standard/viewer/gettrackingid_v2_1?callback=?&customerid={0}",
              DEFAULT_FALLBACK_IMAGE:
                "//viewer." +
                e() +
                "/" +
                i +
                "/assets/images/no-image-found.gif",
              DEFAULT_FALLBACK_VIDEO_IMAGE:
                "//viewer." +
                e() +
                "/" +
                i +
                "/assets/images/fallback_video_image.png",
              SERVICES_GET_IMAGE_URL: n + "/api/v2/standard/viewer/getimageurl",
              PRODUCT_EXISTS:
                n + "/api/v2/__accid__/products/__productCode__/configuration",
              BUSAPI: "//busapicdnendpoint.azureedge.net/getimage/",
              AR: "//s3.amazonaws.com/test.cylindev.com/AR/",
              OLD_SERVICES_GET_IMAGE_URL:
                "//viewer-services.cylindo.com/standard/viewer/getimageurl",
              ARV_GOOGLE: "//arvr.google.com/scene-viewer/1.0",
            },
            defaults: { ignoreCache: !1, loggerLimit: 100 },
            metadata: {
              VERSION: t,
              TRACKING_API: "1.8",
              TRACKING_MSG_VERSION: 3,
            },
          };
        window.cylindo.addModule("cylindo.settings.environments", o);
      }.call(this),
      function () {
        var e = function () {
          var e = cylindo.getModule("cylindo.settings.environments"),
            t = cylindo.getModule("cylindo.core.util"),
            n = {
              defaults: {
                pictureDataPath: "..\\assets\\viewer\\",
                dataPathTemp: "..\\assets\\viewer\\",
              },
            },
            i = {};
          t.object.extend(!0, i, n, e),
            (this.get = function (e) {
              if ("string" == typeof e) return i[e];
            }),
            (this.setDefault = function (e, t) {
              if (t) return (i.defaults[e] = t);
            }),
            (this.getVersion = function () {
              return i.metadata.VERSION;
            });
        };
        window.cylindo.addModule("cylindo.core.config", new e());
      }.call(this),
      function () {
        var e = function () {
          function e(e, t, n) {
            var i = e && e.status ? e.status : null;
            if ((console.error("Request failed: %s - %s", i, t), n))
              try {
                n(null, e);
              } catch (o) {}
          }
          function t(e, t) {
            return (
              (e = a.object.extend(!0, {}, l, e)),
              t && (e.data["x-service-version"] = t),
              "POST" == e.type && (e.data = JSON.stringify(e.data)),
              (e.method = e.type ? e.type : "GET"),
              e
            );
          }
          function n(t, n, o, l, d) {
            function c(e, t) {
              var n,
                i = e.response || e.responseText || "";
              try {
                i = JSON.parse(i);
              } catch (o) {}
              "string" == typeof i &&
                i.indexOf("callback") > -1 &&
                ((i = i.replace("callback(", "")),
                (n = i.lastIndexOf(")")),
                n > 0 && (i = i.substring(0, n)),
                (i = JSON.parse(i))),
                t && t(i, e);
            }
            function u(t, n, i) {
              var o = t && t.statusText ? t.statusText : null;
              i ? i(t, t.statusText, n) : e(t, o, n);
            }
            var h,
              m,
              p = o.method,
              f = !1;
            return (
              (d = d || null),
              (h = ++s),
              window.XDomainRequest
                ? ((f = !0), (m = new XDomainRequest()))
                : window.XMLHttpRequest && (m = new XMLHttpRequest()),
              (r[h] = m),
              f
                ? ((m.onload = function () {
                    c(m, n);
                  }),
                  (m.onerror = function () {
                    u(m, n, l);
                  }))
                : (m.onreadystatechange = function () {
                    (4 === m.readyState ||
                      ("HEAD" === p && m.readyState === m.DONE)) &&
                      (200 === m.status ? c(m, n) : u(m, n, l));
                  }),
              "POST" === p
                ? (m.open(p, t, !0),
                  ((!a.browser.isMobile() &&
                    a.browser.isSafari() &&
                    parseFloat(a.browser.browser.version, 10) < 9) ||
                    (a.browser.isIOS() &&
                      parseFloat(a.browser.getIOSVersion(), 10) < 9)) &&
                    m.setRequestHeader("Content-Type", "application/json"),
                  m.send(o.data))
                : ((t = i(t, o.data)),
                  m.open(p, t, !0),
                  d && (m.responseType = d),
                  m.send()),
              h
            );
          }
          function i(e, t) {
            var n;
            return (
              t &&
                ((n = o(t)),
                n.length &&
                  (e =
                    e.indexOf("?") !== -1
                      ? "&" === e.slice(-1) || "?" === e.slice(-1)
                        ? e + n
                        : e + "&" + n
                      : e + "?" + n)),
              e
            );
          }
          function o(e) {
            function t(e) {
              n.push(i + "=" + e);
            }
            var n = [];
            for (var i in e)
              e.hasOwnProperty(i) &&
                (e[i] instanceof Array
                  ? e[i].forEach(t)
                  : n.push(i + "=" + e[i]));
            return n.join("&");
          }
          var r = {},
            s = 0,
            a = cylindo.getModule("cylindo.core.util"),
            l = {
              method: "GET",
              contentType: "text/plain",
              traditional: !0,
              data: {},
            },
            d = cylindo.getModule("cylindo.core.config");
          d.get("metadata");
          (this.addQueryString = i),
            (this.doRequest = function (e, i, o, r, s) {
              return (o = t(o, null)), n(e, i, o, r, s);
            }),
            (this.abort = function (e) {
              r[e] && (r[e].abort(), delete r[e]);
            }),
            (this.resolveProtocol = function (e) {
              if (e) {
                if (e.indexOf("data:image") !== -1) return e;
                if (
                  !(
                    !/^(https?:)?\/\/([a-zA-Z\d-]+\.){0,}cylindo\.com/.test(
                      e
                    ) ||
                    a.browser.equalOrLessThanIE10() ||
                    (a.browser.isSafari() &&
                      parseFloat(a.browser.browser.version, 10) < 7)
                  )
                )
                  return (
                    "https:" +
                    e
                      .replace("file:", "")
                      .replace("http:", "")
                      .replace("https:", "")
                  );
                if (
                  e.indexOf("https:") === -1 &&
                  e.indexOf("http:") === -1 &&
                  e.indexOf("file:") === -1
                )
                  return "https:" === window.location.protocol
                    ? "https:" +
                        e
                          .replace("file:", "")
                          .replace("http:", "")
                          .replace("https:", "")
                    : "http:" +
                        e
                          .replace("file:", "")
                          .replace("http:", "")
                          .replace("https:", "");
              }
              return e;
            }),
            (this.requestImage = function (t, n, i, o, r) {
              var s;
              o &&
                ((t = t += t.indexOf("?") > -1 ? "&" : "?"),
                (t += "_=" + Date.now() + "&directives=IGNORE-CACHE")),
                (s = new XMLHttpRequest()),
                (s.onreadystatechange = function () {
                  4 === s.readyState &&
                    (200 === s.status
                      ? n && n(s.response, s)
                      : e(s, s.statusText, i));
                }),
                s.open("GET", t, !0),
                r && s.setRequestHeader("Authorization", "Basic " + r),
                (s.responseType = "blob"),
                s.send();
            }),
            (this.getXhrById = function (e) {
              return r[e];
            });
        };
        window.cylindo.addModule("cylindo.core.network", new e());
      }.call(this),
      function () {
        function e(e, o, r) {
          var s,
            a = t.promise.create(),
            l = !1,
            d = { type: "HEAD" },
            c =
              "Cylindo: skuExists method has been deprecated, please consult our documentation or contact the Support team to look for alternatives.";
          return (
            console.warn ? console.warn(c) : console.log(c),
            (s = i.resolveProtocol(n.get("urls").PRODUCT_EXISTS)),
            (s = s.replace("__accid__", e).replace("__productCode__", o)),
            i.doRequest(
              s,
              function (e, t) {
                (l = !0), a.resolve(l), r && r(l);
              },
              d,
              function (e, t) {
                (l = !1), a.resolve(l), r && r(l);
              },
              null
            ),
            a
          );
        }
        var t = cylindo.getModule("cylindo.core.util"),
          n = cylindo.getModule("cylindo.core.config"),
          i = window.cylindo.getModule("cylindo.core.network"),
          o = { skuExists: e };
        window.cylindo.addModule("cylindo.viewer.services", o);
      }.call(this),
      function () {
        var e = [
            "accountID",
            "alternateContent",
            "alternateContentZoom",
            "ARDesktop",
            "ARBanner",
            "ARBannerConfig",
            "_ARBannerConfig",
            "ARQuickLook",
            "backgroundColor",
            "buildNumber",
            "carouselSlideSpeed",
            "containerID",
            "country",
            "customZoomContainer",
            "cylindoContent",
            "debug",
            "environmentZoom",
            "fallbackImage",
            "fallbackVideoImage",
            "features",
            "fileName",
            "focusOnFeatureChange",
            "format",
            "fullscreen",
            "frames",
            "gaEvents",
            "height",
            "imageResolution",
            "imageTimeout",
            "loggerLimit",
            "maxZoom",
            "missingCombinationErrorText",
            "mobileZoomDelay",
            "overrideTracking",
            "presentation",
            "productCode",
            "progressBar",
            "proxy",
            "rotationSpeed",
            "removeEnvironmentShadow",
            "speedMultiplier",
            "size",
            "SKU",
            "skuVersion",
            "startFrame",
            "thumbAngles",
            "thumbCount",
            "thumbLocation",
            "thumbPageSize",
            "thumbs",
            "title",
            "tooltipAltImgText",
            "tooltipCarouselText",
            "tooltipDragText",
            "tooltipStackedPosition",
            "tooltipStackedText",
            "tooltipZoomText",
            "version",
            "viewerType",
            "width",
            "zoom",
            "zoomBackgroundColor",
            "zoomButton",
            "zoomMode",
            "zoomOverlapsThumbs",
          ],
          t = function (t) {
            var n = [],
              i = [],
              o = ["threeSixty", "alternateImages"],
              r = [],
              s = [
                "country",
                "SKU",
                "skuVersion",
                "buildNumber",
                "environmentZoom",
                "viewerType",
                "imageResolution",
              ];
            if (Object && "function" == typeof Object.keys) {
              var a,
                l = Object.keys(t);
              if (l && l.length)
                for (a = 0; a < l.length; a++)
                  s.includes(l[a]) && r.push(l[a]),
                    o.includes(l[a])
                      ? i.push(l[a])
                      : e.includes(l[a]) || n.push(l[a]);
            }
            return {
              unknownProperties: n,
              removedProps: i,
              toBeDeprecatedProperties: r,
            };
          },
          n = function (e) {
            if (e && e.debug) {
              var n = t(e);
              n.unknownProperties.length > 0 &&
                console.warn(
                  "WARNING: Unknown properties supplied to the 360 HD Viewer:",
                  n.unknownProperties,
                  "\nPlease check spelling and camel case as properties are case sensitive"
                ),
                n.removedProps.length > 0 &&
                  console.warn(
                    "WARNING: Obsolete properties supplied to the 360 HD Viewer:",
                    n.removedProps,
                    "\nPlease check our documentation for this viewer version."
                  ),
                n.toBeDeprecatedProperties.length > 0 &&
                  console.warn(
                    "WARNING: Some of the properties supplied to the 360 HD Viewer has been deprecated:",
                    n.toBeDeprecatedProperties,
                    "\nPlease check our documentation for this viewer version to update the configuration object."
                  );
            }
          },
          i = function (e) {
            return (
              !!e &&
              "undefined" != typeof e.accountID &&
              (e.productCode || e.SKU) &&
              "undefined" !== e.features &&
              e.containerID
            );
          },
          o = {
            getUnknownProperties: t,
            reportUnknownProperties: n,
            areRequiredPropertiesPresent: i,
          };
        window.cylindo.addModule("cylindo.viewer.properties", o);
      }.call(this),
      function () {
        var e = function () {
          var e = {},
            t = cylindo.getModule("cylindo.viewer.services"),
            n = cylindo.getModule("cylindo.viewer.properties");
          (this.services = { skuExists: t.skuExists }),
            (this.create = function (t) {
              var i = (cylindo.getModule("cylindo.core.util"), null);
              if (t && n.areRequiredPropertiesPresent(t)) {
                n.reportUnknownProperties(t),
                  t.containerID &&
                    (t.containerID = t.containerID.replace(/^#/, "")),
                  t.hasOwnProperty("SKU") &&
                    ((t.productCode = t.SKU), delete t.SKU),
                  t.hasOwnProperty("skuVersion") &&
                    ((t.version = t.skuVersion), delete t.skuVersion),
                  t.hasOwnProperty("imageResolution") &&
                    ((t.size = t.imageResolution), delete t.imageResolution);
                try {
                  (i = cylindo.getModule("cylindo.controller").create(t)),
                    (e[t.productCode + "_" + t.containerID] = i),
                    e[t.productCode + "_" + t.containerID].on(
                      i.events.DESTROYED,
                      function () {
                        delete e[t.productCode + "_" + t.containerID];
                      }
                    );
                } catch (o) {
                  console.error(o);
                }
                return i;
              }
              throw "Cylindo 360 HD Viewer require a valid options object to instantiate. Please refer to the integration guide";
            }),
            (this.getInstances = function () {
              return e;
            }),
            (this.getViewer = function (t) {
              return e[t] || null;
            }),
            (this.destroyAll = function () {
              for (var t in e) e.hasOwnProperty(t) && e[t].destroy();
              e = {};
            }),
            (this.update = function (t, n, i) {
              var o = e[t];
              if (!o) throw Error("Instance doesn't exist");
              o.hideImage(), o.update(n, i);
            }),
            (this.destroy = function (t) {
              var n = n[t];
              if (!n) throw Error("Instance doesn't exist");
              n.destroy(), (n = null), delete e[t];
            });
        };
        window.cylindo.addModule("viewer", new e(), !0);
      }.call(this),
      function () {
        var e = function (e) {
          function t(e) {
            function i(e) {
              R.reject(e);
            }
            function o(e) {
              e
                ? ((e.firstFeaturesFailed = M),
                  (e.firstSetOfFeatures = x),
                  R.resolve(e))
                : i(e);
            }
            function r(e) {
              e && e.error
                ? i(e)
                : (++h.requestID,
                  (T = h.requestID),
                  (w = n(I)),
                  u.log("Set of features resolved succesfully.", e),
                  o({ paths: w, data: e, refRequestID: T, ftToBeShown: b }));
            }
            function s() {
              var n;
              (M = !0),
                (x = I.features),
                u.error(k.FIRST_RUN, I.features),
                (e.features = []),
                (n = t(e)),
                n.then(o, i);
            }
            var d,
              A,
              T,
              R = l.promise.create(),
              b = e.features instanceof Array ? e.features.slice() : [],
              I = l.object.extend({}, e, { ftToBeShown: b }),
              L = b.join("*"),
              w = l.picture.getPaths(m, I),
              C = I.accountID,
              _ = I.productCode,
              N = b.join("*"),
              D = c && c.isInitialized() ? c.getData(_ + "-" + N) : null,
              O = c && c.isInitialized() ? c.getData(_) : null,
              S = I.startFrame || 1,
              M = !1,
              x = [],
              F = null,
              P = new Image(),
              k = {
                FIRST_RUN:
                  "First set of features failed while trying to get the images. Trying with the default set of features instead. Please check your product code and features to ensure this is a valid combination.",
                DEFAULT:
                  "Set of features failed while trying to get the images. Please check your product code and features to ensure this is a valid combination.",
                ABORTED: "Set of features canceled",
              };
            return (
              (d = w.framePath.replace("__FRAME_INDEX__", S)),
              (A = w.additionalDataUrl),
              b instanceof Array
                ? (f &&
                    (u.log("Previous request aborted.", f),
                    p.push(f),
                    a.abort(f)),
                  g &&
                    (u.log("Previous image request aborted.", g),
                    (g.onload = null),
                    (g.onerror = null),
                    (g.src = "")),
                  (g = P),
                  D
                    ? (u.log("Variation found in cache.", D), r(D))
                    : O
                    ? (u.log("Additional data found in cache.", O),
                      (P.src = d),
                      (P.onload = function () {
                        (P.onload = null),
                          (P.onerror = null),
                          (O.firstFrameImage = P.cloneNode()),
                          c.processData(_, L, O),
                          u.log("Variation stored.", _, L, O),
                          r(O);
                      }),
                      (P.onerror = function () {
                        (P.onload = null), (P.onerror = null), i(I);
                      }))
                    : (u.log(
                        "Variation/AdditionalData not found in cache, trying to get it.",
                        A,
                        P
                      ),
                      (f = F =
                        a.doRequest(
                          A,
                          function (t) {
                            var n = v,
                              o = t
                                ? "object" ===
                                  ("undefined" == typeof t
                                    ? "undefined"
                                    : _typeof(t))
                                  ? t
                                  : JSON.parse(t)
                                : null;
                            return (
                              (v = !1),
                              o
                                ? (E.isInitialized ||
                                    E.init(C, _, b, o.viewerAnalyticsData),
                                  (S < 1 || S > o.frameCount) &&
                                    (u.warning(
                                      "The startFrame value provided is out of the limits. The startFrame property has been set to 1, the value " +
                                        S +
                                        " has been dismissed."
                                    ),
                                    (e.startFrame = S = 1),
                                    (d = w.framePath.replace(
                                      "__FRAME_INDEX__",
                                      1
                                    ))),
                                  (o.startFrame = S),
                                  (f = null),
                                  void (c
                                    ? (c.isInitialized() || c.init(),
                                      c.setData(_, o),
                                      u.log("Additional data stored.", _, o),
                                      (P.src = d),
                                      (P.onload = function () {
                                        (P.onload = null),
                                          (P.onerror = null),
                                          (o.firstFrameImage = P.cloneNode()),
                                          c.processData(_, L, o),
                                          E.updateProductVersion(
                                            y.version || o.version
                                          ),
                                          u.log("Variation stored.", _, L, o),
                                          r(o);
                                      }),
                                      (P.onerror = function () {
                                        (P.onload = null),
                                          (P.onerror = null),
                                          n ? s() : i(I);
                                      }))
                                    : (u.error("Database module not found."),
                                      i(I))))
                                : void i(I)
                            );
                          },
                          { method: "OPTIONS" },
                          function (e, t) {
                            var n = (e && e.response) || "Unknown",
                              o = p.indexOf(F);
                            return o !== -1
                              ? (p.splice(o, 1), void u.error(k.ABORTED, b))
                              : void (v
                                  ? ((v = !1), s())
                                  : (i(e), u.error(k.DEFAULT, n, b)));
                          },
                          null
                        ))))
                : i(I),
              R
            );
          }
          function n(e) {
            return l.picture.getPaths(m, e);
          }
          function i(e, t) {
            var n = { type: "GET" },
              i = l.picture.getPaths(m, e);
            a.doRequest(
              i.resolvedFtPath,
              function (e, n) {
                t && t(e);
              },
              n,
              function (e, n) {
                t && t(e);
              },
              null
            );
          }
          function o() {
            f && a.abort(f), (c = null), r.trigger(r.events.DESTROYED);
          }
          var r = this,
            s = cylindo.getModule("cylindo.core.config"),
            a = cylindo.getModule("cylindo.core.network"),
            l = cylindo.getModule("cylindo.core.util"),
            d = cylindo.getModule("cylindo.util.pubsub").create(),
            c = cylindo
              .getModule("cylindo.classes.database")
              .create({ logger: e.logger, viewerData: e.viewerData }),
            u = e.logger,
            h = e.currentDataStatus,
            m = {
              defaults: s.get("defaults"),
              urls: s.get("urls"),
              metadata: s.get("metadata"),
            },
            p = [],
            f = 0,
            g = null,
            v = !0,
            E = e.tags,
            y = e.viewerData;
          (this.utils = l),
            (this.fetchFeatures = t),
            (this.updatePaths = n),
            (this.getResolvedFeatures = i),
            (this.destroy = o),
            (this.on = d.on),
            (this.off = d.off),
            (this.trigger = d.trigger);
        };
        e.prototype.events = { DESTROYED: "dao:destroyed" };
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("DAO", t);
      }.call(this),
      function () {
        var e = function (e) {
            var t = e.model;
            this.texts = {
              TITLE: t.get("title"),
              PRESENTATION: " viewer",
              VIEW_IN_AR: t.get("ARBtnTxt"),
              ENTER_FULLSCREEN: "Enter full screen mode",
              EXIT_FULLSCREEN: "Exit full screen mode",
              ENTER_ZOOM: "Enter zoom mode",
              EXIT_ZOOM: "Exit zoom mode",
              THUMBNAILS_BAR: "Thumbnails bar",
              THUMBNAIL_IMAGES: "Thumbnail images",
              ACTION_BUTTONS_GROUP: "Action buttons",
              THUMBS_LEFT: "Move thumbs bar to the left",
              THUMBS_RIGHT: "Move thumbs bar to the right",
              CAROUSEL_LEFT: "Move carousel viewer to the left",
              CAROUSEL_RIGHT: "Move carousel viewer to the right",
              ZOOM_CONTAINER: "Zoom container",
              ZOOM_IMAGE: "Zoomed image",
              AR_MODAL_WINDOW: "AR modal window",
            };
          },
          t = {
            create: function (t) {
              return new e(t);
            },
          };
        window.cylindo.addModule("cylindo.aria.label", t);
      }.call(this),
      function () {
        var e = function () {
            var e = {};
            (this.get = function (t) {
              return e[t] || null;
            }),
              (this.set = function (t, n) {
                e[t] = n;
              }),
              (this.getAllKeys = function () {
                return Object.keys(e);
              }),
              (this.setCache = function (t) {
                e = t;
              }),
              (this.clear = function () {
                e = {};
              }),
              (this.getCache = function () {
                return e;
              });
          },
          t = {
            create: function () {
              return new e();
            },
          };
        window.cylindo.addModule("cylindo.core.cache", t);
      }.call(this),
      function () {
        function e() {
          var e = cylindo.getModule("cylindo.core.network"),
            t = cylindo.getModule("cylindo.core.config"),
            n = cylindo.getModule("cylindo.core.util"),
            i = r(),
            o = screen && screen.width ? screen.width : null;
          return {
            accountID: null,
            alternateContent: null,
            alternateContentZoom: !0,
            ARBtnTxt: "View in your space",
            ARLoadingTxt: "Loading",
            arMode: "",
            ARNotAvailableTxt:
              "Unfortunately, your mobile<br /> device does not support<br /> this feature.",
            ARDesktop: !1,
            ARQuickLook: !0,
            ARBanner: "none",
            ARBannerConfig: null,
            ARBackToViewTxt: "Back to 360 view",
            backgroundColor: "FFFFFF",
            buildNumber: null,
            BUSAPIImage: "",
            BUSAPIFrame: "01",
            BUSAPIExtension: "jpg",
            containerID: null,
            country: "us",
            carouselSlideSpeed: 32,
            customZoomContainer: null,
            cylindoContent: !0,
            debug: !1,
            drawImageBackground: !0,
            defaultFallbackImage: e.resolveProtocol(
              t.get("urls").DEFAULT_FALLBACK_IMAGE
            ),
            environmentZoom: !1,
            fallbackImage: e.resolveProtocol(
              t.get("urls").DEFAULT_FALLBACK_IMAGE
            ),
            fallbackVideoImage: e.resolveProtocol(
              t.get("urls").DEFAULT_FALLBACK_VIDEO_IMAGE
            ),
            features: null,
            fileName: null,
            focusOnFeatureChange: !1,
            format: "JPG",
            frameCount: 32,
            frames: null,
            framesSetOnInit: !1,
            fullRTVData: null,
            fullscreen: !0,
            gaEvents: !0,
            getArRedirectUrl: null,
            gridSize: 1024,
            hasUnsupportedFeatures: !1,
            height: 512,
            ignoreCache: t.get("defaults").ignoreCache,
            ignoreRTVCache: 0,
            imageResolution: null,
            imageTimeout: 0,
            keepAliveInterval: 6e4,
            loggerLimit: t.get("defaults").loggerLimit,
            maxZoom: n.browser.isMobile() && o && o < 768 ? "2k" : "4k",
            missingCombinationErrorText:
              "Sorry, we do not have images for the requested feature set.",
            mobileZoomDelay: 250,
            overrideTracking: !1,
            partialRotationStart: 50,
            presentation: "threesixty",
            productCode: null,
            progressBar: !0,
            proxy: "",
            QRCodeTitleTxt: "View this product<br /> in your space",
            QRCodeTxt:
              "Point your smartphone or tablet's<br /> camera at the QR code below.",
            removeEnvironmentShadow: !1,
            rotationSpeed: 1,
            size: null,
            SKU: null,
            showGrid: !1,
            showGridCoordinates: !1,
            speedMultiplier: 1.2,
            startFrame: 1,
            thumbAngles: null,
            thumbCount: 5,
            thumbLocation: i.BOTTOM,
            thumbPageSize: 5,
            thumbs: !0,
            title: "360 HD Product Viewer",
            tooltipAltImgText: n.browser.isMobile()
              ? "Use Button to Zoom"
              : "Click to Zoom",
            tooltipCarouselText: n.browser.isMobile()
              ? "Use Button to Zoom"
              : "Click to Zoom",
            tooltipDragText: n.browser.isMobile()
              ? "Drag to Rotate. Use Button to Zoom"
              : "Drag to Rotate. Click to Zoom",
            tooltipDragTextFixed: !1,
            // tooltipNoZoomText: "Could not zoom in on the image.",
            tooltipNoZoomText: "",
            tooltipStackedPosition: 1,
            tooltipStackedText: n.browser.isMobile()
              ? "Use Button to Zoom"
              : "Click to Zoom",
            tooltipZoomText: n.browser.isMobile()
              ? "Drag to Pan"
              : "Move the Mouse to Pan",
            tooltipZoomTextFixed: !1,
            version: null,
            viewerType: 2,
            width: 512,
            zoom: !0,
            zoomBackgroundColor: "FFFFFF",
            zoomButton: !0,
            zoomMargin: 256,
            zoomMode: "mouseMove",
            zoomOverlapsThumbs: !0,
          };
        }
        function t() {
          return [
            "ARQuickLookBtn",
            "cylindoContent",
            "debug",
            "drawImageBackground",
            "environmentZoom",
            "focusOnFeatureChange",
            "fullscreen",
            "gaEvents",
            "progressBar",
            "overrideTracking",
            "removeEnvironmentShadow",
            "showGrid",
            "showGridCoordinates",
            "thumbs",
            "tooltipDragTextFixed",
            "zoom",
            "zoomButton",
            "zoomOverlapsThumbs",
          ];
        }
        function n() {
          return ["alternateContent", "features", "frames", "thumbAngles"];
        }
        function i() {
          return [
            "accountID",
            "environmentZoom",
            "alternateContentZoom",
            "format",
            "ARDesktop",
            "ARQuickLook",
            "zoomOverlapsThumbs",
            "thumbs",
            "thumbLocation",
            "imageResolution",
            "size",
            "proxy",
          ];
        }
        function o() {
          return ["threesixty", "single", "carousel", "stacked"];
        }
        function r() {
          return { TOP: "top", BOTTOM: "bottom", LEFT: "left", RIGHT: "right" };
        }
        var s = {
          getDefaults: e,
          getBooleans: t,
          getArrays: n,
          getNotCfgAtRuntime: i,
          getAllowedPresentations: o,
          getThumbLocations: r,
        };
        window.cylindo.addModule("cylindo.model.values", s);
      }.call(this),
      function () {
        var e = function n(e, t, i) {
          function o(e, t) {
            var n;
            if (x.length !== t.length) return !1;
            for (n = 0; n < t.length; n++) if (x[n] !== t[n]) return !1;
            return P === M.productCode;
          }
          function r(e) {
            var t;
            "features" === e &&
              ((t = M.features),
              g.log("Features has been changed.", x, t),
              (F = x),
              (x = M.features.slice(0)),
              (V = !1),
              h.fetchFeatures(),
              R.updateFeatures(t),
              R.send(R.events.FEATURE_CHANGED));
          }
          function s(e) {
            return "true" === e || e === !0;
          }
          function a(e) {
            var t = e.data,
              n = e.paths,
              i = e.ftToBeShown;
            M.currentFeatures
              ? ((M.currentFeatures.data = t), (M.currentFeatures.paths = n))
              : (M.currentFeatures = { data: t, paths: n }),
              (M.frameCount = t.frameCount),
              (M.hasUnsupportedFeatures = !1),
              (M.ftToBeShown = i),
              (q = (V && e && e.firstFeaturesFailed) || !1),
              h.trigger(h.events.FEATURES_NO_WARNING, M),
              h.trigger(h.events.FEATURES_CHANGED, e);
          }
          function l(e) {
            var t = h.get("features");
            e &&
              e.error &&
              g.error(
                "Could not set features with the provided array.",
                t,
                JSON.stringify(e)
              ),
              (M.hasUnsupportedFeatures = !0),
              h.trigger(h.events.FEATURES_ERROR, e),
              R.send(R.events.FEATURE_ERROR),
              R.send(R.events.ERROR_LOADING, {
                error_description: "Set of features could not be resolved.",
              });
          }
          function d() {
            g.log("Enabled to set features."),
              (H = !0),
              (k instanceof Array || "string" == typeof k) &&
                (g.log("Retrying to change feature set: " + k),
                h.set("features", k),
                (k = null));
          }
          function c() {
            try {
              console.warn ? console.warn(msg) : console.log(msg);
            } catch (e) {}
          }
          var u,
            h = this,
            m = 1,
            p = cylindo.getModule("DAO"),
            f = cylindo.getModule("cylindo.util.pubsub").create(),
            g = window.cylindo.getModule("cylindo.util.logger"),
            v = cylindo.getModule("cylindo.core.util"),
            E = cylindo.getModule("cylindo.core.config"),
            y = cylindo.getModule("cylindo.core.network"),
            A = cylindo.getModule("cylindo.model.values"),
            T = cylindo.getModule("cylindo.helpers.viewer.presentations"),
            R = t,
            b = i,
            I = { requestID: 0 },
            L = { IOS: "ios", ANDROID: "android", BOTH: "ios-android" },
            w = [L.IOS, L.ANDROID, L.BOTH],
            C = A.getThumbLocations(),
            _ = A.getDefaults(),
            N = A.getBooleans(),
            D = A.getArrays(),
            O = A.getNotCfgAtRuntime(),
            S = A.getAllowedPresentations(),
            M = null,
            x = [],
            F = [],
            P = null,
            k = null,
            U = !1,
            B =
              "AR button will not be displayed because HD 360 Viewer is not served over a https protocol.",
            G = "'ARBannerConfig' has not been configured properly",
            H = !1,
            z = !1,
            V = !0,
            q = !1,
            Y = cylindo.getModule("cylindo.helpers.ar.modes");
          screen && screen.width ? screen.width : null;
          for (u = 0; u < N.length; u++)
            e.hasOwnProperty(N[u]) && (e[N[u]] = s(e[N[u]]));
          for (u = 0; u < D.length; u++)
            e.hasOwnProperty(D[u]) &&
              e[D[u]] instanceof Array &&
              (e[D[u]] = e[D[u]].slice());
          if (
            ((e.productCode = e.productCode
              ? e.productCode.toUpperCase()
              : null),
            (e.productCode = e.productCode
              ? decodeURIComponent(e.productCode)
              : null),
            (P = e.productCode),
            e.hasOwnProperty("features"))
          ) {
            if (
              ((e.features && e.features instanceof Array) || (e.features = []),
              e.features && e.features.length)
            )
              for (u = 0; u < e.features.length; u++)
                e.features[u] = decodeURIComponent(
                  String(e.features[u])
                ).toUpperCase();
            x = e.features;
          }
          !e.fileName &&
            e.productCode &&
            ((z = !0), (e.fileName = e.productCode)),
            ("string" != typeof e.fallbackImage ||
              ("string" == typeof e.fallbackImage &&
                0 === e.fallbackImage.length)) &&
              delete e.fallbackImage,
            e.fallbackImage &&
              (e.fallbackImage = y.resolveProtocol(e.fallbackImage)),
            "undefined" != typeof e.tooltipDragText &&
              (e.tooltipDragTextFixed = !0),
            "undefined" != typeof e.zoomBackgroundColor &&
              (e.zoomBackgroundColor =
                "string" == typeof e.zoomBackgroundColor
                  ? e.zoomBackgroundColor
                  : ""),
            "undefined" != typeof e.backgroundColor &&
              ((U = !0),
              (e.backgroundColor =
                "string" == typeof e.backgroundColor ? e.backgroundColor : ""),
              "undefined" == typeof e.zoomBackgroundColor &&
                (e.zoomBackgroundColor = e.backgroundColor)),
            "00000000" === e.zoomBackgroundColor &&
              (e.zoomBackgroundColor = ""),
            "undefined" != typeof e.environmentZoom &&
              "undefined" == typeof e.alternateContentZoom &&
              (e.alternateContentZoom = e.environmentZoom),
            "undefined" != typeof e.startFrame &&
              (("number" != typeof e.startFrame ||
                _typeof(e.startFrame) < 1 ||
                isNaN(e.startFrame)) &&
                (e.startFrame = 1),
              (e.startFrame = parseInt(e.startFrame))),
            "undefined" != typeof e.presentation &&
              S.indexOf(e.presentation) === -1 &&
              (e.presentation = T.THREESIXTY.NAME),
            _typeof(e.presentation) === T.CUSTOM.NAME &&
              (e.cylindoContent = !1),
            "undefined" != typeof e.proxy &&
              "string" != typeof e.proxy &&
              (e.proxy = ""),
            "undefined" != typeof e.frames &&
              (e.frames instanceof Array && e.frames.length > 0
                ? (e.framesSetOnInit = !0)
                : (e.frames = null)),
            "undefined" != typeof e.carouselSlideSpeed &&
              ((e.carouselSlideSpeed = parseFloat(e.carouselSlideSpeed, 10)),
              (e.carouselSlideSpeed = isNaN(e.carouselSlideSpeed)
                ? 100
                : e.carouselSlideSpeed)),
            "stacked" === e.presentation && (e.thumbs = !1),
            "undefined" != typeof e.tooltipStackedPosition &&
              "number" != typeof e.tooltipStackedPosition &&
              (e.tooltipStackedPosition = 1),
            "undefined" != typeof e.format &&
              ("PNG" !== e.format.toUpperCase() &&
                "JPG" !== e.format.toUpperCase() &&
                (e.format = "JPG"),
              (e.format = e.format.toUpperCase())),
            "undefined" != typeof e.speedMultiplier &&
              (isNaN(e.speedMultiplier) || e.speedMultiplier < 1) &&
              (e.speedMultiplier = 1.2),
            "undefined" != typeof e.tooltipZoomText &&
              (e.tooltipZoomTextFixed = !0),
            "undefined" != typeof e.zoomMode &&
              ("mouseMove" !== e.zoomMode &&
                "mouseDrag" !== e.zoomMode &&
                (e.zoomMode = "mouseMove"),
              "mouseDrag" === e.zoomMode &&
                "undefined" == typeof e.tooltipZoomText &&
                (e.tooltipZoomText = "Drag to Pan")),
            e.ARDesktop !== !0 && (e.ARDesktop = !1),
            e.ARQuickLook !== !1 &&
              (v.browser.isSceneViewerCandidate()
                ? ("https:" !== window.location.protocol &&
                    ((e.ARQuickLook = !1), c(B)),
                  (e.arMode = Y.SCENE_VIEWER))
                : v.browser.isARQuickLookCandidate()
                ? (e.arMode = Y.ARQUICKLOOK)
                : e.ARDesktop && !v.browser.isMobile()
                ? (e.arMode = Y.QR)
                : ((e.ARQuickLook = !1), (e.arMode = null))),
            w.indexOf(e.ARBanner) === -1
              ? ((e.ARBanner = "none"), (e.ARBannerConfig = null))
              : (e.ARBannerConfig = e.ARBannerConfig || {}),
            "string" == typeof e.ARBanner &&
              "undefined" != typeof e.ARBannerConfig &&
              (null === e.arMode ||
              "object" !== _typeof(e.ARBannerConfig) ||
              null === e.ARBannerConfig
                ? ((e.ARBannerConfig = null), c(G))
                : ((e.ARBannerConfig = {
                    qrAction: e.ARBannerConfig.qrAction || "Visit",
                    action: e.ARBannerConfig.action || "Visit",
                    androidTitle: e.ARBannerConfig.androidTitle || "",
                    title: e.ARBannerConfig.title || e.productCode,
                    subtitle: e.ARBannerConfig.subtitle || e.productCode,
                    price: e.ARBannerConfig.price
                      ? e.ARBannerConfig.price.toString()
                      : null,
                  }),
                  (e._ARBannerConfig = e.ARBannerConfig),
                  e.arMode !== Y.ARQUICKLOOK ||
                  (e.ARBanner !== L.IOS && e.ARBanner !== L.BOTH)
                    ? e.arMode === Y.SCENE_VIEWER &&
                      (e.ARBanner === L.ANDROID || e.ARBanner === L.BOTH
                        ? (e.ARBannerConfig = {
                            title:
                              e.ARBannerConfig.androidTitle ||
                              e.ARBannerConfig.title,
                          })
                        : (e.ARBannerConfig = {}))
                    : (e.ARBannerConfig = {
                        qrCallToAction: e.ARBannerConfig.qrAction,
                        callToAction: e.ARBannerConfig.action,
                        checkoutTitle: e.ARBannerConfig.title,
                        checkoutSubtitle: e.ARBannerConfig.subtitle,
                        price: e.ARBannerConfig.price,
                        canonicalWebPageURL: e.ARBannerConfig.link,
                      }))),
            "undefined" != typeof e.zoomOverlapsThumbs &&
              "boolean" != typeof e.zoomOverlapsThumbs &&
              (e.zoomOverlapsThumbs = !1),
            "undefined" != typeof e.thumbLocation &&
              e.thumbLocation !== C.BOTTOM &&
              e.thumbLocation !== C.TOP &&
              e.thumbLocation !== C.LEFT &&
              e.thumbLocation !== C.RIGHT &&
              (e.thumbLocation = C.BOTTOM),
            "undefined" != typeof e.maxZoom &&
              ((e.maxZoom = String(e.maxZoom).toLocaleLowerCase()),
              ["mixed", "4k", "2k"].indexOf(e.maxZoom) === -1 &&
                delete e.maxZoom),
            "function" != typeof e.getArRedirectUrl &&
              (e.getArRedirectUrl = null),
            (M = v.object.extend(!0, {}, _, e)),
            M.cylindoContent &&
              M.accountID &&
              M.productCode &&
              ((M.BUSAPIImage = y.resolveProtocol(E.get("urls").BUSAPI)),
              (M.BUSAPIImage =
                M.BUSAPIImage +
                [
                  M.accountID,
                  M.productCode,
                  M.productCode + M.BUSAPIFrame + "." + M.BUSAPIExtension,
                ].join("/"))),
            (this.id = ++n.counter),
            (this.isValid = function () {
              return !0;
            }),
            (this.getRequestID = function () {
              return I.requestID;
            }),
            (this.updateRequestID = function () {
              ++I.requestID;
            }),
            (this.getAltRequestID = function () {
              return m;
            }),
            (this.prepareToFetchFeatures = function () {
              var e = this.getLogger();
              (p = p.create({
                logger: e,
                currentDataStatus: I,
                viewerData: M,
                framesHandler: b,
                tags: R,
              })),
                h.on(h.events.FEATURES_ERROR, d),
                h.on(h.events.FEATURES_CHANGED, d);
            }),
            (this.fetchFeatures = function () {
              M &&
                M.cylindoContent &&
                (M.size &&
                  ("number" != typeof M.size || isNaN(M.size)
                    ? ((M.size = null),
                      g.error(
                        "The image resolution should be a numeric value."
                      ))
                    : Math.floor(M.size) !== M.size &&
                      (g.warning(
                        "The resolution value must be an integer. Any decimal points will be ignored."
                      ),
                      (M.size = Math.floor(M.size)))),
                p.fetchFeatures(M).then(a, l));
            }),
            (this.get = function (e) {
              var t = ["debug", "loggerLimit"];
              if (M.hasOwnProperty(e)) return M[e];
              if (t.indexOf(e) !== -1)
                try {
                  console.warn
                    ? console.warn("Unknown property: '" + e + "'")
                    : console.log("Unknown property: '" + e + "'");
                } catch (n) {}
              else g.warning("Unknown property: '" + e + "'");
              return null;
            }),
            (this.set = function (e, t, n, i) {
              var a, l;
              if (
                ((t = t && t instanceof Array ? t.slice() : t),
                (i = !!i),
                (n = n || !1),
                g.log("Trying to set: '" + e + "' to: ", t),
                N.includes(e) && (t = s(t)),
                O.includes(e))
              )
                return void g.log(
                  "The property '" + e + "' is not configurable at runtime."
                );
              if (
                ("zoomBackgroundColor" === e && "00000000" === t && (t = ""),
                M.hasOwnProperty(e))
              ) {
                if ("productCode" === e)
                  return (
                    (t = t ? t : null),
                    (t = t ? decodeURIComponent(t) : null),
                    t && t !== P
                      ? ((M[e] = t),
                        M &&
                          M.currentFeatures &&
                          (M.currentFeatures.data = null),
                        z && (M.fileName = t),
                        (l = x),
                        (k = null),
                        R.updateProductCode(t),
                        h.set("features", l, !1, !0),
                        void (P = t))
                      : void g.error(
                          "Could not update the productCode with the provided value.",
                          t
                        )
                  );
                if ("features" === e) {
                  if ((t || (t = []), !(t instanceof Array)))
                    return void g.error(
                      "When viewer has been configured to use features an array or null values should be provided to configure the features.",
                      t
                    );
                  for (a = 0; a < t.length; a++)
                    t[a] = decodeURIComponent(String(t[a]).toUpperCase());
                  if (!H && !i)
                    return (
                      g.warning(
                        "Can not process set these features at the moment. This set of features: '" +
                          t +
                          "' will be processed until the earlier features has been resolved."
                      ),
                      void (k = t)
                    );
                  if (o(e, t))
                    return void g.warning(
                      "Features set ignored because is the same than the displayed.",
                      t
                    );
                  H = !!i;
                }
                if ("alternateContent" === e)
                  return ++m, void this.updateAlternateContent(t);
                "ARBannerConfig" === e &&
                  (w.indexOf(M.ARBanner) === -1
                    ? ((M.ARBanner = "none"), (t = null))
                    : (t = t || {}),
                  "string" == typeof M.ARBanner &&
                  "object" ===
                    ("undefined" == typeof t ? "undefined" : _typeof(t))
                    ? null === M.arMode ||
                      "object" !==
                        ("undefined" == typeof t ? "undefined" : _typeof(t)) ||
                      null === t
                      ? ((t = null), c(G))
                      : ((t = {
                          qrAction: t.qrAction || "Visit",
                          action: t.action || "Visit",
                          androidTitle: t.androidTitle || "",
                          title: t.title || M.productCode,
                          subtitle: t.subtitle || "",
                          price: t.price ? t.price.toString() : null,
                        }),
                        (M._ARBannerConfig = t),
                        M.arMode !== Y.ARQUICKLOOK ||
                        (M.ARBanner !== L.IOS && M.ARBanner !== L.BOTH)
                          ? M.arMode === Y.SCENE_VIEWER &&
                            (t =
                              M.ARBanner === L.ANDROID || M.ARBanner === L.BOTH
                                ? { title: t.title }
                                : {})
                          : (t = {
                              qrCallToAction: t.qrAction,
                              callToAction: t.action,
                              checkoutTitle: t.title,
                              checkoutSubtitle: t.subtitle,
                              price: t.price,
                              canonicalWebPageURL: t.link,
                            }))
                    : (t = null),
                  this.trigger(this.events.AR_CONFIG_CHANGED, {
                    prop: e,
                    value: t,
                  })),
                  (M[e] = t),
                  r(e),
                  M &&
                    M.currentFeatures &&
                    "features" !== e &&
                    !n &&
                    ((M.currentFeatures.paths = p.updatePaths(
                      v.object.extend(!0, {}, M)
                    )),
                    (M.currentFeatures.data.image = null)),
                  b && b.initialized && b.cleanCache(),
                  "features" === e ||
                    n ||
                    this.trigger(this.events.CHANGED, { prop: e, value: t });
              }
            }),
            (this.updateAlternateContent = function (e, t) {
              var n = "alternateContent",
                i = {};
              b && b.initialized && b.cleanCache(),
                b && b.initialized && b.reordered
                  ? ((i = b.prepareToUpdateAltContent(e)),
                    i && i.canUpdate
                      ? (b.prepareToReorder(),
                        g.log(
                          "updateAlternateContent - Trying to set frames to",
                          i.frames
                        ),
                        g.log(
                          "updateAlternateContent - Trying to set alternateContent to",
                          i.alternateContent
                        ),
                        (M.alternateContent = i.alternateContent),
                        (M.frames = i.frames),
                        t ||
                          this.trigger(this.events.CHANGED, {
                            prop: n,
                            value: i.alternateContent,
                            useFramesToReorder: i.useFramesToReorder,
                          }))
                      : g.log("alternateContent could not be updated."))
                  : ((M.alternateContent = e),
                    g.log(
                      "Content has not been reordered yet, alternate content will be updated but frames will not be updated."
                    ));
            }),
            (this.on = f.on),
            (this.once = f.once),
            (this.off = f.off),
            (this.trigger = f.trigger),
            (this.destroy = function () {
              (M = {}),
                f.destroy(),
                p && "function" == typeof p.destroy && p.destroy();
            }),
            (this.getLogger = function () {
              return g;
            }),
            (this.getCanceledFeatures = function () {
              return F || [];
            }),
            (this.isCustomBackgroundColor = function () {
              return U;
            }),
            (this.getThumbLocations = function () {
              return C;
            }),
            (this.getResolvedFeatures = function (e) {
              p &&
                "function" == typeof p.getResolvedFeatures &&
                p.getResolvedFeatures(M, e);
            }),
            (this.isFirstSetOfFt = function () {
              return V;
            }),
            (this.didFirstFeaturesFailed = function () {
              return q;
            }),
            (g = g.create(this));
        };
        (e.counter = 0),
          (e.prototype.events = {
            FEATURES_CHANGED: "features:changed",
            FEATURES_ERROR: "features:error",
            FEATURES_NO_WARNING: "features:nowarning",
            ALL_FEATURES_LOADED: "features:all:loaded",
            CHANGED: "model:changed",
            AR_CONFIG_CHANGED: "ar:config:changed",
          });
        var t = {
          create: function (t, n, i) {
            return new e(t, n, i);
          },
        };
        window.cylindo.addModule("model", t);
      }.call(this),
      function () {
        var e = function (e) {
          function t() {
            try {
              s = window.cylindo
                .getModule("cylindo.viewer.controller")
                .create(c);
            } catch (e) {
              console.error(e),
                null === s &&
                  (s = cylindo.getModule("cylindo.core.fallback").create(c));
            }
            (o.isRotating = s.isRotating),
              (o.isPanning = s.isPanning),
              (o.loggerMap = s.loggerMap),
              (o.printGrid = s.printGrid),
              (o.exitZoom = s.exitZoom),
              (o.disableTags = s.disableTags),
              (o.rotate = s.rotate),
              (o.goToAngle = s.goToAngle),
              (o.previousSlide = s.previousSlide),
              (o.nextSlide = s.nextSlide),
              (o.zoom = s.zoom),
              s.off(s.events.ZOOM, n),
              s.off(s.events.ZOOM_ENTER, n),
              s.off(s.events.ZOOM_EXIT, n),
              s.off(s.events.VIEWER_READY, n),
              s.off(s.events.VIEWER_COMPLETE, n),
              s.off(s.events.THUMBS_READY, n),
              s.off(s.events.THUMB_CLICKED, n),
              s.off(s.events.ALT_THUMBS_CLICKED, n),
              s.off(s.events.FIRST_FRAME_READY, n),
              s.off(s.events.FULLSCREEN_ENTER, n),
              s.off(s.events.FULLSCREEN_EXIT, n),
              s.off(s.events.SPIN_BEGIN, n),
              s.off(s.events.SPIN_END, n),
              s.off(s.events.PREV, n),
              s.off(s.events.NEXT, n),
              s.off(s.events.DESTROYED, n),
              s.off(s.events.ERROR, n),
              s.off(s.events.FEATURES_CANCELED, n),
              s.off(s.events.FEATURES_ERROR, n),
              s.off(s.events.AR_BUTTON_READY, n),
              s.off(s.events.AR_BUTTON_ERROR, n),
              s.off(s.events.AR_ACTION_BTN_TAPPED, n),
              s.on(s.events.ZOOM, n),
              s.on(s.events.ZOOM_ENTER, n),
              s.on(s.events.ZOOM_EXIT, n),
              s.on(s.events.VIEWER_READY, n),
              s.on(s.events.VIEWER_COMPLETE, n),
              s.on(s.events.THUMBS_READY, n),
              s.on(s.events.THUMB_CLICKED, n),
              s.on(s.events.ALT_THUMBS_CLICKED, n),
              s.on(s.events.FIRST_FRAME_READY, n),
              s.on(s.events.FULLSCREEN_ENTER, n),
              s.on(s.events.FULLSCREEN_EXIT, n),
              s.on(s.events.SPIN_BEGIN, n),
              s.on(s.events.SPIN_END, n),
              s.on(s.events.PREV, n),
              s.on(s.events.NEXT, n),
              s.on(s.events.DESTROYED, n),
              s.on(s.events.ERROR, n),
              s.on(s.events.FEATURES_CANCELED, n),
              s.on(s.events.FEATURES_ERROR, n),
              s.on(s.events.AR_BUTTON_READY, n),
              s.on(s.events.AR_BUTTON_ERROR, n),
              s.on(s.events.AR_ACTION_BTN_TAPPED, n),
              (o.initialized = !0),
              s.isFallbackController &&
                (s.show(),
                setTimeout(function () {
                  o.trigger(o.events.ERROR, c);
                }, 100));
          }
          function n(e, t) {
            o.trigger(a[e], t);
          }
          function i(e, t) {
            console.warn ? console.warn(e, t) : console.log(e, t);
          }
          var o = this,
            r = cylindo.getModule("cylindo.util.pubsub").create(),
            s = null,
            a = {},
            l = {
              toBeDeprecated:
                "Cylindo: Some of the requested methods has been deprecated, please consult our documentation or contact the Support team to look for alternatives.",
            },
            d = {
              ADD_TO_CART: "addToCart",
              GET_AR_QUICKLOOK_URL: "getArQuickLookUrl",
              GET_CURRENT_FRAME_URL: "getCurrentFrameUrl",
              GET_FRAME_URL: "getFrameUrl",
              GET_SKU: "getSKU",
              GET_STATE: "getState",
              SHOW_IMAGE: "showImage",
              HIDE_IMAGE: "hideImage",
              DISABLE_TRACKING: "disableTracking",
            },
            c = e;
          (this.on = r.on),
            (this.trigger = r.trigger),
            (this.off = r.off),
            t(),
            (a[o.events.ZOOM] = o.events.ZOOM),
            (a[o.events.ZOOM_ENTER] = o.events.ZOOM_ENTER),
            (a[o.events.ZOOM_EXIT] = o.events.ZOOM_EXIT),
            (a[o.events.VIEWER_READY] = o.events.VIEWER_READY),
            (a[o.events.VIEWER_COMPLETE] = o.events.VIEWER_COMPLETE),
            (a[o.events.THUMBS_READY] = o.events.THUMBS_READY),
            (a[o.events.THUMB_CLICKED] = o.events.THUMB_CLICKED),
            (a[o.events.ALT_THUMBS_CLICKED] = o.events.ALT_THUMBS_CLICKED),
            (a[o.events.FIRST_FRAME_READY] = o.events.FIRST_FRAME_READY),
            (a[o.events.FULLSCREEN_ENTER] = o.events.FULLSCREEN_ENTER),
            (a[o.events.FULLSCREEN_EXIT] = o.events.FULLSCREEN_EXIT),
            (a[o.events.SPIN_BEGIN] = o.events.SPIN_BEGIN),
            (a[o.events.SPIN_END] = o.events.SPIN_END),
            (a[o.events.PREV] = o.events.PREV),
            (a[o.events.NEXT] = o.events.NEXT),
            (a[o.events.DESTROYED] = o.events.DESTROYED),
            (a[o.events.ERROR] = o.events.ERROR),
            (a[o.events.FEATURES_CANCELED] = o.events.FEATURES_CANCELED),
            (a[o.events.FEATURES_ERROR] = o.events.FEATURES_ERROR),
            (a[o.events.AR_BUTTON_READY] = o.events.AR_BUTTON_READY),
            (a[o.events.AR_BUTTON_ERROR] = o.events.AR_BUTTON_ERROR),
            (a[o.events.AR_ACTION_BTN_TAPPED] = o.events.AR_ACTION_BTN_TAPPED),
            (this.update = function (e, n) {
              s.isFallbackController ? ((c[e] = n), t()) : s.update(e, n);
            }),
            (this.updateAlternateContent = function (e) {
              s.updateAlternateContent(e);
            }),
            (this.setProduct = function (e) {
              s.isFallbackController
                ? ((c.productCode = e), t())
                : s.setProduct(e);
            }),
            (this.setFeatures = function (e) {
              s.isFallbackController
                ? ((c.features = e), t())
                : s.setFeatures(e);
            }),
            (this.destroy = function () {
              s.destroy(), r.destroy();
            }),
            (this.getProduct = function () {
              return s.getProduct();
            }),
            (this.getFeatures = function () {
              return s.getFeatures();
            }),
            (this.getAccount = function () {
              return s.getAccount();
            }),
            (this.getVersion = function () {
              return s.getVersion();
            }),
            (this.getRotationSpeed = function () {
              return s.getRotationSpeed();
            }),
            (this.getDebugInfo = function (e) {
              return s.getDebugInfo(e);
            }),
            (this.getCurrentImageUrl = function (e, t) {
              return s.getUrlImage(o.getCurrentFrameIndex(), e, t);
            }),
            (this.getCurrentFrameIndex = function () {
              return s.getCurrentFrameIndex();
            }),
            (this.addToCart = function (e, t, n, o) {
              i(l.toBeDeprecated, d.ADD_TO_CART), s.addToCart(e, t, n, o);
            }),
            (this.getArQuickLookUrl = function (e) {
              i(l.toBeDeprecated, d.GET_AR_QUICKLOOK_URL),
                s.getArQuickLookUrl(e);
            }),
            (this.getCurrentFrameUrl = function (e, t, n) {
              o.getFrameUrl(o.getCurrentFrameIndex(), e, t, n);
            }),
            (this.getFrameUrl = function (e, t, n, o) {
              var r = s.getUrlImage(e, t, o),
                a = "An error ocurred while trying to get the current frame.";
              i(l.toBeDeprecated, [d.GET_FRAME_URL, d.GET_CURRENT_FRAME_URL]);
              try {
                r ? n(r) : n(r, a);
              } catch (c) {
                console.error ? console.error(a, c) : console.log(a, c);
              }
            }),
            (this.getSKU = function () {
              return i(l.toBeDeprecated, d.GET_SKU), s.getProduct();
            }),
            (this.getState = function () {
              return i(l.toBeDeprecated, d.GET_STATE), s.getState();
            }),
            (this.showImage = function (e, t) {
              i(l.toBeDeprecated, d.SHOW_IMAGE), s.showImage(e, t);
            }),
            (this.hideImage = function () {
              i(l.toBeDeprecated, d.HIDE_IMAGE), s.hideImage();
            }),
            (this.disableTracking = function (e) {
              i(l.toBeDeprecated, d.DISABLE_TRACKING), s.disableTracking(e);
            }),
            (this.getResolvedFeatures = function (e) {
              s && s.getResolvedFeatures && s.getResolvedFeatures(e);
            });
        };
        (e.counter = 0),
          (e.prototype.events = {
            DESTROYED: "instance:destroyed",
            THREESIXTY_READY: "instance:viewer:ready",
            THREESIXTY_COMPLETE: "instance:viewer:complete",
            VIEWER_READY: "instance:viewer:ready",
            VIEWER_COMPLETE: "instance:viewer:complete",
            FIRST_FRAME_READY: "instance:firstframe:ready",
            THUMBS_READY: "instance:thumbs:ready",
            THREESIXTY_THUMB_CLICKED: "instance:viewer:thumbs:clicked",
            THUMB_CLICKED: "instance:viewer:thumbs:clicked",
            ALT_THUMBS_CLICKED: "instance:alt:thumbs:clicked",
            ZOOM: "instance:zoom",
            ZOOM_ENTER: "instance:zoom:enter",
            ZOOM_EXIT: "instance:zoom:exit",
            FULLSCREEN_ENTER: "instance:fullscreen:enter",
            FULLSCREEN_EXIT: "instance:fullscreen:exit",
            SPIN_BEGIN: "instance:threesixty:start",
            SPIN_END: "instance:threesixty:end",
            PREV: "instance:carousel:prev",
            NEXT: "instance:carousel:next",
            ERROR: "instance:error",
            FEATURES_CANCELED: "instance:features:canceled",
            FEATURES_ERROR: "instance:features:error",
            AR_BUTTON_READY: "instance:ar:button:ready",
            AR_BUTTON_ERROR: "instance:ar:button:error",
            AR_ACTION_BTN_TAPPED: "instance:ar:action:btn:tapped",
          });
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.controller", t);
      }.call(this),
      function () {
        var e = function (e) {
          function t() {
            function e() {
              var e =
                /(cylindev.com|bugtest.it|cylindo.com|localhost|bs-local)/gi;
              return (
                e.test(window.location.host) ||
                "file:" == window.location.protocol
              );
            }
            (c.get("gaEvents") === !1 ||
              (c.get("overrideTracking") !== !0 && e())) &&
              d.disableTags(!0),
              c.get("overrideTracking") !== !0 && e() && i(),
              u.on(u.events.ZOOM, n),
              u.on(u.events.ZOOM_ENTER, n),
              u.on(u.events.ZOOM_EXIT, n),
              u.on(u.events.VIEWER_READY, n),
              u.on(u.events.DOWNLOAD_COMPLETE, n),
              u.on(u.events.THUMBS_READY, n),
              u.on(u.events.THUMB_CLICKED, n),
              u.on(u.events.ALT_THUMBS_CLICKED, n),
              u.on(u.events.FIRST_FRAME_COMPLETE, n),
              u.on(u.events.ENTER_FULLSCREEN, n),
              u.on(u.events.EXIT_FULLSCREEN, n),
              u.on(u.events.START_SPIN, n),
              u.on(u.events.END_SPIN, n),
              u.on(u.events.PREV, n),
              u.on(u.events.NEXT, n),
              u.on(u.events.FEATURES_CANCELED, n),
              u.on(u.events.FEATURES_ERROR, n),
              u.on(u.events.AR_BUTTON_READY, n),
              u.on(u.events.AR_BUTTON_ERROR, n),
              u.on(u.events.AR_ACTION_BTN_TAPPED, n),
              (o.initialized = !0);
          }
          function n(e, t) {
            o.trigger(f[e], t);
          }
          function i() {
            try {
              console.warn(
                "Cylindo's tracking functionality has been deprecated. Please contact support team for more information about it."
              );
            } catch (e) {
              console.warn(
                "Cylindo's tracking functionality has been deprecated. Please contact support team for more information about it."
              );
            }
          }
          var o = this,
            r = cylindo.getModule("cylindo.util.pubsub").create(),
            s = null,
            a = cylindo.getModule("cylindo.classes.frames.handler").create({}),
            l = {
              cid: e.accountID,
              productCode: e.productCode,
              features: e.features,
            },
            d = cylindo.tags.handler.create(l),
            c = cylindo.getModule("model").create(e, d, a),
            u = cylindo.getModule("view").create(c, d, a),
            h = cylindo.getModule("cylindo.core.config"),
            m = cylindo.getModule("cylindo.classes.capi"),
            p = {};
          (p.LOG = 1),
            (p.INFO = 2),
            (p.WARNING = 4),
            (p.ERROR = 8),
            (p.EVENT = 16);
          var f = {};
          (f[u.events.ZOOM] = o.events.ZOOM),
            (f[u.events.ZOOM_ENTER] = o.events.ZOOM_ENTER),
            (f[u.events.ZOOM_EXIT] = o.events.ZOOM_EXIT),
            (f[u.events.VIEWER_READY] = o.events.VIEWER_READY),
            (f[u.events.DOWNLOAD_COMPLETE] = o.events.VIEWER_COMPLETE),
            (f[u.events.THUMBS_READY] = o.events.THUMBS_READY),
            (f[u.events.THUMB_CLICKED] = o.events.THUMB_CLICKED),
            (f[u.events.ALT_THUMBS_CLICKED] = o.events.ALT_THUMBS_CLICKED),
            (f[u.events.FIRST_FRAME_COMPLETE] = o.events.FIRST_FRAME_READY),
            (f[u.events.ENTER_FULLSCREEN] = o.events.FULLSCREEN_ENTER),
            (f[u.events.EXIT_FULLSCREEN] = o.events.FULLSCREEN_EXIT),
            (f[u.events.START_SPIN] = o.events.SPIN_BEGIN),
            (f[u.events.END_SPIN] = o.events.SPIN_END),
            (f[u.events.PREV] = o.events.PREV),
            (f[u.events.NEXT] = o.events.NEXT),
            (f[u.events.FEATURES_CANCELED] = o.events.FEATURES_CANCELED),
            (f[u.events.FEATURES_ERROR] = o.events.FEATURES_ERROR),
            (f[u.events.AR_BUTTON_READY] = o.events.AR_BUTTON_READY),
            (f[u.events.AR_BUTTON_ERROR] = o.events.AR_BUTTON_ERROR),
            (f[u.events.AR_ACTION_BTN_TAPPED] = o.events.AR_ACTION_BTN_TAPPED),
            (s = c.getLogger()),
            (this.isFallbackController = !1),
            (this.on = r.on),
            (this.trigger = r.trigger),
            (this.off = r.off),
            (this.loggerMap = p),
            (this.getControllerType = function () {
              return this.controllerType;
            }),
            (this.update = function (e, t) {
              o.setModelProperty(e, t);
            }),
            (this.updateAlternateContent = function (e) {
              try {
                return c.updateAlternateContent(e);
              } catch (t) {
                return (
                  o.logError(
                    "Could not set property " + field + " from model.",
                    t
                  ),
                  null
                );
              }
            }),
            (this.setProduct = function (e) {
              o.update("productCode", e);
            }),
            (this.setFeatures = function (e) {
              o.update("features", e);
            }),
            (this.destroy = function () {
              r.destroy(),
                d.destroy(),
                c.destroy(),
                u.destroy(),
                a.destroy(),
                o.trigger(o.events.DESTROYED);
            }),
            (this.getProduct = function () {
              return o.getModelProperty("productCode");
            }),
            (this.getFeatures = function () {
              return o.getModelProperty("features");
            }),
            (this.getAccount = function () {
              return o.getModelProperty("accountID");
            }),
            (this.getVersion = function () {
              return h && o.isFunction(h.getVersion) ? h.getVersion() : null;
            }),
            (this.getRotationSpeed = function () {
              return o.getModelProperty("rotationSpeed");
            }),
            (this.getDebugInfo = function (e) {
              return (
                s.getDebugInfo(e),
                "You can use bitwise operators to filter messages, e.g. instanceName.loggerMap.ERROR | instanceName.loggerMap.WARNING  "
              );
            }),
            (this.getUrlImage = function (e, t, n) {
              var i =
                  u && o.isFunction(u.getThreesixtyMaxSize)
                    ? u.getThreesixtyMaxSize()
                    : 512,
                r = o.getModelProperty("accountID"),
                s = o.getModelProperty("productCode"),
                a = o.getModelProperty("features"),
                l = o.getModelProperty("version"),
                d = o.getModelProperty("ignoreCache"),
                c = o.getModelProperty("removeEnvironmentShadow"),
                h = o.getModelProperty("proxy"),
                p = Math.min(t, i);
              try {
                return m.getUrlV2(r, s, e, p, a, c, h, n, l, d);
              } catch (f) {
                return (
                  o.logError(
                    "Cannot get frame URL, CAPI module may not exist.",
                    f
                  ),
                  null
                );
              }
            }),
            (this.getCurrentFrameIndex = function () {
              return u && o.isFunction(u.getCurrentThreesixtyIndex)
                ? u.getCurrentThreesixtyIndex()
                : null;
            }),
            (this.addToCart = function (e, t, n, o) {
              i();
            }),
            (this.printGrid = function () {
              u && o.isFunction(u.printGrid) && u.printGrid();
            }),
            (this.exitZoom = function () {
              u && o.isFunction(u.exitZoom) && u.exitZoom();
            }),
            (this.disableTags = function (e) {
              d && o.isFunction(d.disableTags) && d.disableTags(e);
            }),
            (this.disableTracking = function (e) {
              i();
            }),
            (this.rotate = function (e, t) {
              u && o.isFunction(u.rotate) && u.rotate(e, t);
            }),
            (this.goToAngle = function (e) {
              u && o.isFunction(u.goToAngle) && u.goToAngle(e);
            }),
            (this.previousSlide = function () {
              u && o.isFunction(u.previousSlide) && u.previousSlide();
            }),
            (this.nextSlide = function () {
              u && o.isFunction(u.nextSlide) && u.nextSlide();
            }),
            (this.zoom = function (e, t, n) {
              u && o.isFunction(u.zoom) && u.zoom(e, t, n);
            }),
            (this.getState = function () {
              return u && o.isFunction(u.getState) ? u.getState() : null;
            }),
            (this.getArQuickLookUrl = function (e) {
              u && o.isFunction(u.getArQuickLookUrl) && u.getArQuickLookUrl(e);
            }),
            (this.showImage = function (e, t) {
              u && o.isFunction(u.showImage) && u.showImage(e, t);
            }),
            (this.hideImage = function () {
              u && o.isFunction(u.hideImage) && u.hideImage();
            }),
            (this.isRotating = function () {
              if (u && o.isFunction(u.isRotating)) return u.isRotating();
            }),
            (this.isPanning = function () {
              if (u && o.isFunction(u.isPanning)) return u.isPanning();
            }),
            (this.getResolvedFeatures = function (e) {
              c && c.getResolvedFeatures(e);
            }),
            (this.getModelProperty = function (e) {
              try {
                return c.get(e);
              } catch (t) {
                return (
                  o.logError("Could not get property " + e + " from model.", t),
                  null
                );
              }
            }),
            (this.setModelProperty = function (e, t) {
              try {
                return c.set(e, t);
              } catch (n) {
                return (
                  o.logError("Could not set property " + e + " from model.", n),
                  null
                );
              }
            }),
            (this.logError = function (e, t) {
              try {
                s.error(e, t);
              } catch (n) {
                console.error
                  ? console.error(e, t)
                  : console.log("Error: ", e, t);
              }
            }),
            (this.isFunction = function (e) {
              return "function" == typeof e;
            }),
            t();
        };
        e.prototype.events = {
          DESTROYED: "instance:destroyed",
          VIEWER_READY: "instance:viewer:ready",
          VIEWER_COMPLETE: "instance:viewer:complete",
          FIRST_FRAME_READY: "instance:firstframe:ready",
          THUMBS_READY: "instance:thumbs:ready",
          THUMB_CLICKED: "instance:viewer:thumbs:clicked",
          ALT_THUMBS_CLICKED: "instance:alt:thumbs:clicked",
          ZOOM: "instance:zoom",
          ZOOM_ENTER: "instance:zoom:enter",
          ZOOM_EXIT: "instance:zoom:exit",
          FULLSCREEN_ENTER: "instance:fullscreen:enter",
          FULLSCREEN_EXIT: "instance:fullscreen:exit",
          SPIN_BEGIN: "instance:threesixty:start",
          SPIN_END: "instance:threesixty:end",
          PREV: "instance:carousel:prev",
          NEXT: "instance:carousel:next",
          ERROR: "instance:error",
          FEATURES_CANCELED: "instance:features:canceled",
          FEATURES_ERROR: "instance:features:error",
          AR_BUTTON_READY: "instance:ar:button:ready",
          AR_BUTTON_ERROR: "instance:ar:button:error",
          AR_ACTION_BTN_TAPPED: "instance:ar:action:btn:tapped",
        };
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.viewer.controller", t);
      }.call(this),
      function () {
        var e = {
          SCENE_VIEWER: "scene-viewer",
          ARQUICKLOOK: "arquicklook",
          QR: "qr",
        };
        window.cylindo.addModule("cylindo.helpers.ar.modes", e);
      }.call(this),
      function () {
        function e() {
          return i;
        }
        function t(e, t) {
          var n,
            o = e.getAllFramesToBeLoaded(),
            r = cylindo.getModule("cylindo.helpers.viewer.presentations"),
            s = o.THREESIXTY.TO_BE_LOADED,
            a = o.THUMB.ENABLED,
            l = o.ALTERNATE.LIST,
            d = [],
            c = [],
            u = [],
            h = [];
          if (
            (t.presentation === r.CUSTOM.NAME
              ? l.length &&
                (d.push({ type: i.FIRST_FRAME, downloaded: !1, elapsed: 0 }),
                h.push({ type: i.FIRST_FRAME, downloaded: !1, elapsed: 0 }),
                d.push({ type: i.ALTERNATE, downloaded: !1, elapsed: 0 }),
                h.push({ type: i.ALTERNATE, downloaded: !1, elapsed: 0 }))
              : (t.presentation === r.THREESIXTY.NAME &&
                  (d.push({ type: i.READY, downloaded: !1, elapsed: 0 }),
                  h.push({ type: i.READY, downloaded: !1, elapsed: 0 })),
                d.push({ type: i.FIRST_FRAME, downloaded: !1, elapsed: 0 }),
                h.push({ type: i.FIRST_FRAME, downloaded: !1, elapsed: 0 }),
                d.push({ type: i.FRAME, downloaded: !1, elapsed: 0 }),
                h.push({ type: i.FRAME, downloaded: !1, elapsed: 0 }),
                l.length &&
                  d.push({ type: i.ALTERNATE, downloaded: !1, elapsed: 0 })),
            a && t.presentation !== r.STACKED.NAME)
          ) {
            for (n = 0; n < d.length; n++)
              d[n].type !== i.READY &&
                d[n].type !== i.FIRST_FRAME &&
                c.push({ type: d[n].type + "t", downloaded: !1, elapsed: 0 });
            for (n = 0; n < h.length; n++)
              d[n].type !== i.READY &&
                d[n].type !== i.FIRST_FRAME &&
                u.push({ type: h[n].type + "t", downloaded: !1, elapsed: 0 });
          }
          return (
            (d = d.concat(c)),
            (h = h.concat(u)),
            {
              contentToLoad: d,
              contentToUpdate: h,
              downloaded: !1,
              elapsed: 0,
              totalFrames: s,
            }
          );
        }
        var n = { getContent: t, getContentTypes: e },
          i = {
            FIRST_FRAME: "f",
            READY: "r",
            FRAME: "t",
            ALTERNATE: "ac",
            FRAME_THUMB: "tt",
            ALTERNATE_THUMB: "act",
          };
        window.cylindo.addModule("cylindo.helpers.content.to.load", n);
      }.call(this),
      function () {
        function e(e, n, i) {
          function o(t) {
            var n = m,
              i = p;
            return (m = p = void 0), (y = t), (g = e.apply(i, n));
          }
          function r(e) {
            return (y = e), (v = setTimeout(l, n)), A ? o(e) : g;
          }
          function s(e) {
            var t = e - E,
              i = e - y,
              o = n - t;
            return T ? Math.min(o, f - i) : o;
          }
          function a(e) {
            var t = e - E,
              i = e - y;
            return void 0 === E || t >= n || t < 0 || (T && i >= f);
          }
          function l() {
            var e = Date.now();
            return a(e) ? d(e) : void (v = setTimeout(l, s(e)));
          }
          function d(e) {
            return (v = void 0), R && m ? o(e) : ((m = p = void 0), g);
          }
          function c() {
            void 0 !== v && clearTimeout(v), (y = 0), (m = E = p = v = void 0);
          }
          function u() {
            return void 0 === v ? g : d(Date.now());
          }
          function h() {
            var e = Date.now(),
              t = a(e);
            if (((m = arguments), (p = this), (E = e), t)) {
              if (void 0 === v) return r(E);
              if (T) return (v = setTimeout(l, n)), o(E);
            }
            return void 0 === v && (v = setTimeout(l, n)), g;
          }
          var m,
            p,
            f,
            g,
            v,
            E,
            y = 0,
            A = !1,
            T = !1,
            R = !0;
          return (
            t(i) &&
              ((A = !!i.leading),
              (T = "maxWait" in i),
              (f = T ? Math.max(i.maxWait || 0, n) : f),
              (R = "trailing" in i ? !!i.trailing : R)),
            (h.cancel = c),
            (h.flush = u),
            h
          );
        }
        function t(e) {
          var t = "undefined" == typeof e ? "undefined" : _typeof(e);
          return null !== e && ("object" == t || "function" == t);
        }
        function n(n, i, o) {
          var r = !0,
            s = !0;
          return (
            t(o) &&
              ((r = "leading" in o ? !!o.leading : r),
              (s = "trailing" in o ? !!o.trailing : s)),
            e(n, i, { leading: r, maxWait: i, trailing: s })
          );
        }
        var i = "cylindo.core.util",
          o = window.cylindo.getModule(i) || {};
        (o.debounce_throttle = { debounce: e, throttle: n }),
          window.cylindo.addModule(i, o);
      }.call(this),
      function () {
        var e = function () {
            function e(e, t, n, i, o, r, s) {
              var a,
                l = new Date().getTime();
              e &&
                ((a = setInterval(function () {
                  var d = Math.min(1, (new Date().getTime() - l) / r);
                  s
                    ? (e[t] = i + d * (o - i) + n)
                    : (e.style[t] = i + d * (o - i) + n),
                    d >= 1 && clearInterval(a);
                }, 17)),
                s ? (e[t] = i + n) : (e.style[t] = i + n));
            }
            function t(t) {
              var n = f(t).top,
                i =
                  window.pageYOffset ||
                  document.documentElement.scrollTop ||
                  document.body.scrollTop ||
                  0;
              e(
                document.documentElement || document.scrollingElement,
                "scrollTop",
                "",
                i,
                n,
                1e3,
                !0
              );
            }
            function n(e) {
              var t,
                n = 0;
              if (e instanceof Array)
                for (t = e.length, n; n < t; n++)
                  if ("undefined" != typeof document.body.style[e[n]])
                    return e[n];
              return null;
            }
            function i(e) {
              var t;
              for (t = 0; t < E.currentAnimations.length; t++)
                if (
                  E.currentAnimations[t].element === e.element &&
                  E.currentAnimations[t].id !== e.id
                )
                  return E.currentAnimations[t];
              return !1;
            }
            function o(e) {
              clearInterval(e.ticker),
                e.callbacks &&
                  e.callbacks instanceof Array &&
                  e.callbacks.forEach(function (e) {
                    y.object.isFunction(e) && e();
                  }),
                r(e);
            }
            function r(e) {
              E.currentAnimations.indexOf(e) !== -1 &&
                E.currentAnimations.splice(E.currentAnimations.indexOf(e), 1);
            }
            function s(e, t, n, i, r) {
              return (e && e.type === n) || 0 === i
                ? (e && o(e), !0)
                : e && e.type === t
                ? (r && e.callbacks.push(r), !1)
                : void 0;
            }
            function a(e, t, n) {
              var a,
                l,
                d,
                c = 0.1,
                u = t && t > 0 ? t / 100 : 10,
                h = n && "function" == typeof n ? [n] : [],
                m = E.animationId++,
                p = {
                  id: m,
                  element: e,
                  type: E.animations.FADEIN,
                  callbacks: h,
                };
              if (e) {
                if ((E.currentAnimations.push(p), (l = i(p)), l || 0 === t)) {
                  if (
                    ((d = s(
                      l,
                      E.animations.FADEIN,
                      E.animations.FADEOUT,
                      t,
                      n
                    )),
                    !d)
                  )
                    return void r(p);
                  if (0 === t)
                    return (
                      r(p),
                      (e.style.opacity = 1),
                      (e.style.display = "block"),
                      (e.style.filter = "alpha(opacity=100)"),
                      void (n && y.object.isFunction() && n())
                    );
                }
                (e.style.opacity = 0),
                  (e.style.filter = "alpha(opacity=0)"),
                  (e.style.display = "block"),
                  (a = setInterval(function () {
                    (c >= 1 || "none" === e.style.display) &&
                      ((e.style.opacity = ""), (e.style.filter = ""), o(p)),
                      (e.style.opacity = c),
                      (e.style.filter = "alpha(opacity=" + 100 * c + ")"),
                      (c += 0.1 * c);
                  }, u)),
                  (p.ticker = a);
              }
            }
            function l(e, t, n) {
              var a,
                l,
                d,
                c = 1,
                u = t && t > 0 ? t / 100 : 8,
                h = n && "function" == typeof n ? [n] : [],
                m = E.animationId++,
                p = {
                  id: m,
                  element: e,
                  type: E.animations.FADEOUT,
                  callbacks: h,
                };
              if (e) {
                if ((E.currentAnimations.push(p), (l = i(p)), l || 0 === t)) {
                  if (
                    ((d = s(
                      l,
                      E.animations.FADEOUT,
                      E.animations.FADEIN,
                      t,
                      n
                    )),
                    !d)
                  )
                    return void r(p);
                  if (0 === t)
                    return (
                      r(p),
                      (e.style.opacity = 0),
                      (e.style.display = "none"),
                      (e.style.filter = "alpha(opacity=0)"),
                      void (n && y.object.isFunction(n) && n())
                    );
                }
                (a = setInterval(function () {
                  c <= 0.1 && ((e.style.display = "none"), o(p)),
                    (e.style.opacity = c),
                    (e.style.filter = "alpha(opacity=" + 100 * c + ")"),
                    (c -= 0.1 * c);
                }, u)),
                  (p.ticker = a);
              }
            }
            function d(e, t) {
              t.nextSibling
                ? t.parentNode.insertBefore(e, t.nextSibling)
                : t.parentNode.appendChild(e);
            }
            function c(e, t) {
              t.parentNode.insertBefore(e, t);
            }
            function u(e, t) {
              var n = [],
                i = e.parentNode.firstChild;
              if (e) {
                for (; i; i = i.nextSibling)
                  1 === i.nodeType && i !== e && n.push(i);
                return "string" == typeof t && t.length
                  ? n.filter(function (e) {
                      return e.id === t || e.classList.contains(t);
                    })
                  : n;
              }
            }
            function h(e) {
              function t(e) {
                null !== e.parentNode && e.parentNode.removeChild(e);
              }
              e &&
                (e instanceof Array
                  ? e.forEach(function (e) {
                      t(e);
                    })
                  : t(e));
            }
            function m(e, t) {
              if (e) return Array.prototype.slice.call(e.querySelectorAll(t));
            }
            function p(e) {
              return e.getBoundingClientRect();
            }
            function f(e) {
              var t = e.getBoundingClientRect(),
                n = e.ownerDocument.defaultView;
              return {
                top: t.top + n.pageYOffset,
                left: t.left + n.pageXOffset,
              };
            }
            function g(e) {
              var t,
                n,
                i,
                o = { top: 0, left: 0 };
              if (e) {
                if ("fixed" === e.style.position) n = e.getBoundingClientRect();
                else {
                  for (
                    n = f(e),
                      i = e.ownerDocument,
                      t = e.offsetParent || i.documentElement;
                    t &&
                    (t === i.body || t === i.documentElement) &&
                    "static" === t.style.position;

                  )
                    t = t.parentNode;
                  t &&
                    t !== e &&
                    1 === t.nodeType &&
                    ((o = f(t)),
                    (o.top += t.style.borderTopWidth),
                    (o.left += t.style.borderLeftWidth));
                }
                return {
                  top: n.top - o.top - e.style.marginTop,
                  left: n.left - o.left - e.style.marginLeft,
                };
              }
            }
            function v(e) {
              var t,
                n,
                i = "height",
                o = e && e.getClientRects ? e.getClientRects().length : null,
                r = e ? e.getBoundingClientRect() : null,
                s = r ? r.height : null,
                a = {
                  position: "absolute",
                  visibility: "hidden",
                  display: "block",
                },
                l = !1;
              return (
                0 === s &&
                  ((r.width && (null === o || o)) ||
                    ((l = !0),
                    (n = {
                      position: e.style.position,
                      visibility: e.style.visibility,
                      display: e.style.display,
                    }),
                    (e.style.position = a.position),
                    (e.style.visibility = a.visibility),
                    (e.style.display = a.display)),
                  (t =
                    e && window && window.getComputedStyle
                      ? window.getComputedStyle(e)
                      : null),
                  (s = t && t[i] ? parseFloat(t[i]) : 0),
                  (s = isNaN(s) ? 0 : s),
                  l &&
                    ((e.style.position = n.position),
                    (e.style.visibility = n.visibility),
                    (e.style.display = n.display))),
                s
              );
            }
            var E = this,
              y = cylindo.getModule("cylindo.core.util");
            (this.getRect = p),
              (this.position = g),
              (this.offset = f),
              (this.siblings = u),
              (this.remove = h),
              (this.insertAfter = d),
              (this.insertBefore = c),
              (this.querySelectorAll = m),
              (this.getSupportedPropertyName = n),
              (this.fadeIn = a),
              (this.fadeOut = l),
              (this.scrollTo = t),
              (this.currentAnimations = []),
              (this.animations = { FADEIN: "fadeIn", FADEOUT: "fadeOut" }),
              (this.animationId = 0),
              (this.height = v);
          },
          t = {
            create: function () {
              return new e();
            },
          };
        window.cylindo.addModule("cylindo.dom", t);
      }.call(this),
      function () {
        function e(e, t, n, i) {
          return (n * e) / i + t;
        }
        function t(e, t, n, i) {
          return (e /= i), n * e * e + t;
        }
        function n(e, t, n, i) {
          return (e /= i), -n * e * (e - 2) + t;
        }
        function i(e, t, n, i) {
          return (
            (e /= i / 2),
            e < 1
              ? (n / 2) * e * e + t
              : (e--, (-n / 2) * (e * (e - 2) - 1) + t)
          );
        }
        var o = {
          linearTween: e,
          easeInQuad: t,
          easeOutQuad: n,
          easeInOutQuad: i,
        };
        window.cylindo.addModule("cylindo.helpers.easing", o);
      }.call(this),
      function () {
        function e() {
          var e = n(this.model, this.config),
            i = this.img,
            o = this.li,
            r = this.imageStatus,
            s = e.logger,
            a = e.fallbackImage,
            l = e.defaultFallbackImage,
            d = e.BUSAPIImage,
            c = d && d.length,
            u = "";
          return (
            c && this.useBUSAPI === !1 && (c = this.useBUSAPI),
            (u = a !== l ? a : d && c ? d : l)
              ? ((i.src = u),
                (i.onerror = t.bind({
                  fallbackImage: a,
                  defaultFallbackImage: l,
                  BUSAPIImage: d,
                  logger: s,
                  img: i,
                  useBUSAPI: this.useBUSAPI,
                })),
                o && o.classList && o.classList.add("cylindo-img-not-found"),
                void (
                  r &&
                  "object" ===
                    ("undefined" == typeof r ? "undefined" : _typeof(r)) &&
                  (r.notFound = !0)
                ))
              : void s.error(
                  "Valid image must be provided as fallback image.",
                  u
                )
          );
        }
        function t() {
          function e(e) {
            (e.src = t), (e.onerror = null);
          }
          var t = this.defaultFallbackImage,
            n = decodeURIComponent(this.fallbackImage),
            i = decodeURIComponent(this.BUSAPIImage),
            o = i && i.length,
            r = this.logger,
            s = this.errorText || "Fallback image not found: ",
            a = this.img,
            l = decodeURIComponent(a.src);
          o && this.useBUSAPI === !1 && (o = this.useBUSAPI);
          try {
            r.error(s + l);
          } catch (d) {
            console.log(s + l);
          }
          l === n && n !== t
            ? o
              ? (a.src = i)
              : e(a)
            : l === i
            ? e(a)
            : l === t && (a.onerror = null);
        }
        function n(e, t) {
          var n = cylindo.getModule("cylindo.core.network"),
            i = {
              fallbackImage: null,
              defaultFallbackImage: null,
              BUSAPIImage: null,
              logger: null,
            };
          return (
            e
              ? ((i.fallbackImage = e.get("fallbackImage")),
                (i.defaultFallbackImage = e.get("defaultFallbackImage")),
                (i.BUSAPIImage = e.get("BUSAPIImage")),
                (i.logger = e.getLogger()))
              : t &&
                ((i.fallbackImage = n.resolveProtocol(t.fallbackImage)),
                (i.defaultFallbackImage = n.resolveProtocol(
                  t.defaultFallbackImage
                )),
                (i.BUSAPIImage = n.resolveProtocol(t.BUSAPIImage)),
                (i.logger = null)),
            i
          );
        }
        var i = "cylindo.core.util",
          o = window.cylindo.getModule(i) || {};
        (o.fallback = { loadFallbackImage: e, fallbackFail: t }),
          window.cylindo.addModule(i, o);
      }.call(this),
      function () {
        var e = function () {
            function e(e) {
              var t = null;
              return (
                e.every(function (e) {
                  return (
                    ("undefined" == typeof document[e] &&
                      "undefined" == typeof document.body[e]) ||
                    ("onmsfullscreenchange" === e &&
                      "Internet Explorer" === util.browser.browser.name &&
                      "11.0" === util.browser.browser.version &&
                      (e = "MSFullscreenChange"),
                    (t = e),
                    !1)
                  );
                }),
                t
              );
            }
            function t() {
              (n.request = e(i.request)),
                (n.exit = e(i.exit)),
                (n.change = e(i.change)),
                (n.element = e(i.element));
            }
            var n = this,
              i = {
                request: [
                  "requestFullscreen",
                  "webkitRequestFullscreen",
                  "mozRequestFullScreen",
                  "msRequestFullscreen",
                ],
                exit: [
                  "exitFullscreen",
                  "webkitExitFullscreen",
                  "mozCancelFullScreen",
                  "msExitFullscreen",
                ],
                change: [
                  "onfullscreenchange",
                  "onwebkitfullscreenchange",
                  "onmozfullscreenchange",
                  "onmsfullscreenchange",
                  "MSFullscreenChange",
                ],
                element: [
                  "fullscreenElement",
                  "webkitFullscreenElement",
                  "mozFullScreenElement",
                  "msFullscreenElement",
                ],
              };
            t();
          },
          t = {
            create: function () {
              return new e();
            },
          };
        window.cylindo.addModule("cylindo.helpers.fullscreen.map", t);
      }.call(this),
      function () {
        function e(e) {
          var t = Array.prototype.slice.call(arguments);
          return (
            t.shift(),
            function () {
              var n = Array.prototype.slice.call(arguments),
                i = t.concat(n);
              return e.apply(null, i);
            }
          );
        }
        function t(e) {
          var t = /<%([^%>]+)?%>/g;
          return function (n) {
            for (var i, o = e; (i = t.exec(o)); )
              o = o.replace(new RegExp(i[0], "g"), n[i[1].trim()] || "");
            return o;
          };
        }
        var n = { partial: e, template: t };
        window.cylindo.addModule("cylindo.helpers.function", n);
      }.call(this),
      function () {
        function e(e) {
          var n,
            i,
            o,
            r = (cylindo.getModule("cylindo.core.util"), e.importance),
            s = "Cylindo.Logger/" + r + " : ";
          try {
            switch (((o = [s].concat(e.args)), r)) {
              case t.INFO:
                i = console.info;
                break;
              case t.WARNING:
                i = console.warn;
                break;
              case t.ERROR:
                i = console.error;
                break;
              case t.EVENT:
              case t.LOG:
              default:
                i = console.log;
            }
            return (i = i || console.log), (n = i), n.apply(console, o);
          } catch (a) {
            return (
              console.error ? console.error(a) : console.log("Error: ", a),
              (n = console.log),
              n.apply(console, [s].concat(e.args))
            );
          }
        }
        function t(e) {
          var t, n;
          if (!e || !e.get) throw new Error("Invalid model instance");
          (n = parseInt(_typeof(e.get("loggerLimit")), 10)),
            (n = isNaN(n) ? 100 : n),
            (t = { loggerLimit: n }),
            (this.messageQueue = cylindo.getModule("cylindo.message.queue")),
            (this.messageQueue = this.messageQueue.create(t)),
            (this.isDebugMode = function () {
              var t = e.get("debug");
              return "boolean" == typeof t && t;
            });
        }
        (t.LOG = "log"),
          (t.INFO = "info"),
          (t.WARNING = "warning"),
          (t.ERROR = "error"),
          (t.EVENT = "event"),
          (t.prototype.log = function () {
            var n = Array.prototype.slice.call(arguments),
              i = this.storeMessage(t.LOG, n);
            this.isDebugMode() && e(i);
          }),
          (t.prototype.info = function () {
            var n = Array.prototype.slice.call(arguments),
              i = this.storeMessage(t.INFO, n);
            this.isDebugMode() && e(i);
          }),
          (t.prototype.warning = function () {
            var n = Array.prototype.slice.call(arguments),
              i = this.storeMessage(t.WARNING, n);
            this.isDebugMode() && e(i);
          }),
          (t.prototype.error = function () {
            var n = Array.prototype.slice.call(arguments),
              i = this.storeMessage(t.ERROR, n);
            this.isDebugMode() && e(i);
          }),
          (t.prototype.event = function () {
            var n = Array.prototype.slice.call(arguments),
              i = this.storeMessage(t.EVENT, n);
            this.isDebugMode() && e(i);
          }),
          (t.prototype.storeMessage = function (e, n) {
            var i = {};
            switch (((i.importance = e), (i.args = n), e)) {
              case t.LOG:
                i.bin = 1;
                break;
              case t.INFO:
                i.bin = 2;
                break;
              case t.WARNING:
                i.bin = 4;
                break;
              case t.ERROR:
                i.bin = 8;
                break;
              case t.EVENT:
                i.bin = 16;
                break;
              default:
                i.bin = 0;
            }
            return this.messageQueue.add(i), i;
          }),
          (t.prototype.getDebugInfo = function (t) {
            var n,
              i = [],
              o = 0;
            for (
              i =
                "number" == typeof t
                  ? this.messageQueue.getMessagesByImportance(t)
                  : this.messageQueue.getAllMessages(),
                o = i.length,
                n = 0;
              n < o;
              n++
            )
              e(i[n]);
          });
        var n = {
          create: function (e) {
            return new t(e);
          },
        };
        window.cylindo.addModule("cylindo.util.logger", n);
      }.call(this),
      function () {
        function e(e, t) {
          var n,
            o,
            r =
              "boolean" == typeof t.ignoreCache
                ? t.ignoreCache
                : e.defaults.ignoreCache,
            s = Date.now(),
            a = {},
            l = {},
            d = {},
            c = {
              campaign: "desktop",
              redirect_url:
                "function" == typeof t.getArRedirectUrl
                  ? encodeURIComponent(decodeURIComponent(t.getArRedirectUrl()))
                  : encodeURIComponent(window.location.href),
            },
            u = { framePath: "", thumbPath: "", zoomPath: "", arPath: "" },
            h = "",
            m = "",
            p = "",
            f = "",
            g = "",
            v =
              t && t.proxy && t.proxy.length > 0
                ? t.proxy
                : e && e && e.urls.SERVICES_BASE
                ? e.urls.SERVICES_BASE
                : "",
            E = t.fileName || t.productCode,
            y = t.format || "JPG",
            A = t.ftToBeShown instanceof Array ? t.ftToBeShown : [],
            T = A.length,
            R = [],
            b = { HTTPS: "https:", HTTP: "http:" },
            I = encodeURIComponent(t.productCode);
          if (A instanceof Array && v && v.length > 0) {
            for (v = i.resolveProtocol(v) + "/api/v2", n = 0; n < T; n += 2)
              R.push(
                encodeURIComponent(String(A[n])) +
                  ":" +
                  encodeURIComponent(String(A[n + 1]))
              );
            (o = t.hasOwnProperty("ssl")
              ? t.ssl
                ? b.HTTPS + v.replace(/^(https?:|)/, "")
                : b.HTTP + v.replace(/^(https?:|)/, "")
              : v),
              (p =
                o +
                "/" +
                t.accountID +
                "/products/" +
                I +
                "/frames/__FRAME_INDEX__/" +
                E +
                "." +
                y),
              (m =
                o + "/" + t.accountID + "/products/" + I + "/additionaldata"),
              (h =
                o + "/" + t.accountID + "/products/" + I + "/resolvefeatures"),
              (f =
                o +
                "/" +
                t.accountID +
                "/products/" +
                I +
                "/AR/__AR_FILE__.__AR_FORMAT__"),
              (g =
                o + "/" + t.accountID + "/products/" + I + "/ARQR/__AR_FILE__"),
              r &&
                ((l.directives = "ignore-cache"),
                (d.directives = "ignore-cache"),
                (c.directives = "ignore-cache"),
                (l._ = s),
                (d._ = s),
                (c._ = s)),
              t.version &&
                ((l.version = t.version),
                (d.version = t.version),
                (c.version = t.version)),
              t.backgroundColor &&
                (l.background = String(t.backgroundColor).toUpperCase()),
              t.buildNumber &&
                ((l.bn = t.buildNumber),
                (d.bn = t.buildNumber),
                (c.bn = t.buildNumber)),
              R &&
                ((l.feature = R),
                (d.feature = R),
                (c.feature = R),
                (a.feature = R)),
              t.size && (l.size = t.size),
              t.frame && (p = p.replace("__FRAME_INDEX__", t.frame)),
              t.removeEnvironmentShadow &&
                ((l.removeEnvironmentShadow = !0),
                (d.removeEnvironmentShadow = !0),
                (c.removeEnvironmentShadow = !0)),
              (u.framePath = i.addQueryString(p, l)),
              (u.additionalDataUrl = m),
              (l.size = 128),
              (u.thumbPath = i.addQueryString(p, l)),
              delete l.background,
              delete l.size,
              (l.size = 128),
              delete l.size,
              (l.crop = "(__COORDS__)"),
              (u.zoomPath = i.addQueryString(p, l)),
              (u.arPath = i.addQueryString(f, d)),
              (u.qrPath = i.addQueryString(g, c)),
              (u.resolvedFtPath = i.addQueryString(h, a));
          }
          return u;
        }
        var t = "cylindo.core.util",
          n = window.cylindo.getModule(t) || {},
          i = window.cylindo.getModule("cylindo.core.network");
        (n.picture = { getPaths: e }), window.cylindo.addModule(t, n);
      }.call(this),
      function () {
        function e() {
          var e, t, n;
          return (
            (e = new Promise(function (e, i) {
              (t = e), (n = i);
            })),
            (e.resolve = t),
            (e.reject = n),
            e
          );
        }
        var t = "cylindo.core.util",
          n = window.cylindo.getModule(t) || {};
        (n.promise = { create: e }), window.cylindo.addModule(t, n);
      }.call(this),
      function () {
        var e = function () {
            function e(e, n) {
              function i(o, r) {
                n(o, r);
                var s,
                  a = t && t[e] && t[e].length > 0 ? t[e].length : 0;
                for (s = 0; s < a; s++)
                  t[e][s] === i && (t[e].splice(s, 1), a--, s--);
              }
              return i;
            }
            var t = {};
            (this.trigger = function (e, n) {
              function i(e, t, n) {
                setTimeout(function () {
                  e(t, n);
                }, 0);
              }
              var o, r;
              if (!t[e]) return !1;
              for (r = t[e].length, o = 0; o < r; o++) i(t[e][o], e, n);
            }),
              (this.on = function (e, n) {
                return t[e] || (t[e] = []), t[e].push(n), this;
              }),
              (this.once = function (t, n) {
                var i = e(t, n);
                return this.on(t, i), this;
              }),
              (this.off = function (n, i) {
                var o,
                  r = e(n, i),
                  s = t[n] ? t[n].length : 0;
                for (o = 0; o < s; o++)
                  (t[n][o] !== i && t[n][o].toString() !== r.toString()) ||
                    (t[n].splice(o, 1), s--, o--);
                return this;
              }),
              (this.destroy = function () {
                t = {};
              });
          },
          t = {
            create: function () {
              return new e();
            },
          };
        window.cylindo.addModule("cylindo.util.pubsub", t);
      }.call(this),
      function () {
        function e(t) {
          if (!r) {
            var o = n(t, !1),
              s = i(o) ? o.body : o;
            s && s.classList && s.classList.add("cylindo-prevent-scroll"),
              a.push(s),
              o.parentNode && !i(o) ? e(o) : (r = !0);
          }
        }
        function t() {
          var e = 0,
            t = null;
          for (e = 0; e < a.length; e++)
            (t = a[e]), t.classList.remove("cylindo-prevent-scroll");
          r = !1;
        }
        function n(e, t) {
          var n,
            i = getComputedStyle(e),
            o = "absolute" === i.position,
            r = t ? /(auto|scroll|hidden)/ : /(auto|scroll)/;
          if ("fixed" === i.position) return e.ownerDocument || document;
          for (n = e; (n = n.parentElement); )
            if (
              ((i = getComputedStyle(n)),
              (!o || "static" !== i.position) &&
                n !== document.documentElement &&
                s.indexOf(n.tagName) === -1 &&
                r.test(i.overflowX) &&
                n.scrollWidth > n.clientWidth)
            )
              return n;
          return e.ownerDocument || document;
        }
        function i(e) {
          return e instanceof HTMLDocument;
        }
        var o = { preventScrollX: e, allowScrollX: t },
          r = !1,
          s = ["HTML", "BODY"],
          a = [];
        window.cylindo.addModule("cylindo.helpers.scroll", o);
      }.call(this),
      function () {
        function e(e) {
          var t,
            n,
            i,
            o = ["direct", "youtube", "vimeo"],
            r =
              /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/videoseries\/|embed\/videoseries|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/,
            s =
              /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
          for (n = e.length, t = 0; t < n; t++)
            "undefined" != typeof e[t].provider &&
              (o.indexOf(e[t].provider) !== -1
                ? "youtube" === e[t].provider
                  ? ((i = e[t].url.match(r)),
                    (e[t].videoId =
                      null !== i && i[1].length > 0 ? i[1] : null))
                  : "vimeo" === e[t].provider &&
                    ((i = e[t].url.match(s)),
                    (e[t].videoId =
                      null !== i && i[3].length > 0 ? i[3] : null))
                : (e[t].provider = "not-supported"));
          return e;
        }
        var t = { getVideoId: e };
        window.cylindo.addModule("cylindo.helpers.video", t);
      }.call(this),
      function () {
        var e = {
          CAROUSEL: { NAME: "carousel", LIST_CLASS: "cylindo-threesixty-list" },
          SINGLE: { NAME: "single", LIST_CLASS: "cylindo-threesixty-list" },
          STACKED: { NAME: "stacked", LIST_CLASS: "cylindo-threesixty-list" },
          CUSTOM: { NAME: "custom", LIST_CLASS: "cylindo-custom-list" },
          THREESIXTY: {
            NAME: "threesixty",
            LIST_CLASS: "cylindo-threesixty-list",
          },
        };
        window.cylindo.addModule("cylindo.helpers.viewer.presentations", e);
      }.call(this),
      function () {
        function e() {
          return i;
        }
        function t(t) {
          var n,
            i = cylindo.getModule("cylindo.helpers.viewer.presentations"),
            l = cylindo.getModule("cylindo.core.util"),
            d = e();
          return "string" == typeof t && t.length > 0
            ? t === i.CUSTOM.NAME
              ? l.object.extend(
                  {},
                  d,
                  {
                    FRAME: {
                      FRAME: o + s.FRAME.FRAME,
                      ZOOM: o + s.FRAME.ZOOM,
                      FULLSCREEN: o + s.FRAME.FULLSCREEN,
                      ZOOM_FULLSCREEN: o + s.FRAME.ZOOM_FULLSCREEN,
                    },
                  },
                  a
                )
              : ((n = t.charAt(0).toUpperCase() + t.substr(1)),
                (n = r.indexOf(n) !== -1 ? n : ""),
                l.object.extend(
                  {},
                  d,
                  {
                    FRAME: {
                      FRAME: n + s.FRAME.FRAME,
                      ZOOM: n + s.FRAME.ZOOM,
                      FULLSCREEN: n + s.FRAME.FULLSCREEN,
                      ZOOM_FULLSCREEN: n + s.FRAME.ZOOM_FULLSCREEN,
                    },
                  },
                  a
                ))
            : d;
        }
        var n = { getInitialStates: e, getAllPossibleStates: t },
          i = {
            GENERIC: {
              UINITIALIZED: "Unititialized",
              INITIALIZING: "Initializing",
            },
            CUSTOM: {
              FRAME: "ImageOverride",
              ZOOM: "ImageOverrideZoom",
              FULLSCREEN: "ImageOverrideFullScreen",
              ZOOM_FULLSCREEN: "ImageOverrideZoomFullScreen",
            },
            FALLBACK: { FRAME: "Fallback", FULLSCREEN: "FallbackFullScreen" },
          },
          o = "AlternateContent",
          r = ["Threesixty", "Single", "Carousel", "Stacked"],
          s = {
            FRAME: {
              FRAME: "",
              ZOOM: "Zoom",
              FULLSCREEN: "FullScreen",
              ZOOM_FULLSCREEN: "ZoomFullScreen",
            },
          },
          a = {
            ALT_CONT: {
              FRAME: "AlternateContent",
              ZOOM: "AlternateContentZoom",
              FULLSCREEN: "AlternateContentFullScreen",
              ZOOM_FULLSCREEN: "AlternateContentZoomFullScreen",
            },
          };
        window.cylindo.addModule("cylindo.helpers.viewer.states", n);
      }.call(this),
      function () {
        var e = function (e) {
          var t = cylindo.getModule("cylindo.core.util");
          (this.deferred = t.promise.create()),
            (this.id = e.id),
            (this.player = e.video),
            this.createPlayer();
        };
        (e.prototype.createPlayer = function () {
          this.deferred.resolve();
        }),
          (e.prototype.play = function () {
            this.player.play();
          }),
          (e.prototype.stop = function () {}),
          (e.prototype.pause = function () {
            this.player.pause();
          }),
          (e.prototype.destroy = function () {});
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.video.direct", t);
      }.call(this),
      function () {
        var e = function n(e) {
          var t = cylindo.getModule("cylindo.core.util");
          (this.deferred = t.promise.create()),
            (this.apiProgress = n.apiProgress),
            (this.id = e.id),
            (this.videoId = e.videoId),
            (this.APIUrl = "https://www.youtube.com/iframe_api"),
            (this.player = {}),
            this.createPlayer();
        };
        (e.prototype.createPlayer = function () {
          var e = this,
            t = function () {
              "function" == typeof window.YT.Player &&
                (e.player = new window.YT.Player(e.id, {
                  events: {
                    onError: function () {
                      e.deferred.reject();
                    },
                    onReady: function () {
                      e.deferred.resolve();
                    },
                  },
                }));
            };
          this.checkAPIStatus(t);
        }),
          (e.prototype.checkAPIStatus = function (e) {
            this.apiProgress.started ||
            this.apiProgress.finished ||
            "object" === _typeof(window.YT)
              ? (this.apiProgress.started && !this.apiProgress.finished) ||
                ("object" === _typeof(window.YT) && 0 === window.YT.loaded)
                ? this.apiProgress.fns.push(e)
                : "object" === _typeof(window.YT) && e.call()
              : (this.embedAPIScript(), this.apiProgress.fns.push(e));
          }),
          (e.prototype.embedAPIScript = function () {
            var e = document.createElement("script"),
              t = document.getElementsByTagName("script")[0];
            (e.src = this.APIUrl),
              t.parentNode.insertBefore(e, t),
              (this.apiProgress.started = !0),
              this.APIListener();
          }),
          (e.prototype.APIListener = function () {
            var e = this;
            window.onYouTubeIframeAPIReady = function () {
              e.apiProgress.finished = !0;
              var t,
                n = e.apiProgress.fns.length;
              for (t = 0; t < n; t++) e.apiProgress.fns[t].call();
              e.apiProgress.fns = [];
            };
          }),
          (e.prototype.play = function () {
            this.player.playVideo();
          }),
          (e.prototype.pause = function () {
            this.player.pauseVideo();
          }),
          (e.prototype.stop = function () {
            this.player.stopVideo();
          }),
          (e.prototype.destroy = function () {
            this.player.destroy();
          });
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        (e.apiProgress = { started: !1, finished: !1, fns: [] }),
          window.cylindo.addModule("cylindo.video.youtube", t);
      }.call(this),
      function () {
        var e = function n(e) {
          var t = cylindo.getModule("cylindo.core.util");
          (this.deferred = t.promise.create()),
            (this.apiProgress = n.apiProgress),
            (this.id = e.id),
            (this.videoId = e.videoId),
            (this.APIUrl = "https://player.vimeo.com/api/player.js"),
            (this.player = {}),
            this.createVideo();
        };
        (e.prototype.createVideo = function () {
          var e = this,
            t = function () {
              "function" == typeof window.Vimeo.Player &&
                ((e.player = new window.Vimeo.Player(e.id)),
                e.deferred.resolve());
            };
          this.checkAPIStatus(t);
        }),
          (e.prototype.checkAPIStatus = function (e) {
            this.apiProgress.started ||
            this.apiProgress.finished ||
            "object" === _typeof(window.Vimeo)
              ? this.apiProgress.started &&
                !this.apiProgress.finished &&
                "object" !== _typeof(window.Vimeo)
                ? this.apiProgress.fns.push(e)
                : "object" === _typeof(window.Vimeo) && e.call()
              : (this.embedAPIScript(), this.apiProgress.fns.push(e));
          }),
          (e.prototype.embedAPIScript = function () {
            var e = this,
              t = document.createElement("script"),
              n = document.getElementsByTagName("script")[0];
            (t.src = this.APIUrl),
              t.readyState
                ? (t.onreadystatechange = function () {
                    ("loaded" !== t.readyState &&
                      "complete" !== t.readyState) ||
                      ((t.onreadystatechange = null), e.APIListener());
                  })
                : (t.onload = function () {
                    e.APIListener();
                  }),
              n.parentNode.insertBefore(t, n),
              (this.apiProgress.started = !0);
          }),
          (e.prototype.APIListener = function () {
            this.apiProgress.finished = !0;
            var e,
              t = this.apiProgress.fns.length;
            for (e = 0; e < t; e++) this.apiProgress.fns[e].call();
            this.apiProgress.fns = [];
          }),
          (e.prototype.play = function () {
            this.player
              .play()
              .then(function () {})
              ["catch"](function (e) {});
          }),
          (e.prototype.pause = function () {
            this.player
              .pause()
              .then(function () {})
              ["catch"](function (e) {});
          }),
          (e.prototype.stop = function () {}),
          (e.prototype.destroy = function () {});
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        (e.apiProgress = { started: !1, finished: !1, fns: [] }),
          window.cylindo.addModule("cylindo.video.vimeo", t);
      }.call(this),
      function () {
        var e = function (e) {
            function t() {
              var e = {};
              "direct" === s.provider
                ? ((e = { id: s.id, video: s.video }),
                  (s.player = s.direct.create(e)))
                : "youtube" === s.provider
                ? ((e = { id: s.id, videoId: s.videoId }),
                  (s.player = s.youtube.create(e)))
                : "vimeo" === s.provider &&
                  ((e = { id: s.id, videoId: s.videoId }),
                  (s.player = s.vimeo.create(e))),
                Promise.all([s.player.deferred]).then(function () {
                  s.viewer.on(s.viewer.events.ALT_CONTENT_LOADED, n),
                    s.viewer.on(s.viewer.events.FRAME_ACTIVATED, n),
                    s.viewer.on(s.viewer.events.ALT_CONTENT_REMOVED, i),
                    s.deferred.resolve(),
                    s.li.classList.contains("active") &&
                      s.autoplay &&
                      !a.browser.isMobile() &&
                      o();
                });
            }
            function n() {
              null !== s.li &&
                (s.li.classList.contains("active") &&
                s.autoplay &&
                !a.browser.isMobile()
                  ? o()
                  : r());
            }
            function i() {
              s.viewer.off(s.viewer.events.FRAME_ACTIVATED, n),
                s.viewer.off(s.viewer.events.ALT_CONTENT_REMOVED, i),
                s.player.destroy(),
                (s.provider = null),
                (s.id = null),
                (s.videoId = null),
                (s.provider = null),
                (s.li = null);
            }
            function o() {
              try {
                s.player.play();
              } catch (e) {
                s.logger && s.logger.error("Cannot not play the video", e);
              }
            }
            function r() {
              try {
                s.player.pause();
              } catch (e) {
                s.logger && s.logger.error("Cannot not pause the video", e);
              }
            }
            var s = this,
              a = cylindo.getModule("cylindo.core.util");
            (this.deferred = e.deferred),
              (this.id = e.id),
              (this.videoId = e.videoId ? e.videoId : null),
              (this.provider = e.provider),
              (this.li = e.li),
              (this.player = {}),
              (this.autoplay = !!e.autoplay && e.autoplay),
              (this.viewer = e.viewer),
              (this.logger =
                this.viewer && this.viewer.model
                  ? this.viewer.model.getLogger()
                  : null),
              (this.viewerId = e.viewer.id),
              (this.video = e.video),
              (this.youtube = cylindo.getModule("cylindo.video.youtube")),
              (this.vimeo = cylindo.getModule("cylindo.video.vimeo")),
              (this.direct = cylindo.getModule("cylindo.video.direct")),
              t();
          },
          t = {
            create: function (t) {
              return new e(t);
            },
          };
        window.cylindo.addModule("cylindo.video", t);
      }.call(this),
      function () {
        var e = function (e) {
          e = e || {};
          var t = "boolean" != typeof e.appendButton || e.appendButton,
            n = e.linkButton,
            i = cylindo.getModule("cylindo.core.util"),
            o = e.dom;
          (this.appendButton = t),
            (this.linkButton = n),
            (this.util = i),
            (this.dom = o),
            (this.text = e.text || ""),
            (this.btn = null),
            (this.parentEl =
              e.parent || document.getElementsByTagName("body")[0]),
            (this.initialized = !0),
            (this.el = document.createElement("div")),
            (this.btn = this.linkButton
              ? document.createElement("a")
              : document.createElement("button"));
        };
        (e.prototype.render = function (e) {
          var t = this;
          t.wrapperClasses &&
            t.wrapperClasses instanceof Array &&
            t.wrapperClasses.forEach(function (e) {
              t.el.classList.add(e);
            }),
            t.parentEl.appendChild(t.el),
            t.appendButton && t.el.appendChild(t.btn);
        }),
          (e.prototype.remove = function () {
            var e = this;
            e.dom.remove(e.el);
          }),
          (e.prototype.show = function (e, t) {
            var n = this;
            t ? n.dom.fadeIn(n.el, 0) : n.dom.fadeIn(n.el);
          }),
          (e.prototype.hide = function (e) {
            var t = this;
            e ? t.dom.fadeOut(t.el, 0) : t.dom.fadeOut(t.el);
          }),
          (e.prototype.setParent = function (e) {
            var t = this;
            t.parentEl = e;
          }),
          (e.prototype.isVisible = function () {
            var e = this;
            return "block" === e.el.style.display;
          }),
          window.cylindo.addModule("cylindo.classes.button", e);
      }.call(this),
      function () {
        var e = function () {
            var e = cylindo.getModule("cylindo.core.network"),
              t = cylindo.getModule("cylindo.core.config"),
              n = cylindo.getModule("cylindo.core.util"),
              i = {
                defaults: t.get("defaults"),
                urls: t.get("urls"),
                metadata: t.get("metadata"),
              };
            (this.getUrlV2 = function (e, t, o, r, s, a, l, d, c, u) {
              var h, m;
              return i && n
                ? ((h = {
                    accountID: e,
                    productCode: t,
                    frame: o,
                    size: r,
                    ftToBeShown: s,
                    ssl: d || !1,
                    ignoreCache: u,
                    version: c,
                    removeEnvironmentShadow: a,
                    proxy: l,
                  }),
                  (m = n.picture.getPaths(i, h)),
                  m && "string" == typeof m.framePath && m.framePath.length > 0
                    ? m.framePath
                    : (console.log(
                        "Cylindo msg: CAPI module could not create the image."
                      ),
                      null))
                : (console.log("Cylindo msg: no settings module."), null);
            }),
              (this.getUrl = function (t, n, o, r, s, a, l, d, c, u, h) {
                function m(e) {
                  t && "function" == typeof t
                    ? t(e, null)
                    : console.error(
                        "Callback sent to CAPI module is null or not a function."
                      );
                }
                function p(e) {
                  console.log("could not get image from CAPI"),
                    t && "function" == typeof t
                      ? t(null, e)
                      : console.error(
                          "Callback sent to CAPI module is null or not a function."
                        );
                }
                try {
                  console.warn(
                    "Cylindo: The getUrl method has been deprecated. Please use the Content API directly."
                  );
                } catch (f) {
                  console.log(
                    "Cylindo: The getUrl method has been deprecated. Please use the Content API directly."
                  );
                }
                if (
                  ((h = "boolean" == typeof h ? h : i.defaults.ignoreCache), i)
                ) {
                  var g = i.urls,
                    v = (i.metadata, null),
                    E = {
                      accountid: n,
                      sku: o,
                      frame: r,
                      size: s,
                      country: a,
                      features: l,
                      ssl: d ? 1 : 0,
                      "x-service-version": "3.1",
                    };
                  if (
                    (u && (E.skuVersion = u),
                    c && (E.viewerType = c),
                    h && ((E._ = Date.now()), (E.directives = "IGNORE-CACHE")),
                    (v = { type: "GET", data: E }),
                    e)
                  ) {
                    var y = g.OLD_SERVICES_GET_IMAGE_URL;
                    (y = e.resolveProtocol(y)), e.doRequest(y, m, v, p);
                  } else console.log("no network module");
                } else console.log("no settings module");
              }),
              (this.getImage = function (t, n, o, r) {
                function s(e) {
                  if (n)
                    if (null !== e) {
                      var t = window.URL || window.webkitURL;
                      n(t.createObjectURL(e, null));
                    } else n(null, "Image data does not exist.");
                }
                function a(e) {
                  n &&
                    (429 == e.status
                      ? n(null, "Request was throttled")
                      : 401 == e.status
                      ? n(
                          null,
                          "Unauthrorized... Have you remembered the autorization header?"
                        )
                      : n(null, "xhr"));
                }
                try {
                  console.warn(
                    "Cylindo: The getImage method has been deprecated. Please use the Content API directly."
                  );
                } catch (l) {
                  console.log(
                    "Cylindo: The getImage method has been deprecated. Please use the Content API directly."
                  );
                }
                (r = "boolean" == typeof r ? r : i.defaults.ignoreCache),
                  e
                    ? e.requestImage(t, s, a, r, o)
                    : console.log("No network module found in CAPI module.");
              });
          },
          t = new e();
        window.cylindo.addModule("cylindo.classes.capi", t);
      }.call(this),
      function () {
        var e = function () {
          function e(e) {
            (A = e),
              (T = A.getLogger()),
              (y.reordered = !1),
              (y.getAllFramesToBeLoaded = u),
              (y.shouldDownloadAll360Frames = h),
              (y.validateOrder = t),
              (y.getStartFrame = r),
              (y.prepareToReorder = p),
              (y.cleanCache = g),
              (y.propsToValidateOrder = [
                "alternateContent",
                "thumbCount",
                "thumbAngles",
              ]),
              (E = A.get("framesSetOnInit")),
              (y.initialized = !0);
          }
          function t(e, t) {
            function r() {
              return m(), N === b.SINGLE.NAME && M > 0;
            }
            function d() {
              var e,
                t = !1;
              if (0 === M)
                if (N === b.THREESIXTY.NAME || N === b.SINGLE.NAME) t = !0;
                else if (N === b.STACKED.NAME || N === b.CAROUSEL.NAME)
                  if (F && F.length > 0) {
                    for (e = 0; e < F.length; e++)
                      if (!s(F[e])) {
                        t = !0;
                        break;
                      }
                  } else t = !0;
              return t;
            }
            var u,
              h,
              p,
              f,
              v,
              I,
              w =
                A.get("alternateContent") instanceof Array
                  ? A.get("alternateContent")
                  : [],
              C = w.length,
              S = A.get("currentFeatures") ? A.get("frameCount") : 0,
              M = 0,
              x = A.get("thumbCount"),
              F = A.get("frames"),
              P = null,
              k = A.get("thumbAngles"),
              U = 0,
              B = A.get("startFrame"),
              G = !1,
              H = !1,
              z = !1,
              V = [],
              q = {
                OBJ_WITHIN_FRAMES:
                  "Alternate content objects order defined within frames array.",
                ALT_CONTENT_IGNORED:
                  "When the alternate images/videos are declared within frames array, the alternateContent value will be ignored.",
                ALT_CONTENT_REPLACED:
                  "alternateContent value will be modified because the frames order does not correspond with the alternateContent array provided.",
                ALT_ID_WITHIN_FRAMES:
                  "Alternate content indexes order defined within frames array.",
                WRONG_ALT_INDEX:
                  "Some alternate indexes don't exist within alternateContent array. Please check that alternateContent is an array and verify if the index inside the alternateContent array is a valid object.",
                WRONG_OBJECT:
                  "Object removed from frames array because is not a valid Alternate Content object.",
                MIXED_CONTENT:
                  "Alternate content indexes defined inside frames array will be ignored when frames array also contains alternate content objects.",
                FRAMES_PRIORITY:
                  "When frames property is set in the configuration object it has priority over thumbCount and thumbAngles properties.",
                ALT_UNSORTED:
                  "Some alternate indexes where not sorted inside the frames array. These alternate images will not be displayed.",
                INVALID_ANGLE:
                  "The angle you provided within frames array is invalid, so that frame will not be displayed.",
                REMOVING_WRONG_INDEX:
                  "Wrong index removed from the frames array.",
                ALT_NEW_ORDER_IGNORED:
                  "The desired order for alternate content  will be ignored because wrong indexes were provided in the configuration. In case alternate content exists will be displayed at the end of the thumbnails bar",
                CANNOT_ADD_FRAME:
                  "This frame could not be added. If this is a single viewer and you already defined a 360 frame to be displayed all the other 360 frames will be ignored. Otherwise if this is a custom viewer all the 360 frames will be ignored.",
                FORCE_360_FRAME:
                  "Frames array should contain at least one 360 frame. The first frame of the requested product will be included into the frames array.",
              },
              Y = 0,
              X = !1,
              Z = !0,
              W = !1,
              j = !1;
            if ((m(), (v = o(C)), F instanceof Array && F.length > 0 && E)) {
              for (
                (parseInt(x, 10) !== F.length || (k && k.length)) &&
                  T.log(q.FRAMES_PRIORITY),
                  U = 0;
                U < F.length;
                U++
              ) {
                if (((P = F[U]), R.object.isPlainObject(P))) {
                  if (n(P)) {
                    if (!H) {
                      if (z)
                        for (I = 0; I < U; I++)
                          s(F[I]) &&
                            (T.error(q.MIXED_CONTENT),
                            T.error(q.REMOVING_WRONG_INDEX, F[I]),
                            F.splice(I, 1),
                            U--,
                            I--);
                      (V = []),
                        T.log(q.OBJ_WITHIN_FRAMES, F),
                        (H = !0),
                        C && T.warning(q.ALT_CONTENT_IGNORED, w);
                    }
                    V.push(P), (F[U] = _.ALT + (V.length - 1));
                    continue;
                  }
                  T.error(q.WRONG_OBJECT, P), (W = !0);
                } else
                  a(P)
                    ? r() || i()
                      ? (T.error(q.CANNOT_ADD_FRAME, P), (W = !0))
                      : ((h = L.degreesToIndexes([P.replace(/deg/g, "")], S)),
                        1 === h.length
                          ? ((F[U] = P = h[0]),
                            null === D && (D = P),
                            (O = P),
                            M++)
                          : (T.log(q.INVALID_ANGLE, P), (W = !0)))
                    : s(P)
                    ? (z || (T.log(q.ALT_ID_WITHIN_FRAMES, F), (z = !0)),
                      H
                        ? ((W = !0), T.error(q.MIXED_CONTENT))
                        : ((p = parseInt(P.replace(/alt-/g, ""), 10)),
                          (f = w[p]),
                          R.object.isPlainObject(f) && n(f)
                            ? (V.push(f),
                              (F[U] = P = _.ALT + (V.length - 1)),
                              v.splice(p, 1))
                            : ((W = !0), T.error(q.WRONG_ALT_INDEX, P)),
                          Y !== p && (X = !0),
                          Y++))
                    : c(P)
                    ? r() || i()
                      ? (T.error(q.CANNOT_ADD_FRAME, P), (W = !0))
                      : (l(P) && (F[U] = P = parseInt(P, 10)),
                        null === D && (D = P),
                        (O = P),
                        M++)
                    : (W = !0);
                W &&
                  (T.error(q.REMOVING_WRONG_INDEX, P),
                  F.splice(U, 1),
                  U--,
                  (W = !1));
              }
              if (H) j = !0;
              else if (z)
                if (V.length) {
                  if (v.length > 0) {
                    for (U = 0; U < v.length; U++)
                      T.error(q.ALT_UNSORTED, _.ALT + v[U]);
                    X = !0;
                  }
                  X && (T.warning(q.ALT_CONTENT_REPLACED, V), (j = !0));
                } else T.error(q.ALT_NEW_ORDER_IGNORED, F), (G = !0);
              else C && (G = !0);
            } else if (((F = []), (G = !0), A.get("cylindoContent") === !0)) {
              if (k && k.length)
                (F = L.degreesToIndexes(k, A.get("frameCount"))),
                  (M = F.length);
              else if (N === b.THREESIXTY.NAME || N === b.CAROUSEL.NAME)
                for (
                  M = x > S ? 5 : x, u = Math.floor(S / M), U = 0;
                  U < M;
                  U++
                )
                  F[U] = U * u + 1;
              else N === b.SINGLE.NAME && ((M = 1), (F = [B]));
              N === b.CAROUSEL.NAME || N === b.STACKED.NAME
                ? ((D = 1),
                  (O = A.get("frameCount")),
                  (F = F && 0 !== F.length ? F : [D]),
                  (M = F.length))
                : (D = B);
            }
            if (G && C) for (U = 0; U < C; U++) F.push(_.ALT + U);
            d() &&
              (F.unshift(1),
              (D = 1),
              (O = 1),
              (M = 1),
              T.error(q.FORCE_360_FRAME, F)),
              j && A.set("alternateContent", V, Z),
              A.set("frames", F, Z),
              A.set("thumbCount", M, Z),
              A.set("thumbAngles", null, Z),
              c(D) && A.set("startFrame", D, Z),
              e &&
                t &&
                e === A.events.CHANGED &&
                ("alternateContent" === t.prop
                  ? y.trigger(y.events.RELOAD_ALT_CONTENT, t)
                  : ("thumbCount" !== t.prop && "thumbAngles" !== t.prop) ||
                    y.trigger(y.events.RELOAD_THUMBNAILS, t)),
              (y.reordered = !0),
              g();
          }
          function n(e) {
            var t = ["direct", "youtube", "vimeo"];
            return (
              e && (e.image || (e.provider && t.indexOf(e.provider) !== -1))
            );
          }
          function i() {
            return m(), N === b.CUSTOM.NAME;
          }
          function o(e) {
            var t,
              n = [];
            for (t = 0; t < e; t++) n.push(t);
            return n;
          }
          function r() {
            startFrame = A && A.get("startFrame") ? A.get("startFrame") : 1;
          }
          function s(e) {
            return l(e) && e.indexOf(_.ALT) !== -1;
          }
          function a(e) {
            return l(e) && e.indexOf(_.DEG) !== -1;
          }
          function l(e) {
            return "string" == typeof e;
          }
          function d(e) {
            return "number" == typeof e && !isNaN(e);
          }
          function c(e) {
            var t = C ? C.frameCount : 0,
              n = A ? (A.get("currentFeatures") ? A.get("frameCount") : 0) : t;
            return l(e) && (e = parseInt(e, 10)), d(e) && e > 0 && e <= n;
          }
          function u() {
            var e, t, n, i, o, r, s, a, l, d, c, u;
            return (
              M ||
                ((e = A.get("thumbs") === !0),
                (t = A.get("cylindoContent")),
                (n =
                  A.get("alternateContent") instanceof Array
                    ? A.get("alternateContent")
                    : []),
                (i = n.length),
                (o = t && A.get("currentFeatures") ? A.get("frameCount") : 0),
                (r = A.get("frames") instanceof Array ? A.get("frames") : []),
                (s = r.length),
                (a = t ? o : 0),
                (l = e ? r : []),
                (d = l.length),
                (c = A.get("thumbCount")),
                (u = e ? c : 0),
                (n = I.getVideoId(n)),
                t && !h() && (a = c),
                (M = {
                  ALTERNATE: { LIST: n, LEN: i },
                  THREESIXTY: {
                    TO_BE_LOADED: a,
                    LEN: o,
                    FRAMES: r,
                    FIRST: D,
                    LAST: O,
                  },
                  THUMB: {
                    ENABLED: e,
                    LIST: l,
                    LEN: d,
                    THREESIXTY_THUMB_LEN: u,
                  },
                  VIEWER_ORDER: { LIST: r, LEN: s },
                  ALL: { LEN: a + i + d },
                })),
              M
            );
          }
          function h() {
            var e = A.get("framesSetOnInit");
            return (
              m(),
              N === b.THREESIXTY.NAME ||
                ((N === b.CAROUSEL.NAME || N === b.STACKED.NAME) && !e)
            );
          }
          function m() {
            N = A ? A.get("presentation") : null;
          }
          function p() {
            y.reordered = !1;
          }
          function f(e) {
            function t() {
              for (w = !0, _ = null, i = 0; i < f; i++) s(p[i]) || C.push(p[i]);
            }
            var i,
              o,
              r,
              l,
              d,
              h = u(),
              m = A.get("frameCount"),
              p = h.VIEWER_ORDER.LIST,
              f = h.VIEWER_ORDER.LEN,
              g = h.ALTERNATE.LIST,
              v = h.ALTERNATE.LEN,
              y = 0,
              R = !1,
              b = !1,
              I = !1,
              w = !1,
              C = [],
              _ = [],
              N = [],
              D = !1;
            if ((e instanceof Array && 0 === e.length) || null === e) t();
            else {
              if (!(e instanceof Array && e.length > 0))
                return (
                  T.error(
                    "Cannot update the alternate content with the parameter sent."
                  ),
                  !1
                );
              for (i = 0; i < f; i++) c(p[i]) && N.push(p[i]);
              for (i = 0; i < e.length; i++)
                if (
                  ((r = e[i]),
                  a(r) &&
                    ((l = L.degreesToIndexes([r.replace(/deg/g, "")], m)),
                    (r = 1 === l.length ? l[0] : null)),
                  c(r))
                ) {
                  if (N[0] !== r)
                    return (
                      T.error(
                        "The supplied frames array should have the same 360 frames that were declared on the initialization, only alt content order or elements can be modified with this function.",
                        r,
                        p
                      ),
                      !1
                    );
                  N.splice(N.indexOf(r), 1), (I = !0), d++;
                } else if (s(r)) {
                  if (p.indexOf(r) === -1)
                    return (
                      T.error(
                        "The requested index to be reordered does not exist in the current alternate content array.",
                        r
                      ),
                      !1
                    );
                  (b = !0), y++;
                } else {
                  if (!n(r))
                    return (
                      T.error(
                        "Wrong value provided into the alt content arr please provide correct values to update the alternate content.",
                        r
                      ),
                      !1
                    );
                  (R = !0), y++;
                }
              if (b && R)
                T.error(
                  "Alternate objects are used to replace the current content while indexes are used to reorder the content, so they should not be mixed."
                );
              else if (I) {
                if (N.length > 0)
                  return (
                    T.error(
                      "The supplied frames array should have the same 360 frames that were declared on the initialization, only alt content order or elements can be modified with this function."
                    ),
                    !1
                  );
                0 === y
                  ? t()
                  : R
                  ? ((E = !0), (w = !0), (C = e), (_ = []))
                  : b && ((E = !0), (w = !0), (C = e), (_ = g));
              } else {
                if (!R && !b)
                  return (
                    T.error(
                      "Something went wrong while trying to update the alt content."
                    ),
                    !1
                  );
                if (R && e.length === v) (w = !0), (C = p), (_ = e);
                else if (b && e.length === v) {
                  for (o = 0, i = 0; i < f; i++)
                    s(p[i]) ? ((C[i] = e[o]), o++) : (C[i] = p[i]);
                  (w = !0), (_ = g);
                } else {
                  for (i = 0; i < f - 1; i++)
                    if (s(p[i]) && !s(p[i + 1])) {
                      T.warning(
                        "Current alternative content was reordered when viewer was initialized. Alternative content will be placed at the end of the viewer because new content length is different than the earlier."
                      );
                      break;
                    }
                  t(), (w = !0), (C = C.concat(e)), (_ = R ? e : g);
                }
              }
            }
            for (i = 0; i < C.length - 1; i++)
              (!s(C[i]) && !n(C[i])) || s(C[i + 1]) || n(C[i + 1]) || (D = !0);
            return {
              canUpdate: w,
              frames: C,
              alternateContent: _,
              useFramesToReorder: D,
            };
          }
          function g() {
            M = null;
          }
          function v() {
            S.destroy();
          }
          var E,
            y = this,
            A = null,
            T = null,
            R = cylindo.getModule("cylindo.core.util"),
            b = cylindo.getModule("cylindo.helpers.viewer.presentations"),
            I = cylindo.getModule("cylindo.helpers.video"),
            L = cylindo.getModule("cylindo.util.angles"),
            w = cylindo.getModule("cylindo.model.values"),
            C = w ? w.getDefaults() : null,
            _ = { PREALT: "pre-alt-", ALT: "alt-", DEG: "deg" },
            N = m(),
            D = null,
            O = null,
            S = cylindo.getModule("cylindo.util.pubsub").create(),
            M = null;
          (y.on = S.on),
            (y.trigger = S.trigger),
            (y.off = S.off),
            (y.initialize = e),
            (y.prepareToUpdateAltContent = f),
            (y.isValidAltObject = n),
            (y.isAltId = s),
            (y.isDegreeIndex = a),
            (y.is360Frame = c),
            (y.prefixes = _),
            (y.angles = L),
            (y.initialized = !1),
            (y.destroy = v);
        };
        e.prototype.events = {
          RELOAD_ALT_CONTENT: "frames:handler:reload:altcontent",
        };
        var t = {
          create: function () {
            return new e();
          },
        };
        window.cylindo.addModule("cylindo.classes.frames.handler", t);
      }.call(this),
      function () {
        var e = cylindo.getModule("cylindo.helpers.function"),
          t = function (t) {
            t = t || {};
            var n = e.template("<div><% text %></div>"),
              i = cylindo.getModule("cylindo.core.util"),
              o = t.dom;
            (this.util = i),
              (this.dom = o),
              (this.text = t.text || ""),
              (this.el = null),
              (this.parentEl =
                t.parent || document.getElementsByTagName("body")[0]),
              (this.role = t.role || ""),
              (this.setTemplate = function (t) {
                n = e.template(t);
              }),
              (this.getTemplate = function (e) {
                return (e = e || {}), n(e);
              });
          };
        (t.prototype.render = function (e) {
          var t,
            n = this;
          (e = e || {}),
            (e = this.util.object.extend({}, e, { text: this.text })),
            (t = this.getTemplate(e)),
            (this.el = document.createElement("div")),
            this.wrapperClasses &&
              this.wrapperClasses instanceof Array &&
              this.wrapperClasses.forEach(function (e) {
                n.el.classList.add(e);
              }),
            (this.el.innerHTML = t),
            this.el.setAttribute("role", n.role),
            this.el.setAttribute("aria-label", n.text),
            this.parentEl.appendChild(this.el);
        }),
          (t.prototype.remove = function () {
            this.dom.remove(this.el);
          }),
          (t.prototype.isInDOM = function () {
            return this.parentEl && this.el && this.parentEl.contains(this.el);
          }),
          (t.prototype.show = function (e, t) {
            t ? this.dom.fadeIn(this.el, 0) : this.dom.fadeIn(this.el),
              this.changeText(e);
          }),
          (t.prototype.changeText = function (e) {
            var t = this.getTemplate({ text: e });
            e &&
              (this.el.setAttribute("aria-label", this.text),
              (this.text = e),
              (this.el.innerHTML = t));
          }),
          (t.prototype.hide = function (e) {
            e ? this.dom.fadeOut(this.el, 0) : this.dom.fadeOut(this.el);
          }),
          (t.prototype.getText = function () {
            return this.text;
          }),
          (t.prototype.setText = function (e) {
            this.text = e || "";
          }),
          (t.prototype.setParent = function (e) {
            this.parentEl = e;
          }),
          (t.prototype.isVisible = function () {
            return "block" === this.el.style.display;
          }),
          (t.prototype.destroy = function () {
            var e = this;
            e.isInDOM() && e.parentEl && e.el && e.remove(),
              (e.layerTemplate = null),
              (e.text = null),
              (e.el = null),
              (e.parentEl = null);
          }),
          window.cylindo.addModule("cylindo.classes.layer", t);
      }.call(this),
      function () {
        var e = function n(e) {
          (this.id = ++n.counter),
            (this.loggerLimit = e.loggerLimit),
            (this.messages = []);
        };
        (e.prototype.add = function (e) {
          this.checkLoggerLimit(), this.messages.push(e);
        }),
          (e.prototype.checkLoggerLimit = function () {
            this.messages.length === this.loggerLimit && this.messages.shift();
          }),
          (e.prototype.getMessagesByImportance = function (e) {
            return this.messages.filter(function (t, n) {
              return t.bin & e;
            });
          }),
          (e.prototype.getAllMessages = function () {
            return this.messages;
          }),
          (e.counter = 0);
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.message.queue", t);
      }.call(this),
      function () {
        function e(e) {
          var t = h.promise.create(),
            n = e.viewer.model,
            i = e.index,
            o = e.urls,
            r = [],
            s = [],
            a = { notFound: !1 },
            c = o.framePath.replace("__FRAME_INDEX__", e.index),
            u = o.zoomPath.replace("__FRAME_INDEX__", e.index),
            m = h.promise.create(),
            p = new Image(),
            f = n.get("currentFeatures"),
            g = f && f.data ? f.data : null,
            v = null;
          g && g.startFrame === i && g.image && (v = productData.image || null),
            (p = v || p),
            d(p),
            (p.onload = function () {
              a.notFound
                ? e.li.classList.add("cylindo-img-not-found")
                : e.li.classList.remove("cylindo-img-not-found"),
                m.resolve();
            }),
            (p.onerror = h.fallback.loadFallbackImage.bind({
              img: p,
              imageStatus: a,
              model: n,
              errorText: "Fallback image not found: ",
            })),
            v || (p.src = c),
            e.viewer.pendingImages.push({
              index: i,
              img: p,
              requestID: e.requestID,
              prepareDefer: e.prepareDefer || h.promise.create(),
            }),
            s.push(p),
            r.push(m);
          try {
            e.li.dataset.zoomImage = u;
          } catch (E) {
            e.li.setAttribute("data-zoom-image", u);
          }
          return Promise.all(r).then(function () {
            l(i, s, t, e);
          });
        }
        function t(e) {
          var t = h.promise.create(),
            n = e.index,
            i = new Image(),
            o = "",
            s = "";
          (o = e.imageToPreload.zoom || e.imageToPreload.image),
            (s = e.imageToPreload.image);
          try {
            (e.li.dataset.index = e.prefix + n),
              (e.li.dataset.zoomImage = o),
              (e.li.dataset.altorder = e.index),
              (e.li.dataset.id = "cylindo-thumb" + e.index),
              (e.li.dataset.isAlternateImage = 1),
              (e.li.dataset.altRequestId = e.refAltRequestID),
              (e.li.dataset.baseOneAltIndex = e.baseOneAltIndex);
          } catch (a) {
            e.li.setAttribute("data-index", e.prefix + n),
              e.li.setAttribute("data-zoom-image", o),
              e.li.setAttribute("data-altorder", n),
              e.li.setAttribute("data-id", "cylindo-thumb" + n),
              e.li.setAttribute("data-is-alternate-image", 1),
              e.li.setAttribute("data-alt-request-id", e.refAltRequestID),
              e.li.setAttribute("data-base-one-alt-index", e.baseOneAltIndex);
          }
          return (
            i.setAttribute("role", "img"),
            (i.alt =
              e.imageToPreload.description || "Alternative: " + (+n + 1)),
            (i.src = e.viewer.network.resolveProtocol(s)),
            d(i),
            (i.onload = r.bind({ deferred: t, el: i, li: e.li })),
            (i.onerror = h.fallback.loadFallbackImage.bind({
              img: i,
              li: e.li,
              model: e.viewer.model,
              errorText: "Fallback image not found: ",
              useBUSAPI: !1,
            })),
            t
          );
        }
        function n(e) {
          function t(n) {
            T ||
              ((T = !0),
              g.removeEventListener("loadstart", t),
              e.li.appendChild(g),
              d &&
                u.create({
                  deferred: m,
                  li: e.li,
                  id: d,
                  provider: f,
                  viewer: e.viewer,
                  autoplay: y,
                  video: g,
                }));
          }
          var n,
            i,
            o,
            a,
            l,
            d,
            c,
            m = h.promise.create(),
            p = e.index,
            f = e.videoToPreload.provider,
            g = document.createElement("video"),
            v = new Image(),
            E = e.videoToPreload.options,
            y = 1,
            A = 0.1,
            T = !1,
            R = e.viewer.model.getLogger();
          e.li.classList.add("cylindo-video");
          try {
            (e.li.dataset.index = e.prefix + p),
              (e.li.dataset.altorder = p),
              (e.li.dataset.id = "cylindo-thumb" + p),
              (e.li.dataset.isAlternateVideo = 1),
              (e.li.dataset.altRequestId = e.refAltRequestID);
          } catch (b) {
            e.li.setAttribute("data-index", e.prefix + p),
              e.li.setAttribute("data-altorder", p),
              e.li.setAttribute("data-id", "cylindo-thumb" + p),
              e.li.setAttribute("data-is-alternate-video", 1),
              e.li.setAttribute("data-alt-request-id", e.refAltRequestID);
          }
          if (
            ((n = e.videoToPreload.sources),
            (o = n instanceof Array ? n.length : 0),
            (a = e.videoToPreload.poster ? e.videoToPreload.poster : ""),
            o && o > 0)
          )
            for (l = 0; l < o; l++)
              (i = document.createElement("source")),
                (i.src = e.viewer.network.resolveProtocol(n[l].src)),
                (i.type = n[l].type),
                l === o - 1 &&
                  (i.onerror = s.bind({
                    li: e.li,
                    element: i,
                    img: v,
                    imageSrc: e.viewer.model.get("fallbackVideoImage"),
                  })),
                g.appendChild(i);
          else
            (g.src = ""),
              (g.onerror = s.bind({
                li: e.li,
                element: g,
                img: v,
                imageSrc: e.viewer.model.get("fallbackVideoImage"),
              }));
          if (
            ((v.onload = r.bind({
              deferred: m,
              el: v,
              li: e.li,
              elementToRemove: g,
            })),
            (d = "cylindo-video-" + e.viewer.id + "-" + p),
            (g.id = d),
            (g.controls = "true"),
            h.browser.isChrome())
          )
            try {
              g.controlsList = "nodownload";
            } catch (I) {
              R.warning("Can not set controlList for this browser version", I);
            }
          if (
            (a.length > 0 && (g.poster = e.viewer.network.resolveProtocol(a)),
            "object" === ("undefined" == typeof E ? "undefined" : _typeof(E)))
          )
            for (c in E)
              if ("autoplay" === c) y = E[c];
              else if ("currentTime" === c)
                try {
                  g.currentTime = !isNaN(E[c]) && E[c] > 0 ? E[c] : A;
                } catch (b) {}
          return g.addEventListener("loadstart", t), g.load(), m;
        }
        function i(e) {
          var t,
            n,
            i = h.promise.create(),
            l = ["enablejsapi", "rel"],
            d = e.index,
            c = e.videoToPreload.provider,
            u = e.videoToPreload.videoId,
            m = document.createElement("iframe"),
            p = new Image(),
            f = [],
            g = e.videoToPreload.options,
            v = 1;
          e.li.classList.add("cylindo-video");
          try {
            (e.li.dataset.index = e.prefix + d),
              (e.li.dataset.url = e.videoToPreload.url),
              (e.li.dataset.altorder = d),
              (e.li.dataset.id = "cylindo-thumb" + d),
              (e.li.dataset.isAlternateVideo = 1),
              (e.li.dataset.altRequestId = e.refAltRequestID);
          } catch (E) {
            e.li.setAttribute("data-index", e.prefix + d),
              e.li.setAttribute("data-url", e.videoToPreload.url),
              e.li.setAttribute("data-altorder", d),
              e.li.setAttribute("data-id", "cylindo-thumb" + d),
              e.li.setAttribute("data-is-alternate-video", 1),
              e.li.setAttribute("data-alt-request-id", e.refAltRequestID);
          }
          if (
            ((t = "cylindo-video-" + e.viewer.id + "-" + d),
            m.setAttribute("id", t),
            m.setAttribute("allowFullScreen", ""),
            m.setAttribute("mozallowfullscreen", ""),
            m.setAttribute("webkitallowfullscreen", ""),
            m.setAttribute("allow", "autoplay"),
            m.setAttribute("autoplay", ""),
            m.setAttribute("title", t),
            "object" === ("undefined" == typeof g ? "undefined" : _typeof(g)))
          ) {
            for (n in g)
              "autoplay" === n
                ? (v = g[n])
                : l.indexOf(n) === -1 && f.push(n + "=" + g[n]);
            f = f.join("&");
          }
          return (
            "youtube" === c && null !== u
              ? ((f =
                  f.length > 0
                    ? f + "&enablejsapi=1&rel=0"
                    : "enablejsapi=1&rel=0"),
                (m.src = e.viewer.network.resolveProtocol(
                  "//www.youtube.com/embed/" + u + "?" + f
                )),
                m.classList.add("cylindo-video-youtube"))
              : "vimeo" === c && null !== u
              ? ((m.src = e.viewer.network.resolveProtocol(
                  "//player.vimeo.com/video/" + u + "?" + f
                )),
                m.classList.add("cylindo-video-vimeo"))
              : s.call({
                  img: p,
                  imageSrc: e.viewer.model.get("fallbackVideoImage"),
                }),
            (m.onload = o.bind({
              iframe: m,
              li: e.li,
              videoId: u,
              id: t,
              provider: c,
              viewer: e.viewer,
              autoplay: v,
              deferred: i,
            })),
            (p.onload = a.bind({ li: e.li, iframe: m, img: p, deferred: i })),
            r.call({ el: m, li: e.li }),
            i
          );
        }
        function o() {
          var e = {
            deferred: this.deferred,
            li: this.li,
            id: this.id,
            videoId: this.videoId,
            provider: this.provider,
            viewer: this.viewer,
            autoplay: this.autoplay,
          };
          this.videoId && this.id && u.create(e);
        }
        function r() {
          "undefined" != typeof this.elementToRemove &&
            this.li.removeChild(this.elementToRemove),
            this.li.appendChild(this.el),
            "undefined" != typeof this.deferred && this.deferred.resolve();
        }
        function s() {
          "undefined" != typeof this.element && (this.element.onerror = null),
            this.li &&
              this.li.classList &&
              this.li.classList.add("cylindo-video-not-found"),
            (this.img.src = this.imageSrc);
        }
        function a() {
          this.li.removeChild(this.iframe),
            this.li.appendChild(this.img),
            this.deferred.resolve();
        }
        function l(e, t, n, i) {
          var o,
            r,
            s = i.baseClassName + e;
          i.li.classList.add(s);
          try {
            i.li.dataset.index = e;
          } catch (a) {
            i.li.setAttribute("data-index", e);
          }
          i.imgTimeout > 0 &&
            (r = setTimeout(
              function () {
                i.onError.call(o);
              }.bind(i.viewer),
              i.imgTimeout
            )),
            (o = {
              requestID: i.requestID,
              index: e,
              self: i.viewer,
              img: t,
              li: i.li,
              layers: i.layers,
              totalFrames: i.totalFrames,
              deferred: n,
              timeout: r,
            }),
            t instanceof Image
              ? (t.addEventListener
                  ? t.addEventListener("load", i.onImageLoad.bind(o))
                  : t.attachEvent &&
                    t.attachEvent("onload", i.onImageLoad.bind(o)),
                (t.onerror = i.onError.bind(o)))
              : i.onImageLoad.call(o);
        }
        function d(e) {
          try {
            (e.draggable = !1),
              (e.ondragstart = function () {
                return !1;
              });
          } catch (t) {}
        }
        var c = {},
          u = cylindo.getModule("cylindo.video"),
          h = cylindo.getModule("cylindo.core.util");
        (c.strategies = {
          ALT_IMAGE: t,
          ALT_VENDOR: i,
          ALT_VIDEO: n,
          RTV_SINGLE_MERGED: e,
        }),
          (c.useStrategy = function (e, t) {
            try {
              return e.call(null, t);
            } catch (n) {
              return (
                console.log("The strategy was not found"), console.error(n), !0
              );
            }
          }),
          window.cylindo.addModule("cylindo.render.strategy", c);
      }.call(this),
      function () {
        var e = function (e) {
          var t = this,
            n = cylindo.getModule("cylindo.core.util"),
            i = e.dom,
            o = cylindo.getModule("cylindo.util.pubsub").create();
          (e = e || {}),
            (this.pubsub = o),
            (this.on = o.on),
            (this.off = o.off),
            (this.trigger = o.trigger),
            (this.util = n),
            (this.dom = i),
            (this.el = e.el),
            (this.thumbPageSize = e.thumbPageSize),
            (this.min = 0),
            (this.offset = e.offset || 0),
            (this.offsetReference = 0),
            (this.pressed = !1),
            (this.xform = "transform"),
            (this.velocity = null),
            (this.frame = null),
            (this.timestamp = null),
            (this.ticker = null),
            (this.amplitude = null),
            (this.target = null),
            (this.timeConstant = e.timeConstant || 500),
            (this.reference = null),
            (this.parentEl = this.el.parentNode),
            (this.wrapper = e.wrapper),
            (this.isScrolling = !1),
            (this.isAnimating = !1),
            (this.closestSibling = null),
            (this.model = e.model),
            (this.leftBtn = this.wrapper.querySelector(
              ".cylindo-thumbnail-slider.left"
            )),
            (this.rightBtn = this.wrapper.querySelector(
              ".cylindo-thumbnail-slider.right"
            )),
            (this.thumbLocations = this.model.getThumbLocations()),
            (this.thumbLocation = this.model.get("thumbLocation")),
            ["webkit", "Moz", "O", "ms"].every(
              function (e) {
                var t = e + "Transform";
                return (
                  "undefined" == typeof this.el.style[t] ||
                  ((this.xform = t), !1)
                );
              }.bind(this)
            ),
            (this.endAnimation = this.endAnimation.bind(this)),
            (this.clearEndStep = this.clearEndStep.bind(this)),
            (this.tap = this.tap.bind(this)),
            (this.drag = this.drag.bind(this)),
            (this.release = this.release.bind(this)),
            (this.wheelScroll = this.wheelScroll.bind(this)),
            (this.startStep = this.startStep.bind(this)),
            (this.endStep = this.endStep.bind(this)),
            this.wrapper.classList.add("has-scroll"),
            this.wrapper.classList.add("scroll-min"),
            this.leftBtn.setAttribute("aria-hidden", !0),
            this.wrapper.classList.contains("scroll-max") &&
              (this.wrapper.classList.remove("scroll-max"),
              this.leftBtn.setAttribute("aria-hidden", !1)),
            this.addEvents(),
            0 !== this.offset &&
              setTimeout(function () {
                t.scroll(t.offset);
              }, 100);
        };
        (e.prototype.events = { THUMB_CLICKED: "thumbscroll.clicked" }),
          (e.prototype.wheelScroll = function (e) {
            var t,
              n = this.areVerticalThumbs() ? e.deltaY : e.deltaX;
            if (n >= 2 || n <= -2)
              return (
                (t = this.currentPos(e)),
                (this.reference = t),
                this.scroll(this.offset + n),
                e.stopPropagation(),
                !1
              );
          }),
          (e.prototype.currentPos = function (e) {
            return e.targetTouches && e.targetTouches.length >= 1
              ? this.areVerticalThumbs()
                ? e.targetTouches[0].clientY
                : e.targetTouches[0].clientX
              : this.areVerticalThumbs()
              ? e.clientY
              : e.clientX;
          }),
          (e.prototype.getElementWidth = function () {
            return this.areVerticalThumbs()
              ? this.getMax() + this.parentEl.clientWidth
              : this.getMax() + this.parentEl.clientHeight;
          }),
          (e.prototype.getMax = function () {
            var e = this.areVerticalThumbs()
              ? this.el.childNodes[0].clientHeight *
                (this.el.childNodes.length - this.thumbPageSize)
              : this.el.childNodes[0].clientWidth *
                (this.el.childNodes.length - this.thumbPageSize);
            return e;
          }),
          (e.prototype.getStepSize = function () {
            return this.areVerticalThumbs()
              ? this.el.childNodes[0].clientHeight * this.thumbPageSize
              : this.el.childNodes[0].clientWidth * this.thumbPageSize;
          }),
          (e.prototype.getRelative = function () {
            var e = this.getMax();
            return this.areVerticalThumbs()
              ? (this.parentEl.clientHeight - 20) / e
              : (this.parentEl.clientWidth - 20) / e;
          }),
          (e.prototype.scroll = function (e, t) {
            var n = this.areVerticalThumbs() ? "translateY" : "translateX";
            (this.max = this.getMax()),
              (this.offset =
                e > this.max ? this.max : e < this.min ? this.min : e),
              t
                ? (this.el.style.transition = "transform 200ms linear")
                : (this.el.style.transition = "none"),
              (this.el.style[this.xform] = n + "(" + -this.offset + "px)"),
              this.offset === this.max
                ? (this.leftBtn.setAttribute("aria-hidden", !1),
                  this.rightBtn.setAttribute("aria-hidden", !0),
                  this.wrapper.classList.remove("scroll-min"),
                  this.wrapper.classList.add("scroll-max"))
                : this.offset === this.min
                ? (this.leftBtn.setAttribute("aria-hidden", !0),
                  this.rightBtn.setAttribute("aria-hidden", !1),
                  this.wrapper.classList.add("scroll-min"),
                  this.wrapper.classList.remove("scroll-max"))
                : (this.leftBtn.setAttribute("aria-hidden", !1),
                  this.rightBtn.setAttribute("aria-hidden", !1),
                  this.wrapper.classList.remove("scroll-min"),
                  this.wrapper.classList.remove("scroll-max"));
          }),
          (e.prototype.store = function () {
            var e, t, n, i;
            (e = Date.now()),
              (t = e - this.timestamp),
              (this.timestamp = e),
              (n = this.offset - this.frame),
              (this.frame = this.offset),
              (i = (1e3 * n) / (1 + t)),
              (this.velocity = 0.8 * i + 0.2 * this.velocity);
          }),
          (e.prototype.autoScroll = function () {
            var e, t;
            this.amplitude &&
              ((e = Date.now() - this.timestamp),
              (t = -this.amplitude * Math.exp(-e / this.timeConstant)),
              t > 0.5 || t < -0.5
                ? (this.scroll(this.target + t),
                  requestAnimationFrame(this.autoScroll.bind(this)))
                : this.scroll(this.target));
          }),
          (e.prototype.tap = function (e) {
            if (
              (e.stopImmediatePropagation(),
              this.addDocumentEvents(),
              (this.offsetReference = this.offset),
              !(this.getMax() <= 0))
            )
              return (
                (this.pressed = !0),
                (this.reference = this.currentPos(e)),
                (this.velocity = this.amplitude = 0),
                (this.frame = this.offset),
                (this.timestamp = Date.now()),
                clearInterval(this.ticker),
                (this.ticker = setInterval(this.store.bind(this), 100)),
                (this.closestSibling = setTimeout(
                  function () {
                    var t,
                      n,
                      i,
                      o,
                      r,
                      s =
                        "IMG" === e.target.tagName
                          ? e.target.parentElement
                          : "LI" === e.target.tagName
                          ? e.target
                          : null,
                      a = s.getBoundingClientRect(),
                      l = this.wrapper.querySelector(".cylindo-thumbnail-bar"),
                      d = l.getBoundingClientRect(),
                      c = this.areVerticalThumbs() ? a.height : a.width,
                      u = !0;
                    (t = this.areVerticalThumbs() ? a.top : a.left),
                      (n = this.areVerticalThumbs()
                        ? a.top + a.height
                        : a.left + a.width),
                      (i = this.areVerticalThumbs() ? d.top : d.left),
                      (o = this.areVerticalThumbs()
                        ? d.top + d.height
                        : d.left + d.width),
                      i + 2 > t && i - 2 < t
                        ? (this.scroll(this.offset + c * -1, !0), (r = !1))
                        : t < i + c && t > i
                        ? (this.scroll(this.offset + (c - (t - i)) * -1, u),
                          (r = !1))
                        : n < i + c && n > i
                        ? (t > i - 20
                            ? this.scroll(this.offset + (i - t + c) * -1, u)
                            : this.scroll(this.offset + (i - t) * -1, u),
                          (r = !1))
                        : o + 2 > n && o - 2 < n
                        ? (this.scroll(this.offset + c, !0), (r = !0))
                        : n > o - c && n < o
                        ? (this.scroll(this.offset + n - (o - c), u), (r = !0))
                        : t > o - c &&
                          t < o &&
                          (n > o && n - o < 20
                            ? this.scroll(this.offset + c + n - o, u)
                            : this.scroll(this.offset + n - o, u),
                          (r = !0));
                  }.bind(this),
                  300
                )),
                e.stopPropagation(),
                e.preventDefault(),
                !1
              );
          }),
          (e.prototype.drag = function (e) {
            var t, n;
            if (!(this.getMax() <= 0))
              return (
                this.pressed &&
                  ((t = this.currentPos(e)),
                  (n = this.reference - t),
                  (n > 3 || n < -3) &&
                    (clearTimeout(this.closestSibling),
                    (this.reference = t),
                    this.scroll(this.offset + n))),
                e.preventDefault(),
                e.stopPropagation(),
                !1
              );
          }),
          (e.prototype.release = function (e) {
            var t;
            if (
              (e.preventDefault(),
              e.stopPropagation(),
              this.removeDocumentEvents(),
              this.offsetReference === this.offset &&
                ((t =
                  "IMG" === e.target.tagName
                    ? e.target.parentElement
                    : "LI" === e.target.tagName
                    ? e.target
                    : null),
                t && this.trigger(this.events.THUMB_CLICKED, { thumb: t })),
              !(this.getMax() <= 0))
            )
              return (
                (this.pressed = !1),
                clearInterval(this.ticker),
                (this.velocity > 10 || this.velocity < -10) &&
                  ((this.amplitude = 0.8 * this.velocity),
                  (this.target = Math.round(this.offset + this.amplitude)),
                  (this.timestamp = Date.now()),
                  requestAnimationFrame(this.autoScroll.bind(this))),
                !1
              );
          }),
          (e.prototype.step = function (e) {
            var t = this.offset + e;
            this.isScrolling &&
              (requestAnimationFrame(
                function () {
                  this.step(e);
                }.bind(this)
              ),
              (!this.timestamp || Date.now() - this.timestamp > 240) &&
                ((this.timestamp = Date.now()),
                (this.isAnimating = !0),
                this.scroll(t)));
          }),
          (e.prototype.stepBack = function () {
            var e = this.getStepSize();
            (e *= -1), this.step(e);
          }),
          (e.prototype.stepForward = function () {
            var e = this.getStepSize();
            this.step(e);
          }),
          (e.prototype.endAnimation = function () {
            this.isAnimating = !1;
          }),
          (e.prototype.startStep = function (e) {
            return (
              e.preventDefault(),
              e.stopPropagation(),
              (this.isScrolling = !0),
              (this.el.style.willChange = "transform"),
              (this.el.style.transition = "transform 230ms ease-in-out"),
              this.el.addEventListener("transitionend", this.endAnimation),
              e.target.classList.contains("prev")
                ? this.stepBack()
                : this.stepForward(),
              !1
            );
          }),
          (e.prototype.endStep = function (e) {
            return (
              e.preventDefault(),
              e.stopPropagation(),
              this.isAnimating
                ? this.el.addEventListener("transitionend", this.clearEndStep)
                : this.clearTransitions(),
              (this.isScrolling = !1),
              (this.timestamp = null),
              !1
            );
          }),
          (e.prototype.clearEndStep = function () {
            this.clearTransitions(),
              this.el.removeEventListener("transitionend", this.clearEndStep),
              this.el.removeEventListener("transitionend", this.endAnimation);
          }),
          (e.prototype.clearTransitions = function () {
            (this.el.style.willChange = ""), (this.el.style.transition = "");
          }),
          (e.prototype.addEvents = function () {
            var e,
              t,
              n = this;
            if (this.wrapper) {
              var i = this.dom.querySelectorAll(
                this.wrapper,
                ".cylindo-thumbnail-slider"
              );
              for (t = i.length, e = 0; e < t; e++) {
                var o = i[e];
                o.addEventListener("touchstart", n.startStep),
                  o.addEventListener("touchend", n.endStep),
                  o.addEventListener("mousedown", n.startStep, !0),
                  o.addEventListener("mouseup", n.endStep, !0);
              }
            }
            this.parentEl.addEventListener("touchstart", this.tap),
              this.parentEl.addEventListener("mousedown", this.tap, !0),
              this.parentEl.addEventListener("mousewheel", this.wheelScroll, {
                passive: !0,
              });
          }),
          (e.prototype.addDocumentEvents = function () {
            document.addEventListener("touchmove", this.drag),
              document.addEventListener("touchend", this.release),
              document.addEventListener("mousemove", this.drag, !0),
              document.addEventListener("mouseup", this.release, !0);
          }),
          (e.prototype.removeDocumentEvents = function () {
            document.removeEventListener("touchmove", this.drag),
              document.removeEventListener("touchend", this.release),
              document.removeEventListener("mousemove", this.drag, !0),
              document.removeEventListener("mouseup", this.release, !0);
          }),
          (e.prototype.removeEvents = function () {
            var e = this;
            this.parentEl.removeEventListener("touchstart", this.tap),
              this.parentEl.removeEventListener("touchmove", this.drag),
              this.parentEl.removeEventListener("touchend", this.release),
              this.parentEl.removeEventListener("mousedown", this.tap, !0),
              this.parentEl.removeEventListener("mousemove", this.drag, !0),
              this.parentEl.removeEventListener("mouseup", this.release, !0),
              this.parentEl.removeEventListener("mousewheel", this.wheelScroll);
            var t,
              n = this.dom.querySelectorAll(
                this.wrapper,
                ".cylindo-thumbnail-slider"
              ),
              i = n.length;
            if (this.wrapper)
              for (t = 0; t < i; t++)
                n[t].removeEventListener("touchstart", e.startStep),
                  n[t].removeEventListener("touchend", e.endStep),
                  n[t].removeEventListener("mousedown", e.startStep, !0),
                  n[t].removeEventListener("mouseup", e.endStep, !0);
          }),
          (e.prototype.destroy = function () {
            this.removeEvents(),
              this.wrapper.classList.remove("has-scroll"),
              this.pubsub &&
                "function" == typeof this.pubsub.destroy &&
                this.pubsub.destroy();
          }),
          (e.prototype.getCurrentOffset = function () {
            return this.offset;
          }),
          (e.prototype.areVerticalThumbs = function () {
            return (
              this.thumbLocation === this.thumbLocations.LEFT ||
              this.thumbLocation === this.thumbLocations.RIGHT
            );
          }),
          window.cylindo.addModule("cylindo.classes.thumbScroll", e);
      }.call(this),
      function () {
        var e = function t(e) {
          var n = cylindo.getModule("cylindo.util.pubsub").create();
          (this.id = ++t.counter),
            (this.enabled = !0),
            (this.promises = []),
            (this.promisesCompleted = 0),
            (this.ul360 = null),
            (this.currentIndex = 1),
            (this.initialized = !0),
            (this.wrapper = e.el),
            (this.model = e.model),
            (this.logger = e.logger),
            (this.listClassName = ""),
            (this.currentFeatures = this.model.get("currentFeatures")),
            (this.contentKeys = null),
            (this.url = this.currentFeatures
              ? this.currentFeatures.paths
              : null),
            (this.firstImageLoadedTime = 0),
            (this.viewerUpdatedStartTime = Date.now()),
            (this.customImageOn = !1),
            (this.isReady = !1),
            (this.firstFrameIsReady = !1),
            (this.isVisible = !1),
            (this.isComplete = !1),
            (this.util = cylindo.getModule("cylindo.core.util")),
            (this.dom = e.dom),
            (this.dpiDensity = this.util.browser.getDPI()),
            (this.mouseClickPos = {
              startX: 0,
              startY: 0,
              currentX: 0,
              currentY: 0,
            }),
            (this.startFrame = 1),
            (this.requestID = 0),
            (this.altRequestID = 0),
            (this.renderer = cylindo.getModule("cylindo.render.strategy")),
            (this.network = cylindo.getModule("cylindo.core.network")),
            (this.contentHelper = cylindo.getModule(
              "cylindo.helpers.content.to.load"
            )),
            (this.contentTypes = this.contentHelper.getContentTypes()),
            (this.framesHandler = e.framesHandler),
            (this.tags = e.tags),
            (this.presentation = e.presentation),
            (this.alternateContentPromises = []),
            (this.ariaLabel = e.ariaLabel),
            (this.initializedWithError = e.initializedWithError || !1),
            this.framesHandler.on(
              this.framesHandler.events.RELOAD_ALT_CONTENT,
              this.processChange.bind(this)
            ),
            this.model.on(
              this.model.events.CHANGED,
              this.processChange.bind(this)
            ),
            (this.pubsub = n),
            (this.on = n.on),
            (this.once = n.once),
            (this.trigger = n.trigger),
            (this.off = n.off);
        };
        (e.extendEvents = function (t) {
          var n = cylindo.getModule("cylindo.core.util");
          return (
            (t && n.object.isPlainObject(t)) || (t = {}),
            n.object.extend({}, e.prototype.events, t)
          );
        }),
          (e.prototype.events = {
            CUSTOM_IMG_CLICKED: "view:custom:img:clicked",
            READY_TO_BE_SHOWN: "viewer:ready:to:be:shown",
          }),
          (e.prototype.setMobileCoords = function (e) {
            (e.clientX = e.touches.length
              ? e.touches[0].clientX
              : e.changedTouches[0].clientX),
              (e.clientY = e.touches.length
                ? e.touches[0].clientY
                : e.changedTouches[0].clientY);
          }),
          (e.prototype.isSignificantMove = function (e) {
            var t = !0,
              n = 2 / this.dpiDensity,
              i = Math.abs(e.clientX - this.mouseClickPos.startX),
              o = Math.abs(e.clientY - this.mouseClickPos.startY);
            return i <= n && o <= n && (t = !1), t;
          }),
          (e.prototype.getCurrentThreesixtyIndex = function () {
            return this.currentIndex;
          }),
          (e.prototype.processChange = function (e, t) {
            if (e === this.framesHandler.events.RELOAD_ALT_CONTENT)
              this.reloadAltContent(e, t);
            else if (t)
              if (
                "backgroundColor" === t.prop ||
                "removeEnvironmentShadow" === t.prop ||
                "buildNumber" === t.prop
              )
                try {
                  this.refresh.call(this);
                } catch (n) {}
              else if ("ARBannerConfig" === t.prop)
                try {
                  this.model.updateRequestID(),
                    this.refresh.call(this, "ar:banner:config:changed", {
                      refRequestID: this.model.getRequestID(),
                    });
                } catch (n) {}
          }),
          (e.prototype.onReady = function () {
            (this.isReady = !0),
              this.addMouseCallbacks(),
              this.trigger(this.events.READY);
          }),
          (e.prototype.displayViewer = function () {
            (this.isVisible = !0),
              (this.ul360.style.transition = "opacity 0.2s linear"),
              this.trigger(this.events.READY_TO_BE_SHOWN, null);
          }),
          (e.prototype.onDownloadComplete = function () {
            (this.isComplete = !0),
              (this.promises = []),
              (this.promisesCompleted = 0),
              this.trigger(this.events.DOWNLOAD_COMPLETE),
              this.trigger(this.events.CONTENT_TYPE_COMPLETE, {
                contentType: this.contentTypes.FRAME,
              });
          }),
          (e.prototype.render = function () {
            var e;
            (this.viewerUpdatedStartTime = Date.now()),
              (this.requestID = this.model.getRequestID()),
              (e = this.requestID),
              this.ul360 &&
                (this.removeMouseCallbacks(), this.dom.remove(this.ul360)),
              this.createViewerList(),
              this.downloadContent(e);
          }),
          (e.prototype.downloadContent = function (e) {
            function t(e, t, i) {
              h =
                null === h
                  ? s.prepare(e, t).then(function (t) {
                      n(e, i);
                    })
                  : h.then(function () {
                      var o = s.prepare(e, t);
                      return (
                        o.then(function (t) {
                          n(e, i);
                        }),
                        o
                      );
                    });
            }
            function n(e, t) {
              s.framesHandler.isAltId(e) &&
                (u--,
                0 === u &&
                  s.trigger(s.events.CONTENT_TYPE_COMPLETE, {
                    contentType: s.contentTypes.ALTERNATE,
                  }));
            }
            var i,
              o,
              r,
              s = this,
              a = s.model.get("startFrame"),
              l = s.framesHandler.getAllFramesToBeLoaded(),
              d = l.VIEWER_ORDER.LIST,
              c = l.VIEWER_ORDER.LEN,
              u = 0,
              h = null,
              m = l.THREESIXTY.TO_BE_LOADED,
              p = s.framesHandler.shouldDownloadAll360Frames(),
              f = !0;
            if (((this.isCustomViewer = 0 === m), (this.frameCount = m), c > 0))
              for (
                this.currentIndex = d[0],
                  this.prevIndex = a,
                  this.startFrame = a,
                  i = 0;
                i < c;
                i++
              )
                if (((r = d[i]), s.framesHandler.is360Frame(r)))
                  if (p) {
                    if (f)
                      for (
                        r !== a &&
                          ((this.currentIndex =
                            this.currentIndex === r ? a : this.currentIndex),
                          (r = a)),
                          t(r, e, i),
                          f = !1,
                          o = 1;
                        o <= m;
                        o++
                      )
                        o !== r && t(o, e, i);
                  } else t(r, e, i);
                else s.framesHandler.isAltId(r) && u++, t(r, e, i);
          }),
          (e.prototype.downloadRest = function () {
            throw new Error("Method MUST be implemented.");
          }),
          (e.prototype.addMouseCallbacks = function () {
            throw new Error("Method MUST be implemented.");
          }),
          (e.prototype.removeMouseCallbacks = function () {
            throw new Error("Method MUST be implemented.");
          }),
          (e.prototype.createViewerList = function () {
            (this.ul360 = this.wrapper.getElementsByTagName("ul")[0]),
              (this.ul360.style.display = ""),
              this.ul360.setAttribute("role", "list"),
              this.ul360.setAttribute(
                "aria-label",
                this.model.get("presentation") +
                  this.ariaLabel.texts.PRESENTATION
              ),
              this.ul360.classList.add(this.listClassName);
          }),
          (e.prototype.goToIndex = function (e) {
            var t = this.ul360.querySelector(".cylindo-viewer-frame-" + e),
              n = this.ul360.querySelector(".active"),
              i = n
                ? n.dataset
                  ? n.dataset.index
                  : n.getAttribute("data-index")
                : null,
              o = !1;
            t &&
              (n && this.handleActiveFrame(n, !1),
              this.handleActiveFrame(t, !0),
              (this.currentIndex = isNaN(e) ? e : parseInt(e, 10)),
              this.trigger(this.events.FRAME_ACTIVATED, { index: e }),
              this.handleTooltip(t, e, i),
              this.handleZoomButton(t, e, i),
              this.handleActionBtns(t, e, o)),
              this.ul360.classList.toggle(
                "cylindo-display-alt-image",
                isNaN(e)
              );
          }),
          (e.prototype.prepareAltContent = function (e, t, n) {
            function i() {
              this.viewer.onAltContentLoad.call(this);
            }
            var o,
              r,
              s,
              a,
              l,
              d,
              c,
              u,
              h = this.framesHandler.getAllFramesToBeLoaded(),
              m = this.util.promise.create(),
              p = "cylindo-viewer-frame-",
              f = p + "alt-",
              g = h.VIEWER_ORDER.LIST,
              v = h.VIEWER_ORDER.LEN,
              E = h.ALTERNATE.LIST,
              y = g.indexOf(this.framesHandler.prefixes.ALT + e),
              A = y + 1,
              T = (n && n.useFramesToReorder) || !1;
            if (T) {
              for (a = y > 0 ? g[y - 1] : null, u = y + 1; u < v; u++)
                if (!this.framesHandler.isAltId(g[u])) {
                  d = g[u];
                  break;
                }
              (l = this.ul360.querySelector("." + p + a)),
                (c = this.ul360.querySelector("." + p + d));
            }
            return (
              (this.altRequestID = this.model.getAltRequestID()),
              (s = this.altRequestID),
              (o = document.createElement("li")),
              o.setAttribute("aria-hidden", !0),
              o.classList.add(f + e),
              o.classList.add("is-alt-content"),
              o.classList.add("hidden"),
              o.classList.add("is-rendering"),
              l
                ? this.dom.insertAfter(o, l)
                : c
                ? this.dom.insertBefore(o, c)
                : this.ul360.appendChild(o),
              "undefined" == typeof E[e].provider
                ? ((r = {
                    index: e,
                    viewer: this,
                    li: o,
                    imageToPreload: E[e],
                    refAltRequestID: s,
                    baseOneAltIndex: A,
                    prefix: this.framesHandler.prefixes.ALT,
                  }),
                  (m = this.renderer.useStrategy(
                    this.renderer.strategies.ALT_IMAGE,
                    r
                  )))
                : "direct" === E[e].provider
                ? ((r = {
                    index: e,
                    viewer: this,
                    li: o,
                    videoToPreload: E[e],
                    refAltRequestID: s,
                    prefix: this.framesHandler.prefixes.ALT,
                  }),
                  (m = this.renderer.useStrategy(
                    this.renderer.strategies.ALT_VIDEO,
                    r
                  )))
                : ("youtube" !== E[e].provider &&
                    "vimeo" !== E[e].provider &&
                    "not-supported" !== E[e].provider) ||
                  ((r = {
                    index: e,
                    viewer: this,
                    li: o,
                    videoToPreload: E[e],
                    refAltRequestID: s,
                    prefix: this.framesHandler.prefixes.ALT,
                  }),
                  (m = this.renderer.useStrategy(
                    this.renderer.strategies.ALT_VENDOR,
                    r
                  ))),
              m.then(i.bind(r)),
              this.alternateContentPromises.push(m),
              m
            );
          }),
          (e.prototype.reloadAltContent = function (e, t) {
            var n = this.dom.querySelectorAll(this.ul360, '[class*="-alt-"]');
            n && n.length > 0 && this.dom.remove(n),
              this.trigger(this.events.ALT_CONTENT_REMOVED);
          }),
          (e.prototype.prepare = function () {
            throw new Error("Method Prepare must be implemented.");
          }),
          (e.prototype.onError = function () {
            (this.img.onerror = this.self.util.fallback.loadFallbackImage.bind({
              img: this.img,
              li: this.li,
              model: this.self.model,
              errorText: "Fallback image not found: ",
            })),
              (this.img.src = ""),
              this.self.hideTooltip(!0),
              this.timeout &&
                (clearTimeout(this.timeout), (this.timeout = null));
          }),
          (e.prototype.onImageLoad = function () {
            throw new Error("Method Prepare must be implemented.");
          }),
          (e.prototype.enable = function (e) {
            e === !0
              ? (this.ul360.style.visibility = "visible")
              : this.ul360.classList.add("opacity-one"),
              (this.enabled = !0);
          }),
          (e.prototype.disable = function (e) {
            e === !0
              ? (this.ul360.style.visibility = "hidden")
              : this.ul360.classList.remove("opacity-one"),
              (this.enabled = !1);
          }),
          (e.prototype.destroy = function () {
            var e,
              t = this.pendingImages ? this.pendingImages.length : 0;
            for (
              this.rafIndex &&
                (this.logger.log("Current rotation stopped for 360 Viewer."),
                clearTimeout(this.rafIndex),
                (this.rafIndex = null)),
                this.logger.log("360 Viewer destroyed."),
                this.removeMouseCallbacks(),
                this.wrapper.innerHTML = "",
                this.promises = [],
                this.promisesCompleted = 0,
                this.ul360 = null,
                this.currentIndex = 1,
                this.initialized = !1,
                this.wrapper = null,
                this.wrapper = null,
                this.listClassName = "",
                this.pubsub.destroy(),
                e = 0;
              e < t;
              e++
            )
              (this.pendingImages[e].img.onload = null),
                (this.pendingImages[e].img.onerror = null),
                (this.pendingImages[e].img.src = ""),
                this.pendingImages.splice(e, 1),
                e--,
                t--;
          }),
          (e.prototype.getAvailableFrames = function () {
            var e = this.dom.querySelectorAll(
              this.ul360,
              '[class*="cylindo-viewer-frame-"]:not(.hidden):not(.cylindo-img-not-found)'
            );
            return "undefined" == typeof e
              ? []
              : ((e = e.map(function (e) {
                  var t = e.dataset
                    ? e.dataset.index
                    : e.getAttribute("data-index");
                  return isNaN(t) ? t : parseInt(t, 10);
                })),
                e.sort(function (e, t) {
                  return e - t;
                }),
                e);
          }),
          (e.prototype.isFrameAvailable = function (e) {
            var t = this.getAvailableFrames();
            return (e = isNaN(e) ? e : ~~e), t.indexOf(e) !== -1;
          }),
          (e.prototype.showImage = function (e, t) {
            function n() {
              var e = this.ul360.querySelector(".active");
              (this.img.onload = null),
                this.instance.dom.fadeOut(this.loaderEl),
                this.ul360.appendChild(this.li),
                e && this.instance.handleActiveFrame(e, !1),
                this.instance.handleActiveFrame(this.li, !0),
                (this.ul360.style.display = "block"),
                this.instance.handleZoomButton(this.li, "", ""),
                this.instance.handleActionBtns(this.li, "", u),
                this.instance.trigger(this.instance.events.FRAME_ACTIVATED, {
                  index: null,
                });
            }
            function i() {
              var e = this.instance.model.get("fallbackImage");
              (this.img.onerror = o.bind(this)), (this.img.src = e);
            }
            function o() {
              var e = this.instance.model.get("defaultFallbackImage");
              (this.img.onerror = null), (this.img.src = e);
            }
            var r,
              s = this.wrapper.querySelector(".cylindo-loader"),
              a = "cylindo-custom-image",
              l = document.createElement("li"),
              d = new Image(),
              c = {
                loaderEl: s,
                ul360: this.ul360,
                img: d,
                li: l,
                instance: this,
              },
              u = !0,
              h = [];
            l.setAttribute("aria-hidden", !0),
              (this.ul360.style.display = "none"),
              l.classList.add(a),
              l.appendChild(d);
            try {
              (l.dataset.zoomImage = t || e), (l.dataset.url = e);
            } catch (m) {
              l.setAttribute("data-zoom-image", t || e),
                l.setAttribute("data-url", e);
            }
            try {
              (h = this.dom.querySelectorAll(this.ul360, "." + a)),
                this.dom.remove(h);
            } catch (m) {}
            return (
              (d.onload = n.bind(c)),
              (d.onerror = i.bind(c)),
              (r = e),
              (d.src = r),
              (this.customImageOn = !0),
              null
            );
          }),
          (e.prototype.hideImage = function () {
            var e,
              t,
              n,
              i,
              o,
              r = this.ul360.childNodes.length,
              s = !1;
            for (e = 0; e < r; e++)
              (t = this.ul360.childNodes[e]),
                t.classList.contains("cylindo-custom-image") &&
                  (n = t.dataset ? t.dataset.url : t.getAttribute("data-url")),
                (i = t.dataset
                  ? t.dataset.index
                  : t.getAttribute("data-index")),
                t.classList.contains("active") &&
                  (this.handleActiveFrame(t, !1),
                  "undefined" != typeof i && (o = i)),
                i == this.currentIndex &&
                  (this.handleActiveFrame(t, !0),
                  this.handleTooltip(t, i, o),
                  this.handleZoomButton(t, i, o),
                  this.handleActionBtns(t, i, s),
                  this.trigger(this.events.FRAME_ACTIVATED, { index: i }));
            this.customImageOn = !1;
          }),
          (e.prototype.handleTooltip = function (e, t, n) {
            function i() {
              return (
                !(
                  (r.framesHandler.is360Frame(t) &&
                    r.framesHandler.is360Frame(n)) ||
                  (r.framesHandler.isAltId(t) && r.framesHandler.isAltId(n))
                ) && (r.hideTooltip(!0), !0)
              );
            }
            var o,
              r = this,
              s = !1,
              a = this.getTooltipText(),
              l = this.model.get("tooltipAltImgText"),
              d = r.ul360.querySelector(".active");
            (t = "" + t),
              (n = "" + n),
              (s = !!d && d.classList.contains("cylindo-img-not-found")),
              "undefined" == typeof r.tooltip || s
                ? s && r.hideTooltip()
                : (r.tooltip.el.classList.remove("cylindo-tooltip-empty-text"),
                  this.framesHandler.is360Frame(t)
                    ? "string" == typeof a && a.length > 0
                      ? ((o = i()), r.showTooltip(a, !o))
                      : (r.tooltip.el.classList.add(
                          "cylindo-tooltip-empty-text"
                        ),
                        r.hideTooltip(!0))
                    : r.framesHandler.isAltId(t) &&
                      (e.classList.contains("cylindo-video")
                        ? (r.tooltip.el.classList.add(
                            "cylindo-tooltip-empty-text"
                          ),
                          r.hideTooltip(!0))
                        : "string" == typeof l && l.length > 0
                        ? ((o = i()), r.showTooltip(l, !o))
                        : (r.tooltip.el.classList.add(
                            "cylindo-tooltip-empty-text"
                          ),
                          r.hideTooltip(!0)),
                      r.tooltip.changeText(r.model.get("tooltipAltImgText"))));
          }),
          (e.prototype.handleZoomButton = function (e, t, n) {
            var i,
              o = this,
              r = o.dom.siblings(o.ul360, "cylindo-action-button-group"),
              s =
                r && 1 === r.length
                  ? r[0].querySelector(".threesixty-button")
                  : null,
              a = this.util.browser.isMobile(),
              l = o.ul360.getBoundingClientRect(),
              d = null,
              c = null;
            if (
              ((t = "" + t),
              (n = "" + n),
              a && e && o.model.get("zoomButton") && s && s.classList)
            )
              if (
                e.classList.contains("cylindo-video") ||
                e.classList.contains("cylindo-img-not-found")
              )
                s.classList.contains("temporarily-hidden") ||
                  s.classList.add("temporarily-hidden");
              else {
                if (
                  ((i = e.childNodes[0]),
                  i &&
                    (d =
                      i.src ||
                      (i.dataset ? i.dataset.src : i.getAttribute("data-src"))),
                  (c = e.dataset
                    ? e.dataset.zoomImage
                    : e.getAttribute("data-zoom-image")),
                  c &&
                    c.indexOf("data:image") === -1 &&
                    (c = "//" + c.split("//")[1]),
                  c &&
                    d &&
                    c === d.replace(/^http(s)*:/i, "") &&
                    i &&
                    (i.naturalHeight <= l.height || i.naturalWidth <= l.width))
                )
                  return void (
                    s.classList.contains("temporarily-hidden") ||
                    s.classList.add("temporarily-hidden")
                  );
                o.framesHandler.is360Frame(t)
                  ? o.model.get("zoom") &&
                    s.classList.contains("temporarily-hidden") &&
                    s.classList.remove("temporarily-hidden")
                  : o.framesHandler.isAltId(t)
                  ? o.model.get("alternateContentZoom")
                    ? s.classList.contains("temporarily-hidden") &&
                      s.classList.remove("temporarily-hidden")
                    : s.classList.contains("temporarily-hidden") ||
                      s.classList.add("temporarily-hidden")
                  : e.classList.contains("cylindo-custom-image") &&
                    (o.model.get("alternateContentZoom")
                      ? s.classList.contains("temporarily-hidden") &&
                        s.classList.remove("temporarily-hidden")
                      : s.classList.contains("temporarily-hidden") ||
                        s.classList.add("temporarily-hidden"));
              }
          }),
          (e.prototype.handleActionBtns = function (e, t, n) {
            var i = this.wrapper.classList.contains("full-screen"),
              o = this.dom.siblings(this.ul360, "cylindo-action-button-group");
            o &&
              o.length &&
              (this.framesHandler.is360Frame(t) || n
                ? o[0].classList.remove("temporarily-hidden")
                : e.classList.contains("cylindo-video")
                ? (i &&
                    (o[0].classList.contains("video-fullscreen-allowed") ||
                      o[0].classList.add("video-fullscreen-allowed")),
                  o[0].classList.contains("permanently-hidden") ||
                    o[0].classList.add("temporarily-hidden"))
                : o[0].classList.contains("permanently-hidden") ||
                  o[0].classList.remove("temporarily-hidden"));
          }),
          (e.prototype.isRightClick = function (e) {
            return "which" in e
              ? 3 === e.which
              : "button" in e && 2 === e.button;
          }),
          (e.prototype.tryToCreateTooltip = function () {
            var e = this.framesHandler.getAllFramesToBeLoaded(),
              t = !!this.getTooltipText(),
              n = e.ALTERNATE.LEN > 0,
              i =
                "string" == typeof this.model.get("tooltipAltImgText") &&
                this.model.get("tooltipAltImgText").length > 0;
            (this.getTooltipText() || (n && i)) &&
              (this.tooltip = cylindo
                .getModule("tooltip.viewer")
                .create({
                  parent: this.wrapper,
                  text: this.getTooltipText(),
                  dom: this.dom,
                })),
              this.tooltip &&
                (this.tooltip.render(),
                t ||
                  (this.tooltip.el.classList.add("cylindo-tooltip-empty-text"),
                  this.hideTooltip(!0)));
          }),
          (e.prototype.getTooltipText = function () {
            return this.model.get(this.defaultTooltip);
          }),
          (e.prototype.showTooltip = function (e, t) {
            this.tooltip &&
              (this.enabled === !1
                ? this.tooltip.changeText(e)
                : this.tooltip.show(e, t));
          }),
          (e.prototype.hideTooltip = function (e) {
            this.tooltip && this.tooltip.hide(e);
          }),
          (e.prototype.sendFirstFrameCompleteEvt = function (e) {
            this.trigger(this.events.CONTENT_TYPE_COMPLETE, {
              contentType: this.contentTypes.FIRST_FRAME,
              elapsed: this.firstImageLoadedTime - this.viewerUpdatedStartTime,
            });
          }),
          (e.prototype.getThumbsDetails = function () {
            var e = this.framesHandler.getAllFramesToBeLoaded(),
              t = { ts: -1, ac: -1 };
            return (
              e.THUMB.ENABLED &&
                ((t.ts = e.THUMB.THREESIXTY_THUMB_LEN),
                (t.ac = e.ALTERNATE.LEN)),
              t
            );
          }),
          (e.prototype.onAltContentLoad = function () {
            var e = this,
              t = e.viewer.framesHandler.prefixes.ALT + e.index;
            e.li.classList.remove("hidden"),
              e.li.classList.remove("is-rendering"),
              e.viewer.trigger(e.viewer.events.ALT_CONTENT_LOADED, {
                sequence: e.viewer.framesHandler.prefixes.ALT + e.index,
                viewerId: e.viewer.id,
                image:
                  e.imageToPreload && e.imageToPreload.image
                    ? e.imageToPreload.image
                    : null,
              }),
              t === e.viewer.currentIndex &&
                (e.viewer.handleActiveFrame(e.li, !0),
                e.viewer.isVisible || e.viewer.displayViewer());
          }),
          (e.prototype.handleActiveFrame = function (e, t) {
            e &&
              e.classList &&
              (t
                ? (e.setAttribute("aria-hidden", "false"),
                  e.classList.add("active"))
                : (e.setAttribute("aria-hidden", "true"),
                  e.classList.remove("active")));
          }),
          (e.prototype.firstFrameEvt = function (e) {
            this.firstFrameIsReady ||
              ((this.firstFrameIsReady = !0),
              this.trigger(this.events.FIRST_FRAME_COMPLETE, {
                index: e,
                frameCount: this.frameCount,
              }));
          }),
          (e.counter = 0),
          window.cylindo.addModule("cylindo.classes.abstract.view", e);
      }.call(this),
      function () {
        var e = function (e) {
            function t() {
              try {
                f && (r = f.create(A));
              } catch (e) {
                y.error(
                  "An error happened while trying to create the viewer instance.",
                  e
                );
              } finally {
                return i.call();
              }
            }
            function n() {
              var e = !0;
              (s = E.get("presentation")),
                s === d.THREESIXTY.NAME && T > 1
                  ? ((a = d.THREESIXTY.LIST_CLASS),
                    E.set("presentation", "threesixty", e),
                    (A.presentation = s),
                    (f = c),
                    y.log(
                      "Threesixty viewer instance prepared to be created.",
                      A
                    ))
                  : T > 0 &&
                    (s === d.SINGLE.NAME ||
                      (s === d.THREESIXTY.NAME && 1 === T))
                  ? ((a = d.SINGLE.LIST_CLASS),
                    E.set("presentation", "single", e),
                    o(),
                    (s = d.SINGLE.NAME),
                    (A.presentation = s),
                    (f = h),
                    y.log("Single viewer instance prepared to be created.", A))
                  : s === d.CAROUSEL.NAME && T + R > 0
                  ? ((a = d.CAROUSEL.LIST_CLASS),
                    (A.presentation = s),
                    (f = u),
                    y.log(
                      "Carousel viewer instance prepared to be created.",
                      A
                    ))
                  : s === d.STACKED.NAME && T + R > 0
                  ? ((a = d.STACKED.LIST_CLASS),
                    (A.presentation = s),
                    (f = p),
                    y.log("Stacked viewer instance prepared to be created.", A))
                  : R
                  ? ((a = d.CUSTOM.LIST_CLASS),
                    E.set("presentation", "custom", e),
                    (s = d.CUSTOM.NAME),
                    (A.presentation = s),
                    (f = m),
                    y.log("Custom viewer instance prepared to be created.", A))
                  : y.error(
                      "Cannot create instance with the provided parameters",
                      A
                    );
            }
            function i() {
              return { instance: r, presentation: s, list_class: a };
            }
            function o() {
              var e = E.get("tooltipDragTextFixed"),
                t = !0;
              e !== !0 &&
                (l.browser.isMobile()
                  ? E.set("tooltipDragText", "Use Button to Zoom", t)
                  : E.set("tooltipDragText", "Click to Zoom", t));
            }
            var r = null,
              s = null,
              a = null,
              l = cylindo.getModule("cylindo.core.util"),
              d = cylindo.getModule("cylindo.helpers.viewer.presentations"),
              c = cylindo.getModule("threesixty"),
              u = cylindo.getModule("carouselViewer"),
              h = cylindo.getModule("singleViewer"),
              m = cylindo.getModule("customViewer"),
              p = cylindo.getModule("stackedViewer"),
              f = null,
              g = e.framesHandler,
              v = g.getAllFramesToBeLoaded(),
              E = e.model,
              y = e.logger,
              A = e,
              T = v.THREESIXTY.TO_BE_LOADED,
              R = v.ALTERNATE.LEN;
            (this.createViewerInstance = t),
              (this.getInstanceDetails = i),
              (this.prepareViewerCreator = n),
              (this.initialized = !0);
          },
          t = {
            create: function (t) {
              return new e(t);
            },
          };
        window.cylindo.addModule("cylindo.classes.viewer.factory", t);
      }.call(this),
      function () {
        function e(e) {
          function n() {
            function e(e) {
              (a.glbSrc = e),
                a.el.appendChild(a.btn),
                a.btn.removeEventListener("touchend", i, !0),
                a.btn.addEventListener("touchend", i, !0),
                a.show(),
                a.trigger(a.events.AR_BUTTON_READY, { url: a.glbSrc }),
                a.btnExistsPromise.resolve({ glb: a.glbSrc });
            }
            function t() {
              var e = "GLB not found for the requested feature set.";
              (a.glbSrc = null),
                a.btn.removeEventListener("touchend", i, !0),
                a.trigger(a.events.AR_BUTTON_ERROR, {}),
                a.logger.error(e),
                a.btnExistsPromise.reject({ err: e });
            }
            var n,
              o,
              r = {
                AR_NOT_ENABLED: "AR not enabled for this product or version.",
                WRONG_PATHS: "AR paths not found.",
              },
              s = "";
            return (
              (a.currentFeatures = a.model.get("currentFeatures")),
              (o =
                !(!a.currentFeatures || !a.currentFeatures.data) &&
                a.currentFeatures.data.isArEnabled),
              (a.urls = a.currentFeatures ? a.currentFeatures.paths : null),
              a.hide(),
              a.model.isFirstSetOfFt() && a.model.didFirstFeaturesFailed()
                ? void a.logger.error(
                    "First group of features failed, AR won't be displayed."
                  )
                : o && a.urls && a.urls.arPath
                ? ((n = a.urls.arPath.replace("__AR_FORMAT__", "glb")),
                  (n = n.replace("__AR_FILE__", "AR")),
                  (a.el.innerHTML = ""),
                  void a.network.doRequest(
                    n,
                    function (t, i) {
                      a.logger.log("Glb file found for this combination. ", n),
                        e(n);
                    },
                    { type: "HEAD" },
                    t,
                    null
                  ))
                : ((s = o ? r.WRONG_PATHS : r.AR_NOT_ENABLED),
                  a.trigger(a.events.AR_BUTTON_ERROR, {}),
                  void a.logger.error(
                    "Cannot create GLB file for this product. ",
                    s
                  ))
            );
          }
          function i(e) {
            var t,
              n,
              i,
              o = document.createElement("a"),
              r = encodeURIComponent(a.glbSrc),
              s = "#model-viewer-no-ar-fallback",
              l = window.location.toString(),
              d = new URL(l),
              u = new URL(a.network.resolveProtocol(c.ARV_GOOGLE)),
              h = a.model.get("ARBannerConfig"),
              m = h && h.title ? h.title : "",
              p = m
                ? "function" == typeof a.model.get("getArRedirectUrl")
                  ? encodeURIComponent(
                      decodeURIComponent(a.model.get("getArRedirectUrl")())
                    )
                  : encodeURIComponent(l)
                : "",
              f = u.protocol.replace(":", "");
            e && (e.stopPropagation(), a.preventEvents()),
              a.fallbackInvoked ||
                (a.trigger(a.events.AR_SHOW_MODAL, null),
                document.addEventListener("visibilitychange", function () {
                  "visible" === document.visibilityState &&
                    a.trigger(a.events.AR_HIDE_MODAL, null);
                }),
                a.tags.send(a.tags.events.AR_LAUNCHED),
                a.tags.send(a.tags.events.AR_CLICKED),
                a.trigger(a.events.AR_LAUNCHED, null),
                (d.hash = s),
                (m = encodeURIComponent(m)),
                (u.protocol = "intent://"),
                (t = u.toString()),
                (i = t.indexOf("?") !== -1 ? "&" : "?"),
                (t +=
                  i +
                  "file=" +
                  r +
                  "&mode=ar_only&resizable=true&link=" +
                  p +
                  "&title=" +
                  m +
                  "#Intent;scheme=" +
                  f +
                  ";package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=" +
                  encodeURIComponent(d.toString()) +
                  ";end;"),
                (n = function () {
                  window.location.hash !== s ||
                    a.fallbackInvoked ||
                    ((a.fallbackInvoked = !0),
                    window.history.back(),
                    a.hide(),
                    a.trigger(a.events.AR_BUTTON_ERROR, {}),
                    a.trigger(a.events.AR_SHOW_ERROR_MODAL, {}));
                }),
                window.addEventListener("hashchange", n, { once: !0 }),
                o.setAttribute("href", t),
                setTimeout(function () {
                  o.click();
                }, 3e3));
          }
          function o() {
            (a.glbSrc = null),
              a.hide(),
              a.trigger(a.events.AR_BUTTON_ERROR, {});
          }
          function r() {
            var e,
              t,
              n = "ar_only",
              i = !0,
              o = encodeURIComponent(a.glbSrc),
              r = "#model-viewer-no-ar-fallback",
              s = window.location.toString(),
              l = new URL(s),
              d = new URL(a.network.resolveProtocol(c.ARV_GOOGLE)),
              u = a.model.get("ARBannerConfig"),
              h = u && u.title ? u.title : "",
              m = h
                ? "function" == typeof a.model.get("getArRedirectUrl")
                  ? encodeURIComponent(
                      decodeURIComponent(a.model.get("getArRedirectUrl")())
                    )
                  : encodeURIComponent(s)
                : "",
              p = d ? d.protocol.replace(":", "") : null;
            return o
              ? ((l.hash = r),
                (h = encodeURIComponent(h)),
                (d.protocol = "intent://"),
                (e = d.toString()),
                (t = e.indexOf("?") !== -1 ? "&" : "?"),
                (e +=
                  t +
                  "file=" +
                  o +
                  "&link=" +
                  m +
                  "&title=" +
                  h +
                  "&mode=" +
                  n +
                  "&resizable=" +
                  i +
                  "#Intent;scheme=" +
                  p +
                  ";package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=" +
                  encodeURIComponent(l.toString()) +
                  ";end;"))
              : null;
          }
          function s() {
            d.destroy(), (a.btn = null);
          }
          (e.appendButton = !1), t.call(this, e);
          var a = this,
            l = cylindo.getModule("cylindo.core.network"),
            d = cylindo.getModule("cylindo.util.pubsub").create(),
            c = e.settings.get("urls"),
            u = c.AR,
            h = e.util,
            m = e.parent,
            p = e.dom;
          (this.util = h),
            (this.on = d.on),
            (this.off = d.off),
            (this.trigger = d.trigger),
            (this.glbSrc = null),
            (this.network = l),
            (this.settings = e.settings),
            (this.wrapperClasses = ["cylindo-button", "cylindo-ar-button"]),
            (this.model = e.model),
            (this.logger = this.model.getLogger()),
            (this.currentFeatures = this.model.get("currentFeatures")),
            (this.urls = this.currentFeatures
              ? this.currentFeatures.paths
              : null),
            (this.tags = e.tags),
            (this.preventEvents = e.preventEvents),
            (this.glbEndPoint = u),
            (this.initialized = !1),
            (this.btnExistsPromise = this.util.promise.create()),
            (this.fallbackInvoked = !1),
            (this.viewerContainer = m),
            (this.tryToShow = n),
            (this.onFeaturesError = o),
            (this.getArQuickLookUrl = r),
            (this.dom = p),
            (this.destroy = s),
            (this.arOpen = !1);
        }
        var t = cylindo.getModule("cylindo.classes.button");
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e),
          (e.prototype.render = function () {
            function e(e) {
              e && (e.stopPropagation(), e.stopImmediatePropagation());
            }
            var n = this,
              i = document.createElement("div"),
              o = document.createElement("div"),
              r = document.createElement("div");
            (r.innerHTML = n.model.get("ARBtnTxt")),
              i.classList.add("ar-glyph-background"),
              o.classList.add("ar-icon"),
              r.classList.add("ar-text"),
              i.appendChild(o),
              i.appendChild(r),
              t.prototype.render.call(n),
              n.btn.appendChild(i),
              n.btn.setAttribute("href", "#"),
              n.btn.setAttribute("role", "link"),
              n.btn.setAttribute("aria-label", n.ariaLabel.texts.VIEW_IN_AR),
              n.btn.addEventListener("mousedown", e, !0),
              n.btn.addEventListener("mouseup", e, !0),
              n.btn.addEventListener("touchstart", e, !0),
              n.tryToShow(),
              (n.initialized = !0);
          }),
          (e.prototype.events = {
            AR_BUTTON_READY: "ar:button:ready",
            AR_BUTTON_ERROR: "ar:button:error",
            AR_LAUNCHED: "ar:launched",
            AR_SHOW_MODAL: "ar:show:modal",
            AR_HIDE_MODAL: "ar:hide:modal",
            AR_ACTION_BTN_TAPPED: "ar:action:btn:tapped",
            AR_SHOW_ERROR_MODAL: "ar:show:error:modal",
          });
        var n = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.button.ar.glb", n);
      }.call(this),
      function () {
        function e(e) {
          function n() {
            o.destroy(), (self.btn = null);
          }
          (e.appendButton = !1), t.call(this, e);
          var i = cylindo.getModule("cylindo.core.network"),
            o = cylindo.getModule("cylindo.util.pubsub").create(),
            r = e.settings.get("urls"),
            s = r.AR,
            a = e.util;
          (this.util = a),
            (this.on = o.on),
            (this.off = o.off),
            (this.trigger = o.trigger),
            (this.usdzSrc = null),
            (this.network = i),
            (this.settings = e.settings),
            (this.wrapperClasses = ["cylindo-button", "cylindo-ar-button"]),
            (this.model = e.model),
            (this.logger = this.model.getLogger()),
            (this.currentFeatures = this.model.get("currentFeatures")),
            (this.urls = this.currentFeatures
              ? this.currentFeatures.paths
              : null),
            (this.tags = e.tags),
            (this.preventEvents = e.preventEvents),
            (this.usdzEndPoint = s),
            (this.initialized = !1),
            (this.btnExistsPromise = this.util.promise.create()),
            (this.destroy = n),
            (this.arOpen = !1);
        }
        var t = cylindo.getModule("cylindo.classes.button");
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e),
          (e.prototype.render = function () {
            function e(e) {
              e &&
                (e.preventDefault(),
                e.stopPropagation(),
                e.stopImmediatePropagation(),
                o.preventEvents());
            }
            function n(t) {
              t && e(t),
                o.trigger(o.events.AR_SHOW_MODAL, null),
                document.addEventListener("visibilitychange", function () {
                  "visible" === document.visibilityState &&
                    o.trigger(o.events.AR_HIDE_MODAL, null);
                }),
                o.tags.send(o.tags.events.AR_LAUNCHED),
                o.tags.send(o.tags.events.AR_CLICKED),
                o.trigger(o.events.AR_LAUNCHED, null),
                setTimeout(function () {
                  o.btn.click();
                }, 3e3);
            }
            function i(e) {
              e &&
                "_apple_ar_quicklook_button_tapped" === e.data &&
                (o.tags.send(o.tags.events.AR_BANNER_CLICKED),
                o.trigger(o.events.AR_ACTION_BTN_TAPPED, e));
            }
            var o = this,
              r = new Image(),
              s = document.createElement("div"),
              a = document.createElement("div"),
              l = document.createElement("div");
            (l.innerHTML = o.model.get("ARBtnTxt")),
              s.classList.add("ar-glyph-background"),
              a.classList.add("ar-icon"),
              l.classList.add("ar-text"),
              s.appendChild(a),
              s.appendChild(l),
              t.prototype.render.call(o),
              (r.src = ""),
              o.btn.appendChild(r),
              o.btn.appendChild(s),
              o.btn.setAttribute("rel", "ar"),
              o.btn.setAttribute("href", "#"),
              o.btn.setAttribute("role", "link"),
              o.btn.setAttribute("aria-label", o.ariaLabel.texts.VIEW_IN_AR),
              o.btn.addEventListener("mousedown", e, !0),
              o.btn.addEventListener("mouseup", e, !0),
              o.btn.addEventListener("touchstart", e, !0),
              o.btn.addEventListener("touchend", n, !0),
              o.btn.addEventListener("message", i, !1),
              o.tryToShow(),
              (o.initialized = !0);
          }),
          (e.prototype.tryToShow = function () {
            function e(e) {
              var t,
                n = [],
                i = o.model.get("ARBannerConfig");
              for (t in i)
                "string" == typeof i[t] &&
                  n.push(t + "=" + encodeURIComponent(i[t]));
              n.length > 0 && (e = e + "#" + n.join("&")),
                (o.usdzSrc = e),
                o.btn.setAttribute("href", o.usdzSrc),
                o.el.appendChild(o.btn),
                o.show(),
                o.trigger(o.events.AR_BUTTON_READY, { url: o.usdzSrc }),
                o.btnExistsPromise.resolve({ usdz: o.usdzSrc });
            }
            function t() {
              var e = "USDZ not found for the requested feature set.";
              (o.usdzSrc = null),
                o.trigger(o.events.AR_BUTTON_ERROR, {}),
                o.logger.error(e),
                o.btnExistsPromise.reject({ err: e });
            }
            var n,
              i,
              o = this,
              r = {
                AR_NOT_ENABLED: "AR not enabled for this product or version.",
                WRONG_PATHS: "AR paths not found.",
              },
              s = "";
            return (
              (o.currentFeatures = o.model.get("currentFeatures")),
              (i =
                !(!o.currentFeatures || !o.currentFeatures.data) &&
                o.currentFeatures.data.isArEnabled),
              (o.urls = o.currentFeatures ? o.currentFeatures.paths : null),
              o.hide(),
              o.model.isFirstSetOfFt() && o.model.didFirstFeaturesFailed()
                ? void o.logger.error(
                    "First group of features failed, AR won't be displayed."
                  )
                : i && o.urls && o.urls.arPath
                ? ((n = o.urls.arPath.replace("__AR_FORMAT__", "usdz")),
                  (n = n.replace("__AR_FILE__", "AR")),
                  (o.el.innerHTML = ""),
                  void o.network.doRequest(
                    n,
                    function (t, i) {
                      o.logger.log("Usdz file found for this combination. ", n),
                        e(n);
                    },
                    { type: "HEAD" },
                    t,
                    null
                  ))
                : ((s = i ? r.WRONG_PATHS : r.AR_NOT_ENABLED),
                  o.trigger(o.events.AR_BUTTON_ERROR, {}),
                  void o.logger.error(
                    "Cannot create USDZ file for this product.",
                    s
                  ))
            );
          }),
          (e.prototype.onFeaturesError = function () {
            var e = this;
            (e.usdzSrc = null),
              e.hide(),
              e.trigger(e.events.AR_BUTTON_ERROR, {});
          }),
          (e.prototype.getArQuickLookUrl = function () {
            return this.usdzSrc || null;
          }),
          (e.prototype.events = {
            AR_BUTTON_READY: "ar:button:ready",
            AR_BUTTON_ERROR: "ar:button:error",
            AR_LAUNCHED: "ar:launched",
            AR_SHOW_MODAL: "ar:show:modal",
            AR_HIDE_MODAL: "ar:hide:modal",
            AR_ACTION_BTN_TAPPED: "ar:action:btn:tapped",
            AR_SHOW_ERROR_MODAL: "ar:show:error:modal",
          });
        var n = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.button.ar.usdz", n);
      }.call(this),
      function () {
        function e(e) {
          function t() {
            n() ||
              (r.seenEventsAttached && i(),
              window.addEventListener
                ? (window.addEventListener("scroll", n, !1),
                  window.addEventListener("resize", n, !1),
                  (r.seenEventsAttached = !0))
                : window.attachEvent &&
                  (window.attachEvent("onscroll", n),
                  window.attachEvent("onresize", n),
                  (r.seenEventsAttached = !0)));
          }
          function n() {
            if (!(h && Date.now() - h < 250))
              return (
                (h = Date.now()),
                !(r.arSeen || !o()) &&
                  ((r.arSeen = !0),
                  r.tags.send(r.tags.events.AR_SEEN),
                  r.seenEventsAttached && i(),
                  !0)
              );
          }
          function i() {
            window.removeEventListener
              ? (window.removeEventListener("scroll", n, !1),
                window.removeEventListener("resize", n, !1),
                (r.seenEventsAttached = !1))
              : window.attachEvent &&
                (window.detachEvent("onscroll", n),
                window.detachEvent("onresize", n),
                (r.seenEventsAttached = !1));
          }
          function o() {
            var e,
              t,
              n,
              i,
              o = r.el && r.el.getBoundingClientRect();
            return (
              !!o &&
              ((e =
                window.innerHeight || document.documentElement.clientHeight),
              (t = window.innerWidth || document.documentElement.clientWidth),
              (n = o.top <= e && o.top + o.height >= 0),
              (i = o.left <= t && o.left + o.width >= 0),
              n && i)
            );
          }
          var r = this,
            s = cylindo.getModule("cylindo.helpers.ar.modes"),
            a = cylindo.getModule("cylindo.button.ar.usdz"),
            l = cylindo.getModule("cylindo.button.ar.glb"),
            d = cylindo.getModule("cylindo.button.ar.qr"),
            c = e.util,
            u = null,
            h = 0,
            m = e.model;
          if (
            ((this.model = m),
            (this.arSeen = !1),
            (this.seenEventsAttached = !0),
            (this.ariaLabel = e.ariaLabel),
            m.get("arMode") === s.ARQUICKLOOK
              ? (u = a.create(e))
              : m.get("arMode") === s.SCENE_VIEWER
              ? (u = l.create(e))
              : m.get("arMode") === s.QR && (u = d.create(e)),
            u)
          )
            return (u.handleARButtonReady = t), c.object.extend(this, u);
        }
        (e.prototype.render = function () {
          throw new Error("Method MUST be implemented.");
        }),
          (e.prototype.tryToShow = function () {
            throw new Error("Method MUST be implemented.");
          }),
          (e.prototype.onFeaturesError = function () {
            throw new Error("Method MUST be implemented.");
          }),
          (e.prototype.previousErrorFound = function () {
            throw new Error("Method MUST be implemented.");
          }),
          (e.prototype.getArQuickLookUrl = function () {
            throw new Error("Method MUST be implemented.");
          }),
          (e.prototype.on = function () {
            throw new Error("Method MUST be implemented.");
          }),
          (e.prototype.off = function () {
            throw new Error("Method MUST be implemented.");
          }),
          (e.prototype.destroy = function () {
            throw new Error("Method MUST be implemented.");
          }),
          (e.prototype.sendInitialTags = function () {
            var e = this,
              t = ["ios", "android", "ios-android"],
              n = e.model.get("ARDesktop") === !0,
              i = t.indexOf(e.model.get("ARBanner")) !== -1;
            e &&
              e.tags &&
              (e.tags.updateARFlags(n, i),
              e.tags.send(e.tags.events.AR_LOADED),
              e.arSeen || e.handleARButtonReady());
          }),
          (e.prototype.events = {});
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.button.ar", t);
      }.call(this),
      function () {
        var e = function (e) {
            function t(e) {
              return a.getData(e);
            }
            function n(e, t) {
              a.setData(e, t);
            }
            function i() {
              return a.processData.apply(null, arguments);
            }
            function o() {
              return s.initialized;
            }
            function r() {
              var e = { viewerData: d, logger: l };
              s.initialized ||
                ((s.initialized = !0),
                (a = cylindo
                  .getModule("cylindo.classes.database.rtv")
                  .create(e)));
            }
            var s = this,
              a = null,
              l = e.logger,
              d = e.viewerData;
            (this.enabled = !1),
              (this.init = r),
              (this.isInitialized = o),
              (this.getData = t),
              (this.setData = n),
              (this.processData = i);
          },
          t = {
            create: function (t) {
              return new e(t);
            },
          };
        window.cylindo.addModule("cylindo.classes.database", t);
      }.call(this),
      function () {
        var e = function (e) {
            function t(e) {
              return r.get(e);
            }
            function n(e, t) {
              r.set(e, t);
            }
            function i(e, t, i) {
              try {
                n(e + "-" + t, i);
              } catch (r) {
                o.logger.error("Cannot store the features.", r);
              }
            }
            var o = this,
              r = cylindo.getModule("cylindo.core.cache").create();
            (this.setData = n), (this.getData = t), (this.processData = i);
          },
          t = {
            create: function (t) {
              return new e(t);
            },
          };
        window.cylindo.addModule("cylindo.classes.database.rtv", t);
      }.call(this),
      function () {
        var e = cylindo.getModule("tracking") || {},
          t = function (e) {};
        (t.prototype.checkout = function (e, t, n, i) {
          var o =
            "Cylindo: checkout method has been deprecated, please consult our documentation or contact the Support team to look for alternatives.";
          console.warn ? console.warn(o) : console.log(o), i(!1);
        }),
          (t.prototype.getItem = function (e, t, n, i, o) {
            var r =
              "Cylindo: getItem method has been deprecated, please consult our documentation or contact the Support team to look for alternatives.";
            return (
              console.warn ? console.warn(r) : console.log(r),
              {
                sku: e,
                quantity: t,
                price: n,
                org_price: i,
                features: o.join("*"),
              }
            );
          }),
          (e.checkout = {}),
          (e.checkout.create = function (e) {
            var n =
              "Cylindo: 'checkout' module has been deprecated, please consult our documentation or contact the Support team to look for alternatives.";
            return console.warn ? console.warn(n) : console.log(n), new t(e);
          }),
          cylindo.addModule("tracking", e, !0);
      }.call(this),
      function () {
        var e = function n(e) {
          function t() {
            (o.instanceID = ++n.counter), (o.initialized = !0);
          }
          function i(e, t) {
            function n() {
              return window[a] || window["_" + a] || null;
            }
            var i,
              o,
              s,
              a = "gtag",
              l = 0,
              u = 0,
              h = t.features instanceof Array ? t.features : [],
              m = null;
            if (e && n())
              try {
                for (i in r) r[i] === e.e && (o = c[i]);
                if (o && ((o.ONE_PER_PAGE && o.TRIGGERED) || !o.GA4)) return;
                for (
                  s = {
                    event: "cylindoGA4Event",
                    event_name: o.EVENT_NAME_GA4,
                    model_code: decodeURIComponent(t.productCode),
                    model_version: t.version,
                    device: d,
                  },
                    l = 0;
                  l < h.length;
                  l += 2
                )
                  ++u,
                    (s["feature_type_code_" + u] = decodeURIComponent(h[l])),
                    (s["option_code_" + u] = decodeURIComponent(h[l + 1]));
                switch (((m = (e && e.d) || {}), e.e)) {
                  case r.AR_LOADED:
                  case r.AR_SEEN:
                  case r.AR_LAUNCHED:
                  case r.AR_CLICKED:
                  case r.AR_BANNER_CLICKED:
                    (s.ar_desktop_enabled = t.ARDesktop || !1),
                      (s.ar_banner_enabled = t.ARBanner || !1);
                    break;
                  case r.FULLSCREEN:
                  case r.ZOOM:
                  case r.SPIN:
                  case r.FEATURE_CHANGED:
                  case r.THUMBNAIL_CLICK:
                    s.viewer_engagement_type = o.ACTION;
                    break;
                  case r.ALT_IMAGE_LOADED:
                  case r.ALT_IMAGE_VIEWED:
                    if (
                      ((s.alt_model_code =
                        decodeURIComponent(m.productCode) || ""),
                      (s.alt_model_version = m.version || ""),
                      (s.alt_frame_number = m.frameNumber || ""),
                      (s.alt_image_name =
                        decodeURIComponent(m.imageName) || ""),
                      (s.alt_cylindo_content = m.isCylindoImage || !1),
                      (s.alt_image = m.image || ""),
                      (u = 0),
                      m.features)
                    )
                      for (l = 0; l < m.features.length; l += 2)
                        ++u,
                          (s["alt_feature_type_code_" + u] = decodeURIComponent(
                            m.features[l]
                          )),
                          (s["alt_option_code_" + u] = decodeURIComponent(
                            m.features[l + 1]
                          ));
                    break;
                  case r.ERROR_LOADING:
                    s.error_description = m.error_description || "";
                }
                n()("event", o.EVENT_NAME_GA4, s), (o.TRIGGERED = !0);
              } catch (p) {
                console.log(
                  "Something went wrong while trying to send the event using Global Site Tag.",
                  p
                );
              }
          }
          var o = this,
            r = e.events,
            s = cylindo.getModule("cylindo.core.google.maps"),
            a = cylindo.getModule("cylindo.core.util"),
            l = s.getDeviceCategories(),
            d = a.browser.isMobile() ? l.MOBILE : l.DESKTOP,
            c = s.getEventsData();
          (o.initialized = !1), (o.init = t), (o.saveEvent = i), t();
        };
        e.counter = 0;
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.core.ga4.gtag", t);
      }.call(this),
      function () {
        var e = function n(e) {
          function t() {
            (o.instanceID = ++n.counter), (o.initialized = !0);
          }
          function i(e, t) {
            var n,
              i,
              o,
              a = 0,
              l = 0,
              d = t.features instanceof Array ? t.features : [],
              h = null;
            if (e && r)
              try {
                for (n in s) s[n] === e.e && (i = u[n]);
                if (i && ((i.ONE_PER_PAGE && i.TRIGGERED) || !i.GA4)) return;
                for (
                  o = {
                    event: "cylindoGA4Event",
                    event_name: i.EVENT_NAME_GA4,
                    model_code: decodeURIComponent(t.productCode),
                    model_version: t.version,
                    device: c,
                  },
                    a = 0;
                  a < d.length;
                  a += 2
                )
                  ++l,
                    (o["feature_type_code_" + l] = decodeURIComponent(d[a])),
                    (o["option_code_" + l] = decodeURIComponent(d[a + 1]));
                switch (((h = (e && e.d) || {}), e.e)) {
                  case s.AR_LOADED:
                  case s.AR_SEEN:
                  case s.AR_LAUNCHED:
                  case s.AR_CLICKED:
                  case s.AR_BANNER_CLICKED:
                    (o.ar_desktop_enabled = t.ARDesktop || !1),
                      (o.ar_banner_enabled = t.ARBanner || !1);
                    break;
                  case s.FULLSCREEN:
                  case s.ZOOM:
                  case s.SPIN:
                  case s.FEATURE_CHANGED:
                  case s.THUMBNAIL_CLICK:
                    o.viewer_engagement_type = i.ACTION;
                    break;
                  case s.ALT_IMAGE_LOADED:
                  case s.ALT_IMAGE_VIEWED:
                    if (
                      ((o.alt_model_code =
                        decodeURIComponent(h.productCode) || ""),
                      (o.alt_model_version = h.version || ""),
                      (o.alt_frame_number = h.frameNumber || ""),
                      (o.alt_image_name =
                        decodeURIComponent(h.imageName) || ""),
                      (o.alt_cylindo_content = h.isCylindoImage || !1),
                      (o.alt_image = h.image || ""),
                      (l = 0),
                      h.features)
                    )
                      for (a = 0; a < h.features.length; a += 2)
                        ++l,
                          (o["alt_feature_type_code_" + l] = decodeURIComponent(
                            h.features[a]
                          )),
                          (o["alt_option_code_" + l] = decodeURIComponent(
                            h.features[a + 1]
                          ));
                    break;
                  case s.ERROR_LOADING:
                    o.error_description = h.error_description || "";
                }
                r.push(o), (i.TRIGGERED = !0);
              } catch (m) {
                console.log(
                  "Something went wrong while trying to send the event using Google Tag Manager.",
                  m
                );
              }
          }
          var o = this,
            r = e.dataLayer,
            s = e.events,
            a = cylindo.getModule("cylindo.core.google.maps"),
            l = cylindo.getModule("cylindo.core.util"),
            d = a.getDeviceCategories(),
            c = l.browser.isMobile() ? d.MOBILE : d.DESKTOP,
            u = a.getEventsData();
          (o.initialized = !1), (o.init = t), (o.saveEvent = i), t();
        };
        e.counter = 0;
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.core.ga4.gtm", t);
      }.call(this),
      function () {
        function e() {
          return r;
        }
        function t() {
          return s;
        }
        function n() {
          return a;
        }
        function i() {
          return {
            LOADED: {
              UA: !0,
              GA4: !0,
              ACTION: "Loaded",
              LABEL: s.CYLINDO_360,
              ONE_PER_PAGE: !0,
              TRIGGERED: !1,
              DIMENSION_VAL_360: a.LOADED + " " + s.CYLINDO_360,
              EVENT_NAME_GA4: s.CYLINDO_VIEWER_GA4 + a.LOADED,
            },
            SEEN: {
              UA: !0,
              GA4: !0,
              ACTION: "Seen",
              LABEL: s.CYLINDO_360,
              ONE_PER_PAGE: !0,
              TRIGGERED: !1,
              DIMENSION_VAL_360: a.SEEN + " " + s.CYLINDO_360,
              EVENT_NAME_GA4: s.CYLINDO_VIEWER_GA4 + a.SEEN,
            },
            FULLSCREEN: {
              UA: !0,
              GA4: !0,
              ACTION: "Full screen",
              LABEL: s.CYLINDO_360,
              ONE_PER_PAGE: !0,
              TRIGGERED: !1,
              DIMENSION_VAL_360: a.ENGAGED + " " + s.CYLINDO_360,
              EVENT_NAME_GA4: s.CYLINDO_VIEWER_GA4 + a.ENGAGED,
            },
            ZOOM: {
              UA: !0,
              GA4: !0,
              ACTION: "Zoom",
              LABEL: s.CYLINDO_360,
              ONE_PER_PAGE: !0,
              TRIGGERED: !1,
              DIMENSION_VAL_360: a.ENGAGED + " " + s.CYLINDO_360,
              EVENT_NAME_GA4: s.CYLINDO_VIEWER_GA4 + a.ENGAGED,
            },
            SPIN: {
              UA: !0,
              GA4: !0,
              ACTION: "Spin",
              LABEL: s.CYLINDO_360,
              ONE_PER_PAGE: !0,
              TRIGGERED: !1,
              DIMENSION_VAL_360: a.ENGAGED + " " + s.CYLINDO_360,
              EVENT_NAME_GA4: s.CYLINDO_VIEWER_GA4 + a.ENGAGED,
            },
            FEATURE_CHANGED: {
              UA: !0,
              GA4: !0,
              ACTION: "Feature changed",
              LABEL: s.CYLINDO_360,
              ONE_PER_PAGE: !1,
              TRIGGERED: !1,
              DIMENSION_VAL_360: a.ENGAGED + " " + s.CYLINDO_360,
              EVENT_NAME_GA4: s.CYLINDO_VIEWER_GA4 + a.ENGAGED,
            },
            FEATURE_ERROR: {
              UA: !0,
              GA4: !1,
              ACTION: "Feature error",
              LABEL: s.CYLINDO_360,
              ONE_PER_PAGE: !1,
              TRIGGERED: !1,
              DIMENSION_VAL_360: a.ENGAGED + " " + s.CYLINDO_360,
            },
            THUMBNAIL_CLICK: {
              UA: !0,
              GA4: !0,
              ACTION: "Thumbnail click",
              LABEL: s.CYLINDO_360,
              ONE_PER_PAGE: !1,
              TRIGGERED: !1,
              DIMENSION_VAL_360: a.ENGAGED + " " + s.CYLINDO_360,
              EVENT_NAME_GA4: s.CYLINDO_VIEWER_GA4 + a.ENGAGED,
            },
            AR_LOADED: {
              UA: !0,
              GA4: !0,
              ACTION: "Loaded",
              LABEL: s.CYLINDO_AR,
              ONE_PER_PAGE: !0,
              TRIGGERED: !1,
              EVENT_NAME_GA4: s.CYLINDO_AR_GA4 + a.LOADED,
            },
            AR_SEEN: {
              UA: !0,
              GA4: !0,
              ACTION: "Seen",
              LABEL: s.CYLINDO_AR,
              ONE_PER_PAGE: !0,
              TRIGGERED: !1,
              DIMENSION_VAL_AR: s.CYLINDO_AR + " " + a.BUTTON_SEEN,
              EVENT_NAME_GA4: s.CYLINDO_AR_GA4 + a.BUTTON_SEEN,
            },
            AR_LAUNCHED: {
              UA: !0,
              GA4: !0,
              ACTION: "AR Launched",
              LABEL: s.CYLINDO_AR,
              ONE_PER_PAGE: !0,
              TRIGGERED: !1,
              DIMENSION_VAL_AR: s.CYLINDO_AR + " " + a.LAUNCHED,
              EVENT_NAME_GA4: s.CYLINDO_AR_GA4 + a.LAUNCHED,
            },
            AR_CLICKED: {
              UA: !0,
              GA4: !0,
              ACTION: "AR Clicked",
              LABEL: s.CYLINDO_AR,
              ONE_PER_PAGE: !1,
              TRIGGERED: !1,
              DIMENSION_VAL_AR: s.CYLINDO_AR + " " + a.CLICKED,
              EVENT_NAME_GA4: s.CYLINDO_AR_GA4 + a.CLICKED,
            },
            AR_BANNER_CLICKED: {
              UA: !0,
              GA4: !0,
              ACTION: "AR Banner Clicked",
              LABEL: s.CYLINDO_AR,
              ONE_PER_PAGE: !1,
              TRIGGERED: !1,
              DIMENSION_VAL_AR: s.CYLINDO_AR + " " + a.CLICKED,
              EVENT_NAME_GA4: s.CYLINDO_AR_GA4 + a.BANNER_CLICKED,
            },
            ALT_IMAGE_LOADED: {
              UA: !1,
              GA4: !0,
              ONE_PER_PAGE: !1,
              TRIGGERED: !1,
              EVENT_NAME_GA4: s.CYLINDO_ALT_IMG_GA4 + a.LOADED,
            },
            ALT_IMAGE_VIEWED: {
              UA: !1,
              GA4: !0,
              ONE_PER_PAGE: !1,
              TRIGGERED: !1,
              EVENT_NAME_GA4: s.CYLINDO_ALT_IMG_GA4 + a.VIEWED,
            },
            ERROR_LOADING: {
              UA: !1,
              GA4: !0,
              ONE_PER_PAGE: !1,
              TRIGGERED: !1,
              EVENT_NAME_GA4: s.CYLINDO_VIEWER_GA4 + a.ERROR_LOADING,
            },
          };
        }
        var o = {
            getLabels: t,
            getActions: n,
            getEventsData: i,
            getDeviceCategories: e,
          },
          r = { MOBILE: "mobile", DESKTOP: "desktop" },
          s = {
            CYLINDO_360: "Cylindo360",
            CYLINDO_AR: "CylindoAR",
            CYLINDO_VIEWER_GA4: "Cylindo Viewer ",
            CYLINDO_AR_GA4: "Cylindo AR ",
            CYLINDO_ALT_IMG_GA4: "Cylindo Alt Image ",
          },
          a = {
            LOADED: "Loaded",
            VIEWED: "Viewed",
            SEEN: "Seen",
            ENGAGED: "Engaged",
            BUTTON_SEEN: "Button seen",
            LAUNCHED: "Lauched",
            CLICKED: "Clicked",
            BANNER_CLICKED: "Banner Clicked",
            ERROR_LOADING: "Error Loading,",
          };
        window.cylindo.addModule("cylindo.core.google.maps", o);
      }.call(this),
      function () {
        var e = function n(e) {
          function t() {
            (o.instanceID = ++n.counter), (o.initialized = !0);
          }
          function i(e, t) {
            function n() {
              return window[window[d]];
            }
            var i,
              o,
              d = "GoogleAnalyticsObject",
              u = !1,
              h = {
                hitType: "event",
                event: "cylindoEvent",
                eventCategory: "Cylindo",
                eventValue: void 0,
              },
              m = { id: t.productCode, name: t.productCode },
              p = !1,
              f = !1,
              g = !1;
            if (e && n())
              try {
                for (i in s) s[i] === e.e && (o = c[i]);
                switch (e.e) {
                  case s.LOADED:
                    (u = !0), (f = !0);
                    break;
                  case s.SEEN:
                  case s.FULLSCREEN:
                  case s.ZOOM:
                  case s.SPIN:
                  case s.FEATURE_CHANGED:
                  case s.FEATURE_ERROR:
                  case s.THUMBNAIL_CLICK:
                    a.analytics360HitMetric &&
                      ((p = !0), (h[l.METRIC + a.analytics360HitMetric] = 1));
                    break;
                  case s.AR_LOADED:
                  case s.AR_SEEN:
                    f = !0;
                    break;
                  case s.AR_CLICKED:
                  case s.AR_BANNER_CLICKED:
                  case s.AR_LAUNCHED:
                    a.analyticsARHitMetric &&
                      ((p = !0), (h[l.METRIC + a.analyticsARHitMetric] = 1));
                }
                if (o && ((o.ONE_PER_PAGE && o.TRIGGERED) || !o.UA)) return;
                (h.eventAction = o.ACTION),
                  (h.eventLabel = o.LABEL),
                  o.DIMENSION_VAL_360 &&
                    (a.analytics360HitDimension &&
                      (h[l.DIMENSION + a.analytics360HitDimension] =
                        o.DIMENSION_VAL_360),
                    a.analytics360SessionDimension &&
                      (h[l.DIMENSION + a.analytics360SessionDimension] =
                        o.DIMENSION_VAL_360)),
                  o.DIMENSION_VAL_AR &&
                    (a.analyticsARHitDimension &&
                      (h[l.DIMENSION + a.analyticsARHitDimension] =
                        o.DIMENSION_VAL_AR),
                    a.analyticsARSessionDimension &&
                      (h[l.DIMENSION + a.analyticsARSessionDimension] =
                        o.DIMENSION_VAL_AR)),
                  u &&
                    e.d &&
                    (a.analytics360ProductDimension &&
                      e.d.hasOwnProperty("t") &&
                      e.d.t > 0 &&
                      ((g = !0),
                      (m[l.DIMENSION + a.analytics360ProductDimension] =
                        "Cylindo360")),
                    g &&
                      (n()("require", "ec"),
                      n()(r + ".ec:addProduct", m),
                      n()(r + ".ec:setAction", "detail"),
                      n()(
                        r + ".send",
                        "event",
                        "Ecommerce",
                        "Product Detail View",
                        void 0,
                        void 0
                      ))),
                  (p || f) &&
                    (n()(r + ".send", "event", h), (o.TRIGGERED = !0));
              } catch (v) {
                console.log(
                  "Something went wrong while trying to send the event using Google Analytics.",
                  v
                );
              }
          }
          var o = this,
            r = e.gaName,
            s = e.events,
            a = e.gaKeys,
            l = e.prefixes,
            d = cylindo.getModule("cylindo.core.google.maps"),
            c = d.getEventsData();
          (o.initialized = !1), (o.init = t), (o.saveEvent = i), t();
        };
        e.counter = 0;
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.core.ua.ga", t);
      }.call(this),
      function () {
        var e = function n(e) {
          function t() {
            (o.instanceID = ++n.counter), (o.initialized = !0);
          }
          function i(e, t) {
            function n() {
              return window[h] || window["_" + h];
            }
            var i,
              o,
              d,
              u,
              h = "gtag",
              m = !1,
              p = !1,
              f = !1,
              g = !1,
              v = {
                event: "cylindoEvent",
                eventCategory: "Cylindo",
                eventValue: void 0,
              },
              E = { event: "detail", ecommerce: { detail: { items: [{}] } } };
            if (
              ((v[l.DIMENSION + a.analytics360HitDimension] = void 0),
              (v[l.DIMENSION + a.analytics360SessionDimension] = void 0),
              (v[l.DIMENSION + a.analytics360ProductDimension] = void 0),
              (v[l.DIMENSION + a.analyticsARHitDimension] = void 0),
              (v[l.DIMENSION + a.analyticsARSessionDimension] = void 0),
              (v[l.METRIC + a.analytics360HitMetric] = void 0),
              (v[l.METRIC + a.analyticsARHitMetric] = void 0),
              (E.ecommerce.detail.items[0][
                l.DIMENSION + a.analytics360ProductDimension
              ] = void 0),
              e && r)
            )
              try {
                for (i in s) s[i] === e.e && (o = c[i]);
                switch (e.e) {
                  case s.LOADED:
                    (m = !0), (f = !0);
                    break;
                  case s.SEEN:
                    f = !0;
                    break;
                  case s.FULLSCREEN:
                  case s.ZOOM:
                  case s.SPIN:
                  case s.FEATURE_CHANGED:
                  case s.THUMBNAIL_CLICK:
                    a.analytics360HitMetric &&
                      ((p = !0), (v[l.METRIC + a.analytics360HitMetric] = 1));
                    break;
                  case s.AR_LOADED:
                  case s.AR_SEEN:
                    f = !0;
                    break;
                  case s.AR_CLICKED:
                  case s.AR_BANNER_CLICKED:
                  case s.AR_LAUNCHED:
                    a.analyticsARHitMetric &&
                      ((p = !0), (v[l.METRIC + a.analyticsARHitMetric] = 1));
                }
                if (o && ((o.ONE_PER_PAGE && o.TRIGGERED) || !o.UA)) return;
                if (
                  ((v.eventAction = o.ACTION),
                  (v.eventLabel = o.LABEL),
                  o.DIMENSION_VAL_360 &&
                    (a.analytics360HitDimension &&
                      (v[l.DIMENSION + a.analytics360HitDimension] =
                        o.DIMENSION_VAL_360),
                    a.analytics360SessionDimension &&
                      (v[l.DIMENSION + a.analytics360SessionDimension] =
                        o.DIMENSION_VAL_360)),
                  o.DIMENSION_VAL_AR &&
                    (a.analyticsARHitDimension &&
                      (v[l.DIMENSION + a.analyticsARHitDimension] =
                        o.DIMENSION_VAL_AR),
                    a.analyticsARSessionDimension &&
                      (v[l.DIMENSION + a.analyticsARSessionDimension] =
                        o.DIMENSION_VAL_AR)),
                  m &&
                    e.d &&
                    (a.analytics360ProductDimension &&
                      e.d.hasOwnProperty("t") &&
                      e.d.t > 0 &&
                      ((g = !0),
                      (E.ecommerce.detail.items[0][
                        l.DIMENSION + a.analytics360ProductDimension
                      ] = "Cylindo360")),
                    g &&
                      ((E.ecommerce.detail.items[0].id = t.productCode),
                      (E.ecommerce.detail.items[0].name = t.productCode),
                      (d = { items: E.ecommerce.detail.items }),
                      n()("event", E.event, d))),
                  p || f)
                ) {
                  d = {
                    event_action: v.eventAction,
                    event_category: v.eventCategory,
                    event_label: v.eventLabel,
                    value: v.eventValue,
                  };
                  for (u in v)
                    (u.indexOf(l.DIMENSION) === -1 &&
                      u.indexOf(l.METRIC) === -1) ||
                      (d[u] = v[u]);
                  n()("event", v.eventAction, d), (o.TRIGGERED = !0);
                }
              } catch (y) {
                console.log(
                  "Something went wrong while trying to send the event using Global Site Tag.",
                  y
                );
              }
          }
          var o = this,
            r = e.dataLayer,
            s = e.events,
            a = e.gaKeys,
            l = e.prefixes,
            d = cylindo.getModule("cylindo.core.google.maps"),
            c = d.getEventsData();
          (o.initialized = !1), (o.init = t), (o.saveEvent = i), t();
        };
        e.counter = 0;
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.core.ua.gtag", t);
      }.call(this),
      function () {
        var e = function n(e) {
          function t() {
            (o.instanceID = ++n.counter), (o.initialized = !0);
          }
          function i(e, t) {
            var n,
              i,
              o = !1,
              d = !1,
              u = !1,
              h = !1,
              m = {
                event: "cylindoEvent",
                eventCategory: "Cylindo",
                eventValue: void 0,
              },
              p = {
                event: "eec.detail",
                ecommerce: { detail: { products: [{}] } },
              };
            if (
              ((m[l.DIMENSION + a.analytics360HitDimension] = void 0),
              (m[l.DIMENSION + a.analytics360SessionDimension] = void 0),
              (m[l.DIMENSION + a.analytics360ProductDimension] = void 0),
              (m[l.DIMENSION + a.analyticsARHitDimension] = void 0),
              (m[l.DIMENSION + a.analyticsARSessionDimension] = void 0),
              (m[l.METRIC + a.analytics360HitMetric] = void 0),
              (m[l.METRIC + a.analyticsARHitMetric] = void 0),
              (p.ecommerce.detail.products[0][
                l.DIMENSION + a.analytics360ProductDimension
              ] = void 0),
              e && r)
            )
              try {
                for (n in s) s[n] === e.e && (i = c[n]);
                switch (e.e) {
                  case s.LOADED:
                    (o = !0), (u = !0);
                    break;
                  case s.SEEN:
                    u = !0;
                    break;
                  case s.FULLSCREEN:
                  case s.ZOOM:
                  case s.SPIN:
                  case s.FEATURE_CHANGED:
                  case s.FEATURE_ERROR:
                  case s.THUMBNAIL_CLICK:
                    a.analytics360HitMetric &&
                      ((d = !0), (m[l.METRIC + a.analytics360HitMetric] = 1));
                    break;
                  case s.AR_LOADED:
                  case s.AR_SEEN:
                    u = !0;
                    break;
                  case s.AR_CLICKED:
                  case s.AR_BANNER_CLICKED:
                  case s.AR_LAUNCHED:
                    a.analyticsARHitMetric &&
                      ((d = !0), (m[l.METRIC + a.analyticsARHitMetric] = 1));
                }
                if (i && ((i.ONE_PER_PAGE && i.TRIGGERED) || !i.UA)) return;
                (m.eventAction = i.ACTION),
                  (m.eventLabel = i.LABEL),
                  i.DIMENSION_VAL_360 &&
                    (a.analytics360HitDimension &&
                      (m[l.DIMENSION + a.analytics360HitDimension] =
                        i.DIMENSION_VAL_360),
                    a.analytics360SessionDimension &&
                      (m[l.DIMENSION + a.analytics360SessionDimension] =
                        i.DIMENSION_VAL_360)),
                  i.DIMENSION_VAL_AR &&
                    (a.analyticsARHitDimension &&
                      (m[l.DIMENSION + a.analyticsARHitDimension] =
                        i.DIMENSION_VAL_AR),
                    a.analyticsARSessionDimension &&
                      (m[l.DIMENSION + a.analyticsARSessionDimension] =
                        i.DIMENSION_VAL_AR)),
                  o &&
                    e.d &&
                    (a.analytics360ProductDimension &&
                      e.d.hasOwnProperty("t") &&
                      e.d.t > 0 &&
                      ((h = !0),
                      (p.ecommerce.detail.products[0][
                        l.DIMENSION + a.analytics360ProductDimension
                      ] = "Cylindo360")),
                    h &&
                      ((p.ecommerce.detail.products[0].id = t.productCode),
                      (p.ecommerce.detail.products[0].name = t.productCode),
                      r.push(p))),
                  (d || u) && (r.push(m), (i.TRIGGERED = !0));
              } catch (f) {
                console.log(
                  "Something went wrong while trying to send the event using Google Tag Manager.",
                  f
                );
              }
          }
          var o = this,
            r = e.dataLayer,
            s = e.events,
            a = e.gaKeys,
            l = e.prefixes,
            d = cylindo.getModule("cylindo.core.google.maps"),
            c = d.getEventsData();
          (o.initialized = !1), (o.init = t), (o.saveEvent = i), t();
        };
        e.counter = 0;
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.core.ua.gtm", t);
      }.call(this),
      function () {
        var e = cylindo.getModule("tags") || {},
          t = function n(e) {
            function t(t, i, o, r) {
              function s() {
                return u
                  ? ((c.data.instanceID = ++n.counter),
                    (v.clientID = t),
                    (v.productCode = i),
                    (v.features = o),
                    (v.ARDesktop = !1),
                    (v.ARBanner = !1),
                    !0)
                  : (console.error ? console.error(A) : console.log(A), !1);
              }
              function a() {
                return window[window[E]];
              }
              function l() {
                return window[y] || window["_" + y];
              }
              var d = "dataLayer",
                u = null,
                E = "GoogleAnalyticsObject",
                y = "gtag",
                A =
                  "Cylindo Error: GTM/GTAG/GA core not found, please make sure you have one of them. For google analytics core make sure you've also created a tracker.",
                T = "Cylindo Error: UA or GA4 property not defined",
                R = {
                  GTM: "GoogleTagManager",
                  GTAG: "GlobalSiteTag",
                  GA: "GoogleAnalytics",
                };
              (c.isInitialized = !0), c.data.instanceID && c.destroy();
              var b = r && r.hasOwnProperty("analyticsModule") ? r : null;
              if (b && b.analyticsPropertyType) {
                if (
                  ((m =
                    p.UA === b.analyticsPropertyType ||
                    p.GA4 === b.analyticsPropertyType
                      ? b.analyticsPropertyType
                      : null),
                  !m)
                )
                  return void (console.error
                    ? console.error(T)
                    : console.log(T));
                (e.gaKeys = {
                  analytics360HitDimension: b.analytics360HitDimension,
                  analytics360SessionDimension: b.analytics360SessionDimension,
                  analytics360ProductDimension: b.analytics360ProductDimension,
                  analyticsARHitDimension: b.analyticsARHitDimension,
                  analyticsARSessionDimension: b.analyticsARSessionDimension,
                  analytics360HitMetric: b.analytics360HitMetric,
                  analyticsARHitMetric: b.analyticsARHitMetric,
                }),
                  (e.prefixes = { DIMENSION: "dimension", METRIC: "metric" }),
                  b.analyticsModule === R.GA && a()
                    ? a()(function (t) {
                        t && "function" == typeof t.get && t.get("name")
                          ? (u = t.get("name"))
                          : a() &&
                            "function" == typeof a().getAll &&
                            a().getAll().length > 0 &&
                            (u = a().getAll()[0].get("name")),
                          s() &&
                            ((e.gaName = u),
                            (f = g.UA.GA.create(h.object.extend(e, c))));
                      })
                    : (b.analyticsModule !== R.GTM &&
                        b.analyticsModule !== R.GTAG) ||
                      !window[d] ||
                      ((u = d),
                      s() &&
                        ((e.dataLayer = window[u]),
                        m === p.GA4
                          ? b.analyticsModule === R.GTAG && l()
                            ? (f = g.GA4.GTAG.create(h.object.extend(e, c)))
                            : b.analyticsModule === R.GTM &&
                              (f = g.GA4.GTM.create(h.object.extend(e, c)))
                          : b.analyticsModule === R.GTAG && l()
                          ? (f = g.UA.GTAG.create(h.object.extend(e, c)))
                          : b.analyticsModule === R.GTM &&
                            (f = g.UA.GTM.create(h.object.extend(e, c)))));
              }
            }
            function i() {
              u && "function" == typeof u.destroy && u.destroy();
            }
            function o(e, t, n) {
              var i;
              E ||
                ((i = { t: Date.now(), e: e, d: t || {}, c: n || null }), r(i));
            }
            function r(e) {
              f && f.initialized && f.saveEvent(e, v);
            }
            function s(t) {
              (e.productCode = t), (v.productCode = t);
            }
            function a(t) {
              (e.features = t), (v.features = t);
            }
            function l(t) {
              (e.version = t), (v.version = t);
            }
            function d(t, n) {
              (e.ARDesktop = t),
                (v.ARDesktop = t),
                (e.ARBanner = n),
                (v.ARBanner = n);
            }
            var c = this,
              u = cylindo.getModule("cylindo.util.pubsub").create(),
              h = cylindo.getModule("cylindo.core.util"),
              m = null,
              p = { UA: "Ua", GA4: "Ga4" },
              f = null,
              g = {
                UA: {
                  GA: cylindo.getModule("cylindo.core.ua.ga"),
                  GTAG: cylindo.getModule("cylindo.core.ua.gtag"),
                  GTM: cylindo.getModule("cylindo.core.ua.gtm"),
                },
                GA4: {
                  GTAG: cylindo.getModule("cylindo.core.ga4.gtag"),
                  GTM: cylindo.getModule("cylindo.core.ga4.gtm"),
                },
              },
              v = (cylindo.getModule("cylindo.core.network"), {}),
              E = !1;
            (e = e || {}),
              (this.on = u.on),
              (this.trigger = u.trigger),
              (this.off = u.off),
              (this.opts = e),
              (this.data = { instanceID: 0 }),
              (this.destroy = i),
              (this.send = o),
              (this.updateProductCode = s),
              (this.updateFeatures = a),
              (this.updateProductVersion = l),
              (this.updateARFlags = d),
              (this.disableTags = function (e) {
                E = e;
              }),
              (this.isInitialized = !1),
              (this.init = t);
          };
        (t.prototype.events = {
          LOADED: 1,
          SEEN: 2,
          FULLSCREEN: 3,
          ZOOM: 4,
          SPIN: 5,
          FEATURE_CHANGED: 6,
          THUMBNAIL_CLICK: 7,
          ROOM_SCENE_LOADED: 8,
          ROOM_SCENE_SEEN: 9,
          AR_LOADED: 10,
          AR_SEEN: 11,
          AR_LAUNCHED: 12,
          AR_CLICKED: 13,
          AR_BANNER_CLICKED: 14,
          FEATURE_ERROR: 15,
          ALT_IMAGE_LOADED: 16,
          ALT_IMAGE_VIEWED: 17,
          ERROR_LOADING: 18,
        }),
          (t.counter = 0),
          (e.handler = {}),
          (e.handler.create = function (e) {
            return new t(e);
          }),
          cylindo.addModule("tags", e, !0);
      }.call(this),
      function () {
        function e(e, t) {
          var n,
            i = 360 / t,
            o = [],
            r = e.length;
          for (n = 0; n < r; ++n) {
            if ("string" == typeof e[n])
              try {
                e[n] = parseInt(e[n], 10);
              } catch (s) {
                continue;
              }
            null !== e[n] &&
              ((e[n] = e[n] % 360),
              e[n] < 0 && (e[n] = 360 + e[n]),
              o.push((Math.round(e[n] / i) % t) + 1));
          }
          return o;
        }
        var t = { degreesToIndexes: e };
        window.cylindo.addModule("cylindo.util.angles", t);
      }.call(this),
      function () {
        function e(e) {
          function i() {
            switch (((s.initialized = !0), d)) {
              case n.QR:
                (o = a.template("<h1><% text %></h1>")),
                  s.templatePattern.unshift(o({ text: e.title })),
                  (r = a.template(
                    '<a><div class="cylindo-back-icon"></div><% text %></a>'
                  )),
                  s.templatePattern.unshift(r({ text: e.ARBackToViewTxt })),
                  s.templatePattern.unshift(),
                  s.templatePattern.push(
                    '<div class="cylindo-devices-img"></div>'
                  ),
                  s.templatePattern.push(
                    '<div class="cylindo-qr-img-wrapper"><img class="cylindo-qr-img" /></div>'
                  ),
                  s.wrapperClasses.push("is-qr-modal");
                break;
              case n.AR:
                s.templatePattern.unshift(
                  '<div class="cylindo-ar-loader"></div>'
                ),
                  s.templatePattern.push(
                    '<div class="cylindo-ar-white"></div>'
                  ),
                  s.templatePattern.push("<a>Go to product page</a>"),
                  s.wrapperClasses.push("is-ar-modal");
            }
            s.setTemplate(s.templatePattern.join(""));
          }
          var o,
            r,
            s = this,
            a = cylindo.getModule("cylindo.helpers.function"),
            l = cylindo.getModule("cylindo.core.network"),
            d = e.type,
            c = e.errorText;
          e &&
            "object" === ("undefined" == typeof e ? "undefined" : _typeof(e)) &&
            (e.role = "dialog"),
            t.call(this, e),
            (s.network = l),
            (s.preventEvents = e.preventEvents),
            (s.wrapperClasses = ["cylindo-ar-modal"]),
            (s.templatePattern = ["<p><% text %></p>"]),
            (s.type = d),
            (s.errorText = c),
            (s.qrSrc = ""),
            (s.initialized = !1),
            i();
        }
        var t = cylindo.getModule("cylindo.classes.layer"),
          n = { AR: "ar", AR_ERROR: "ar-error", QR: "qr" };
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e),
          (e.prototype.render = function () {
            function e(e) {
              e &&
                (e.preventDefault(),
                e.stopPropagation(),
                e.stopImmediatePropagation()),
                i.preventEvents();
            }
            var i = this,
              o = null;
            t.prototype.render.call(i),
              i.type === n.QR &&
                (i.updateCode(),
                (o = i.el.querySelector("a")),
                o &&
                  (o.addEventListener("mousedown", e),
                  o.addEventListener(
                    "mouseup",
                    function (t) {
                      e(t), i.hide(!0);
                    },
                    !0
                  ),
                  o.addEventListener("touchstart", e),
                  o.addEventListener(
                    "touchend",
                    function (t) {
                      e(t), i.hide(!0);
                    },
                    !0
                  )));
          }),
          (e.prototype.updateCode = function (e) {
            var t = this,
              n = t.el.querySelector("img.cylindo-qr-img"),
              i = (e && e.qr) || t.qrSrc;
            (t.qrSrc = i), (n.src = t.qrSrc);
          }),
          (e.prototype.showError = function () {
            function e(e) {
              e && (e.stopPropagation(), e.stopImmediatePropagation()),
                t.preventEvents();
            }
            var t = this,
              n = null;
            t.el.classList.remove("is-ar-modal"),
              t.el.classList.add("is-ar-error-modal"),
              t.show(t.errorText, !0),
              (n = t.el.querySelector("a")),
              n &&
                n.addEventListener("touchend", function () {
                  e(), t.hide(!0);
                });
          }),
          (e.prototype.destroy = function () {
            var e = this;
            t.prototype.destroy.call(e);
          });
        var i = {
          create: function (t) {
            return new e(t);
          },
          types: n,
        };
        window.cylindo.addModule("ar.modal", i);
      }.call(this),
      function () {
        var e = cylindo.getModule("cylindo.classes.abstract.view"),
          t = function (t) {
            function n() {
              L && L.noFeatureTooltip && L.noFeatureTooltip.show(),
                L.trigger(L.events.FEATURES_ERROR, null);
            }
            function i() {
              r.call(this),
                this.customImageOn || L.showCarouselBtns(),
                e.prototype.enable.call(this, !0);
            }
            function o() {
              s.call(this),
                L.hideCarouselBtns(),
                e.prototype.disable.call(this, !0);
            }
            function r() {
              L.carouselLeftBtn.addEventListener("touchstart", T, !1),
                L.carouselRightBtn.addEventListener("touchstart", T, !1),
                L.wrapper.addEventListener("touchstart", d, !1),
                L.carouselLeftBtn.addEventListener("mouseup", T),
                L.carouselRightBtn.addEventListener("mouseup", T),
                L.wrapper.addEventListener("mousedown", h, !1);
            }
            function s() {
              L.carouselLeftBtn.removeEventListener("touchstart", T, !1),
                L.carouselRightBtn.removeEventListener("touchstart", T, !1),
                L.wrapper.removeEventListener("touchstart", d, !1),
                L.carouselLeftBtn.removeEventListener("mouseup", T),
                L.carouselRightBtn.removeEventListener("mouseup", T),
                L.wrapper.removeEventListener("mousedown", h, !1),
                l();
            }
            function a() {
              document.addEventListener("touchend", c, !1),
                document.addEventListener("touchmove", u, !1),
                document.addEventListener("mouseup", p, !1),
                document.addEventListener("mousemove", m, !1);
            }
            function l() {
              document.removeEventListener("mouseup", p, !1),
                document.removeEventListener("mousemove", m, !1),
                document.removeEventListener("touchend", c, !1),
                document.removeEventListener("touchmove", u, !1);
            }
            function d(e) {
              I(e) ||
                ((M = !0),
                _.preventScrollX(L.wrapper.parentNode),
                L.setMobileCoords(e),
                h(e));
            }
            function c(e) {
              e && (e.preventDefault(), e.stopPropagation()),
                D && (window.clearTimeout(D), (D = null)),
                L.setMobileCoords(e),
                p(e),
                _.allowScrollX(L.wrapper.parentNode),
                (S = !1),
                (M = !1);
            }
            function u(e) {
              var t, n;
              L.setMobileCoords(e),
                (t = Math.abs(e.clientY - L.mouseClickPos.startY)),
                (n = Math.abs(e.clientX - L.mouseClickPos.startX)),
                L.isSignificantMove(e) &&
                  (window.clearTimeout(D),
                  (D = null),
                  (S || !L.wasDragging) && t > n && (S = !0),
                  S || m(e));
            }
            function h(e) {
              if (e) {
                if (I(e) || b(e)) return;
                L.isRightClick(e) ||
                  (a(),
                  (L.mouseState = 1),
                  (L.mouseClickPos.startX = L.mouseClickPos.currentX =
                    e.clientX),
                  (L.mouseClickPos.startY = L.mouseClickPos.currentY =
                    e.clientY),
                  (L.mouseClickPos.startTime = e.timeStamp),
                  (L.currentEventTime = e.timeStamp)),
                  e.defaultPrevented || M || e.preventDefault();
              }
            }
            function m(e) {
              var t,
                n = 0,
                i = 0,
                o = L.ul360.getBoundingClientRect(),
                r = o.left - o.width / 4,
                s = o.right + o.width / 4;
              if (L.mouseClickPos.startTime < Date.now() - G) {
                if (0 === L.mouseState) return;
                if (e && L.mouseState > 0) {
                  if (
                    ((n = e.clientX - L.mouseClickPos.currentX),
                    (i = e.clientX - L.mouseClickPos.startX),
                    Math.abs(i) < 3 && !L.isDragging)
                  )
                    return;
                  (t = i < 0),
                    (L.wasDragging = !0),
                    (L.isDragging = !0),
                    (L.deltaX = n),
                    (L.mouseClickPos.currentX = e.clientX),
                    (L.mouseClickPos.currentY = e.clientY),
                    (L.currentEventTime = e.timeStamp),
                    L.mouseClickPos.currentX >= r &&
                      L.mouseClickPos.currentX <= s &&
                      (L.isAutoSliding
                        ? (L.isRightDirection = t)
                        : (f(n, t), L.ul360.classList.add("cylindo-dragging")));
                }
                L.mouseClickPos.startTime = Date.now();
              }
            }
            function p(e) {
              if (
                ((L.isDragging = !1),
                1 == L.mouseState && e && !L.isRightClick(e))
              ) {
                if (
                  ((L.mouseState = 0),
                  (L.deltaX = 0),
                  setTimeout(function () {
                    l();
                  }, 0),
                  L.isAutoSliding)
                )
                  return void (
                    "boolean" == typeof L.isRightDirection &&
                    (g(L.isRightDirection), (L.isRightDirection = null))
                  );
                if (!L.wasDragging && !S && "mouseup" === e.type && !M)
                  return (
                    (L.mouseClickPos.startX = L.mouseClickPos.currentX =
                      e.clientX),
                    (L.mouseClickPos.startY = L.mouseClickPos.currentY =
                      e.clientY),
                    void L.trigger(L.events.CLICKED, L.mouseClickPos)
                  );
                L.wasDragging && g(),
                  (L.wasDragging = !1),
                  L.ul360.classList.remove("cylindo-dragging");
              }
            }
            function f(e, t, n) {
              function i(e, t) {
                e !== t &&
                  ((e.style.left = ""), e.classList.remove("active-sibling"));
              }
              function o(e) {
                if (e)
                  return (
                    (e =
                      e.nextElementSibling || e.parentNode.firstElementChild),
                    e.classList.contains("is-rendering") ? o(e) : e
                  );
              }
              function r(e) {
                if (e)
                  return (
                    (e =
                      e.previousElementSibling ||
                      e.parentNode.lastElementChild),
                    e.classList.contains("is-rendering") ? r(e) : e
                  );
              }
              var s,
                a,
                l,
                d,
                c,
                u = L.ul360.querySelectorAll("li").length,
                h = L.ul360.querySelector("li.active:not(.is-rendering)"),
                m = o(h),
                p = r(h);
              if (
                ((n = n || !1),
                L.tryToRemoveCustomImage(),
                (e = e || 0),
                n || (!L.isAutoSliding && 1 !== u))
              ) {
                if (!h || (!t && h === p) || (t && h === m))
                  return void (L.errorAtPrepareToMoveCarousel = !0);
                (L.errorAtPrepareToMoveCarousel = !1),
                  (s = h.getBoundingClientRect()),
                  (c = L.dom.position(h)),
                  t
                    ? (i(p, m),
                      (l = m),
                      l.classList.add("active-sibling"),
                      (d = c.left + s.width + e))
                    : (i(m, p),
                      (l = p),
                      l.classList.add("active-sibling"),
                      (d = c.left - s.width + e)),
                  (a = c.left + e),
                  (h.style.left = a + "px"),
                  (l.style.left = d + "px"),
                  (B = {
                    currentActive: { element: h },
                    newActive: { element: l },
                  });
              }
            }
            function g(e, t) {
              function n(e) {
                var t = L.wrapper.classList.contains("full-screen");
                !t &&
                  e &&
                  e.classList &&
                  e.classList.add("cylindo-hide-on-fullscreen");
              }
              var i,
                o,
                r,
                s,
                a,
                l = !1,
                d = !1,
                c = 0,
                u = L.ul360.querySelectorAll("li").length;
              if (((t = t || !1), !L.errorAtPrepareToMoveCarousel)) {
                if (!t && (L.isAutoSliding || 1 === u))
                  return void L.pendingMovements.push(e);
                0 === L.pendingMovements.length && L.pendingMovements.push(e),
                  (L.isAutoSliding = !0),
                  (i = B.currentActive.element),
                  (a = B.newActive.element),
                  (o = i.getBoundingClientRect()),
                  (r = L.dom.position(i).left),
                  (0 === r && "undefined" == typeof e) || (l = !0),
                  r <= 60 && r >= -60 && "undefined" == typeof e
                    ? ((d = !0),
                      (e = r < 0),
                      (s = 0),
                      (c = e ? o.width : o.width * -1))
                    : r < 0 || e === !0
                    ? ((e = !0), (s = o.width * -1))
                    : (r > 0 || e === !1) && ((e = !1), (s = o.width)),
                  (B.currentActive.desiredLeft = s),
                  (B.newActive.desiredLeft = c),
                  n(d ? a : i),
                  l
                    ? v.call({
                        isRightDirection: e,
                        elemsToAnimate: B,
                        keepSameActive: d,
                      })
                    : ((L.isAutoSliding = !1),
                      B &&
                        B.newActive &&
                        B.newActive &&
                        (B.newActive.element.classList.remove("active-sibling"),
                        (B.newActive.element.style.left = "")),
                      B &&
                        B.currentActive &&
                        B.currentActive &&
                        (B.currentActive.element.style.left = ""));
              }
            }
            function v() {
              E.call(w.object.extend({}, { animateCurrent: !0 }, this)),
                E.call(w.object.extend({}, { animateCurrent: !1 }, this));
            }
            function E() {
              function e() {
                try {
                  ++h,
                    isNaN(s) ||
                    h >= s ||
                    "undefined" == typeof o ||
                    "undefined" == typeof i
                      ? (clearInterval(a), y.call(d))
                      : ((r = m
                          ? N.easeOutQuad(h, o, i - o, s)
                          : N.linearTween(h, o, i - o, s)),
                        (r = Math.round(100 * r) / 100),
                        (n.style.left = r + "px"));
                } catch (e) {
                  L.logger.error("Cannot finish carousel animation", e),
                    clearInterval(a),
                    y.call(d);
                }
              }
              function t(e) {
                var t =
                    L.model.get("carouselSlideSpeed") > 0
                      ? L.model.get("carouselSlideSpeed")
                      : 32,
                  n = t,
                  i = L.pendingMovements.length;
                return (
                  L.pendingMovements.length > 1 &&
                    ((n = t * i), n > e && (n = e), (t = n)),
                  t
                );
              }
              var n,
                i,
                o,
                r,
                s,
                a,
                l,
                d = this,
                c = 16.7,
                u = d.animateCurrent
                  ? d.elemsToAnimate.currentActive
                  : d.elemsToAnimate.newActive,
                h = 0,
                m = 1 === L.pendingMovements.length;
              (n = u.element),
                (o = L.dom.position(n).left),
                (i = u.desiredLeft),
                (l = t(Math.abs(i - o) / 5)),
                (s = Math.floor(Math.abs(i - o) / l)),
                (a = setInterval(e, c));
            }
            function y() {
              ++U, 2 === U && ((U = 0), A.call(this));
            }
            function A() {
              function e() {
                var e = !0;
                return L.pendingMovements.length > 0 &&
                  (L.pendingMovements.shift(), L.pendingMovements.length > 0)
                  ? void R(L.pendingMovements[0], e)
                  : ((L.isAutoSliding = !1),
                    L.refreshRequested &&
                      (L.refresh.call(L, null, {
                        refRequestID: L.refRequestID,
                      }),
                      (L.refreshRequested = !1),
                      (L.refRequestID = null)),
                    L.goToIndexRequested &&
                      L.goToIndex.call(L, L.indexRequested),
                    L.showImageRequested &&
                      L.showImage.call(L, L.customImageUrl, L.customImageLarge),
                    void (
                      L.reloadAltContentRequested && L.reloadAltContent.call(L)
                    ));
              }
              var t,
                n,
                i,
                o,
                r = L.framesHandler.getAllFramesToBeLoaded(),
                s = !1,
                a =
                  this.elemsToAnimate && this.elemsToAnimate.currentActive
                    ? this.elemsToAnimate.currentActive.element
                    : null,
                l =
                  this.elemsToAnimate && this.elemsToAnimate.newActive
                    ? this.elemsToAnimate.newActive.element
                    : null,
                d = r.ALTERNATE.LEN,
                c = r.THREESIXTY.TO_BE_LOADED;
              if (((c = L.isCustomViewer ? d : c + d), a && l)) {
                if (
                  ((o = C.querySelectorAll(L.ul360, "li")),
                  (i = o.indexOf(l) + 1),
                  (t = a.dataset
                    ? a.dataset.index
                    : a.getAttribute("data-index")),
                  (n = l.dataset
                    ? l.dataset.index
                    : l.getAttribute("data-index")),
                  (a.style.left = ""),
                  a.classList.remove("cylindo-hide-on-fullscreen"),
                  (l.style.left = ""),
                  l.classList.remove("active-sibling"),
                  l.classList.remove("cylindo-hide-on-fullscreen"),
                  this.keepSameActive)
                )
                  return void e();
                L.handleActiveFrame(a, !1),
                  L.handleActiveFrame(l, !0),
                  L.framesHandler.is360Frame(n)
                    ? (L.prevIndex = n)
                    : L.framesHandler.is360Frame(t) && (L.prevIndex = t),
                  (L.currentIndex = n),
                  this.isRightDirection
                    ? L.trigger(L.events.NEXT, {
                        index: n,
                        frame: i,
                        frames: c,
                      })
                    : L.trigger(L.events.PREV, {
                        index: n,
                        frame: i,
                        frames: c,
                      }),
                  L.trigger(L.events.FRAME_ACTIVATED, { index: n }),
                  L.trigger(L.events.CURRENT, { current: n }),
                  L.handleTooltip(l, n, t),
                  L.handleZoomButton(l, n, t),
                  L.handleActionBtns(l, n, s);
              }
              e();
            }
            function T(e) {
              var t,
                n,
                i = 0;
              L.isDragging ||
                (e && (e.preventDefault(), e.stopPropagation()),
                e &&
                  e.target &&
                  (e.target.classList.contains("move-to-left") ||
                    e.target.classList.contains("move-to-right")) &&
                  ((t = e.target.dataset
                    ? e.target.dataset.direction
                    : e.target.getAttribute("data-direction")),
                  (n = "right" === t),
                  f(i, n),
                  g(n)));
            }
            function R(e, t) {
              var n = 0;
              f(n, e, t), g(e, t);
            }
            function b(e) {
              return !!(
                e &&
                e.target &&
                e.target.classList &&
                (e.target.classList.contains("move-to-left") ||
                  e.target.classList.contains("move-to-right"))
              );
            }
            function I(e) {
              var t = L.ul360.querySelector(".active");
              return !(!t || !t.classList.contains("cylindo-video"));
            }
            e.call(this, t);
            var L = this,
              w = cylindo.getModule("cylindo.core.util"),
              C = t.dom,
              _ = cylindo.getModule("cylindo.helpers.scroll"),
              N = cylindo.getModule("cylindo.helpers.easing"),
              D = null,
              O = null,
              S = !1,
              M = !1,
              x = document.createElement("div"),
              F = document.createElement("div"),
              P = document.createElement("a"),
              k = document.createElement("a"),
              U = 0,
              B = null,
              G = 10;
            (this.util = w),
              (this.dom = C),
              (this.wasDragging = !1),
              (this.isDragging = !1),
              (this.isAutoSliding = !1),
              (this.frameWidth = 512),
              (this.mouseState = 0),
              (this.prevIndex = null),
              (this.deltaX = 0),
              (this.ratio = null),
              (this.resizeTimer = 0),
              (this.pendingImages = []),
              (this.carouselLeftBtnIcon = P),
              (this.carouselRightBtnIcon = k),
              (this.carouselLeftBtn = x),
              (this.carouselRightBtn = F),
              (this.autoSlideCarousel = R),
              (this.refreshRequested = !1),
              (this.refRequestID = null),
              (this.goToIndexRequested = !1),
              (this.indexRequested = null),
              (this.showImageRequested = !1),
              (this.customImageUrl = null),
              (this.customImageLarge = null),
              (this.reloadAltContentRequested = !1),
              (this.isCustomViewer = !1),
              (this.defaultTooltip = "tooltipCarouselText"),
              (this.pendingMovements = []),
              (this.isRightDirection = null),
              (this.errorAtPrepareToMoveCarousel = !1),
              t.model.get("missingCombinationErrorText") &&
                (this.noFeatureTooltip = cylindo
                  .getModule("tooltip.no-feaure")
                  .create({
                    parent: t.el,
                    text: t.model.get("missingCombinationErrorText"),
                    dom: C,
                  })),
              this.model.on(
                this.model.events.FEATURES_CHANGED,
                this.tryToRefresh.bind(this)
              ),
              this.model.on(this.model.events.FEATURES_ERROR, n),
              this.model.on(
                this.model.events.FEATURES_NO_WARNING,
                this.onFeaturesUpdated.bind(this)
              ),
              this.model.on(
                this.model.events.CHANGED,
                this.updateView.bind(this)
              ),
              (this.listClassName = "cylindo-threesixty-list"),
              (this.viewerPresentation = "carousel"),
              (this.enable = i.bind(this)),
              (this.disable = o.bind(this)),
              (this.addMouseCallbacks = r.bind(this)),
              (this.removeMouseCallbacks = s.bind(this)),
              (O = this.model.get("mobileZoomDelay")),
              this.noFeatureTooltip &&
                (this.noFeatureTooltip.render(),
                this.initializedWithError && this.noFeatureTooltip.show()),
              t.preventRender
                ? (this.carouselViewer = w.object.extend({}, this))
                : this.render();
          };
        (t.prototype = Object.create(e.prototype)),
          (t.prototype.constructor = t),
          (t.prototype.events = e.extendEvents({
            CLICKED: "carousel:clicked",
            READY: "carousel:ready",
            DOWNLOAD_COMPLETE: "carousel:download:complete",
            CURRENT: "carousel:current",
            IMG_LOADED: "carousel:img:loaded",
            FEATURES_CHANGED: "carousel:features:changed",
            FIRST_FRAME_COMPLETE: "carousel:firstframe:complete",
            FRAME_ACTIVATED: "carousel:frame:activated",
            ALT_CONTENT_REMOVED: "carousel:alt:content:removed",
            ALT_CONTENT_LOADED: "carousel:alt:content:loaded",
            CONTENT_TYPE_COMPLETE: "carousel:content:type:complete",
            PREV: "carousel:prev",
            NEXT: "carousel:next",
            FEATURES_CANCELED: "carousel:features:canceled",
            FEATURES_ERROR: "carousel:features:error",
          })),
          (t.prototype.render = function () {
            e.prototype.tryToCreateTooltip.call(this),
              e.prototype.render.call(this);
          }),
          (t.prototype.goToIndex = function (t) {
            return this.isAutoSliding
              ? ((this.goToIndexRequested = !0),
                (this.indexRequested = t),
                void this.removeMovementsTail.call(this))
              : ((this.goToIndexRequested = !1),
                (this.indexRequested = null),
                this.framesHandler.is360Frame(t)
                  ? (this.prevIndex = t)
                  : this.framesHandler.is360Frame(this.currentIndex) &&
                    (this.prevIndex = this.currentIndex),
                this.tryToRemoveCustomImage(),
                e.prototype.goToIndex.call(this, t),
                void this.trigger(this.events.CURRENT, { current: t }));
          }),
          (t.prototype.tryToRefresh = function (e, t) {
            var n = t && t.refRequestID ? t.refRequestID : null;
            this.hideCarouselBtns(),
              this.isAutoSliding
                ? ((this.refreshRequested = !0),
                  (this.refRequestID = n),
                  this.removeMovementsTail.call(this))
                : ((this.refreshRequested = !1),
                  (this.refRequestID = null),
                  this.refresh.call(this, null, { refRequestID: n }));
          }),
          (t.prototype.refresh = function (e, t) {
            var n,
              i,
              o,
              r = this.framesHandler.getAllFramesToBeLoaded(),
              s = this.ul360 ? this.ul360.querySelector(".active") : null,
              a = this.pendingImages.length,
              l = r.THREESIXTY.TO_BE_LOADED;
            (this.viewerUpdatedStartTime = Date.now()),
              (o =
                t && t.refRequestID
                  ? t.refRequestID
                  : this.model.getRequestID()),
              (this.requestID = o);
            for (var d = 0; d < a; d++)
              o !== this.pendingImages[d].requestID &&
                this.currentIndex !== this.pendingImages[d].index &&
                (this.pendingImages[d].prepareDefer.resolve(),
                (this.pendingImages[d].img.onload = null),
                (this.pendingImages[d].img.onerror = null),
                (this.pendingImages[d].img.src = ""),
                this.pendingImages.splice(d, 1),
                d--,
                a--);
            this.framesHandler.isAltId(this.currentIndex) &&
              this.goToIndex(this.prevIndex),
              this.isComplete === !1 &&
                this.trigger(this.events.FEATURES_CANCELED, {
                  features: this.model.getCanceledFeatures(),
                }),
              (this.firstFrameIsReady = !1),
              (this.isReady = !1),
              (this.isComplete = !1),
              (this.promises = []),
              (this.frameCount = l),
              (this.currentFeatures = this.model.get("currentFeatures")),
              (this.url = this.currentFeatures.paths),
              (n = this.dom.querySelectorAll(
                this.ul360,
                "li:not(.active):not([class*=alt]):not(.active-sibling)"
              )),
              n.forEach(function (e) {
                e.classList.add("hidden"),
                  e.classList.add("is-rendering"),
                  (e.innerHTML = "");
              }),
              s &&
                ((i = this.framesHandler.isAltId(this.currentIndex)
                  ? this.prevIndex
                  : this.currentIndex),
                this.prepare(i, o),
                (this.promises = this.framesHandler.is360Frame(i)
                  ? this.promises
                  : [])),
              Promise.all(this.promises).then(
                function () {
                  this.refreshRest(o);
                }.bind(this)
              );
          }),
          (t.prototype.refreshRest = function (e) {
            (this.promises = []),
              this.downloadRest(e),
              Promise.all(this.promises).then(
                this.onFeaturesUpdated.bind(this)
              );
          }),
          (t.prototype.updateView = function (e, t) {
            var n, i;
            t &&
              t.prop === this.defaultTooltip &&
              this.tooltip &&
              this.tooltip.isVisible() &&
              ((n = this.ul360.querySelector(".active")),
              (i =
                n && n.dataset
                  ? n.dataset.index
                  : n.getAttribute("data-index")),
              this.handleTooltip(n, i, i));
          }),
          (t.prototype.onFeaturesUpdated = function () {
            this.model.get("hasUnsupportedFeatures") ||
              (this.noFeatureTooltip && this.noFeatureTooltip.hide()),
              this.trigger(this.events.FEATURES_CHANGED);
          }),
          (t.prototype.downloadRest = function (e) {
            function t(e, t) {
              r =
                null === r
                  ? i.prepare(e, t)
                  : r.then(function () {
                      return i.prepare(e, t);
                    });
            }
            for (
              var n,
                i = this,
                o = this.framesHandler.getAllFramesToBeLoaded(),
                r = null,
                s = o.VIEWER_ORDER.LIST,
                a = this.framesHandler.shouldDownloadAll360Frames(),
                l = a ? o.THREESIXTY.TO_BE_LOADED : o.VIEWER_ORDER.LEN,
                d = 0;
              d < l && this.model.getRequestID() === e;

            )
              (n = a ? d + 1 : s[d]),
                n !== parseInt(this.currentIndex, 10) &&
                  this.framesHandler.is360Frame(n) &&
                  t(n, e),
                d++;
          }),
          (t.prototype.prepareLi = function (e) {
            var t = "cylindo-viewer-frame-",
              n = t + e,
              i = document.createElement("li"),
              o = this.dom.querySelectorAll(this.ul360, "." + n);
            i.setAttribute("aria-hidden", !0),
              o && 0 === o.length
                ? (i.classList.add(n),
                  i.classList.add("hidden"),
                  i.classList.add("is-rendering"),
                  this.ul360.appendChild(i))
                : ((o = o[o.length - 1]),
                  o &&
                    !o.classList.contains("is-rendering") &&
                    o.classList.add("is-rendering"));
          }),
          (t.prototype.prepare = function (e, t) {
            var n,
              i,
              o,
              r,
              s,
              a,
              l,
              d,
              c = this,
              u = this.util.promise.create(),
              h = this.util.promise.create();
            if (this.framesHandler.is360Frame(e)) {
              if (
                ((n = "cylindo-viewer-frame-"),
                (i = n + e),
                (o = document.createElement("li")),
                o.setAttribute("aria-hidden", !0),
                (r = new Image()),
                (s = this.frameCount),
                (a = this.model.get("imageTimeout")),
                this.prepareLi(e),
                (l = this.dom.querySelectorAll(this.ul360, "." + i)),
                l && l.length >= 1 && (o = l[l.length - 1]),
                this.url)
              ) {
                var m = {
                  requestID: t,
                  viewer: this,
                  urls: this.url,
                  baseClassName: n,
                  index: e,
                  li: o,
                  totalFrames: s,
                  contentKeys: this.contentKeys,
                  blendingModes: this.blendingModes,
                  imgTimeout: a,
                  onImageLoad: this.onImageLoad,
                  onError: this.onError,
                  prepareDefer: h,
                };
                u = this.renderer.useStrategy(
                  this.renderer.strategies.RTV_SINGLE_MERGED,
                  m
                );
              } else r.src = "";
              this.promises.push(h),
                e !== this.currentIndex ||
                  o.classList.contains("active") ||
                  this.handleActiveFrame(o, !0);
            } else
              this.framesHandler.isAltId(e) &&
                ((d = parseInt(
                  e.replace(this.framesHandler.prefixes.ALT, ""),
                  10
                )),
                (u = this.prepareAltContent(d)));
            return (
              u.then(function () {
                c.firstFrameEvt(e), h.resolve();
              }),
              h
            );
          }),
          (t.prototype.reloadAltContent = function (t, n) {
            var i,
              o = this.framesHandler.getAllFramesToBeLoaded(),
              r = o.ALTERNATE.LEN,
              s = this.framesHandler.is360Frame(this.currentIndex)
                ? this.currentIndex
                : this.prevIndex
                ? this.prevIndex
                : 1;
            if (((s = isNaN(s) ? s : parseInt(s, 10)), this.isAutoSliding))
              (this.reloadAltContentRequested = !0),
                this.removeMovementsTail.call(this);
            else
              for (
                this.reloadAltContentRequested = !1,
                  this.prevIndex = s,
                  this.goToIndex(this.prevIndex),
                  e.prototype.reloadAltContent.call(this, t, n),
                  i = 0;
                i < r;
                i++
              )
                this.prepareAltContent(i, t, n);
          }),
          (t.prototype.onReady = function () {
            e.prototype.onReady.call(this),
              e.prototype.sendFirstFrameCompleteEvt.call(this),
              this.tryToShowTooltip(),
              this.showCarouselBtns();
          }),
          (t.prototype.createViewerList = function () {
            e.prototype.createViewerList.call(this),
              (this.util.browser.isIE() || this.util.browser.isEdge()) &&
                this.ul360.classList.add("is-ms"),
              this.ul360.classList.add("is-carousel"),
              this.appendCarouselBtns();
          }),
          (t.prototype.appendCarouselBtns = function () {
            this.carouselLeftBtnIcon.classList.add(
              "move-to-left",
              "glyphicon",
              "glyphicon-menu-left"
            ),
              this.carouselRightBtnIcon.classList.add(
                "move-to-right",
                "glyphicon",
                "glyphicon-menu-right"
              ),
              this.carouselLeftBtnIcon.setAttribute("role", "link"),
              this.carouselLeftBtnIcon.setAttribute(
                "aria-label",
                this.ariaLabel.texts.CAROUSEL_LEFT
              ),
              this.carouselRightBtnIcon.setAttribute("role", "link"),
              this.carouselRightBtnIcon.setAttribute(
                "aria-label",
                this.ariaLabel.texts.CAROUSEL_RIGHT
              );
            try {
              (this.carouselLeftBtnIcon.dataset.direction = "left"),
                (this.carouselRightBtnIcon.dataset.direction = "right");
            } catch (e) {
              this.carouselLeftBtnIcon.setAttribute("data-direction", "left"),
                this.carouselRightBtnIcon.setAttribute(
                  "data-direction",
                  "right"
                );
            }
            this.util.browser.isMobile() &&
              (this.carouselLeftBtn.classList.add("is-mobile"),
              this.carouselRightBtn.classList.add("is-mobile")),
              this.carouselLeftBtn.classList.add(
                "cylindo-carousel-btn",
                "left-btn",
                "temporarily-hidden"
              ),
              this.carouselRightBtn.classList.add(
                "cylindo-carousel-btn",
                "right-btn",
                "temporarily-hidden"
              ),
              this.carouselLeftBtn.appendChild(this.carouselLeftBtnIcon),
              this.carouselRightBtn.appendChild(this.carouselRightBtnIcon),
              this.wrapper.appendChild(this.carouselLeftBtn),
              this.wrapper.appendChild(this.carouselRightBtn);
          }),
          (t.prototype.hideCarouselBtns = function () {
            this.carouselLeftBtn.classList.add("temporarily-hidden"),
              this.carouselRightBtn.classList.add("temporarily-hidden");
          }),
          (t.prototype.showCarouselBtns = function () {
            this.carouselLeftBtn.classList.remove("temporarily-hidden"),
              this.carouselRightBtn.classList.remove("temporarily-hidden");
          }),
          (t.prototype.onImageLoad = function () {
            var e,
              t = this.li,
              n = t.cloneNode(),
              i = this.img,
              o = this.layers,
              r = this.self,
              s = this.deferred,
              a = i.length,
              l = "Frame " + this.index + ' of "__productName__" ',
              d = -1;
            for (e = 0; e < r.pendingImages.length; e++)
              r.pendingImages[e].index === this.index && (d = e);
            if (
              (d !== -1 && r.pendingImages.splice(d, 1),
              this.requestID === r.model.getRequestID())
            ) {
              if (
                ((this.index === r.currentIndex ||
                  (!r.framesHandler.is360Frame(this.currentIndex) &&
                    this.index === r.startFrame)) &&
                  (r.firstImageLoadedTime = Date.now()),
                this.timeout &&
                  (clearTimeout(this.timeout), (this.timeout = null)),
                (l = l.replace("__productName__", r.model.get("fileName"))),
                i.length > 1)
              )
                for (e = 0; e < a; e++)
                  (i[e].alt =
                    l + "(" + o[e].type + " layer - " + o[e].code + ")"),
                    n.appendChild(i[e]);
              else
                i instanceof Image
                  ? ((i.alt = l), n.appendChild(i))
                  : ((i[0].alt = l), n.appendChild(i[0]));
              try {
                t.insertAdjacentElement("afterend", n);
              } catch (c) {
                r.dom.insertAfter(n, t);
              }
              r.dom.remove(t),
                n.classList.remove("is-rendering"),
                r.tryToEnableImageGroup(),
                r.trigger(r.events.IMG_LOADED, {
                  sequence: this.index,
                  img: i,
                }),
                s.resolve();
            }
          }),
          (t.prototype.onAltContentLoad = function () {
            this.viewer.isCustomViewer
              ? (this.viewer.tryToEnableImageGroup(),
                this.li.classList.remove("is-rendering"),
                this.viewer.trigger(this.viewer.events.ALT_CONTENT_LOADED, {
                  sequence: this.viewer.framesHandler.prefixes.ALT + this.index,
                  viewerId: this.viewer.id,
                }))
              : e.prototype.onAltContentLoad.call(this);
          }),
          (t.prototype.tryToEnableImageGroup = function () {
            var e,
              t,
              n = this;
            this.isCustomViewer
              ? ((e = this.dom.querySelectorAll(
                  this.ul360,
                  '[class*="cylindo-viewer-frame-alt"]'
                )),
                (t = this.ul360.querySelector(".active")),
                t ||
                  ((this.firstImageLoadedTime = Date.now()),
                  this.handleActiveFrame(e[0], !0)))
              : ((e = this.dom.querySelectorAll(
                  this.ul360,
                  '[class*="cylindo-viewer-frame-"]:not([class*="-alt-"])'
                )),
                (e = e.filter(function (t) {
                  var i = t.className.match(/cylindo-viewer-frame-(\d+)/gi)[0],
                    o = n.dom.querySelectorAll(n.ul360, "." + i);
                  return (
                    0 !== t.childNodes.length &&
                    e.indexOf(t) === e.indexOf(o[o.length - 1])
                  );
                }))),
              e.forEach(function (e) {
                e.classList.remove("hidden");
              }),
              !this.isVisible && e.length > 0 && this.displayViewer(),
              !this.isReady && e.length > 0 && this.onReady(),
              !this.isComplete &&
                e.length > 0 &&
                (this.isCustomViewer
                  ? (this.onDownloadComplete(),
                    this.trigger(this.events.CONTENT_TYPE_COMPLETE, {
                      contentType: this.contentTypes.ALTERNATE,
                    }))
                  : e.length >= this.frameCount && this.onDownloadComplete());
          }),
          (t.prototype.tryToShowTooltip = function () {
            var e = this.ul360.querySelector(".active"),
              t = e.getAttribute("data-index"),
              n = this.framesHandler.is360Frame(t),
              i = this.framesHandler.isAltId(t),
              o = e.classList.contains("cylindo-video"),
              r = e.classList.contains("cylindo-img-not-found"),
              s = this.model.get("tooltipCarouselText"),
              a = this.model.get("tooltipAltImgText"),
              l = !0;
            (r || o) && (l = !1),
              this.tooltip &&
                !this.tooltip.isVisible() &&
                l &&
                (n
                  ? "string" == typeof s && s.length > 0 && this.showTooltip(s)
                  : i &&
                    "string" == typeof a &&
                    a.length > 0 &&
                    this.showTooltip(a));
          }),
          (t.prototype.tryToRemoveCustomImage = function () {
            var e = "cylindo-custom-image",
              t = this.ul360.querySelector("." + e);
            try {
              this.dom.remove(t), (this.customImageOn = !1);
            } catch (n) {
              logger.error("Cannot remove custome image", n);
            }
            this.showCarouselBtns();
          }),
          (t.prototype.showImage = function (t, n) {
            this.isAutoSliding
              ? ((this.showImageRequested = !0),
                (this.customImageUrl = t),
                (this.customImageLarge = n),
                this.removeMovementsTail.call(this))
              : ((this.showImageRequested = !1),
                (this.customImageUrl = null),
                (this.customImageLarge = null),
                this.hideCarouselBtns(),
                e.prototype.showImage.call(this, t, n));
          }),
          (t.prototype.hideImage = function () {
            this.customImageOn &&
              (this.showCarouselBtns(), e.prototype.hideImage.call(this));
          }),
          (t.prototype.isRightClick = function (t) {
            return e.prototype.isRightClick.call(this, t);
          }),
          (t.prototype.removeMovementsTail = function () {
            this.pendingMovements instanceof Array &&
              this.pendingMovements.length > 0 &&
              (this.pendingMovements = []);
          });
        var n = {
          create: function (e) {
            return new t(e);
          },
          getConstructor: function () {
            return t;
          },
        };
        window.cylindo.addModule("carouselViewer", n);
      }.call(this),
      function () {
        var e = function (e) {
          function t(e) {
            function t(t, n) {
              null !== e && i(e);
            }
            function o(e, t) {
              429 == t.status && console.log("request was throttled"), n();
            }
            var r = { type: "GET" };
            s.doRequest(e, t, r, o, null);
          }
          function n() {
            i(h || u);
          }
          function i(e) {
            var t,
              n,
              i = new Image();
            (e = s.resolveProtocol(e)),
              e
                ? ((t = document.getElementById(o.containerID)),
                  (i.id = "image"),
                  e === h || e === u
                    ? (i.onerror = r.fallback.fallbackFail.bind({
                        fallbackImage: s.resolveProtocol(c),
                        defaultFallbackImage: s.resolveProtocol(u),
                        BUSAPIImage: s.resolveProtocol(h),
                        img: i,
                      }))
                    : (i.onerror = r.fallback.loadFallbackImage.bind({
                        img: i,
                        config: {
                          fallbackImage: c,
                          defaultFallbackImage: u,
                          BUSAPIImage: h,
                        },
                        errorText: "Fallback image not found: ",
                      })),
                  r.browser.isIE() &&
                    (i.onload = function () {
                      (this.style.width = this.naturalWidth + "px"),
                        (this.style.height = this.naturalHeight + "px");
                    }),
                  (i.src = e),
                  (n = t.childNodes.length),
                  n > 0
                    ? t.childNodes[0].parentNode.insertBefore(
                        i,
                        t.childNodes[0]
                      )
                    : t.appendChild(i))
                : console.log(
                    "Embedding a fallback image requires a valid url"
                  );
          }
          var o = e,
            r = cylindo.getModule("cylindo.core.util"),
            s = cylindo.getModule("cylindo.core.network"),
            a = cylindo.getModule("cylindo.core.config"),
            l = cylindo.getModule("cylindo.classes.capi"),
            d = cylindo.getModule("cylindo.util.pubsub").create(),
            c = o.fallbackImage || a.get("urls").DEFAULT_FALLBACK_IMAGE,
            u = a.get("urls").DEFAULT_FALLBACK_IMAGE,
            h = "",
            m = "01",
            p = "jpg",
            f = o.cylindoContent !== !1,
            g = o.accountID,
            v = o.productCode;
          f &&
            g &&
            v &&
            ((h = s.resolveProtocol(a.get("urls").BUSAPI)),
            (h += [g, v, v + m + "." + p].join("/"))),
            (this.isFallbackController = !0),
            (this.on = d.on),
            (this.trigger = d.trigger),
            (this.off = d.off),
            (this.show = function () {
              function e(e) {
                e
                  ? t(e)
                  : (console.log("Could not get fallback image from CAPI"),
                    n());
              }
              var r = null,
                s = null,
                d = null,
                c = null,
                u = null;
              try {
                if (
                  ((r = document.getElementById(o.containerID)),
                  (s = r.getBoundingClientRect()),
                  (c = a.get("urls")),
                  !s)
                )
                  throw "no container defined. Please provide a container ID to embed the 360 HD Viewer into";
                (d = Math.round(s.width)),
                  o.fallbackImage
                    ? i(o.fallbackImage)
                    : l && o.features
                    ? ((u = o.version
                        ? l.getUrlV2(
                            o.accountID,
                            o.productCode,
                            1,
                            d,
                            o.features,
                            o.removeEnvironmentShadow,
                            o.proxy,
                            "https:" === window.location.protocol,
                            o.version
                          )
                        : l.getUrlV2(
                            o.accountID,
                            o.productCode,
                            1,
                            d,
                            o.features,
                            o.removeEnvironmentShadow,
                            o.proxy,
                            "https:" === window.location.protocol
                          )),
                      e(u))
                    : (console.log(
                        "Failed to load custom fallback image or CAPI image, viewer is triying to use BUSAPI or default fallback image instead."
                      ),
                      n());
              } catch (h) {
                console.log(h), n();
              }
            }),
            (this.destroy = function () {
              d.destroy(), this.trigger(this.events.DESTROYED);
            });
        };
        e.prototype.events = {
          DESTROYED: "instance:destroyed",
          VIEWER_READY: "instance:viewer:ready",
          VIEWER_COMPLETE: "instance:viewer:complete",
          FIRST_FRAME_READY: "instance:firstframe:ready",
          THUMBS_READY: "instance:thumbs:ready",
          THUMB_CLICKED: "instance:viewer:thumbs:clicked",
          ALT_THUMBS_CLICKED: "instance:alt:thumbs:clicked",
          ZOOM: "instance:zoom",
          ZOOM_ENTER: "instance:zoom:enter",
          ZOOM_EXIT: "instance:zoom:exit",
          FULLSCREEN_ENTER: "instance:fullscreen:enter",
          FULLSCREEN_EXIT: "instance:fullscreen:exit",
          SPIN_BEGIN: "instance:threesixty:start",
          SPIN_END: "instance:threesixty:end",
          PREV: "instance:carousel:prev",
          NEXT: "instance:carousel:next",
          ERROR: "instance:error",
          AR_BUTTON_READY: "instance:ar:button:ready",
          AR_BUTTON_ERROR: "instance:ar:button:error",
          AR_ACTION_BTN_TAPPED: "instance:ar:action:btn:tapped",
          FEATURES_CANCELED: "instance:features:canceled",
          FEATURES_ERROR: "instance:features:error",
        };
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.core.fallback", t);
      }.call(this),
      function () {
        function e(e) {
          function t() {
            document.addEventListener(r.fullscreenChangeEvent, i, !1);
          }
          function n() {
            document.removeEventListener(r.fullscreenChangeEvent, i, !1);
          }
          function i(e) {
            r.trigger(r.events.FULLSCREEN_CHANGED, e);
          }
          function o() {
            s.destroy(), (r.btn = null), r.trigger(r.events.DESTROYED);
          }
          var r = this,
            s = cylindo.getModule("cylindo.util.pubsub").create(),
            a = cylindo.getModule("cylindo.helpers.fullscreen.map").create();
          (this.on = s.on),
            (this.off = s.off),
            (this.trigger = s.trigger),
            (this.destroy = o),
            (this.model = e.model || null),
            (this.btn = e.btn || null),
            (this.viewerContainer = e.viewerContainer || null),
            (this.enabled = !1),
            (this.available = !0),
            (this.requestFullscreen = a.request),
            (this.exitFullscreen = a.exit),
            (this.fullscreenChangeEvent = (a.change || "").replace(/^on/, "")),
            (this.fullscreenElement = a.element),
            (this.subscribeToFullScreenChangeEvt = t),
            (this.cancelSubscriptionToFullScreenChangeEvt = n),
            (this.ariaLabel = e.ariaLabel),
            r.shouldHideButton(),
            (r.initialized = !0);
        }
        (e.prototype.constructor = e),
          (e.prototype.isAvailable = function () {
            return this.available;
          }),
          (e.prototype.isEnabled = function () {
            return this.enabled;
          }),
          (e.prototype.setStatus = function (e) {
            this.enabled = e;
          }),
          (e.prototype.setBtn = function (e) {
            this.btn = e;
          }),
          (e.prototype.shouldHideButton = function () {
            !this.model ||
              (this.model.get("fullscreen") === !0 &&
                this.requestFullscreen &&
                this.exitFullscreen) ||
              ((this.available = !1),
              this.btn.classList.add("permanently-hidden"));
          }),
          (e.prototype.toggleBtnIcon = function (e) {
            this.btn &&
              (e
                ? (this.btn.setAttribute(
                    "aria-label",
                    this.ariaLabel.texts.EXIT_FULLSCREEN
                  ),
                  this.btn.classList.remove("cylindo-icon-fullscreen-off"),
                  this.btn.classList.add("cylindo-icon-fullscreen-on"))
                : (this.btn.setAttribute(
                    "aria-label",
                    this.ariaLabel.texts.ENTER_FULLSCREEN
                  ),
                  this.btn.classList.remove("cylindo-icon-fullscreen-on"),
                  this.btn.classList.add("cylindo-icon-fullscreen-off")));
          }),
          (e.prototype.close = function () {
            document[this.exitFullscreen]();
          }),
          (e.prototype.processFullScreenEvent = function (e) {
            var t =
              "boolean" == typeof e ? e : document[this.fullscreenElement];
            this.viewerContainer &&
              this.model &&
              this.model.isCustomBackgroundColor() &&
              this.model.get("backgroundColor") &&
              (this.viewerContainer.style.backgroundColor = t
                ? "#" + this.model.get("backgroundColor")
                : ""),
              t ? this.addFullScreenClass() : this.removeFullScreenClass(),
              this.toggleBtnIcon(t);
          }),
          (e.prototype.addFullScreenClass = function () {
            this.viewerContainer.classList.add("full-screen");
          }),
          (e.prototype.removeFullScreenClass = function () {
            this.viewerContainer.classList.remove("full-screen");
          }),
          (e.prototype.show = function () {
            this.btn.style.display = "block";
          }),
          (e.prototype.toggleFullScreen = function () {
            this.isEnabled()
              ? (this.processFullScreenEvent(!1), this.close())
              : (this.subscribeToFullScreenChangeEvt(),
                this.viewerContainer[this.requestFullscreen]());
          }),
          (e.prototype.events = {
            CLICK: "fullscreen:click",
            TOUCHSTART: "fullscreen:touchstart",
            TOUCHEND: "fullscreen:touchend",
            FULLSCREEN_CHANGED: "fullscreen:changed",
            DESTROYED: "fullscreen:destroyed",
          });
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.fullscreen.btn", t);
      }.call(this),
      function () {
        var e = function (e) {
            function t(e) {
              (e = "boolean" != typeof e || e),
                c.get("thumbLocation") === m.TOP &&
                  d &&
                  d.parentElement &&
                  d.parentElement.classList &&
                  !d.parentElement.classList.contains("has-height") &&
                  ((d.style.position = "relative"),
                  (d.style.top = "-5px"),
                  (p = !0)),
                e ? s.fadeIn(d) : s.fadeIn(d, 0);
            }
            function n(e) {
              function t() {
                p && ((p = !1), (d.style.position = ""), (d.style.top = ""));
              }
              (e = "boolean" != typeof e || e),
                e ? s.fadeOut(d, 600, t) : s.fadeOut(d, 0, t);
            }
            function i(e, n) {
              var i = f.getAllFramesToBeLoaded(),
                o = !1;
              return (
                (u = i.ALL.LEN),
                e === f.events.RELOAD_ALT_CONTENT
                  ? (u = i.ALTERNATE.LEN + i.THUMB.LEN)
                  : e === c.events.FEATURES_CHANGED &&
                    (u = i.THREESIXTY.TO_BE_LOADED + i.THUMB.LEN),
                !isNaN(u) &&
                  ((h = 0),
                  l.classList.add("no-animation"),
                  (l.style.width = "0"),
                  void t(o))
              );
            }
            function o() {
              var e = !0;
              h < u && n(e);
            }
            function r() {
              var e = 0;
              return (
                ++h,
                0 !== u &&
                  ((e = Math.min((h / u) * 100, 100)),
                  (l.style.width = e + "%"),
                  1 === h && l.classList.remove("no-animation"),
                  void (100 === e && n()))
              );
            }
            var s = e.dom,
              a = e.container,
              l = document.createElement("div"),
              d = a.querySelector(".cylindo-loading-bar"),
              c = e.model,
              u = 0,
              h = 0,
              m = c ? c.getThumbLocations() : {},
              p = !1,
              f = e.framesHandler;
            for (
              this.show = t,
                this.hide = n,
                this.updateBar = r,
                this.startLoading = i,
                f.on(f.events.RELOAD_ALT_CONTENT, i),
                c.on(c.events.FEATURES_CHANGED, i),
                c.on(c.events.AR_CONFIG_CHANGED, i),
                c.on(c.events.FEATURES_ERROR, o),
                l.style.height = "100%",
                l.style.width = "0%";
              d.hasChildNodes();

            )
              d.removeChild(d.firstChild);
            d.appendChild(l);
          },
          t = {
            create: function (t) {
              return new e(t);
            },
          };
        window.cylindo.addModule("loadingBar", t);
      }.call(this),
      function () {
        function e(e) {
          function n() {
            o.destroy(), (self.btn = null);
          }
          (e.appendButton = !1), t.call(this, e);
          var i = cylindo.getModule("cylindo.core.network"),
            o = cylindo.getModule("cylindo.util.pubsub").create(),
            r = e.settings.get("urls"),
            s = r.AR,
            a = e.util;
          (this.util = a),
            (this.on = o.on),
            (this.off = o.off),
            (this.trigger = o.trigger),
            (this.src = null),
            (this.qrSrc = null),
            (this.network = i),
            (this.settings = e.settings),
            (this.wrapperClasses = ["cylindo-button", "cylindo-ar-button"]),
            (this.model = e.model),
            (this.logger = this.model.getLogger()),
            (this.currentFeatures = this.model.get("currentFeatures")),
            (this.urls = this.currentFeatures
              ? this.currentFeatures.paths
              : null),
            (this.tags = e.tags),
            (this.preventEvents = e.preventEvents),
            (this.endPoint = s),
            (this.initialized = !1),
            (this.btnExistsPromise = this.util.promise.create()),
            (this.destroy = n),
            (this.btnImg = null),
            (this.btnIcon = null),
            (this.btnTxt = null),
            (this.btnContainer = null);
        }
        var t = cylindo.getModule("cylindo.classes.button");
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e),
          (e.prototype.render = function () {
            function e(e) {
              e &&
                (e.preventDefault(),
                e.stopPropagation(),
                e.stopImmediatePropagation(),
                i.preventEvents());
            }
            function n(t) {
              e(t),
                i.trigger(i.events.AR_SHOW_MODAL, null),
                i.tags.send(i.tags.events.AR_CLICKED),
                i.trigger(i.events.AR_LAUNCHED, null);
            }
            var i = this,
              o = new Image(),
              r = document.createElement("div"),
              s = document.createElement("div"),
              a = document.createElement("div");
            (a.innerHTML = i.model.get("ARBtnTxt")),
              r.classList.add("ar-glyph-background"),
              s.classList.add("ar-icon"),
              a.classList.add("ar-text"),
              r.appendChild(s),
              r.appendChild(a),
              t.prototype.render.call(i),
              (o.src = ""),
              (i.btnImg = o),
              (i.btnIcon = s),
              (i.btnTxt = a),
              (i.btnContainer = r),
              i.btn.appendChild(o),
              i.btn.appendChild(r),
              i.btn.setAttribute("rel", "ar"),
              i.btn.setAttribute("href", "#"),
              i.btn.setAttribute("role", "link"),
              i.btn.setAttribute("aria-label", i.ariaLabel.texts.VIEW_IN_AR),
              i.btn.addEventListener("click", e, !0),
              i.btn.addEventListener("mousedown", e, !0),
              i.btn.addEventListener("mouseup", n, !0),
              i.btn.addEventListener("touchstart", e, !0),
              i.btn.addEventListener("touchend", n, !0),
              i.tryToShow(),
              (i.initialized = !0);
          }),
          (e.prototype.tryToShow = function () {
            function e(e) {
              var t,
                i = s.model.get("_ARBannerConfig") || {},
                o = { IOS: "ios", ANDROID: "android", BOTH: "ios-android" },
                r = [o.IOS, o.ANDROID, o.BOTH],
                a =
                  r.indexOf(s.model.get("ARBanner")) !== -1
                    ? s.model.get("ARBanner")
                    : null,
                l = [],
                d = {
                  ACTION: "action",
                  QR_ACTION: "qrAction",
                  BANNER: "banner",
                };
              (i[d.ACTION] = i[d.QR_ACTION]), (i[d.BANNER] = a);
              for (t in i)
                "string" == typeof i[t] &&
                  l.push(t + "=" + encodeURIComponent(i[t]));
              l.length > 0 &&
                (n = n + (n.indexOf("?") !== -1 ? "&" : "?") + l.join("&")),
                (s.src = e),
                (s.qrSrc = n),
                s.btn.setAttribute("href", s.src),
                s.util.browser.isIE() &&
                  ((s.btn.innerHTML = ""),
                  (s.btnTxt.innerHTML = s.model.get("ARBtnTxt")),
                  s.btn.appendChild(s.btnImg),
                  s.btnContainer.appendChild(s.btnIcon),
                  s.btnContainer.appendChild(s.btnTxt),
                  s.btn.appendChild(s.btnContainer)),
                s.el.appendChild(s.btn),
                s.show(),
                s.trigger(s.events.AR_BUTTON_READY, { url: s.src, qr: n }),
                s.btnExistsPromise.resolve({ ar: s.src, qr: n });
            }
            function t() {
              var e = "USDZ not found for the requested feature set.";
              (s.src = null),
                (s.qrSrc = null),
                s.trigger(s.events.AR_BUTTON_ERROR, {}),
                s.logger.error(e),
                s.btnExistsPromise.reject({ err: e });
            }
            var n,
              i,
              o,
              r,
              s = this,
              a = {
                AR_NOT_ENABLED: "AR not enabled for this product or version.",
                WRONG_PATHS: "AR paths not found.",
              },
              l = "";
            return (
              (s.currentFeatures = s.model.get("currentFeatures")),
              (r =
                !(!s.currentFeatures || !s.currentFeatures.data) &&
                s.currentFeatures.data.isArEnabled),
              (s.urls = s.currentFeatures ? s.currentFeatures.paths : null),
              s.hide(),
              s.model.isFirstSetOfFt() && s.model.didFirstFeaturesFailed()
                ? void s.logger.error(
                    "First group of features failed, AR won't be displayed."
                  )
                : r && s.urls && s.urls.arPath
                ? ((i = s.urls.arPath.replace("__AR_FORMAT__", "usdz")),
                  (o = s.urls.arPath.replace("__AR_FORMAT__", "glb")),
                  (i = i.replace("__AR_FILE__", "AR")),
                  (o = o.replace("__AR_FILE__", "AR")),
                  (n = s.urls.qrPath.replace(
                    "__AR_FILE__",
                    s.model.get("fileName") || s.model.get("productCode")
                  )),
                  (s.el.innerHTML = ""),
                  void s.network.doRequest(
                    i,
                    function (t, n) {
                      s.logger.log("USDZ file found for this combination. ", i),
                        e(i);
                    },
                    { type: "HEAD" },
                    function (n, i) {
                      s.network.doRequest(
                        o,
                        function (t, n) {
                          s.logger.log(
                            "GLB file found for this combination. ",
                            o
                          ),
                            e(o);
                        },
                        { type: "HEAD" },
                        t,
                        null
                      );
                    },
                    null
                  ))
                : ((l = r ? a.WRONG_PATHS : a.AR_NOT_ENABLED),
                  s.trigger(s.events.AR_BUTTON_ERROR, {}),
                  void s.logger.error(
                    "Cannot create 3d file for this product.",
                    l
                  ))
            );
          }),
          (e.prototype.onFeaturesError = function () {
            var e = this;
            (e.src = null),
              (e.qrSrc = null),
              e.hide(),
              e.trigger(e.events.AR_BUTTON_ERROR, {});
          }),
          (e.prototype.getArQuickLookUrl = function () {
            return this.src || null;
          }),
          (e.prototype.events = {
            AR_BUTTON_READY: "ar:button:ready",
            AR_BUTTON_ERROR: "ar:button:error",
            AR_LAUNCHED: "ar:launched",
            AR_SHOW_MODAL: "ar:show:modal",
            AR_HIDE_MODAL: "ar:hide:modal",
            AR_SHOW_ERROR_MODAL: "ar:show:error:modal",
          });
        var n = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.button.ar.qr", n);
      }.call(this),
      function () {
        var e = cylindo.getModule("cylindo.classes.abstract.view"),
          t = function (t) {
            function n() {
              u && u.noFeatureTooltip && u.noFeatureTooltip.show(),
                u.trigger(u.events.FEATURES_ERROR, null);
            }
            function i() {
              r.call(this), e.prototype.enable.call(this, !0);
            }
            function o() {
              s.call(this), e.prototype.disable.call(this, !0);
            }
            function r() {
              u.wrapper.addEventListener("mouseup", c),
                u.wrapper.addEventListener("touchstart", a, !1),
                u.wrapper.addEventListener("touchmove", d, !1),
                u.wrapper.addEventListener("touchend", l, !1);
            }
            function s() {
              u.wrapper.removeEventListener("mouseup", c),
                u.wrapper.removeEventListener("touchstart", a, !1),
                u.wrapper.removeEventListener("touchmove", d, !1),
                u.wrapper.removeEventListener("touchend", l, !1);
            }
            function a(e) {
              p.preventScrollX(u.wrapper.parentNode), u.setMobileCoords(e);
            }
            function l(e) {
              e && (e.preventDefault(), e.stopPropagation()),
                u.setMobileCoords(e),
                p.allowScrollX(u.wrapper.parentNode);
            }
            function d(e) {
              u.setMobileCoords(e);
            }
            function c(e) {
              var t = {};
              (t.currentX = t.startX =
                e.clientX || e.changedTouches[0].clientX),
                (t.currentY = t.startY =
                  e.clientY || e.changedTouches[0].clientY),
                (t.startTime = e.timeStamp),
                u.trigger(u.events.CLICKED, t);
            }
            e.call(this, t);
            var u = this,
              h = cylindo.getModule("cylindo.core.util"),
              m = t.dom,
              p = cylindo.getModule("cylindo.helpers.scroll");
            (this.util = h),
              (this.dom = m),
              (this.wasRotating = !1),
              (this.rafIndex = null),
              (this.isRotating = !1),
              (this.spinningStartTime = 0),
              (this.frameWidth = 512),
              (this.mouseState = 0),
              (this.rotateSpeed = 50),
              (this.framesMoved = 0),
              (this.pixelsPerFrame = 0),
              (this.endFrame = null),
              (this.prevEndFrame = null),
              (this.prevIndex = null),
              (this.deltaX = 0),
              (this.strength = 0),
              (this.ease = 3),
              (this.ratio = null),
              (this.resizeTimer = 0),
              (this.pendingImages = []),
              (this.isAutoRotating = !1),
              (this.defaultTooltip = "tooltipDragText"),
              t.model.get("missingCombinationErrorText") &&
                (this.noFeatureTooltip = cylindo
                  .getModule("tooltip.no-feaure")
                  .create({
                    parent: t.el,
                    text: t.model.get("missingCombinationErrorText"),
                    dom: m,
                  })),
              this.model.on(
                this.model.events.FEATURES_CHANGED,
                this.refresh.bind(this)
              ),
              this.model.on(this.model.events.FEATURES_ERROR, n),
              this.model.on(
                this.model.events.FEATURES_NO_WARNING,
                this.onFeaturesUpdated.bind(this)
              ),
              this.model.on(
                this.model.events.CHANGED,
                this.updateView.bind(this)
              ),
              (this.listClassName = "cylindo-threesixty-list"),
              (this.viewerPresentation = "single"),
              (this.enable = i.bind(this)),
              (this.disable = o.bind(this)),
              (this.addMouseCallbacks = r.bind(this)),
              (this.removeMouseCallbacks = s.bind(this)),
              (this.targetLoadedPercentage = this.model.get(
                "partialRotationStart"
              )),
              this.noFeatureTooltip &&
                (this.noFeatureTooltip.render(),
                this.initializedWithError && this.noFeatureTooltip.show()),
              this.render();
          };
        (t.prototype = Object.create(e.prototype)),
          (t.prototype.constructor = t),
          (t.prototype.events = e.extendEvents({
            CLICKED: "single:clicked",
            READY: "single:ready",
            DOWNLOAD_COMPLETE: "single:download:complete",
            CURRENT: "single:current",
            IMG_LOADED: "single:img:loaded",
            FEATURES_CHANGED: "single:features:changed",
            FIRST_FRAME_COMPLETE: "single:firstframe:complete",
            FRAME_ACTIVATED: "single:frame:activated",
            ALT_CONTENT_REMOVED: "single:alt:content:removed",
            ALT_CONTENT_LOADED: "single:alt:content:loaded",
            CONTENT_TYPE_COMPLETE: "single:content:type:complete",
            FEATURES_CANCELED: "single:features:canceled",
            FEATURES_ERROR: "single:features:error",
          })),
          (t.prototype.render = function () {
            e.prototype.tryToCreateTooltip.call(this),
              e.prototype.render.call(this);
          }),
          (t.prototype.isRightClick = function (e) {
            return "which" in e
              ? 3 === e.which
              : "button" in e && 2 === e.button;
          }),
          (t.prototype.goToIndex = function (t) {
            this.framesHandler.is360Frame(this.currentIndex) &&
              (this.prevIndex = this.currentIndex),
              e.prototype.goToIndex.call(this, t);
          }),
          (t.prototype.refresh = function (e, t) {
            var n,
              i,
              o,
              r = this.ul360 ? this.ul360.querySelector(".active") : null,
              s = this.pendingImages.length;
            (this.viewerUpdatedStartTime = Date.now()),
              (o =
                t && t.refRequestID
                  ? t.refRequestID
                  : this.model.getRequestID()),
              (this.requestID = o);
            for (var a = 0; a < s; a++)
              o !== this.pendingImages[a].requestID &&
                this.currentIndex !== this.pendingImages[a].index &&
                (this.pendingImages[a].prepareDefer.resolve(),
                (this.pendingImages[a].img.onload = null),
                (this.pendingImages[a].img.onerror = null),
                (this.pendingImages[a].img.src = ""),
                this.pendingImages.splice(a, 1),
                a--,
                s--);
            this.framesHandler.isAltId(this.currentIndex) &&
              this.goToIndex(this.prevIndex),
              this.isComplete === !1 &&
                this.trigger(this.events.FEATURES_CANCELED, {
                  features: this.model.getCanceledFeatures(),
                }),
              (this.firstFrameIsReady = !1),
              (this.isReady = !1),
              (this.isComplete = !1),
              (this.promises = []),
              (this.frameCount = 1),
              (this.currentFeatures = this.model.get("currentFeatures")),
              (this.url = this.currentFeatures.paths),
              (n = this.dom.querySelectorAll(
                this.ul360,
                "li:not(.active):not([class*=alt])"
              )),
              n.forEach(function (e) {
                e.classList.add("hidden"), (e.innerHTML = "");
              }),
              r &&
                ((i = this.framesHandler.isAltId(this.currentIndex)
                  ? this.prevIndex
                  : this.currentIndex),
                this.prepare(i, o),
                (this.promises = this.framesHandler.is360Frame(i)
                  ? this.promises
                  : [])),
              Promise.all(this.promises).then(
                function () {
                  this.refreshRest(o), this.onFeaturesUpdated.call(this);
                }.bind(this)
              );
          }),
          (t.prototype.updateView = function (e, t) {
            this.showTooltip(this.model.get(this.defaultTooltip));
          }),
          (t.prototype.refreshRest = function (e) {
            (this.promises = []),
              this.downloadRest(e),
              Promise.all(this.promises).then(
                this.onFeaturesUpdated.bind(this)
              );
          }),
          (t.prototype.onFeaturesUpdated = function () {
            this.model.get("hasUnsupportedFeatures") ||
              (this.noFeatureTooltip && this.noFeatureTooltip.hide()),
              this.trigger(this.events.FEATURES_CHANGED);
          }),
          (t.prototype.downloadRest = function (e) {
            var t = this.model.get("startFrame");
            t !== this.currentIndex && this.prepare(t, e);
          }),
          (t.prototype.prepare = function (e, t) {
            var n,
              i,
              o,
              r,
              s,
              a,
              l,
              d,
              c = this,
              u = this.util.promise.create(),
              h = this.util.promise.create();
            if (this.framesHandler.is360Frame(e)) {
              if (
                ((n = "cylindo-viewer-frame-"),
                (i = n + e),
                (o = document.createElement("li")),
                o.setAttribute("aria-hidden", !0),
                (r = new Image()),
                (s = this.frameCount),
                (a = this.model.get("imageTimeout")),
                (l = this.dom.querySelectorAll(this.ul360, "." + i)),
                l && l.length >= 1 && (o = l[l.length - 1]),
                o.classList.add(n + e),
                this.url)
              ) {
                var m = {
                  requestID: t,
                  viewer: this,
                  urls: this.url,
                  baseClassName: n,
                  index: e,
                  li: o,
                  totalFrames: s,
                  imgTimeout: a,
                  onImageLoad: this.onImageLoad,
                  onError: this.onError,
                  prepareDefer: h,
                };
                u = this.renderer.useStrategy(
                  this.renderer.strategies.RTV_SINGLE_MERGED,
                  m
                );
              } else r.src = "";
              this.promises.push(h),
                e !== this.currentIndex ||
                  o.classList.contains("active") ||
                  this.handleActiveFrame(o, !0),
                this.ul360 && this.ul360.appendChild(o);
            } else
              this.framesHandler.isAltId(e) &&
                ((d = parseInt(
                  e.replace(this.framesHandler.prefixes.ALT, ""),
                  10
                )),
                (u = this.prepareAltContent(d)));
            return (
              u.then(function () {
                c.firstFrameEvt(e), h.resolve();
              }),
              h
            );
          }),
          (t.prototype.reloadAltContent = function (t, n) {
            var i,
              o = this.framesHandler.getAllFramesToBeLoaded(),
              r = o.ALTERNATE.LEN,
              s = this.prevIndex || 1;
            for (
              s = isNaN(s) ? s : parseInt(s, 10),
                e.prototype.reloadAltContent.call(this, t, n),
                this.prevIndex = s,
                this.goToIndex(this.prevIndex),
                i = 0;
              i < r;
              i++
            )
              this.prepareAltContent(i, t, n);
          }),
          (t.prototype.onReady = function () {
            e.prototype.onReady.call(this),
              e.prototype.sendFirstFrameCompleteEvt.call(this),
              this.tryToShowTooltip();
          }),
          (t.prototype.onImageLoad = function () {
            var e,
              t = this.li,
              n = t.cloneNode(),
              i = this.img,
              o = this.layers,
              r = this.self,
              s = this.deferred,
              a = i.length,
              l = "Frame " + this.index + ' of "__productName__" ',
              d = -1;
            for (e = 0; e < r.pendingImages.length; e++)
              r.pendingImages[e].index === this.index && (d = e);
            if (
              (d !== -1 && r.pendingImages.splice(d, 1),
              this.requestID === r.model.getRequestID())
            ) {
              if (
                ((this.index === r.currentIndex ||
                  (!r.framesHandler.is360Frame(this.currentIndex) &&
                    this.index === r.startFrame)) &&
                  (r.firstImageLoadedTime = Date.now()),
                this.timeout &&
                  (clearTimeout(this.timeout), (this.timeout = null)),
                (l = l.replace("__productName__", r.model.get("fileName"))),
                i.length > 1)
              )
                for (e = 0; e < a; e++)
                  (i[e].alt =
                    l + "(" + o[e].type + " layer - " + o[e].code + ")"),
                    n.appendChild(i[e]);
              else
                i instanceof Image
                  ? ((i.alt = l), n.appendChild(i))
                  : ((i[0].alt = l), n.appendChild(i[0]));
              r.ul360.appendChild(n),
                r.dom.remove(t),
                r.tryToEnableImageGroup(),
                r.trigger(r.events.IMG_LOADED, {
                  sequence: this.index,
                  img: i,
                }),
                s.resolve();
            }
          }),
          (t.prototype.tryToEnableImageGroup = function () {
            var e = this,
              t = this.dom.querySelectorAll(
                this.ul360,
                '[class*="cylindo-viewer-frame-"]:not([class*="-alt-"])'
              );
            (t = t.filter(function (n) {
              var i = n.className.match(/cylindo-viewer-frame-(\d+)/gi)[0],
                o = e.dom.querySelectorAll(e.ul360, "." + i);
              return (
                0 !== n.childNodes.length &&
                t.indexOf(n) === t.indexOf(o[o.length - 1])
              );
            })),
              t.forEach(function (e) {
                e.classList.remove("hidden");
              }),
              !this.isVisible && t.length > 0 && this.displayViewer(),
              !this.isReady && t.length > 0 && this.onReady(),
              !this.isComplete && t.length > 0 && this.onDownloadComplete();
          }),
          (t.prototype.tryToShowTooltip = function () {
            var e = this.ul360.querySelector(".active"),
              t = e.getAttribute("data-index"),
              n = this.framesHandler.is360Frame(t),
              i = this.framesHandler.isAltId(t),
              o = e.classList.contains("cylindo-video"),
              r = e.classList.contains("cylindo-img-not-found"),
              s = this.model.get("tooltipDragText"),
              a = this.model.get("tooltipAltImgText"),
              l = !0;
            (r || o) && (l = !1),
              this.tooltip &&
                !this.tooltip.isVisible() &&
                l &&
                (n
                  ? "string" == typeof s && s.length > 0 && this.showTooltip(s)
                  : i &&
                    "string" == typeof a &&
                    a.length > 0 &&
                    this.showTooltip(a));
          });
        var n = {
          create: function (e) {
            return new t(e);
          },
        };
        window.cylindo.addModule("singleViewer", n);
      }.call(this),
      function () {
        var e = cylindo.getModule("cylindo.classes.abstract.view"),
          t = cylindo.getModule("carouselViewer").getConstructor(),
          n = function (n) {
            function i() {
              g.wrapper.addEventListener("touchstart", d, !1),
                g.wrapper.addEventListener("mousedown", h, !1);
            }
            function o() {
              g.wrapper.removeEventListener("touchstart", d, !1),
                g.wrapper.removeEventListener("mousedown", h, !1),
                s();
            }
            function r() {
              document.addEventListener("touchend", c, !1),
                document.addEventListener("touchmove", u, !1),
                document.addEventListener("mouseup", p, !1),
                document.addEventListener("mousemove", m, !1);
            }
            function s() {
              document.removeEventListener("mouseup", p, !1),
                document.removeEventListener("mousemove", m, !1),
                document.removeEventListener("touchend", c, !1),
                document.removeEventListener("touchmove", u, !1);
            }
            function a() {
              g.isFullScreen()
                ? g.carouselViewer.enable.call(g)
                : (g.addMouseCallbacks.call(g), e.prototype.enable.call(g, !0));
            }
            function l() {
              g.isFullScreen()
                ? g.carouselViewer.disable.call(g)
                : (g.enabled = !1);
            }
            function d(e) {
              f(e) ||
                ((T = !0),
                E.preventScrollX(g.wrapper.parentNode),
                g.setMobileCoords(e),
                h(e));
            }
            function c(e) {
              e && (e.preventDefault(), e.stopPropagation()),
                y && (window.clearTimeout(y), (y = null)),
                g.setMobileCoords(e),
                p(e),
                (A = !1),
                (T = !1);
            }
            function u(e) {
              var t, n;
              return (
                g.setMobileCoords(e),
                (t = Math.abs(e.clientY - g.mouseClickPos.startY)),
                (n = Math.abs(e.clientX - g.mouseClickPos.startX)),
                !!g.isSignificantMove(e) &&
                  (window.clearTimeout(y),
                  (y = null),
                  (A || !g.wasDragging) && t > n
                    ? ((A = !0), E.scroll(e), !1)
                    : void (A || m(e)))
              );
            }
            function h(e) {
              if (!f(e) && e) {
                if (
                  e.target &&
                  e.target.classList &&
                  (e.target.classList.contains("fullscreen-button") ||
                    e.target.classList.contains("threesixty-button"))
                )
                  return;
                g.isRightClick(e) ||
                  (r(),
                  (g.mouseState = 1),
                  (g.mouseClickPos.startX = g.mouseClickPos.currentX =
                    e.clientX),
                  (g.mouseClickPos.startY = g.mouseClickPos.currentY =
                    e.clientY),
                  (g.mouseClickPos.startTime = e.timeStamp),
                  (g.currentEventTime = e.timeStamp)),
                  e.defaultPrevented || T || e.preventDefault();
              }
            }
            function m(e) {
              return !1;
            }
            function p(e) {
              var t,
                n,
                i,
                o = !1,
                r = e && e.target ? e.target : null;
              if (
                ((g.isDragging = !1),
                1 == g.mouseState && e && !g.isRightClick(e))
              ) {
                if (
                  ((g.mouseState = 0),
                  (g.deltaX = 0),
                  setTimeout(function () {
                    s();
                  }, 0),
                  !g.wasDragging && !A && "mouseup" === e.type && !T)
                ) {
                  if (f(e)) return;
                  return (
                    (t =
                      "IMG" === r.tagName
                        ? r.parentElement
                        : "LI" === r.tagName
                        ? r
                        : null),
                    (n = t
                      ? t.querySelector(
                          ".cylindo-action-button-group .threesixty-button"
                        )
                      : null),
                    (i = t
                      ? t.querySelector(
                          ".cylindo-action-button-group .threesixty-button-secondary"
                        )
                      : null),
                    (g.mouseClickPos.startX = g.mouseClickPos.currentX =
                      e.clientX),
                    (g.mouseClickPos.startY = g.mouseClickPos.currentY =
                      e.clientY),
                    g.handleBtnClasses(o),
                    void g.trigger(
                      g.events.CLICKED,
                      g.util.object.extend(
                        {
                          frame: t || null,
                          btnZoom: n || null,
                          btnZoom2: i || null,
                        },
                        g.mouseClickPos
                      )
                    )
                  );
                }
                g.wasDragging && moveCarousel(),
                  (g.wasDragging = !1),
                  g.ul360.classList.remove("cylindo-dragging");
              }
            }
            function f(e) {
              var t = e && e.target ? e.target : null;
              return !!(
                (t && "VIDEO" === t.tagName) ||
                (t &&
                  "LI" === t.tagName &&
                  t.classList &&
                  t.classList.contains("cylindo-video"))
              );
            }
            (n.preventRender = !0), t.call(this, n);
            var g = this,
              v = (cylindo.getModule("cylindo.core.util"), n.dom),
              E = cylindo.getModule("cylindo.helpers.scroll"),
              y = (cylindo.getModule("cylindo.helpers.easing"), null),
              A = !1,
              T = !1,
              R = n.hideZoomBtn,
              b = n.hideFullScreenBtn;
            (this.viewerPresentation = "stacked"),
              (this.dom = v),
              (this.enable = a.bind(this)),
              (this.disable = l.bind(this)),
              (this.addMouseCallbacks = i),
              (this.removeMouseCallbacks = o),
              (this.defaultTooltip = "tooltipStackedText"),
              (this.elementsGroup = []),
              (this.hideZoomBtn = R),
              (this.hideFullScreenBtn = b),
              (this.isCustomViewer = !1),
              (this.fullScreenEnabled = !1),
              this.render();
          };
        (n.prototype = Object.create(t.prototype)),
          (n.prototype.constructor = n),
          (n.prototype.events = {
            CLICKED: "stacked:clicked",
            READY: "stacked:ready",
            DOWNLOAD_COMPLETE: "stacked:download:complete",
            CURRENT: "stacked:current",
            IMG_LOADED: "stacked:img:loaded",
            FEATURES_CHANGED: "stacked:features:changed",
            FIRST_FRAME_COMPLETE: "stacked:firstframe:complete",
            FRAME_ACTIVATED: "stacked:frame:activated",
            ALT_CONTENT_REMOVED: "stacked:alt:content:removed",
            ALT_CONTENT_LOADED: "stacked:alt:content:loaded",
            CONTENT_TYPE_COMPLETE: "stacked:content:type:complete",
            TOGGLE_ZOOM: "stacked:toggle:zoom",
            FEATURES_CANCELED: "stacked:features:canceled",
            FULLSCREEN_BTN_ADDED: "stacked:fullscreen:btn:added",
            FULLSCREEN_BTN_REMOVED: "stacked:fullscreen:btn:removed",
            FEATURES_ERROR: "stacked:features:error",
          }),
          (n.prototype.render = function () {
            e.prototype.render.call(this);
          }),
          (n.prototype.goToIndex = function (t) {
            this.framesHandler.is360Frame(this.currentIndex) &&
              (this.prevIndex = this.currentIndex),
              this.tryToRemoveCustomImage(),
              e.prototype.goToIndex.call(this, t),
              this.trigger(this.events.CURRENT, { current: t });
          }),
          (n.prototype.refresh = function (e, t) {
            var n,
              i,
              o,
              r = this.framesHandler.getAllFramesToBeLoaded(),
              s = this.ul360 ? this.ul360.querySelector(".active") : null,
              a = this.pendingImages.length,
              l = r.THREESIXTY.TO_BE_LOADED;
            (this.viewerUpdatedStartTime = Date.now()),
              (o =
                t && t.refRequestID
                  ? t.refRequestID
                  : this.model.getRequestID()),
              (this.requestID = o);
            for (var d = 0; d < a; d++)
              o !== this.pendingImages[d].requestID &&
                this.currentIndex !== this.pendingImages[d].index &&
                (this.pendingImages[d].prepareDefer.resolve(),
                (this.pendingImages[d].img.onload = null),
                (this.pendingImages[d].img.onerror = null),
                (this.pendingImages[d].img.src = ""),
                this.pendingImages.splice(d, 1),
                d--,
                a--);
            this.framesHandler.isAltId(this.currentIndex) &&
              this.goToIndex(this.prevIndex),
              this.isComplete === !1 &&
                this.trigger(this.events.FEATURES_CANCELED, {
                  features: this.model.getCanceledFeatures(),
                }),
              (this.firstFrameIsReady = !1),
              (this.isReady = !1),
              (this.isComplete = !1),
              (this.promises = []),
              (this.frameCount = l),
              (this.currentFeatures = this.model.get("currentFeatures")),
              (this.url = this.currentFeatures.paths),
              (n = this.dom.querySelectorAll(
                this.ul360,
                "li:not([class*=alt]):not(.active-sibling)"
              )),
              n.forEach(function (e) {
                e.classList.add("is-rendering");
              }),
              s &&
                ((i = this.framesHandler.isAltId(this.currentIndex)
                  ? this.prevIndex
                  : this.currentIndex),
                this.prepare(i, o),
                (this.promises = this.framesHandler.is360Frame(i)
                  ? this.promises
                  : [])),
              Promise.all(this.promises).then(
                function () {
                  this.refreshRest(o);
                }.bind(this)
              );
          }),
          (n.prototype.refreshRest = function (e) {
            (this.promises = []),
              this.downloadRest(e),
              Promise.all(this.promises).then(
                this.onFeaturesUpdated.bind(this)
              );
          }),
          (n.prototype.updateView = function (e, t) {}),
          (n.prototype.onFeaturesUpdated = function () {
            this.model.get("hasUnsupportedFeatures") ||
              (this.noFeatureTooltip && this.noFeatureTooltip.hide()),
              this.trigger(this.events.FEATURES_CHANGED);
          }),
          (n.prototype.downloadRest = function (e) {
            function t(e, t) {
              r =
                null === r
                  ? i.prepare(e, t)
                  : r.then(function () {
                      return i.prepare(e, t);
                    });
            }
            for (
              var n,
                i = this,
                o = this.framesHandler.getAllFramesToBeLoaded(),
                r = null,
                s = o.VIEWER_ORDER.LIST,
                a = this.framesHandler.shouldDownloadAll360Frames(),
                l = a ? o.THREESIXTY.TO_BE_LOADED : o.VIEWER_ORDER.LEN,
                d = 0;
              d < l && this.model.getRequestID() === e;

            )
              (n = a ? d + 1 : s[d]),
                n !== parseInt(this.currentIndex, 10) &&
                  this.framesHandler.is360Frame(n) &&
                  t(n, e),
                d++;
          }),
          (n.prototype.prepareLi = function (e) {
            var t = "cylindo-viewer-frame-",
              n = t + e,
              i = document.createElement("li"),
              o = this.dom.querySelectorAll(this.ul360, "." + n);
            if ((i.setAttribute("aria-hidden", !1), o && 0 === o.length)) {
              i.classList.add(n),
                i.classList.add("hidden"),
                i.classList.add("is-rendering");
              try {
                i.dataset.index = e;
              } catch (r) {
                i.setAttribute("data-index", e);
              }
              this.ul360.appendChild(i);
            } else
              (o = o[o.length - 1]),
                o &&
                  !o.classList.contains("is-rendering") &&
                  o.classList.add("is-rendering");
          }),
          (n.prototype.prepare = function (e, t) {
            var n,
              i,
              o,
              r,
              s,
              a,
              l,
              d,
              c = this,
              u = this.util.promise.create(),
              h = this.util.promise.create();
            if (this.framesHandler.is360Frame(e)) {
              if (
                ((n = "cylindo-viewer-frame-"),
                (i = n + e),
                (o = document.createElement("li")),
                o.setAttribute("aria-hidden", !1),
                (r = new Image()),
                (s = this.frameCount),
                (a = this.model.get("imageTimeout")),
                this.prepareLi(e),
                (l = this.dom.querySelectorAll(this.ul360, "." + i)),
                l && l.length >= 1 && (o = l[l.length - 1]),
                this.elementsGroup.length > 0 &&
                  this.tryToRemoveElements.call(this, e),
                this.url)
              ) {
                var m = {
                  requestID: t,
                  viewer: this,
                  urls: this.url,
                  baseClassName: n,
                  index: e,
                  li: o,
                  totalFrames: s,
                  imgTimeout: a,
                  onImageLoad: this.onImageLoad,
                  onError: this.onError,
                  prepareDefer: h,
                };
                u = this.renderer.useStrategy(
                  this.renderer.strategies.RTV_SINGLE_MERGED,
                  m
                );
              } else r.src = "";
              this.promises.push(h),
                e !== this.currentIndex ||
                  o.classList.contains("active") ||
                  this.handleActiveFrame(o, !0);
            } else
              this.framesHandler.isAltId(e) &&
                ((d = parseInt(
                  e.replace(this.framesHandler.prefixes.ALT, ""),
                  10
                )),
                (u = this.prepareAltContent(d)));
            return (
              u.then(function () {
                c.firstFrameEvt(e), h.resolve();
              }),
              h
            );
          }),
          (n.prototype.reloadAltContent = function (t, n) {
            var i,
              o,
              r = this,
              s = this.dom.querySelectorAll(this.ul360, '[class*="-alt-"]'),
              a = this.framesHandler.getAllFramesToBeLoaded(),
              l = a.ALTERNATE.LEN;
            for (
              s &&
                s.length > 0 &&
                s.forEach(function (e) {
                  (i = e.dataset
                    ? e.dataset.index
                    : e.getAttribute("data-index")),
                    r.tryToRemoveElements(i);
                }),
                e.prototype.reloadAltContent.call(this, t, n),
                o = 0;
              o < l;
              o++
            )
              this.prepareAltContent(o, t, n);
          }),
          (n.prototype.onReady = function () {
            e.prototype.onReady.call(this),
              e.prototype.sendFirstFrameCompleteEvt.call(this);
          }),
          (n.prototype.onDownloadComplete = function () {
            e.prototype.onDownloadComplete.call(this);
          }),
          (n.prototype.createViewerList = function () {
            e.prototype.createViewerList.call(this),
              this.wrapper.parentNode.classList.add("is-stacked"),
              this.util.browser.isIE() &&
                this.wrapper.parentNode.classList.add("is-ie"),
              this.appendCarouselBtns();
          }),
          (n.prototype.onImageLoad = function () {
            var e,
              t = this.li,
              n = t.cloneNode(),
              i = this.img,
              o = this.layers,
              r = this.self,
              s = this.deferred,
              a = i.length,
              l = "Frame " + this.index + ' of "__productName__" ',
              d = -1;
            for (e = 0; e < r.pendingImages.length; e++)
              r.pendingImages[e].index === this.index && (d = e);
            if (
              (d !== -1 && r.pendingImages.splice(d, 1),
              this.requestID === r.model.getRequestID())
            ) {
              if (
                ((this.index === r.currentIndex ||
                  (!r.framesHandler.is360Frame(this.currentIndex) &&
                    this.index === r.startFrame)) &&
                  (r.firstImageLoadedTime = Date.now()),
                this.timeout &&
                  (clearTimeout(this.timeout), (this.timeout = null)),
                (l = l.replace("__productName__", r.model.get("fileName"))),
                i.length > 1)
              )
                for (e = 0; e < a; e++)
                  (i[e].alt =
                    l + "(" + o[e].type + " layer - " + o[e].code + ")"),
                    n.appendChild(i[e]);
              else
                i instanceof Image
                  ? ((i.alt = l), n.appendChild(i))
                  : ((i[0].alt = l), n.appendChild(i[0]));
              (n.style.position = "absolute"),
                (n.style.top = r.dom.offset(t).top + "px");
              try {
                t.insertAdjacentElement("afterend", n);
              } catch (c) {
                r.dom.insertAfter(n, t);
              }
              (t.style.display = "none"),
                (n.style.position = ""),
                (n.style.top = ""),
                r.dom.remove(t),
                n.classList.remove("is-rendering"),
                r.tryToCreateElements.call(r, this.index, n),
                r.tryToEnableImageGroup(),
                r.trigger(r.events.IMG_LOADED, {
                  sequence: this.index,
                  img: i,
                }),
                s.resolve();
            }
          }),
          (n.prototype.onAltContentLoad = function () {
            this.viewer.isCustomViewer
              ? (this.viewer.tryToEnableImageGroup(),
                this.li.classList.remove("is-rendering"),
                this.viewer.trigger(this.viewer.events.ALT_CONTENT_LOADED, {
                  sequence: this.viewer.framesHandler.prefixes.ALT + this.index,
                  viewerId: this.viewer.id,
                }))
              : e.prototype.onAltContentLoad.call(this),
              this.viewer.tryToCreateElements.call(
                this.viewer,
                this.viewer.framesHandler.prefixes.ALT + this.index,
                this.li
              );
          }),
          (n.prototype.tryToEnableImageGroup = function () {
            var e,
              t,
              n = this,
              i = n.framesHandler.getAllFramesToBeLoaded(),
              o = i.THREESIXTY.TO_BE_LOADED;
            this.isCustomViewer
              ? ((o = i.ALTERNATE.LEN),
                (e = this.dom.querySelectorAll(
                  this.ul360,
                  '[class*="cylindo-viewer-frame-alt"]'
                )),
                (t = this.ul360.querySelector(".active")),
                t ||
                  ((this.firstImageLoadedTime = Date.now()),
                  this.handleActiveFrame(e[0], !0)))
              : ((e = this.dom.querySelectorAll(
                  this.ul360,
                  '[class*="cylindo-viewer-frame-"]:not([class*="-alt-"])'
                )),
                (e = e.filter(function (t) {
                  var i = t.className.match(/cylindo-viewer-frame-(\d+)/gi)[0],
                    o = n.dom.querySelectorAll(n.ul360, "." + i);
                  return (
                    0 !== t.childNodes.length &&
                    e.indexOf(t) === e.indexOf(o[o.length - 1])
                  );
                }))),
              !this.isVisible && e.length > 0 && this.displayViewer(),
              !this.isReady && e.length > 0 && this.onReady(),
              !this.isComplete &&
                e.length >= o &&
                (this.onDownloadComplete(),
                this.isCustomStacked &&
                  this.trigger(this.events.CONTENT_TYPE_COMPLETE, {
                    contentType: this.contentTypes.ALTERNATE,
                  }),
                e.forEach(function (e) {
                  e.classList.remove("hidden");
                }));
          }),
          (n.prototype.getThumbsDetails = function () {
            var e = { ts: 0, ac: 0 };
            return e;
          }),
          (n.prototype.tryToRemoveCustomImage = function () {
            var e = "cylindo-custom-image",
              t = this.ul360.querySelector("." + e);
            try {
              this.dom.remove(t),
                (this.customImageOn = !1),
                this.activateCurrentIndex();
            } catch (n) {
              this.logger.error("Cannot remove custome image", n);
            }
            this.showCarouselBtns();
          }),
          (n.prototype.showImage = function (e, t) {
            function n() {
              var e,
                t = !0;
              (this.img.onload = null),
                this.ul360.appendChild(this.li),
                (e = this.ul360.querySelector(".active")),
                e && this.instance.handleActiveFrame(e, !1),
                this.instance.handleActiveFrame(this.li, !0),
                this.instance.tryToCreateElements(
                  "cylindo-custom-image",
                  this.li
                ),
                this.instance.handleActionBtns(this.li, "", t),
                this.instance.handleZoomButton(this.li, "", "");
            }
            function i() {
              var e = this.instance.model.get("fallbackImage");
              (this.img.onerror = o.bind(this)), (this.img.src = e);
            }
            function o() {
              var e = this.instance.model.get("defaultFallbackImage");
              (this.img.onerror = null), (this.img.src = e);
            }
            var r,
              s =
                (cylindo.getModule("cylindo.core.config"),
                "cylindo-custom-image"),
              a = document.createElement("li"),
              l = new Image(),
              d = { ul360: this.ul360, img: l, li: a, instance: this };
            a.setAttribute("aria-hidden", !1),
              a.classList.add(s),
              a.appendChild(l);
            try {
              (a.dataset.zoomImage = t || e), (a.dataset.url = e);
            } catch (c) {
              a.setAttribute("data-zoom-image", t || e),
                a.setAttribute("data-url", e);
            }
            return (
              this.tryToRemoveCustomImage(),
              (l.onload = n.bind(d)),
              (l.onerror = i.bind(d)),
              (r = e),
              (l.src = r),
              (this.customImageOn = !0),
              a
            );
          }),
          (n.prototype.hideImage = function () {
            if (this.customImageOn) {
              var e,
                t,
                n,
                i,
                o = this.ul360.childNodes.length,
                r = "cylindo-custom-image";
              for (e = 0; e < o; e++)
                if (
                  ((t = this.ul360.childNodes[e]),
                  t.classList.contains("cylindo-custom-image"))
                ) {
                  (n = t.dataset ? t.dataset.url : t.getAttribute("data-url")),
                    this.tryToRemoveElements("cylindo-custom-image", this.li);
                  try {
                    (i = this.ul360.querySelector("." + r)), this.dom.remove(i);
                  } catch (s) {}
                }
              (this.customImageOn = !1), this.activateCurrentIndex();
            }
          }),
          (n.prototype.activateCurrentIndex = function () {
            var e = this.ul360.querySelector("li.active"),
              t = "cylindo-viewer-frame-",
              n = this.ul360.querySelector("." + t + this.currentIndex);
            e && this.handleActiveFrame(e, !1),
              n && this.handleActiveFrame(n, !0);
          }),
          (n.prototype.isRightClick = function (t) {
            return e.prototype.isRightClick.call(this, t);
          }),
          (n.prototype.tryToCreateElements = function (e, t) {
            var n,
              i = null,
              o = !1,
              r = {},
              s = {};
            e &&
              (this.framesHandler.is360Frame(e)
                ? (t.classList &&
                    !t.classList.contains("cylindo-img-not-found") &&
                    (o = !0),
                  (n = this.shouldCreateTooltip(e)
                    ? this.getTooltipText()
                    : ""))
                : this.framesHandler.isAltId(e) &&
                  t.classList &&
                  !t.classList.contains("cylindo-video")
                ? (t.classList.contains("cylindo-img-not-found") || (o = !0),
                  (n = this.shouldCreateTooltip(e)
                    ? this.model.get("tooltipAltImgText")
                    : ""))
                : t.classList &&
                  t.classList.contains("cylindo-custom-image") &&
                  (t.classList &&
                    !t.classList.contains("cylindo-img-not-found") &&
                    (o = !0),
                  (n = this.model.get("tooltipAltImgText")
                    ? this.model.get("tooltipAltImgText")
                    : "")),
              "string" == typeof n &&
                n.length > 0 &&
                ((i = cylindo
                  .getModule("tooltip.viewer")
                  .create({ parent: t, text: n, dom: this.dom })),
                i.render(),
                i.el.classList.add("cylindo-dismiss-on-zoom")),
              o && (r = this.createBtnsGroup(e, t)),
              this.util.object.extend(
                s,
                { index: e.toString(), tooltip: i },
                r
              ),
              this.elementsGroup.push(s));
          }),
          (n.prototype.shouldCreateTooltip = function (e) {
            var t,
              n,
              i,
              o,
              r,
              s,
              a = this.framesHandler.getAllFramesToBeLoaded(),
              l = this.model.get("tooltipStackedPosition");
            if (1 === l) return !0;
            if (this.framesHandler.is360Frame(e))
              (o = a.THREESIXTY.FIRST),
                (r = a.THREESIXTY.LAST),
                (s = parseInt(e, 10));
            else if (this.framesHandler.isAltId(e)) {
              for (t = a.ALTERNATE.LIST, n = a.ALTERNATE.LEN, i = 0; i < n; i++)
                if ("undefined" == typeof t[i].provider) {
                  o = i;
                  break;
                }
              for (i = n - 1; i >= 0; i--)
                if ("undefined" == typeof t[i].provider) {
                  r = i;
                  break;
                }
              s = parseInt(e.replace(this.framesHandler.prefixes.ALT, ""), 10);
            }
            return (2 === l && s === o) || (3 === l && s === r);
          }),
          (n.prototype.createBtnsGroup = function (e, t) {
            function n(e) {
              var n = !1;
              i(),
                o.handleBtnClasses(n),
                o.trigger(o.events.TOGGLE_ZOOM, {
                  frame: t,
                  btnZoom: s,
                  btnZoom2: a,
                  withoutCoords: !0,
                });
            }
            function i(e) {
              e &&
                (e.preventDefault(),
                e.stopPropagation(),
                e.stopImmediatePropagation());
            }
            var o = this,
              r = document.createElement("a"),
              s = document.createElement("a"),
              a = document.createElement("a"),
              l = document.createElement("div"),
              d = t.childNodes[0],
              c = d.src,
              u = t.dataset
                ? t.dataset.zoomImage
                : t.getAttribute("data-zoom-image"),
              h = t ? t.getBoundingClientRect() : null,
              m = o.model.get("alternateContentZoom"),
              p = o.model.get("zoom");
            u &&
              u.indexOf("data:image") === -1 &&
              (u = "//" + u.split("//")[1]),
              u &&
                c &&
                u === c.replace(/^http(s)*:/i, "") &&
                d &&
                (d.naturalHeight <= h.height || d.naturalWidth <= h.width) &&
                s.classList.add("temporarily-hidden"),
              o.framesHandler.isAltId(e) || "cylindo-custom-image" === e
                ? m || s.classList.add("temporarily-hidden")
                : !p &&
                  this.framesHandler.is360Frame(e) &&
                  s.classList.add("temporarily-hidden"),
              l.classList.add(
                "cylindo-action-button-group",
                "right",
                "cylindo-dismiss-on-zoom"
              ),
              r.classList.add(
                "fullscreen-button",
                "cylindo-action-button-icon",
                "cylindo-icon-fullscreen-off"
              ),
              s.classList.add(
                "threesixty-button",
                "cylindo-action-button-icon",
                "cylindo-icon-zoom-off"
              ),
              a.classList.add(
                "threesixty-button-secondary",
                "cylindo-action-button-icon",
                "cylindo-icon-zoom-off"
              ),
              l.setAttribute("role", "group"),
              l.setAttribute(
                "aria-label",
                this.ariaLabel.texts.ACTION_BUTTONS_GROUP
              ),
              r.setAttribute("role", "link"),
              r.setAttribute(
                "aria-label",
                this.ariaLabel.texts.ENTER_FULLSCREEN
              ),
              s.setAttribute("role", "link"),
              s.setAttribute("aria-label", this.ariaLabel.texts.ENTER_ZOOM),
              a.setAttribute("role", "link"),
              a.setAttribute("aria-label", this.ariaLabel.texts.EXIT_ZOOM),
              t.appendChild(l),
              l.appendChild(r),
              l.appendChild(s),
              (a.style.display = "none"),
              o.framesHandler.is360Frame(e) ||
                a.classList.add("permanently-hidden"),
              l.appendChild(a),
              this.trigger(this.events.FULLSCREEN_BTN_ADDED, {
                btnFullScreen: r,
              }),
              s.addEventListener("mousedown", i, !0),
              s.addEventListener("mouseup", n, !0),
              s.addEventListener("touchstart", i, !0),
              s.addEventListener("touchend", n, !0);
            try {
              (s.dataset.index = e), (r.dataset.index = e);
            } catch (f) {
              s.setAttribute("data-index", e), r.setAttribute("data-index", e);
            }
            return (
              this.hideFullScreenBtn && r.classList.add("permanently-hidden"),
              this.hideZoomBtn && s.classList.add("permanently-hidden"),
              this.hideZoomBtn &&
                this.hideFullScreenBtn &&
                l.classList.add("permanently-hidden"),
              { btnGroup: l, btnFullScreen: r, btnZoom: s }
            );
          }),
          (n.prototype.handleBtnClasses = function (e) {
            var t,
              n,
              i = e ? "cylindo-icon-fullscreen-" : "cylindo-icon-zoom-",
              o = "on",
              r = "off",
              s = this.elementsGroup.length;
            if (s > 0)
              for (t = 0; t < s; t++)
                (n = e
                  ? this.elementsGroup[t].btnFullScreen
                  : this.elementsGroup[t].btnZoom),
                  n &&
                    n.classList &&
                    n.classList.contains(i + o) &&
                    (n.classList.remove(i + o), n.classList.add(i + r));
          }),
          (n.prototype.tryToRemoveElements = function (e) {
            var t, n, i;
            if (
              e &&
              this.elementsGroup.length &&
              ((t = this.elementsGroup.filter(function (t) {
                return t.index === e.toString();
              })),
              t && 1 === t.length)
            ) {
              n = t[0];
              try {
                n.tooltip.remove();
              } catch (o) {
                this.logger.log(
                  "Tooltip to remove doesn't exist for this index.",
                  e
                );
              }
              try {
                this.trigger(this.events.FULLSCREEN_BTN_REMOVED, {
                  btnFullScreen: n.btnFullScreen,
                }),
                  this.dom.remove(n.btnGroup);
              } catch (o) {
                this.logger.log(
                  "Buttons group to remove doesn't exist for this index.",
                  e
                );
              }
              (i = this.elementsGroup.indexOf(n)),
                this.elementsGroup.splice(i, 1);
            }
          }),
          (n.prototype.isFullScreen = function () {
            return this.fullScreenEnabled;
          }),
          (n.prototype.enableFullScreen = function (e) {
            (this.fullScreenEnabled = e),
              this.isFullScreen()
                ? (this.wrapper.parentNode.classList.remove("is-stacked"),
                  this.wrapper.parentNode.classList.add(
                    "is-stacked-on-fullscreen"
                  ),
                  this.ul360.classList.add("is-carousel"),
                  this.removeMouseCallbacks(),
                  this.carouselViewer.addMouseCallbacks.call(this))
                : (this.wrapper.parentNode.classList.add("is-stacked"),
                  this.wrapper.parentNode.classList.remove(
                    "is-stacked-on-fullscreen"
                  ),
                  this.ul360.classList.remove("is-carousel"),
                  this.carouselViewer.removeMouseCallbacks.call(this),
                  this.addMouseCallbacks()),
              this.handleBtnClasses(!0),
              this.customImageOn
                ? this.hideCarouselBtns()
                : this.showCarouselBtns();
          }),
          (n.prototype.handleActiveFrame = function (e, t) {
            e &&
              e.classList &&
              (t ? e.classList.add("active") : e.classList.remove("active"));
          });
        var i = {
          create: function (e) {
            return new n(e);
          },
        };
        window.cylindo.addModule("stackedViewer", i);
      }.call(this),
      function () {
        var e = cylindo.getModule("cylindo.classes.abstract.view"),
          t = function (t) {
            function n(e) {
              (d = !0),
                a.preventScrollX(s.wrapper.parentNode),
                s.setMobileCoords(e);
            }
            function i(e) {
              e && (e.preventDefault(), e.stopPropagation()),
                s.setMobileCoords(e),
                a.allowScrollX(s.wrapper.parentNode),
                (d = !1);
            }
            function o(e) {
              s.setMobileCoords(e);
            }
            function r(e) {
              var t = {};
              (t.currentX = t.startX =
                e.clientX || e.changedTouches[0].clientX),
                (t.currentY = t.startY =
                  e.clientY || e.changedTouches[0].clientY),
                (t.startTime = e.timeStamp),
                s.trigger(s.events.CLICKED, t);
            }
            var s = this,
              a = cylindo.getModule("cylindo.helpers.scroll"),
              l = (cylindo.getModule("cylindo.core.util"), t.dom),
              d = !1;
            e.call(this, t),
              (this.dom = l),
              (this.alternateContent = t.alternateContent),
              (this.listClassName = "cylindo-custom-list"),
              (this.viewerPresentation = "custom"),
              (this.firstFrameComplete = !1),
              (this.defaultTooltip = "tooltipAltImgText"),
              this.render(),
              (this.addMouseCallbacks = function () {
                this.wrapper.addEventListener("mouseup", r),
                  this.wrapper.addEventListener("touchstart", n, !1),
                  this.wrapper.addEventListener("touchmove", o, !1),
                  this.wrapper.addEventListener("touchend", i, !1);
              }),
              (this.removeMouseCallbacks = function () {
                this.wrapper.removeEventListener("mouseup", r),
                  this.wrapper.removeEventListener("touchstart", n, !1),
                  this.wrapper.removeEventListener("touchmove", o, !1),
                  this.wrapper.removeEventListener("touchend", i, !1);
              });
          };
        (t.prototype = Object.create(e.prototype)),
          (t.prototype.constructor = t),
          (t.prototype.events = e.extendEvents({
            READY: "custom:ready",
            DOWNLOAD_COMPLETE: "custom:download:complete",
            CURRENT: "custom:current",
            CLICKED: "custom:clicked",
            IMG_LOADED: "custom:img:loaded",
            FIRST_FRAME_COMPLETE: "custom:firstframe:complete",
            FRAME_ACTIVATED: "custom:frame:activated",
            ALT_CONTENT_REMOVED: "custom:alt:content:removed",
            ALT_CONTENT_LOADED: "custom:alt:content:loaded",
            CONTENT_TYPE_COMPLETE: "custom:content:type:complete",
          })),
          (t.prototype.render = function () {
            e.prototype.tryToCreateTooltip.call(this),
              e.prototype.render.call(this);
          }),
          (t.prototype.prepare = function (e) {
            var t,
              n = this.util.promise.create();
            return (
              this.framesHandler.isAltId(e) &&
                ((t = parseInt(
                  e.replace(this.framesHandler.prefixes.ALT, ""),
                  10
                )),
                (n = this.prepareAltContent(t)),
                0 === parseInt(t, 10) &&
                  n.then(
                    function () {
                      this.trigger(this.events.FIRST_FRAME_COMPLETE, {
                        index: 1,
                        frameCount: 0,
                      });
                    }.bind(this)
                  )),
              n
            );
          }),
          (t.prototype.reloadAltContent = function (t, n) {
            e.prototype.reloadAltContent.call(this, t, n),
              (this.firstFrameComplete = !1),
              (this.isComplete = !1),
              this.downloadContent();
          }),
          (t.prototype.onImageLoad = function () {
            throw new Error("Method Prepare must be implemented.");
          }),
          (t.prototype.onAltContentLoad = function () {
            var e,
              t,
              n = this.viewer,
              i = n.naturalWidth,
              o = (n.wrapper.clientWidth - i) / 2;
            n.ul360 &&
              !n.ul360.style.width &&
              ((n.ul360.style.width = i + "px"),
              (n.ul360.style.marginLeft = o + "px"),
              (n.ul360.style.marginRight = o + "px")),
              this.li.classList.remove("hidden"),
              this.li.classList.remove("is-rendering"),
              n.trigger(n.events.ALT_CONTENT_LOADED, {
                sequence: n.framesHandler.prefixes.ALT + this.index,
                viewerId: n.id,
              }),
              n.firstFrameComplete ||
                ((n.firstImageLoadedTime = Date.now()),
                n.handleActiveFrame(this.li, !0),
                !n.tooltip ||
                  this.li.classList.contains("cylindo-video") ||
                  this.li.classList.contains("cylindo-img-not-found") ||
                  n.showTooltip(n.model.get("tooltipAltImgText")),
                (n.firstFrameComplete = !0),
                n.sendFirstFrameCompleteEvt()),
              n.isReady || n.onReady(),
              n.isVisible || n.displayViewer(),
              (e = n.dom.querySelectorAll(n.ul360, "li:not(.hidden)")),
              (t = e ? e.length : 0),
              n.isComplete ||
                t !== n.alternateContent.length ||
                (n.onDownloadComplete(),
                n.trigger(n.events.CONTENT_TYPE_COMPLETE, {
                  contentType: n.contentTypes.ALTERNATE,
                }));
          });
        var n = {
          create: function (e) {
            return new t(e);
          },
        };
        window.cylindo.addModule("customViewer", n);
      }.call(this),
      function () {
        var e = cylindo.getModule("cylindo.classes.abstract.view"),
          t = cylindo.getModule("cylindo.util.angles"),
          n = function (t) {
            function n() {
              A && A.noFeatureTooltip && A.noFeatureTooltip.show(),
                A.trigger(A.events.FEATURES_ERROR, null);
            }
            function i() {
              r.call(this), e.prototype.enable.call(this, !0);
            }
            function o() {
              d.call(this), e.prototype.disable.call(this, !0);
            }
            function r() {
              this.wrapper.addEventListener("touchstart", c, !1),
                this.wrapper.addEventListener("mousedown", m, !1);
            }
            function s() {
              document.addEventListener("touchend", u, !1),
                document.addEventListener("touchmove", h, !1),
                document.addEventListener("mouseup", f, !1),
                document.addEventListener("mousemove", p, !1),
                (A.documentEventsAdded = !0);
            }
            function a() {
              document.removeEventListener("mouseup", f, !1),
                document.removeEventListener("mousemove", p, !1),
                document.removeEventListener("touchend", u, !1),
                document.removeEventListener("touchmove", h, !1),
                (A.documentEventsAdded = !1);
            }
            function l() {
              a(),
                (A.start = null),
                (A.mouseState = 0),
                (A.deltaX = 0),
                (A.framesMoved = 0),
                (A.wasRotating = !1),
                (A.isRotating = !1),
                A.ul360.classList.remove("cylindo-rotating");
            }
            function d() {
              this.wrapper.removeEventListener("mousedown", m, !1),
                this.wrapper.removeEventListener("touchstart", c, !1),
                a();
            }
            function c(e) {
              v(e) ||
                ((C = !0),
                b.preventScrollX(A.wrapper.parentNode),
                (A.stopAutoRotation = !0),
                A.setMobileCoords(e),
                m(e));
            }
            function u(e) {
              e && (e.preventDefault(), e.stopPropagation()),
                I && (window.clearTimeout(I), (I = null)),
                A.setMobileCoords(e),
                f(e),
                b.allowScrollX(A.wrapper.parentNode),
                (w = !1),
                (C = !1);
            }
            function h(e) {
              var t, n;
              return (
                A.setMobileCoords(e),
                (t = Math.abs(e.clientY - A.mouseClickPos.startY)),
                (n = Math.abs(e.clientX - A.mouseClickPos.startX)),
                !!A.isSignificantMove(e) &&
                  (window.clearTimeout(I),
                  (I = null),
                  (w || !A.wasRotating) && t > n && (w = !0),
                  void (w || p(e)))
              );
            }
            function m(e) {
              function t() {
                v(e) ||
                  ((A.stopAutoRotation = !0),
                  (E = Date.now()),
                  e &&
                    (A.isRightClick(e) ||
                      (s(),
                      (A.initialFrame = A.currentIndex),
                      (A.mouseState = 1),
                      (A.prevEndFrame = A.endFrame || 1),
                      (A.endFrame = A.currentIndex),
                      (A.mouseClickPos.startX = A.mouseClickPos.currentX =
                        e.clientX),
                      (A.mouseClickPos.startY = A.mouseClickPos.currentY =
                        e.clientY),
                      (A.mouseClickPos.startTime = e.timeStamp),
                      (A.currentEventTime = e.timeStamp),
                      (A.totalFramesMoved = 0),
                      (A.deltaTime = e.timeStamp || new Date().getTime())),
                    e.defaultPrevented || C || e.preventDefault()));
              }
              A.isTailOfMovements
                ? (A.tailPromise.then(function () {
                    t();
                  }),
                  A.resetMovementsTail())
                : t();
            }
            function p(e) {
              var t,
                n = A.getMaxAvalilableIndex(),
                i = 0,
                o = A.ul360.querySelector(".active"),
                r = o
                  ? o.dataset
                    ? o.dataset.index
                    : o.getAttribute("data-index")
                  : null,
                s = null,
                a = 0;
              (r = parseInt(r, 10)),
                (A.pixelsPerFrame = A.calculatePixelsPerFrame()),
                0 === A.mouseState ||
                  /alt\-\d/.test(A.currentIndex) ||
                  (e &&
                    A.mouseState > 0 &&
                    ((a = e.clientX - A.mouseClickPos.currentX),
                    (A.prevEndFrame = A.endFrame || 1),
                    A.prevEndFrame !== A.endFrame &&
                      I &&
                      (clearTimeout(I), (I = null)),
                    Math.abs(a) >= A.pixelsPerFrame &&
                      (A.isRotating ||
                        A.trigger(A.events.START, { index: A.currentIndex }),
                      (A.wasRotating = !0),
                      (A.isRotating = !0),
                      ((A.deltaX > 0 && a < 0) || (A.deltaX < 0 && a > 0)) &&
                        (A.tags.send(A.tags.events.SPIN),
                        (A.initialFrame = A.currentIndex),
                        (A.framesMoved = 0),
                        (A.mouseClickPos.startX = A.mouseClickPos.currentX),
                        (A.totalFramesMoved = 0),
                        (A.deltaTime = e.timeStamp || new Date().getTime())),
                      (A.deltaX = a),
                      A.ul360.classList.add("cylindo-rotating"),
                      (i = A.getDistanceToFrames(a)),
                      a > 0
                        ? (++A.framesMoved,
                          (t = i + A.currentIndex),
                          (A.totalFramesMoved += i))
                        : (--A.framesMoved,
                          (t = A.currentIndex - i),
                          (A.totalFramesMoved -= i)),
                      t <= 0 ? (t = n + t) : t > n && (t -= n),
                      t !== r &&
                        ((A.currentIndex = A.isFrameAvailable(t)
                          ? t
                          : A.getNextAvailableFrame(r)),
                        (s = A.ul360.querySelector(
                          '[data-index="' + A.currentIndex + '"]:not(.hidden)'
                        )),
                        A.handleActiveFrame(s, !0),
                        A.handleActiveFrame(o, !1)),
                      (A.mouseClickPos.currentX = e.clientX),
                      (A.mouseClickPos.currentY = e.clientY),
                      (A.currentEventTime = e.timeStamp),
                      A.trigger(A.events.CURRENT, {
                        current: A.currentIndex,
                      }))),
                  (A.mouseClickPos.startTime = Date.now()));
            }
            function f(e) {
              function t(e) {
                if (1 == A.mouseState && e && !A.isRightClick(e)) {
                  if (
                    ((A.start = null),
                    (A.mouseState = 0),
                    (A.deltaX = 0),
                    n &&
                      setTimeout(function () {
                        a();
                      }, 0),
                    !(A.wasRotating || w || "mouseup" !== e.type || C))
                  )
                    return (
                      (A.mouseClickPos.startX = A.mouseClickPos.currentX =
                        e.clientX),
                      (A.mouseClickPos.startY = A.mouseClickPos.currentY =
                        e.clientY),
                      void A.trigger(A.events.CLICKED, A.mouseClickPos)
                    );
                  if (/alt\-\d/.test(A.currentIndex)) return;
                  A.wasRotating &&
                    (A.trigger(A.events.END, { index: A.currentIndex }),
                    A.tags.send(A.tags.events.SPIN)),
                    (A.framesMoved = 0),
                    (A.wasRotating = !1),
                    (A.isRotating = !1),
                    A.ul360.classList.remove("cylindo-rotating");
                }
                y = Date.now();
              }
              var n = !0;
              g(e),
                A.isTailOfMovements
                  ? ((A.rafIndex = setTimeout(
                      A.update.bind(A),
                      A.updateTimeOut
                    )),
                    (n = !1),
                    a(),
                    A.tailPromise.then(function () {
                      t(e);
                    }))
                  : t(e);
            }
            function g(e) {
              var t,
                n,
                i = A.model.get("speedMultiplier"),
                o = A.getMaxAvalilableIndex(),
                r = e && e.timeStamp ? e.timeStamp : new Date().getTime(),
                s = A.ul360.getBoundingClientRect();
              if (
                ((A.updateTimeOut =
                  (r - A.deltaTime) / Math.abs(A.framesMoved)),
                (A.tailPromise = A.util.promise.create()),
                (A.isTailOfMovements = !1),
                (A.rotations = 0),
                (A.endFrame = A.currentIndex),
                (t = e.clientX - A.mouseClickPos.startX),
                t > 0)
              ) {
                if (
                  ((n = Math.ceil(A.frameCount * i * (t / s.width))),
                  (n -= A.totalFramesMoved),
                  n <= 0)
                )
                  return;
              } else if (
                ((n = Math.floor(A.frameCount * i * (t / s.width))),
                (n -= A.totalFramesMoved),
                n >= 0)
              )
                return;
              A.updateTimeOut >= 25 ||
                ((A.isTailOfMovements = !0),
                Math.abs(n) > A.frameCount &&
                  ((A.rotations = Math.floor(Math.abs(n) / o)),
                  (n %= A.frameCount)),
                (A.endFrame = A.currentIndex + n),
                A.endFrame <= 0
                  ? (A.endFrame = o + A.endFrame)
                  : A.endFrame > o && (A.endFrame = A.endFrame - o));
            }
            function v(e) {
              var t = A.ul360.querySelector(".active");
              return !(!t || !t.classList.contains("cylindo-video"));
            }
            e.call(this, t);
            var E,
              y,
              A = this,
              T = cylindo.getModule("cylindo.core.util"),
              R = t.dom,
              b = cylindo.getModule("cylindo.helpers.scroll"),
              I = null,
              L = null,
              w = !1,
              C = !1;
            (this.util = T),
              (this.dom = R),
              (this.wasRotating = !1),
              (this.rafIndex = null),
              (this.isRotating = !1),
              (this.frameWidth = 512),
              (this.mouseState = 0),
              (this.rotateSpeed = 50),
              (this.framesMoved = 0),
              (this.totalFramesMoved = 0),
              (this.deltaTime = 0),
              (this.pixelsPerFrame = 0),
              (this.initialFrame = null),
              (this.endFrame = null),
              (this.rotations = 0),
              (this.updateTimeOut = 1e3 / 60),
              (this.isTailOfMovements = !1),
              (this.tailPromise = null),
              (this.prevEndFrame = null),
              (this.prevIndex = null),
              (this.deltaX = 0),
              (this.strength = 0),
              (this.ease = 3),
              (this.ratio = null),
              (this.resizeTimer = 0),
              (this.pendingImages = []),
              (this.stopAutoRotation = !1),
              (this.isAutoRotating = !1),
              (this.defaultTooltip = "tooltipDragText"),
              (this.documentEventsAdded = !1),
              (this.removeDocumentEventsForced = l),
              (this.imagesRequested = 0),
              t.model.get("missingCombinationErrorText") &&
                (this.noFeatureTooltip = cylindo
                  .getModule("tooltip.no-feaure")
                  .create({
                    parent: t.el,
                    text: t.model.get("missingCombinationErrorText"),
                    dom: R,
                  })),
              this.model.on(
                this.model.events.FEATURES_CHANGED,
                this.refresh.bind(this)
              ),
              this.model.on(this.model.events.FEATURES_ERROR, n),
              this.model.on(
                this.model.events.FEATURES_NO_WARNING,
                this.onFeaturesUpdated.bind(this)
              ),
              this.model.on(
                this.model.events.CHANGED,
                this.updateView.bind(this)
              ),
              (this.listClassName = "cylindo-threesixty-list"),
              (this.viewerPresentation = "360viewer"),
              (this.enable = i.bind(this)),
              (this.disable = o.bind(this)),
              (this.addMouseCallbacks = r.bind(this)),
              (this.removeMouseCallbacks = d.bind(this)),
              (this.targetLoadedPercentage = this.model.get(
                "partialRotationStart"
              )),
              (L = this.model.get("mobileZoomDelay")),
              this.noFeatureTooltip &&
                (this.noFeatureTooltip.render(),
                this.initializedWithError && this.noFeatureTooltip.show()),
              this.render();
          };
        (n.prototype = Object.create(e.prototype)),
          (n.prototype.constructor = n),
          (n.prototype.events = e.extendEvents({
            CLICKED: "threesixty:clicked",
            READY: "threesixty:ready",
            DOWNLOAD_COMPLETE: "threesixty:download:complete",
            CURRENT: "threesixty:current",
            IMG_LOADED: "threesixty:img:loaded",
            FEATURES_CHANGED: "threesixty:features:changed",
            FIRST_FRAME_COMPLETE: "threesixty:firstframe:complete",
            START: "threesixty:start",
            END: "threesixty:end",
            FRAME_ACTIVATED: "threesixty:frame:activated",
            ALT_CONTENT_REMOVED: "threesixty:alt:content:removed",
            ALT_CONTENT_LOADED: "threesixty:alt:content:loaded",
            CONTENT_TYPE_COMPLETE: "threesixty:content:type:complete",
            FEATURES_CANCELED: "threesixty:features:canceled",
            FEATURES_ERROR: "threesixty:features:error",
          })),
          (n.prototype.render = function () {
            e.prototype.tryToCreateTooltip.call(this),
              e.prototype.render.call(this);
          }),
          (n.prototype.downloadContent = function (e) {
            function t(e, t, n) {
              h =
                null === h
                  ? s.prepare(e, t).then(function (t) {
                      i(e, n);
                    })
                  : h.then(function () {
                      var o = s.prepare(e, t);
                      return (
                        o.then(function (t) {
                          i(e, n);
                        }),
                        o
                      );
                    });
            }
            function n(e) {
              function t(e) {
                var t,
                  n = s.util.promise.create(),
                  i = [];
                for (t = 0; t < e.length; t++)
                  i.push(s.prepare(e[t].index, e[t].requestID));
                return (
                  Promise.all(i).then(function () {
                    n.resolve();
                  }),
                  n
                );
              }
              h =
                null === h
                  ? t(e)
                  : h.then(function () {
                      return t(e);
                    });
            }
            function i(e, t) {
              s.framesHandler.isAltId(e) &&
                (u--,
                0 === u &&
                  s.trigger(s.events.CONTENT_TYPE_COMPLETE, {
                    contentType: s.contentTypes.ALTERNATE,
                  }));
            }
            var o,
              r,
              s = this,
              a = s.model.get("startFrame"),
              l = s.framesHandler.getAllFramesToBeLoaded(),
              d = l.VIEWER_ORDER.LIST,
              c = l.VIEWER_ORDER.LEN,
              u = 0,
              h = null,
              m = l.THREESIXTY.TO_BE_LOADED,
              p = !0,
              f = 1,
              g = f,
              v = this.model.get("partialRotationStart"),
              E = m * (v / 100),
              y = m / E,
              A = [];
            if (((this.isCustomViewer = 0 === m), (this.frameCount = m), c > 0))
              for (
                this.currentIndex = d[0],
                  this.prevIndex = a,
                  this.startFrame = a,
                  o = 0;
                o < c;
                o++
              )
                if (((r = d[o]), s.framesHandler.is360Frame(r))) {
                  if (p)
                    for (
                      r !== a &&
                        ((this.currentIndex =
                          this.currentIndex === r ? a : this.currentIndex),
                        (r = a)),
                        t(r, e, o),
                        ++s.imagesRequested,
                        p = !1;
                      g <= m && this.model.getRequestID() === e;

                    )
                      g !== r &&
                        (++s.imagesRequested,
                        A.push({ index: g, requestID: e }),
                        s.imagesRequested === Math.floor(E) &&
                          ((E = Math.round(E)),
                          n(A),
                          (A = []),
                          (s.imagesRequested = 0))),
                        (g += y),
                        g > m && f < y && (g = ++f);
                } else s.framesHandler.isAltId(r) && u++, t(r, e, o);
          }),
          (n.prototype.calculatePixelsPerFrame = function () {
            var e = this.ul360.getBoundingClientRect(),
              t = this.wrapper.getBoundingClientRect(),
              n = e.width,
              i = this.getAvailableFrames().length,
              o = this.getRotationSpeed(),
              r = this.isFullScreen() ? n / t.width : 1;
            return Math.floor(n / 2 / (i * (o * r)));
          }),
          (n.prototype.isRightClick = function (t) {
            return e.prototype.isRightClick.call(this, t);
          }),
          (n.prototype.goToIndex = function (t) {
            function n() {
              (s.stopAutoRotation = !0),
                s.framesHandler.is360Frame(s.currentIndex) &&
                  (s.prevIndex = s.currentIndex),
                isNaN(i) || isNaN(s.currentIndex)
                  ? (s.documentEventsAdded && s.removeDocumentEventsForced(),
                    e.prototype.goToIndex.call(s, t),
                    s.trigger(s.events.CURRENT, { current: t }))
                  : (i - o > r || i - o <= -r
                      ? (s.deltaX = (i - o) * -1)
                      : (s.deltaX = i - o),
                    (s.endFrame = i),
                    s.isFrameAvailable(s.endFrame) ||
                      (s.endFrame = s.getNextAvailableFrame(s.endFrame)),
                    s.rafIndex &&
                      (clearTimeout(s.rafIndex), (s.rafIndex = null)),
                    (s.wasThumbClicked = !0),
                    (s.rafIndex = setTimeout(
                      s.update.bind(s),
                      s.updateTimeOut
                    )));
            }
            var i = parseInt(t, 10),
              o = isNaN(this.currentIndex) ? 1 : this.currentIndex,
              r = this.getMaxAvalilableIndex() / 2,
              s = this;
            (s.updateTimeOut = 1e3 / 60),
              this.isTailOfMovements
                ? (this.tailPromise.then(function () {
                    n();
                  }),
                  this.resetMovementsTail())
                : n();
          }),
          (n.prototype.showImage = function (t, n) {
            function i(t, n) {
              e.prototype.showImage.call(o, t, n);
            }
            var o = this;
            this.isTailOfMovements
              ? (this.tailPromise.then(function () {
                  i(t, n);
                }),
                this.resetMovementsTail())
              : i(t, n);
          }),
          (n.prototype.moveToNextFrame = function () {
            var e = this.getMaxAvalilableIndex();
            (this.prevIndex = this.currentIndex || 1),
              this.deltaX > 0
                ? (++this.currentIndex,
                  (this.currentIndex =
                    this.currentIndex > e ? 1 : this.currentIndex))
                : this.deltaX < 0 &&
                  (--this.currentIndex,
                  (this.currentIndex =
                    this.currentIndex < 1 ? e : this.currentIndex)),
              ++this.framesMoved;
          }),
          (n.prototype.getMaxAvalilableIndex = function () {
            var e,
              t = this.getAvailableFrames(),
              n = -1,
              i = t.length;
            for (e = 0; e < i; e++) t[e] > n && (n = t[e]);
            return n;
          }),
          (n.prototype.update = function () {
            function e() {
              return n.rotations > 0 && n.endFrame === n.currentIndex;
            }
            var t,
              n = this,
              i =
                this.dom.querySelectorAll(
                  this.ul360,
                  '[class*="cylindo-viewer-frame-"]'
                ) || [];
            return (0 === this.mouseState || this.isTailOfMovements) &&
              this.endFrame &&
              this.endFrame === this.currentIndex &&
              0 === this.rotations
              ? (this.rotation > 0 && this.rotations--,
                (this.endFrame = null),
                i.forEach(function (e) {
                  e.style.transition = "";
                }),
                this.isRotating &&
                  this.ul360.classList.remove("cylindo-rotating"),
                this.isTailOfMovements
                  ? void this.resetMovementsTail()
                  : ((this.isRotating = !1),
                    (this.framesMoved = 0),
                    void (this.wasRotating = !1)))
              : (this.isTailOfMovements &&
                  ((t = 1.02 - this.model.get("rotationSpeed") / 1e3),
                  (this.updateTimeOut = this.updateTimeOut * t)),
                i.forEach(function (e) {
                  e.style.transition = "unset";
                }),
                (this.rafIndex = setTimeout(
                  this.update.bind(this),
                  this.updateTimeOut
                )),
                this.isFrameAvailable(this.endFrame) ||
                  (this.endFrame = this.getNextAvailableFrame(
                    this.prevEndFrame
                  )),
                (this.prevIndex = this.currentIndex || 1),
                void (
                  this.endFrame &&
                  (e() || this.endFrame !== this.currentIndex) &&
                  (e() && this.rotations--,
                  (this.wasRotating = !0),
                  this.framesHandler.is360Frame(this.currentIndex) &&
                    this.moveToNextFrame(),
                  isNaN(this.currentIndex)
                    ? (this.resetMovementsTail(), (this.isRotating = !1))
                    : (this.isRotating = !0),
                  this.isFrameAvailable(this.currentIndex) &&
                    (this.handleActiveFrame(
                      this.ul360.querySelector(".active"),
                      !1
                    ),
                    this.handleActiveFrame(
                      this.ul360.querySelector(
                        '[data-index="' + this.currentIndex + '"]'
                      ),
                      !0
                    )),
                  this.trigger(this.events.CURRENT, {
                    current: this.currentIndex,
                  }))
                ));
          }),
          (n.prototype.getDistanceToFrames = function (e) {
            var t;
            return (
              (e = Math.abs(e)),
              (t = Math.floor(e / this.pixelsPerFrame)),
              (t = Math.min(2, t))
            );
          }),
          (n.prototype.refresh = function (e, t) {
            var n,
              i,
              o,
              r = this.framesHandler.getAllFramesToBeLoaded(),
              s = this.ul360 ? this.ul360.querySelector(".active") : null,
              a = this.pendingImages.length,
              l = a,
              d = r.THREESIXTY.TO_BE_LOADED;
            (this.viewerUpdatedStartTime = Date.now()),
              (o =
                t && t.refRequestID
                  ? t.refRequestID
                  : this.model.getRequestID()),
              (this.requestID = o);
            for (var c = 0; c < a; c++)
              o !== this.pendingImages[c].requestID &&
                this.currentIndex !== this.pendingImages[c].index &&
                (this.pendingImages[c].prepareDefer.resolve(),
                (this.pendingImages[c].img.onload = null),
                (this.pendingImages[c].img.onerror = null),
                (this.pendingImages[c].img.src = ""),
                this.pendingImages.splice(c, 1),
                c--,
                a--);
            this.framesHandler.isAltId(this.currentIndex) &&
              this.goToIndex(this.prevIndex),
              this.isComplete === !1 &&
                (this.trigger(this.events.FEATURES_CANCELED, {
                  features: this.model.getCanceledFeatures(),
                }),
                (l = 0 === l ? this.frameCount : l)),
              (this.firstFrameIsReady = !1),
              (this.isReady = !1),
              (this.isComplete = !1),
              (this.promises = []),
              (this.imagesRequested = 0),
              this.preventRotation(),
              (this.targetLoadedPercentage = this.model.get(
                "partialRotationStart"
              )),
              (this.frameCount = d),
              (this.currentFeatures = this.model.get("currentFeatures")),
              (this.url = this.currentFeatures.paths),
              (n = this.dom.querySelectorAll(
                this.ul360,
                "li:not(.active):not([class*=alt])"
              )),
              n.forEach(function (e) {
                e.classList.add("hidden"), (e.innerHTML = "");
              }),
              s &&
                ((i = this.framesHandler.isAltId(this.currentIndex)
                  ? this.prevIndex
                  : this.currentIndex),
                this.prepare(i, o),
                this.framesHandler.is360Frame(i) && ++this.imagesRequested,
                (this.promises = this.framesHandler.is360Frame(i)
                  ? this.promises
                  : [])),
              Promise.all(this.promises).then(
                function () {
                  this.refreshRest(o);
                }.bind(this)
              );
          }),
          (n.prototype.refreshRest = function (e) {
            (this.promises = []),
              this.downloadRest(e),
              Promise.all(this.promises).then(
                this.onFeaturesUpdated.bind(this)
              );
          }),
          (n.prototype.updateView = function (e, t) {
            var n, i;
            t &&
              t.prop === this.defaultTooltip &&
              this.tooltip &&
              this.tooltip.isVisible() &&
              ((n = this.ul360.querySelector(".active")),
              (i =
                n && n.dataset
                  ? n.dataset.index
                  : n.getAttribute("data-index")),
              this.handleTooltip(n, i, i));
          }),
          (n.prototype.onFeaturesUpdated = function () {
            this.model.get("hasUnsupportedFeatures") ||
              (this.noFeatureTooltip && this.noFeatureTooltip.hide()),
              this.trigger(this.events.FEATURES_CHANGED);
          }),
          (n.prototype.downloadRest = function (e) {
            function t(e) {
              function t(e) {
                var t,
                  n = s.util.promise.create(),
                  i = [];
                for (t = 0; t < e.length; t++)
                  i.push(s.prepare(e[t].index, e[t].requestID));
                return (
                  Promise.all(i).then(function () {
                    n.resolve();
                  }),
                  n
                );
              }
              r =
                null === r
                  ? t(e)
                  : r.then(function () {
                      return t(e);
                    });
            }
            for (
              var n = this.framesHandler.getAllFramesToBeLoaded(),
                i = this.model.get("partialRotationStart"),
                o = n.THREESIXTY.TO_BE_LOADED,
                r = null,
                s = this,
                a = 1,
                l = o / (o * (i / 100)),
                d = a,
                c = [],
                u = o * (i / 100);
              d <= o && this.model.getRequestID() === e;

            )
              d !== parseInt(this.currentIndex, 10) &&
                (++s.imagesRequested,
                c.push({ index: d, requestID: e }),
                s.imagesRequested === Math.floor(u) &&
                  ((u = Math.round(u)),
                  t(c),
                  (c = []),
                  (s.imagesRequested = 0))),
                (d += l),
                d > o && a < l && (d = ++a);
          }),
          (n.prototype.prepare = function (e, t) {
            var n,
              i,
              o,
              r,
              s,
              a,
              l,
              d,
              c = this,
              u = this.util.promise.create(),
              h = this.util.promise.create();
            if (this.framesHandler.is360Frame(e)) {
              if (
                ((n = "cylindo-viewer-frame-"),
                (i = n + e),
                (o = document.createElement("li")),
                o.setAttribute("aria-hidden", !0),
                (r = new Image()),
                (s = this.frameCount),
                (a = this.model.get("imageTimeout")),
                (l = this.dom.querySelectorAll(this.ul360, "." + i)),
                l && l.length >= 1 && (o = l[l.length - 1]),
                o.classList.add(n + e),
                o.clientHeight || o.classList.add("hidden"),
                this.url)
              ) {
                var m = {
                  requestID: t,
                  viewer: this,
                  urls: this.url,
                  baseClassName: n,
                  index: e,
                  li: o,
                  totalFrames: s,
                  imgTimeout: a,
                  onImageLoad: this.onImageLoad,
                  onError: this.onError,
                  prepareDefer: h,
                };
                u = this.renderer.useStrategy(
                  this.renderer.strategies.RTV_SINGLE_MERGED,
                  m
                );
              } else r.src = "";
              this.promises.push(h),
                e !== this.currentIndex ||
                  o.classList.contains("active") ||
                  this.handleActiveFrame(o, !0),
                this.ul360 && this.ul360.appendChild(o);
            } else
              this.framesHandler.isAltId(e) &&
                ((d = parseInt(
                  e.replace(this.framesHandler.prefixes.ALT, ""),
                  10
                )),
                (u = this.prepareAltContent(d)));
            return (
              u.then(function () {
                c.firstFrameEvt(e), h.resolve();
              }),
              h
            );
          }),
          (n.prototype.reloadAltContent = function (t, n) {
            var i,
              o = this.framesHandler.getAllFramesToBeLoaded(),
              r = o.ALTERNATE.LEN,
              s = this.framesHandler.is360Frame(this.currentIndex)
                ? this.currentIndex
                : this.prevIndex
                ? this.prevIndex
                : 1;
            for (
              s = isNaN(s) ? s : parseInt(s, 10),
                this.prevIndex = s,
                this.goToIndex(this.prevIndex),
                e.prototype.reloadAltContent.call(this, t, n),
                i = 0;
              i < r;
              i++
            )
              this.prepareAltContent(i, t, n);
          }),
          (n.prototype.preventRotation = function () {
            this.removeMouseCallbacks(), this.hideTooltip(!0);
          }),
          (n.prototype.onReady = function () {
            this.framesHandler.getAllFramesToBeLoaded();
            e.prototype.onReady.call(this),
              this.sendFirstFrameCompleteEvt(this),
              this.tryToShowTooltip();
          }),
          (n.prototype.createViewerList = function () {
            e.prototype.createViewerList.call(this),
              (this.util.browser.isIE() || this.util.browser.isEdge()) &&
                this.ul360.classList.add("is-ms");
          }),
          (n.prototype.onImageLoad = function () {
            var e,
              t = this.li,
              n = t.cloneNode(),
              i = this.img,
              o = this.layers,
              r = this.self,
              s = this.deferred,
              a = i.length,
              l = "Frame " + this.index + ' of "__productName__" ',
              d = -1,
              c = [],
              u = "cylindo-viewer-frame-";
            for (e = 0; e < r.pendingImages.length; e++)
              r.pendingImages[e].index === this.index && (d = e);
            if (
              (d !== -1 && r.pendingImages.splice(d, 1),
              this.requestID === r.model.getRequestID())
            ) {
              if (
                ((this.index === r.currentIndex ||
                  (!r.framesHandler.is360Frame(this.currentIndex) &&
                    this.index === r.startFrame)) &&
                  (r.firstImageLoadedTime = Date.now()),
                this.timeout &&
                  (clearTimeout(this.timeout), (this.timeout = null)),
                (l = l.replace("__productName__", r.model.get("fileName"))),
                i.length > 1)
              )
                for (e = 0; e < a; e++)
                  (i[e].alt =
                    l + "(" + o[e].type + " layer - " + o[e].code + ")"),
                    n.appendChild(i[e]);
              else
                i instanceof Image
                  ? ((i.alt = l), n.appendChild(i))
                  : ((i[0].alt = l), n.appendChild(i[0]));
              (c = r.dom.querySelectorAll(r.ul360, "." + u + this.index)),
                r.ul360.appendChild(n),
                r.dom.remove(t),
                r.tryToEnableImageGroup(),
                r.trigger(r.events.IMG_LOADED, {
                  sequence: this.index,
                  img: i,
                }),
                s.resolve();
            }
          }),
          (n.prototype.tryToEnableImageGroup = function () {
            var e = this,
              t = e.framesHandler.getAllFramesToBeLoaded(),
              n = this.dom.querySelectorAll(
                this.ul360,
                '[class*="cylindo-viewer-frame-"]:not([class*="-alt-"])'
              );
            n = n.filter(function (t) {
              var i = t.className.match(/cylindo-viewer-frame-(\d+)/gi)[0],
                o = e.dom.querySelectorAll(e.ul360, "." + i);
              return (
                0 !== t.childNodes.length &&
                n.indexOf(t) === n.indexOf(o[o.length - 1])
              );
            });
            var i = t.ALTERNATE.LIST,
              o = (n.length / this.frameCount) * 100,
              r = this.dom.querySelectorAll(
                this.ul360,
                ".cylindo-viewer-frame-" + this.currentIndex
              ),
              s = 1 === r.length ? r[0] : r[r.length - 1],
              a = !1,
              l = s
                ? s.dataset
                  ? s.dataset.index
                  : s.getAttribute("data-index")
                : null,
              d = this.model.get("partialRotationStart"),
              c = (100 * n.length) / this.frameCount;
            (i = i instanceof Array ? i : []),
              (l = this.framesHandler.is360Frame(l) ? parseInt(l, 10) : l),
              l === this.currentIndex &&
              s &&
              s.classList &&
              s.classList.contains("hidden")
                ? (a = !0)
                : o >= this.targetLoadedPercentage &&
                  ((this.targetLoadedPercentage *= 2), (a = !0)),
              a &&
                (n.forEach(function (e) {
                  e.classList.remove("hidden");
                }),
                !this.isVisible && n.length >= 1 && this.displayViewer(),
                !this.isReady &&
                  c >= d &&
                  (this.onReady(),
                  this.trigger(this.events.CONTENT_TYPE_COMPLETE, {
                    contentType: this.contentTypes.READY,
                  })),
                this.isComplete || 100 !== c || this.onDownloadComplete());
          }),
          (n.prototype.getNextAvailableFrame = function (e) {
            var t = this.getAvailableFrames(),
              n = this.framesHandler.getAllFramesToBeLoaded(),
              i = n.THREESIXTY.TO_BE_LOADED;
            this.model.getLogger();
            t = t.filter(function (e) {
              return !isNaN(e);
            });
            for (var o, r, s = t[0], a = t.length, l = t.indexOf(e); l === -1; )
              (e =
                this.deltaX > 0
                  ? (r = e - 1) < 1
                    ? i
                    : r
                  : (r = e + 1) > i
                  ? 1
                  : r),
                (l = t.indexOf(e));
            return (
              (l =
                this.deltaX > 0
                  ? (o = l + 1) === a
                    ? 0
                    : o
                  : (o = l - 1) < 0
                  ? a - 1
                  : o),
              (s = t[l])
            );
          }),
          (n.prototype.tryToShowTooltip = function () {
            var e = this.ul360.querySelector(".active"),
              t = e.getAttribute("data-index"),
              n = this.framesHandler.is360Frame(t),
              i = this.framesHandler.isAltId(t),
              o = e.classList.contains("cylindo-video"),
              r = e.classList.contains("cylindo-img-not-found"),
              s = this.model.get("tooltipDragText"),
              a = this.model.get("tooltipAltImgText"),
              l = !0;
            (r || o) && (l = !1),
              this.tooltip &&
                !this.tooltip.isVisible() &&
                l &&
                (n
                  ? "string" == typeof s && s.length > 0 && this.showTooltip(s)
                  : i &&
                    "string" == typeof a &&
                    a.length > 0 &&
                    this.showTooltip(a));
          }),
          (n.prototype.autoRotate = function (e, t) {
            var n,
              i,
              o,
              r,
              s = this.framesHandler.getAllFramesToBeLoaded(),
              a = [],
              l = s.THREESIXTY.TO_BE_LOADED,
              d = 360 / l,
              c = this.currentIndex,
              u = 0,
              h = !0,
              m = this,
              p = !0;
            if (
              !isNaN(c) &&
              m.isReady &&
              !m.isAutoRotating &&
              !(d / 2 > Math.abs(e))
            ) {
              for (
                this.stopAutoRotation = !1,
                  t = "undefined" != typeof t ? t : 0,
                  n = (c - 1) * d,
                  e < 0 && (p = !1),
                  r = n + e;
                h;

              )
                p
                  ? ((n += d), c === l ? (c = 1) : c++)
                  : ((n -= d), 1 === c ? (c = l) : c--),
                  a.push({ angle: n, index: c }),
                  (i = Math.abs(n - r)),
                  (o = p ? Math.abs(n + d - r) : Math.abs(n - d - r)),
                  i < d && i < o && (h = !1);
              (u = a.length > 0 ? t / a.length : 0),
                m.executeAutoRotation(a, u, p, l);
            }
          }),
          (n.prototype.goToAngle = function (e) {
            var n = this.framesHandler.getAllFramesToBeLoaded();
            if (e < 0 || e > 360)
              return void this.model
                .getLogger()
                .warning("Angle should be a value between 0 and 360");
            var i = n.THREESIXTY.TO_BE_LOADED,
              o = this.currentIndex,
              r = this;
            if (!isNaN(o) && r.isReady && !r.isAutoRotating) {
              this.stopAutoRotation = !1;
              var s = t.degreesToIndexes([e], i);
              s.length && this.goToIndex(s[0]);
            }
          }),
          (n.prototype.executeAutoRotation = function (e, t, n, i) {
            var o,
              r = 0,
              s = this;
            e.length &&
              (0 === t && (e = [e[e.length - 1]]),
              (o = setInterval(function () {
                function a() {
                  if (s.stopAutoRotation)
                    return (
                      (s.isAutoRotating = !1),
                      s.trigger(s.events.END, {
                        index: isNaN(s.currentIndex)
                          ? s.prevIndex
                          : s.currentIndex,
                      }),
                      void clearInterval(o)
                    );
                }
                var l, d, c, u, h;
                0 === r &&
                  t > 0 &&
                  ((s.isAutoRotating = !0),
                  s.trigger(s.events.START, { index: s.currentIndex })),
                  r < e.length
                    ? ((u = e[r].index),
                      (l = s.ul360.querySelector('[data-index="' + u + '"]')),
                      (d = s.ul360.querySelector(".active")),
                      (h = n
                        ? e[r].index === i
                          ? 1
                          : e[r].index + 1
                        : 1 === e[r].index
                        ? i
                        : e[r].index - 1),
                      (c = s.ul360.querySelector('[data-index="' + h + '"]')),
                      l &&
                      l.classList &&
                      l.classList.contains("cylindo-img-not-found")
                        ? r === e.length - 1 && a()
                        : !l ||
                          l.classList.contains("hidden") ||
                          l.classList.contains("active") ||
                          s.stopAutoRotation
                        ? l &&
                          !l.classList.contains("hidden") &&
                          l.classList.contains("active") &&
                          0 === t &&
                          !s.stopAutoRotation
                          ? s.trigger(s.events.CURRENT, {
                              current: s.currentIndex,
                            })
                          : !c ||
                            c.classList.contains("hidden") ||
                            c.classList.contains("active") ||
                            r !== e.length - 1 ||
                            s.stopAutoRotation
                          ? a()
                          : ((s.currentIndex = h),
                            s.handleActiveFrame(d, !1),
                            s.handleActiveFrame(
                              s.ul360.querySelector(
                                '[data-index="' + s.currentIndex + '"]'
                              ),
                              !0
                            ),
                            s.trigger(s.events.CURRENT, {
                              current: s.currentIndex,
                            }))
                        : (s.handleActiveFrame(d, !1),
                          (s.currentIndex = u),
                          s.handleActiveFrame(
                            s.ul360.querySelector(
                              '[data-index="' + s.currentIndex + '"]'
                            ),
                            !0
                          ),
                          s.trigger(s.events.CURRENT, {
                            current: s.currentIndex,
                          })),
                      r === e.length - 1 &&
                        t > 0 &&
                        ((s.isAutoRotating = !1),
                        s.trigger(s.events.END, {
                          index: isNaN(s.currentIndex)
                            ? s.prevIndex
                            : s.currentIndex,
                        })),
                      r++)
                    : clearInterval(o);
              }, t)));
          }),
          (n.prototype.resetMovementsTail = function () {
            clearTimeout(this.rafIndex), (this.rafIndex = null);
            try {
              this.tailPromise.resolve();
            } catch (e) {
              this.model.getLogger().log("Tail of movements did not exist");
            }
            (this.tailPromise = this.util.promise.create()),
              (this.isTailOfMovements = !1),
              (this.rotations = 0),
              (this.endFrame = this.currentIndex),
              (this.updateTimeOut = 1e3 / 60);
          }),
          (n.prototype.getRotationSpeed = function () {
            var e = this.model.get("rotationSpeed"),
              t = this.util.browser.isEdge() || this.util.browser.isIE();
            return t && this.isFullScreen() && (e /= 2), e;
          }),
          (n.prototype.isFullScreen = function () {
            var e = this.ul360.parentNode;
            return e && e.classList.contains("full-screen");
          });
        var i = {
          create: function (e) {
            return new n(e);
          },
        };
        window.cylindo.addModule("threesixty", i);
      }.call(this),
      function () {
        var e = cylindo.getModule("cylindo.classes.thumbScroll"),
          t = cylindo.getModule("cylindo.core.network"),
          n =
            (cylindo.getModule("cylindo.util.angles"),
            function o(n) {
              function i() {
                var e = "thumb-location-";
                I.get("presentation") !== M.STACKED.NAME &&
                  (I.get("thumbs") &&
                    C &&
                    C.parentNode &&
                    C.parentNode.classList.add(e + k),
                  (b.id = ++o.counter),
                  (b.initialized = !0),
                  I.on(I.events.FEATURES_CHANGED, g),
                  I.on(I.events.CHANGED, r),
                  G.on(G.events.RELOAD_THUMBNAILS, r),
                  b.trigger(b.events.CREATED));
              }
              function r(t, n) {
                function i() {
                  var t = R.THUMB.LEN,
                    n = C ? C.parentNode : null,
                    i = {
                      el: g,
                      wrapper: n,
                      thumbPageSize: I.get("thumbPageSize"),
                      dom: S,
                      model: I,
                    },
                    r =
                      (R.THUMB.THREESIXTY_THUMB_LEN,
                      R.ALTERNATE.LEN,
                      R.THUMB.LEN ? R.THUMB.LIST[0] : null),
                    s = G.is360Frame(r) ? I.get("startFrame") : r;
                  (z = []),
                    o === I.getRequestID() &&
                      C &&
                      (u(),
                      (C.innerHTML = ""),
                      C.appendChild(g),
                      C.parentNode.classList.add("has-thumbs"),
                      N &&
                        (b.featuresChanging &&
                          (i.offset = N.getCurrentOffset()),
                        N.off(N.events.THUMB_CLICKED, m),
                        N.destroy()),
                      t > i.thumbPageSize &&
                        ((N = new e(i)), N.on(N.events.THUMB_CLICKED, m)),
                      c(),
                      H && ((H = !1), y || E(s)),
                      (b.ready = !0),
                      b.trigger(b.events.READY),
                      b.trigger(b.events.CONTENT_TYPE_COMPLETE, {
                        contentType: P.FRAME_THUMB,
                      }),
                      (b.featuresChanging = !1));
                }
                var o,
                  r,
                  a,
                  l,
                  h,
                  p,
                  f,
                  g = document.createElement("ul"),
                  v = [],
                  y = C.querySelector(".active"),
                  A = I.get("thumbCount"),
                  T = C ? C.parentNode : null;
                if (
                  ((F = I.get("currentFeatures")),
                  (R = G.getAllFramesToBeLoaded()),
                  (h = R.ALTERNATE.LIST),
                  (p = R.THUMB.LIST),
                  (f = R.THUMB.LEN),
                  b.hiding)
                )
                  return void (b.delayedRender = !0);
                if (
                  !(
                    t &&
                    n &&
                    t === I.events.CHANGED &&
                    G &&
                    G.initialized &&
                    G.propsToValidateOrder.indexOf(n.prop) !== -1
                  ) &&
                  (F || (h && h.length))
                ) {
                  for (
                    F && F.paths && g.classList.add("cylindo-rtv"),
                      T &&
                        T.setAttribute(
                          "aria-label",
                          b.ariaLabel.texts.THUMBNAILS_BAR
                        ),
                      g.setAttribute("role", "list"),
                      g.setAttribute(
                        "aria-label",
                        b.ariaLabel.texts.THUMBNAIL_IMAGES
                      ),
                      g.classList.add("cylindo-thumbnail-list"),
                      b.requestID = I.getRequestID(),
                      o = b.requestID,
                      r = 0;
                    r < f;
                    r++
                  )
                    (a = p[r]),
                      G.isAltId(a)
                        ? ((l = parseInt(a.replace(/alt-/g, ""), 10)),
                          v.push(s(l, h[l], g, A)))
                        : G.is360Frame(a) && d(a, g, y);
                  Promise.all(v).then(
                    function () {
                      this.trigger(this.events.CONTENT_TYPE_COMPLETE, {
                        contentType: P.ALTERNATE_THUMB,
                      });
                    }.bind(b)
                  ),
                    Promise.all(z).then(i);
                }
              }
              function s(e, n, i, o) {
                function r() {
                  m.classList.remove("loading"),
                    m.appendChild(h),
                    u.resolve(),
                    b.trigger(b.events.IMG_LOADED);
                }
                function s() {
                  (f = I.get("fallbackImage")), (h.onerror = d), (h.src = f);
                }
                function d() {
                  (f = I.get("defaultFallbackImage")),
                    L.error("Fallback image not found " + f),
                    (h.onerror = null),
                    (h.src = f);
                }
                var c = C.querySelector(".active"),
                  u = O.promise.create(),
                  h = new Image(),
                  m = document.createElement("li"),
                  p = "",
                  f = "",
                  g = "",
                  v = { dataType: "jsonp", jsonp: "callback", timeout: 1e4 },
                  E =
                    "https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/";
                O.browser.isSafari() &&
                  parseFloat(O.browser.browser.version, 10) < 7 &&
                  (E = t.resolveProtocol(E)),
                  A(m),
                  0 !== o || 0 !== e || c || m.classList.add("active"),
                  m.classList.add("environment-thumb"),
                  "undefined" == typeof n.provider
                    ? (g = n.image)
                    : "direct" === n.provider
                    ? (g = n.sources[0].src)
                    : ("vimeo" !== n.provider && "youtube" !== n.provider) ||
                      (g = n.url),
                  n.provider
                    ? (m.classList.add("cylindo-video-thumb"),
                      h.classList.add("is-video-thumb"))
                    : m.classList.add("loading");
                try {
                  (m.dataset.index = G.prefixes.ALT + e),
                    (m.dataset.alternateIndex = e),
                    (m.dataset.url = g);
                } catch (y) {
                  m.setAttribute("data-index", G.prefixes.ALT + e),
                    m.setAttribute("data-alternate-index", e),
                    m.setAttribute("data-url", g);
                }
                return (
                  h.addEventListener
                    ? h.addEventListener("load", r)
                    : h.attachEvent && h.attachEvent("onload", r),
                  (h.onerror = s),
                  "undefined" == typeof n.provider || n.thumb
                    ? ((f = t.resolveProtocol(n.thumb || n.image)),
                      (h.src = f),
                      m.setAttribute("data-alt-image-url", n.image))
                    : "youtube" === n.provider && null !== n.videoId
                    ? ((p =
                        "//img.youtube.com/vi/" + n.videoId + "/default.jpg"),
                      (h.src = t.resolveProtocol(p)))
                    : "vimeo" === n.provider && null !== n.videoId
                    ? ((p = E + n.videoId),
                      t.doRequest(
                        p,
                        a.bind({ img: h }),
                        v,
                        l.bind({ img: h, model: I }),
                        null
                      ))
                    : ("not-supported" !== n.provider &&
                        "direct" !== n.provider) ||
                      ((h.onerror = null),
                      (h.src = I.get("fallbackVideoImage"))),
                  I.get("buildNumber") &&
                    (h.src += "&bn=" + I.get("buildNumber")),
                  T(h),
                  h.setAttribute("role", "link"),
                  (h.alt = n.description
                    ? n.description + " - thumb"
                    : "Alternative thumb: " + (+e + 1)),
                  i.appendChild(m),
                  u
                );
              }
              function a(e, t) {
                this.img.src = e.thumbnail_url;
              }
              function l(e, t) {
                this.img.src = this.model.get("fallbackVideoImage");
              }
              function d(e, n, i) {
                function o() {
                  var e = I.get("fallbackImage"),
                    t = new Image();
                  (this.img.onerror = l.bind(this)),
                    t.addEventListener
                      ? t.addEventListener("load", r.bind(this))
                      : t.attachEvent && t.attachEvent("onload", r.bind(this)),
                    (this.img.alt = "Fallback image"),
                    (this.img.src = e),
                    a(this.img),
                    s(),
                    e && (t.src = e);
                }
                function r() {
                  s(), this.deferred.resolve(), b.trigger(b.events.IMG_LOADED);
                }
                function s() {
                  d && (window.clearTimeout(d), (d = null));
                }
                function a(e) {
                  e.onerror = l.bind({ img: e });
                }
                function l() {
                  var e = I.get("defaultFallbackImage");
                  (this.img.src = e), (this.img.onerror = null);
                }
                var d,
                  c = O.promise.create(),
                  u = G.getAllFramesToBeLoaded(),
                  h = document.createElement("li"),
                  m = I.get("imageTimeout"),
                  p = null,
                  f = u.THREESIXTY.LEN,
                  g = 360 / f,
                  v = Math.round((e - 1) * g),
                  E = "rotated " + v + " degrees",
                  y = new Image(),
                  R = F && F.paths ? t.resolveProtocol(F.paths.thumbPath) : "",
                  L = { deferred: c, img: y };
                (R = R.replace("__FRAME_INDEX__", e)),
                  z.push(c),
                  i &&
                    ((p = i.dataset
                      ? i.dataset.index
                      : i.getAttribute("data-index")),
                    p === "" + e && h.classList.add("active"));
                try {
                  h.dataset.index = e;
                } catch (w) {
                  h.setAttribute("data-index", e);
                }
                A(h),
                  m > 0 && (d = setTimeout(o.bind(L), m)),
                  y.addEventListener
                    ? y.addEventListener("load", r.bind(L))
                    : y.attachEvent && y.attachEvent("onload", r.bind(L)),
                  (y.onerror = o.bind(L)),
                  (y.alt = I.get("fileName") + ",  " + E),
                  y.setAttribute("role", "link"),
                  (y.src = R),
                  T(y),
                  h.appendChild(y),
                  n.appendChild(h);
              }
              function c() {
                var e = S.querySelectorAll(C, "li");
                e &&
                  e.length > 0 &&
                  e.forEach(function (e) {
                    e.addEventListener("mousedown", h, !0);
                  });
              }
              function u() {
                var e = S.querySelectorAll(C, "li");
                e &&
                  e.length > 0 &&
                  e.forEach(function (e) {
                    e.removeEventListener("mousedown", h, !0);
                  });
              }
              function h(e) {
                var t = this.dataset.altImageUrl || "",
                  n = this.dataset
                    ? this.dataset.index
                    : this.getAttribute("data-index"),
                  i = this.dataset
                    ? this.dataset.alternateIndex
                    : this.getAttribute("data-alternate-index"),
                  o =
                    (this.dataset
                      ? this.dataset.url
                      : this.getAttribute("data-url"),
                    S.querySelectorAll(C, "li")),
                  r = (o.indexOf(this) + 1, null),
                  s = C.querySelector(".active"),
                  a = s
                    ? s.dataset
                      ? s.dataset.index
                      : s.getAttribute("data-index")
                    : null;
                i && (r = this.classList.contains("is-video-thumb") ? 2 : 1),
                  isNaN(n) || isNaN(a) || (_ = !0),
                  s &&
                    ((a = s.dataset
                      ? s.dataset.index
                      : s.getAttribute("data-index")),
                    s.classList.remove("active")),
                  this.classList.add("active"),
                  b.trigger(b.events.CLICK, {
                    index: n,
                    alternateIndex: i,
                    contentType: r,
                    image: t,
                  }),
                  w.send(w.events.THUMBNAIL_CLICK);
              }
              function m(e, t) {
                h.call(t.thumb);
              }
              function p() {
                var e = S.querySelectorAll(C, "li");
                N && N.destroy(),
                  e.forEach(function (e) {
                    e.removeEventListener("mousedown", h);
                  }),
                  C.parentElement.classList.remove("has-thumbs"),
                  S.remove(C),
                  (C = null),
                  D.destroy();
              }
              function f(e) {
                var t = C.parentNode;
                e ? S.fadeIn(t, 800) : S.fadeIn(t, 0), (b.isHidden = !1);
              }
              function g(e) {
                var t = C.parentNode;
                (b.hiding = !0),
                  e
                    ? (I.events.FEATURES_CHANGED === e &&
                        (b.featuresChanging = !0),
                      S.fadeOut(t, 600, function () {
                        (b.hiding = !1),
                          b.delayedRender &&
                            ((b.delayedRender = !1), b.render());
                      }))
                    : S.fadeOut(t, 0, function () {
                        b.hiding = !1;
                      }),
                  (b.isHidden = !0);
              }
              function v(e) {
                var t = G.getAllFramesToBeLoaded(),
                  n = S.querySelectorAll(
                    C,
                    'li[data-index]:not([data-index*="alt-"])'
                  ),
                  i = [],
                  o = 0,
                  r = t.THREESIXTY.LEN,
                  s = 0,
                  a = 0;
                for (a = 0; a < n.length; a++)
                  try {
                    i.push(Number(n[a].dataset.index));
                  } catch (l) {
                    i.push(Number(n[a].getAttribute("data-index")));
                  }
                try {
                  return (
                    (i = i.sort(function (e, t) {
                      return e - t;
                    })),
                    (o = i.reduce(function (t, n) {
                      return e > i[i.length - 1]
                        ? ((s = (r - i[i.length - 1]) / 2),
                          e > i[i.length - 1] + s ? i[0] : i[i.length - 1])
                        : Math.abs(n - e) < Math.abs(t - e)
                        ? n
                        : t;
                    }))
                  );
                } catch (l) {
                  L.warning(
                    "360 thumbnails are not ready or unavailable to activate the closest angle to the frame displayed."
                  );
                }
              }
              function E(e) {
                var t,
                  n = C.querySelector(".active"),
                  i = n;
                if (_) {
                  try {
                    t = n.dataset.index;
                  } catch (o) {
                    t = n.getAttribute("data-index");
                  }
                  return void (parseInt(e, 10) === parseInt(t, 10) && (_ = !1));
                }
                (n = isNaN(e)
                  ? C.querySelector('li[data-index="' + e + '"]')
                  : C.querySelector('li[data-index="' + v(e) + '"]')),
                  n &&
                    (i && i.classList && i.classList.remove("active"),
                    n.classList.add("active"));
              }
              function y() {
                var e = b.el ? b.el.getBoundingClientRect() : { height: 0 };
                return e.height || 128;
              }
              function A(e) {
                k === U.BOTTOM || k === U.TOP
                  ? (e.style.width = B)
                  : (k !== U.LEFT && k !== U.RIGHT) || (e.style.height = B);
              }
              function T(e) {
                try {
                  (e.draggable = !1),
                    (e.ondragstart = function () {
                      return !1;
                    });
                } catch (t) {}
              }
              var R,
                b = this,
                I = n.model,
                L = I.getLogger(),
                w = n.tags,
                C = n.el,
                _ = (n.url, !1),
                N = null,
                D = cylindo.getModule("cylindo.util.pubsub").create(),
                O = cylindo.getModule("cylindo.core.util"),
                S = n.dom,
                M = cylindo.getModule("cylindo.helpers.viewer.presentations"),
                x = cylindo.getModule("cylindo.helpers.content.to.load"),
                F = null,
                P = x.getContentTypes(),
                k = I.get("thumbLocation"),
                U = I.getThumbLocations(),
                B = 100 / I.get("thumbPageSize") + "%",
                G = n.framesHandler,
                H = !0,
                z = [];
              (this.id = null),
                (this.initialized = !1),
                (this.ready = !1),
                (this.isHidden = !0),
                (this.hiding = !1),
                (this.delayedRender = !1),
                (this.featuresChanging = !1),
                (this.show = f),
                (this.hide = g),
                (this.on = D.on),
                (this.off = D.off),
                (this.trigger = D.trigger),
                (this.destroy = p),
                (this.setActive = E),
                (this.render = r),
                (this.thumbsHeight = y),
                (this.framesHandler = G),
                (this.ariaLabel = n.ariaLabel),
                (this.el = C),
                (this.requestID = 0),
                i();
            });
        (n.prototype.events = {
          CREATED: "ui:thumb:created",
          DATAREADY: "ui:thumb:dataready",
          READY: "ui:thumb:ready",
          SCROLL: "ui:thumb:scroll",
          SCROLL_UP: "ui:thumb:scroll:up",
          SCROLL_DOWN: "ui:thumb:scroll:down",
          CLICK: "ui:thumb:click",
          IMG_LOADED: "ui:thumb:loaded",
          CONTENT_TYPE_COMPLETE: "ui:thumb:content:type:complete",
        }),
          (n.counter = 0);
        var i = {
          create: function (e) {
            return new n(e);
          },
        };
        window.cylindo.addModule("thumbnails", i);
      }.call(this),
      function () {
        function e(e) {
          e &&
            "object" === ("undefined" == typeof e ? "undefined" : _typeof(e)) &&
            (e.role = "tooltip"),
            t.call(this, e),
            (this.wrapperClasses = ["cylindo-tooltip", "cylindo-no-feature"]),
            (this.templatePattern = ["<span>!</span>", "<p><% text %></p>"]),
            this.setTemplate(this.templatePattern.join(""));
        }
        var t = cylindo.getModule("cylindo.classes.layer");
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e);
        var n = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("tooltip.no-feaure", n);
      }.call(this),
      function () {
        function e(e) {
          t.call(this, e),
            (this.wrapperClasses = [
              "cylindo-tooltip",
              "cylindo-tooltip-not-available",
            ]),
            (this.templatePattern = ["<span>!</span>", "<p><% text %></p>"]),
            this.setTemplate(this.templatePattern.join(""));
        }
        var t = cylindo.getModule("cylindo.classes.layer");
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e);
        var n = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("tooltip.not.available", n);
      }.call(this),
      function () {
        function e(e) {
          e &&
            "object" === ("undefined" == typeof e ? "undefined" : _typeof(e)) &&
            (e.role = "tooltip"),
            t.call(this, e),
            (this.wrapperClasses = [
              "cylindo-tooltip",
              "cylindo-drag-tooltip",
              "cylindo-drag-to-rotate-tooltip",
            ]),
            (this.templatePattern = [
              '<span class="left" aria-hidden="true"></span><% text %><span class="right" aria-hidden="true"></span>',
            ]),
            this.setTemplate(this.templatePattern.join(""));
        }
        var t = cylindo.getModule("cylindo.classes.layer");
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e);
        var n = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("tooltip.viewer", n);
      }.call(this),
      function () {
        function e(e) {
          e &&
            "object" === ("undefined" == typeof e ? "undefined" : _typeof(e)) &&
            (e.role = "tooltip"),
            t.call(this, e),
            (this.wrapperClasses = ["cylindo-tooltip", "cylindo-drag-tooltip"]),
            (this.templatePattern = [
              '<span class="left" aria-hidden="true"></span><% text %><span class="right" aria-hidden="true"></span>',
            ]),
            this.setTemplate(this.templatePattern.join(""));
        }
        var t = cylindo.getModule("cylindo.classes.layer");
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e);
        var n = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("tooltip.zoom", n);
      }.call(this),
      function () {
        function e(e) {
          function t(e) {
            (e = e || l.btn),
              e &&
                (n(e),
                e.addEventListener("mousedown", i, !0),
                e.addEventListener("touchstart", o, !0),
                e.addEventListener("touchend", r, !0));
          }
          function n(e) {
            (e = e || l.btn),
              e &&
                (e.removeEventListener("mousedown", i, !0),
                e.removeEventListener("touchstart", o, !0),
                e.removeEventListener("touchend", r, !0));
          }
          function i(e) {
            s(e), l.trigger(l.events.CLICK, e);
          }
          function o(e) {
            s(e), l.trigger(l.events.TOUCHSTART, e);
          }
          function r(e) {
            s(e), l.trigger(l.events.TOUCHEND, e);
          }
          function s(e) {
            e &&
              (e.preventDefault(),
              e.stopPropagation(),
              e.stopImmediatePropagation());
          }
          function a() {
            d.destroy(), (l.btn = null), l.trigger(l.events.DESTROYED);
          }
          var l = this,
            d = cylindo.getModule("cylindo.util.pubsub").create();
          (this.isMobile = e.isMobile),
            (this.model = e.model),
            (this.btn = e.btn),
            (this.viewerContainer = e.viewerContainer),
            (this.available = !0),
            (this.on = d.on),
            (this.off = d.off),
            (this.trigger = d.trigger),
            (this.addEventsToBtn = t),
            (this.removeEventsToBtn = n),
            (this.ariaLabel = e.ariaLabel),
            (this.destroy = a),
            l.shouldHideButton(),
            (l.initialized = !0);
        }
        (e.prototype.constructor = e),
          (e.prototype.isAvailable = function () {
            return this.available;
          }),
          (e.prototype.shouldHideButton = function () {
            ((this.model && this.model.get("zoomButton") !== !0) ||
              !this.isMobile ||
              (!this.model.get("cylindoContent") &&
                !this.model.get("alternateContentZoom"))) &&
              ((this.available = !1),
              this.btn.classList.add("permanently-hidden"));
          }),
          (e.prototype.setBtn = function (e) {
            this.btn = e;
          }),
          (e.prototype.addBlinkClass = function () {
            this.btn.classList.add("blink");
          }),
          (e.prototype.removeBlinkClass = function () {
            setTimeout(
              function () {
                this.btn &&
                  this.btn.classList &&
                  this.btn.classList.contains("blink") &&
                  this.btn.classList.remove("blink");
              }.bind(this),
              3200
            );
          }),
          (e.prototype.setZoomInIcon = function () {
            this.btn.setAttribute(
              "aria-label",
              this.ariaLabel.texts.ENTER_ZOOM
            ),
              this.btn.classList.remove("cylindo-icon-zoom-on"),
              this.btn.classList.remove("cylindo-icon-zoom-out"),
              this.btn.classList.add("cylindo-icon-zoom-off");
          }),
          (e.prototype.setZoomOutIcon = function (e) {
            this.btn.setAttribute("aria-label", this.ariaLabel.texts.EXIT_ZOOM),
              this.btn.classList.remove("cylindo-icon-zoom-off"),
              this.btn.classList.add("cylindo-icon-zoom-on"),
              e && this.btn.classList.add("cylindo-icon-zoom-out");
          }),
          (e.prototype.show = function () {
            this.btn.style.display = "block";
          }),
          (e.prototype.hide = function () {
            this.btn.style.display = "none";
          }),
          (e.prototype.events = {
            CLICK: "zoom:click",
            TOUCHSTART: "zoom:touchstart",
            TOUCHEND: "zoom:touchend",
            DESTROYED: "zoom:destroyed",
          });
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("cylindo.zoom.btn", t);
      }.call(this),
      function () {
        var e = function n(e) {
          function t() {
            Ge &&
              ((Ge.id = ++n.counter),
              r(),
              i(),
              Qe.attachEvent
                ? Qe.attachEvent("onresize", o)
                : Qe.addEventListener
                ? Qe.addEventListener("resize", o)
                : Ze.warning(
                    "The browser does not support Javascript event binding"
                  ),
              (Ge.initialized = !0));
          }
          function i() {
            (ct = l(Math.ceil(ln.height / wt), Math.ceil(ln.width / wt))),
              (pt = A(0, 0, ct[0].length - 1, ct.length - 1));
          }
          function o() {
            function e(e) {
              return He.browser.isSafari()
                ? He.object.getRectFixed(e)
                : e.getBoundingClientRect();
            }
            var t = Qe.style.display,
              n = [];
            Qe.isEqualNode($e) ||
              ((tt = e($e)),
              (nt = e(Qe)),
              0 === nt.width &&
                0 === nt.height &&
                ((Qe.style.display = "block"),
                (nt = e(Qe)),
                (Qe.style.display = t)),
              nt.left <= tt.left && nt.right > tt.left && n.push(!0),
              nt.right >= tt.right && nt.left < tt.right && n.push(!0),
              nt.top <= tt.top && nt.bottom > tt.top && n.push(!0),
              nt.bottom >= tt.bottom && nt.top < tt.bottom && n.push(!0),
              n.length > 2 && (it = !0));
          }
          function r() {
            var e = null !== Qe.querySelector("." + Tt),
              t = document.createElement("div"),
              n = document.createElement("div"),
              i = document.createElement("div");
            e ||
              (t.classList.add(Tt),
              t.setAttribute("role", "img"),
              (t.style.display = "none"),
              n.classList.add(Rt),
              i.classList.add(bt),
              t.appendChild(n),
              t.appendChild(i),
              Qe.appendChild(t),
              He.browser.isMobile() && it && Qe.appendChild(Wt)),
              He.browser.isMobile() &&
                it &&
                (jt.addEventListener("touchend", J),
                Kt.addEventListener("touchend", $)),
              (an = Qe.querySelector("." + Tt)),
              (dn = Qe.querySelector("." + Rt)),
              (cn = Qe.querySelector("." + bt)),
              an.setAttribute("role", "group"),
              an.setAttribute("aria-label", yn.texts.ZOOM_CONTAINER),
              cn.setAttribute("role", "img"),
              cn.setAttribute("aria-label", yn.texts.ZOOM_IMAGE),
              he(Pe, Pe),
              o();
          }
          function s() {
            return et && it && !Ht ? Qe : $e;
          }
          function a(e, t, n) {
            var i,
              o,
              r,
              s,
              a,
              l,
              d = He.browser.isMobile()
                ? "Drag to Pan"
                : "Move the Mouse to Pan",
              c =
                e && e.frame
                  ? e.frame
                  : lt
                  ? lt.querySelector(".active")
                  : null,
              u = !1,
              h = e && e.frame ? e.frame : null,
              m = !(!e || !e.reloadZoomContainer) && e.reloadZoomContainer,
              p =
                ("string" == typeof Xe.get("format") &&
                  "PNG" === Xe.get("format").toUpperCase()) ||
                !1;
            if (c) {
              e &&
                e.useFractions &&
                ((e.startX = e.currentX = Re(e.startXFraction, !0)),
                (e.startY = e.currentY = Re(e.startYFraction, !1))),
                (kt = e),
                (Ut = n),
                (xe = Xe.get("zoomBackgroundColor")),
                (h || (at && st && !t) || m) && le(h, m);
              try {
                (Ht = t),
                  re(Ht),
                  se(Ht, it, !0),
                  (gt = c.cloneNode(!0)),
                  (dt = c),
                  (an.style.willChange = "transform"),
                  "string" == typeof xe && xe.length
                    ? (an.style.backgroundColor = "#" + xe)
                    : (an.style.backgroundColor = ""),
                  He.browser.isIE() ||
                    He.browser.isEdge() ||
                    He.browser.isMobile() ||
                    (He.browser.isSafari() && Ht
                      ? Ze.log(
                          "CSS transform prevented for zoom on this browser version."
                        )
                      : (an.style.transition = "transform 25ms linear")),
                  (l =
                    Qe && Qe.getAttribute("zoom-id")
                      ? parseInt(Qe.getAttribute("zoom-id"), 10)
                      : null),
                  l === Ge.id && vt && vt.isEqualNode(gt) && xe === Fe
                    ? (Gt = !0)
                    : ((Gt = !1), (vt = gt));
                try {
                  Qe.setAttribute("zoom-id", Ge.id);
                } catch (f) {}
                for (Fe = xe, s = dt.childNodes.length, r = 0; r < s; r++)
                  (dt.childNodes[r].classList &&
                    dt.childNodes[r].classList.contains(
                      "cylindo-dismiss-on-zoom"
                    )) ||
                    ((i = dt.childNodes[r]),
                    (ut = i.getBoundingClientRect()),
                    (o =
                      i.src ||
                      (i.dataset
                        ? i.dataset.src
                        : i.getAttribute("data-src"))));
                (Bt =
                  !dt.parentNode.classList.contains("cylindo-custom-list") &&
                  !!dt.className.match(/cylindo-viewer-frame-(\d+)/gi)),
                  (ke = Xe.get("maxZoom")),
                  Oe(),
                  "4k" === ke
                    ? (Pe = zt = Pt[ke].value)
                    : "mixed" === ke && Bt
                    ? (Se(),
                      (Pe = Pt["4k"].value),
                      0 === zt
                        ? ((ke = "2k"), (zt = Pt[ke].value))
                        : ((ke = "4k"), (zt = Pt[ke].value)))
                    : (Pe = zt = Pt[ke] ? Pt[ke].value : Pt["2k"].value),
                  Vt !== zt && ((Vt = zt), (Gt = !1)),
                  Gt || bn++,
                  (In = bn),
                  Bt && !xe && p
                    ? (Tn = !0)
                    : ((Tn = !1), dn && (dn.style.display = "")),
                  Tn && !Gt && dn && (dn.style.display = ""),
                  (Qt =
                    dt.dataset && dt.dataset.index
                      ? dt.dataset.index
                      : dt.getAttribute("data-index")),
                  (Jt = dt);
                try {
                  u = dt.dataset.isAlternateImage
                    ? +dt.dataset.isAlternateImage
                    : 0;
                } catch (f) {
                  u = dt.getAttribute("data-is-alternate-image")
                    ? +dt.getAttribute("data-is-alternate-image")
                    : 0;
                }
                ut.height > ut.width
                  ? he((0.5 + zt * (ut.width / ut.height)) << 0, zt)
                  : ut.width > ut.height
                  ? he(zt, (0.5 + zt * (ut.height / ut.width)) << 0)
                  : he(zt, zt),
                  et && "none" === Ce(Qe) && ze.fadeIn(Qe),
                  (tt = $e.getBoundingClientRect()),
                  We.send(We.events.ZOOM),
                  oe(e, i, ut, In),
                  Ge &&
                    Ge.tooltip &&
                    ((a =
                      et && !ae()
                        ? Je.querySelector(".cylindo-viewer-container")
                        : an.parentNode),
                    Ge.tooltip.remove(),
                    Ge.tooltip.setParent(a),
                    Ge.tooltip.render(),
                    An &&
                      !Xe.get("tooltipZoomTextFixed") &&
                      Xe.set("tooltipZoomText", d, !0),
                    Ge.tooltip.show(Xe.get("tooltipZoomText"))),
                  Ge.trigger(Ge.events.ENABLED, {
                    mousePosition: e,
                    clickType: n,
                    index: Qt,
                    li: Jt,
                    x: be(),
                    y: Ie(),
                  }),
                  Ze.event("Zoom started at point: " + JSON.stringify(e));
              } catch (f) {
                te(), ce(), Ze.error(f);
              }
            }
          }
          function l(e) {
            var t = new Array(e || 0),
              n = e;
            if (arguments.length > 1)
              for (var i = Array.prototype.slice.call(arguments, 1); n--; )
                t[e - 1 - n] = l.apply(Ge, i);
            return t;
          }
          function d(e, t) {
            function n(e) {
              var n,
                i,
                o = He.promise.create(),
                r = [],
                s = null;
              for (n = e.minX; n <= e.maxX; n++)
                for (i = e.minY; i <= e.maxY; i++)
                  (s = A(n, i, n, i)), r.push(u(s, t, l));
              return (
                Promise.all(r).then(function () {
                  o.resolve();
                }),
                o
              );
            }
            var i,
              o,
              r = He.promise.create(),
              s = [],
              a = null,
              l = !1;
            if (e)
              for (e.compress(pt), i = e.minX; i <= e.maxX; i++) {
                for (o = e.minY; o <= e.maxY; o++)
                  ct[o][i]
                    ? a && (s.push(n(a)), (a = null))
                    : a
                    ? a.include(i, o)
                    : (a = A(i, o, i, o));
                a && (s.push(n(a)), (a = null));
              }
            return (
              Promise.all(s).then(function () {
                r.resolve();
              }),
              r
            );
          }
          function c(e, t) {
            function n(e) {
              var n,
                i,
                o = He.promise.create(),
                r = [],
                s = null;
              for (i = e.minY; i <= e.maxY; i++)
                for (n = e.minX; n <= e.maxX; n++)
                  (s = A(n, i, n, i)), r.push(u(s, t, l));
              return (
                Promise.all(r).then(function () {
                  o.resolve();
                }),
                o
              );
            }
            var i,
              o,
              r = He.promise.create(),
              s = [],
              a = null,
              l = !1;
            if (e)
              for (e.compress(pt), o = e.minY; o <= e.maxY; o++) {
                for (i = e.minX; i <= e.maxX; i++)
                  ct[o][i]
                    ? a && (s.push(n(a)), (a = null))
                    : a
                    ? a.include(i, o)
                    : (a = A(i, o, i, o));
                a && (s.push(n(a)), (a = null));
              }
            return (
              Promise.all(s).then(function () {
                r.resolve();
              }),
              r
            );
          }
          function u(e, t, n) {
            return e ? h(e, _t++, t, n) : null;
          }
          function h(e, t, n, i) {
            function o(e) {
              var t, n;
              try {
                t = URL.createObjectURL(e);
              } catch (i) {
                (n = new Blob([e])), (t = webkitURL.createObjectURL(n));
              }
              (a.style.position = "absolute"),
                (a.style.left = a.screenRect.x + "px"),
                (a.style.top = a.screenRect.y + "px"),
                (a.src = t),
                St.urls.push(t),
                p(a);
            }
            function r() {
              for (
                a.deferred && a.deferred.reject(), a = null, l = e.minX;
                l < e.maxX;
                l++
              )
                for (d = e.minY; d < e.maxY; d++) ct[d][l] = null;
            }
            var s,
              a,
              l,
              d,
              c = qe.resolveProtocol(
                dt.dataset
                  ? dt.dataset.zoomImage
                  : dt.getAttribute("data-zoom-image")
              ),
              u = y(e),
              h = "",
              m = He.promise.create();
            if (t && Qe && u) {
              (e = E(u)),
                u.x + u.w > ln.width && (u.w = ln.width - u.x),
                u.y + u.h > ln.height && (u.h = ln.height - u.y),
                (a = new Image()),
                (a.id = "zoom-img-" + t),
                a.setAttribute("aria-hidden", "true"),
                a.setAttribute("alt", null),
                a.setAttribute("role", "img"),
                a.classList.add("zoom-img"),
                i && ((Ln[n] = Ln[n] || []), Ln[n].push(a));
              try {
                (a.dataset.zoomTileXMin = e.minX),
                  (a.dataset.zoomTileYMin = e.minY),
                  (a.dataset.zoomTileXMax = e.maxX),
                  (a.dataset.zoomTileYMax = e.maxY);
              } catch (f) {
                a.setAttribute("data-zoom-tile-x-min", e.minX),
                  a.setAttribute("data-zoom-tile-y-min", e.minY),
                  a.setAttribute("data-zoom-tile-x-max", e.maxX),
                  a.setAttribute("data-zoom-tile-y-max", e.maxY);
              }
              for (
                a.requestTime = Date.now(),
                  a.blockCount = (e.maxX - e.minX) * (e.maxY - e.minY),
                  a.blockSize = e.maxX - e.minX + " x " + (e.maxY - e.minY),
                  a.imgName =
                    "img " +
                    t +
                    " (" +
                    (e.maxX - e.minX) +
                    " x " +
                    (e.maxY - e.minY) +
                    ")",
                  a.gridRect = e,
                  a.screenRect = u,
                  a.isFinishedDownloading = !1,
                  a.processFinished = !1,
                  a.deferred = m,
                  a.wasDrawn = !1,
                  a.refRequestId = n,
                  Mt.push(a),
                  l = e.minX;
                l < e.maxX;
                l++
              )
                for (d = e.minY; d < e.maxY; d++)
                  try {
                    ct[d][l] = a;
                  } catch (f) {
                    Ze.error(
                      "Cannot set image for the provided coordinates y = " +
                        d +
                        " x = " +
                        l,
                      f
                    );
                    continue;
                  }
              Bt &&
                ((s = c.replace(
                  "__COORDS__",
                  u.x + "," + u.y + "," + u.w + "," + u.h
                )),
                (s = qe.addQueryString(s, { zoom: ke })),
                (s =
                  "string" == typeof xe && xe.length
                    ? qe.addQueryString(s, { background: xe })
                    : s),
                Ze.event(
                  "Downloading rect: (x: " +
                    u.x +
                    ", y: " +
                    u.y +
                    ", w: " +
                    u.w +
                    ", h: " +
                    u.h +
                    ")"
                ),
                window.XDomainRequest
                  ? ((a.crossOrigin = "Anonymous"),
                    (a.onload = function () {
                      p(a);
                    }),
                    (a.onerror = r),
                    (a.src = s))
                  : qe.requestImage(s, o, r)),
                je || (je = []),
                (h = [u.x, u.y, u.w, u.h].join(",")),
                je.push(h);
            }
            return m;
          }
          function m(e, t, n, i) {
            var o = qe.resolveProtocol(
                dt.dataset
                  ? dt.dataset.zoomImage
                  : dt.getAttribute("data-zoom-image")
              ),
              r = new Image();
            dt.childNodes[0];
            Bt ||
              (ue(dn),
              ue(cn),
              r.addEventListener("load", function () {
                he(r.naturalWidth, r.naturalHeight),
                  ne(e, t, n),
                  I(r, 0, 0, ln.width, ln.height),
                  (ft = r),
                  i.resolve();
              }),
              (r.onerror = function () {
                Ze.error("Zoom image not found"), i.resolve(), te();
              }),
              (r.src = o));
          }
          function p(e) {
            var t;
            e &&
              ("undefined" != typeof e.requestTime &&
                ((t = Date.now() - e.requestTime),
                St.totalImages++,
                (St.totalTime += t)),
              "undefined" != typeof e.isFinishedDownloading &&
                (e.isFinishedDownloading = !0),
              (e.drawIteration = Nt),
              window.XDomainRequest
                ? O()
                : (e.addEventListener("load", O, { once: !0 }),
                  e.deferred &&
                    e.deferred.then(function () {
                      function t() {
                        Rn.indexOf(m) !== -1 &&
                          r() &&
                          (s(I.ALL_IMAGES_DOWNLOADED, m),
                          dn && Tn && (dn.style.display = "none"));
                      }
                      function n() {
                        for (u = g; u <= y; u++)
                          for (h = f; h <= E; h++)
                            if (!ct[h][u] || !ct[h][u].processFinished)
                              return !1;
                        return !0;
                      }
                      function i(e, t) {
                        function n() {
                          var n = He.promise.create();
                          return r()
                            ? e
                              ? d(t, m)
                              : c(t, m)
                            : (n.reject(), n);
                        }
                        return (T =
                          null === T
                            ? n()
                            : T.then(function () {
                                var e = n();
                                return e;
                              }));
                      }
                      function o() {
                        for (u = g; u <= y; u++)
                          for (h = f; h <= E; h++)
                            ct[h][u] ||
                              (s(I.DOWNLOADING_MISSING_GRID, { x: u, y: h }),
                              (l = A(u, h, u, h)),
                              r() && i(!0, l, m));
                      }
                      function r() {
                        return m === bn;
                      }
                      function s(e, t) {
                        Ze.log(e, t);
                      }
                      var a,
                        l = null,
                        u = 0,
                        h = 0,
                        m = e.refRequestId,
                        p = v(),
                        f = 0,
                        g = 0,
                        E = Math.ceil(ln.height / wt) - 1,
                        y = Math.ceil(ln.width / wt - 1),
                        T = null,
                        R = function () {
                          return "object" ===
                            ("undefined" == typeof p ? "undefined" : _typeof(p))
                            ? He.object.extend({}, p)
                            : {};
                        },
                        b = null,
                        I = {
                          DOWNLOADING_ALL_IMGS:
                            "Trying to download the rest of images for zoom request",
                          ALL_IMAGES_DOWNLOADED:
                            "All zoom images have been downloaded for this request: ",
                          DOWNLOADING_MISSING_GRID:
                            "Downloading missing grid image.",
                          ERROR: "Cannot continue downloading grids.",
                          NO_REMAINING_IMAGES:
                            "There are no remaining images to be dowloaded, finishing zoom process",
                        };
                      if (r()) {
                        if (Ln[m].length > 0) return;
                        if (
                          (cn &&
                            cn.classList.contains(wn) &&
                            cn.classList.remove(wn),
                          Rn.indexOf(m) === -1)
                        ) {
                          if ((Rn.push(m), s(I.DOWNLOADING_ALL_IMGS, m), Tn)) {
                            p.compress(pt);
                            do
                              (a = !1),
                                r() &&
                                  ((l = R()),
                                  l.minX > 0 &&
                                    ((l.maxX = l.minX),
                                    (l.minX = l.minX - 1),
                                    (b = i(!0, l)),
                                    (a = !0)),
                                  (l = R()),
                                  l.maxX < y &&
                                    ((l.minX = l.maxX),
                                    (l.maxX = l.maxX + 1),
                                    (b = i(!0, l)),
                                    (a = !0)),
                                  (l = R()),
                                  l.minY > 0 &&
                                    ((l.maxY = l.minY),
                                    (l.minY = l.minY - 1),
                                    (b = i(!1, l)),
                                    (a = !0)),
                                  (l = R()),
                                  l.maxY < E &&
                                    ((l.minY = l.maxY),
                                    (l.maxY = l.maxY + 1),
                                    (b = i(!1, l)),
                                    (a = !0)),
                                  a
                                    ? ((p.minX =
                                        p.minX - 1 < 0 ? p.minX : p.minX - 1),
                                      (p.maxX =
                                        p.maxX + 1 > y ? p.maxX : p.maxX + 1),
                                      (p.minY =
                                        p.minY - 1 < 0 ? p.minY : p.minY - 1),
                                      (p.maxY =
                                        p.maxY + 1 > E ? p.maxY : p.maxY + 1))
                                    : b
                                    ? b
                                        .then(o)
                                        ["catch"](s.bind(null, I.ERROR, m))
                                    : n() &&
                                      (s(I.NO_REMAINING_IMAGES, m), t()));
                            while (a);
                          }
                        } else n() && t();
                      }
                    })));
          }
          function f(e) {
            var t,
              n,
              i,
              o,
              r,
              s,
              a = v();
            a.compress(pt),
              (t = Dt.minX - a.minX),
              (n = Dt.maxX - a.maxX),
              t > 0 &&
                ((r = A(Dt.minX - t, Dt.minY, Dt.minX, Dt.maxY)),
                d(r, e),
                d(a, e)),
              n < 0 &&
                ((r = A(Dt.maxX - n, Dt.minY, Dt.maxX + 1, Dt.maxY)),
                d(r, e),
                d(a, e)),
              (i = Dt.minY - a.minY),
              (o = Dt.maxY - a.maxY),
              i > 0 &&
                ((s = A(a.minX, a.minY - i, a.maxX, a.minY)), c(s, e), c(a, e)),
              o < 0 &&
                ((s = A(a.minX, Dt.maxY + 1, a.maxX, a.maxY)),
                c(s, e),
                c(a, e)),
              (Dt = a);
          }
          function g() {
            var e,
              t,
              n,
              i,
              o = 2 * Ct;
            return (
              (e = Ot.x - Ct < 0 ? 0 : Ot.x - Ct),
              (t = Ot.y - Ct < 0 ? 0 : Ot.y - Ct),
              (n = (it && !Ht ? nt.width : tt.width) + o),
              (i = (it && !Ht ? nt.height : tt.height) + o),
              T(e, t, n, i)
            );
          }
          function v() {
            var e = null,
              t = g();
            return t && (e = E(t)), e;
          }
          function E(e) {
            var t = Math.floor(e.x / wt),
              n = Math.floor(e.y / wt),
              i = Math.floor((e.w + (e.x % wt)) / wt) + t,
              o = Math.floor((e.h + (e.y % wt)) / wt) + n;
            return A(t, n, i, o);
          }
          function y(e) {
            var t = e.minX * wt,
              n = e.minY * wt,
              i = e.maxX * wt + wt - t,
              o = e.maxY * wt + wt - n;
            return T(t, n, i, o);
          }
          function A(e, t, n, i) {
            var o = {};
            return (
              (o.minX = e),
              (o.minY = t),
              (o.maxX = n),
              (o.maxY = i),
              (o.print = function (e) {
                Ze.log(
                  e +
                    "min(" +
                    o.minX +
                    ", " +
                    o.minY +
                    "), max(" +
                    o.maxX +
                    ", " +
                    o.maxY +
                    ")"
                );
              }),
              (o.include = function (e, t) {
                e < o.minX ? (o.minX = e) : e > o.maxX && (o.maxX = e),
                  t < o.minY ? (o.minY = t) : t > o.maxY && (o.maxY = t);
              }),
              (o.compress = function (e) {
                (o.minX = Math.max(o.minX, 0)),
                  (o.minY = Math.max(o.minY, 0)),
                  (o.maxX = Math.min(o.maxX, e.maxX)),
                  (o.maxY = Math.min(o.maxY, e.maxY));
              }),
              o
            );
          }
          function T(e, t, n, i) {
            var o = {};
            return (
              (o.x = e),
              (o.y = t),
              (o.w = n),
              (o.h = i),
              (o.print = function (e) {
                Ze.log(
                  e + "(" + o.x + ", " + o.y + ", " + o.w + ", " + o.h + ")"
                );
              }),
              o
            );
          }
          function R(e, t) {
            var n = {};
            return (
              (n.x = e),
              (n.y = t),
              (n.print = function (e) {
                Ze.log(e + "(" + n.x + ", " + n.y + ")");
              }),
              n
            );
          }
          function b(e, t) {
            return (
              !(!e || !t) &&
              e.minX === t.minX &&
              e.minY === t.minY &&
              e.maxX === t.maxX &&
              e.maxY === t.maxY
            );
          }
          function I(e, t, n, i, o) {
            if (cn && e) {
              if (e.wasDrawn) return;
              (e.wasDrawn = !0),
                (e.style.position = "absolute"),
                (e.style.left = t + "px"),
                (e.style.top = n + "px"),
                (e.style.width = i),
                (e.style.height = o),
                cn.appendChild(e),
                (e.processFinished = !0),
                "undefined" != typeof e.refRequestId &&
                  Ln[e.refRequestId] &&
                  Ln[e.refRequestId].indexOf(e) !== -1 &&
                  Ln[e.refRequestId].splice(Ln[e.refRequestId].indexOf(e), 1),
                e.deferred && e.deferred.resolve();
            }
          }
          function L() {
            Bt ? D().then(O.bind(Ge)) : O();
          }
          function w() {
            un && (un.innerHTML = ""),
              Bt && $t === !0 && (C(wt), en === !0 && _());
          }
          function C(e) {
            var t, n, i;
            if (((un = un || document.createElement("div")), ct && an && un)) {
              for (n = 0; n < ct[0].length; n++)
                for (i = 0; i < ct.length; i++) {
                  (t = document.createElement("div")),
                    t.classList.add(It + i + "-" + n),
                    (t.style.color = "red"),
                    (t.style.fontFamily = At),
                    (t.style.fontSize = "10px"),
                    (t.style.textAlign = "center"),
                    (t.style.border = "thin solid grey"),
                    (t.style.left = e * n + "px"),
                    (t.style.top = e * i + "px"),
                    (t.style.lineHeight = e + "px");
                  try {
                    (t.dataset.x = n), (t.dataset.y = i);
                  } catch (o) {
                    t.setAttribute("data-x", n), t.setAttribute("data-y", i);
                  }
                  me(t, e - 2, e - 2), un.appendChild(t);
                }
              an.appendChild(un);
            } else Ze.log("Grid is not initialized");
          }
          function _() {
            var e, t, n, i, o, r;
            if (ct && an && un)
              for (
                e = un.querySelectorAll('[class*="' + It + '"]'),
                  t = e.length,
                  n = 0;
                n < t;
                n++
              ) {
                i = e[n];
                try {
                  (o = i.dataset.x), (r = i.dataset.y);
                } catch (s) {
                  (o = i.getAttribute("data-x")),
                    (r = i.getAttribute("data-y"));
                }
                i.innerHTML = "(" + o + "," + r + ")";
              }
          }
          function N(e, t) {
            function n() {
              s &&
                an &&
                (Lt === !0
                  ? (i("", "", "", ""),
                    (s.width = ln.width),
                    (s.height = ln.height),
                    s.setAttribute("aria-hidden", "true"),
                    s.setAttribute("alt", null),
                    s.setAttribute("role", "img"),
                    dn.appendChild(s))
                  : (an.style.backgroundColor = "blue"),
                (s.onload = "")),
                t.resolve();
            }
            function i(e, t, n, i) {
              (dn.style.backgroundImage = e),
                (dn.style.backgroundPositionX = t),
                (dn.style.backgroundSize = n),
                (dn.style.repeat = i);
            }
            var o,
              r,
              s = new Image();
            return Gt
              ? void t.resolve()
              : ((s.onload = n),
                void (
                  e instanceof Image &&
                  ((s.src = e.src), (o = e.naturalHeight), (r = e.naturalWidth))
                ));
          }
          function D() {
            var e,
              t = dt.childNodes.length,
              n = He.promise.create();
            for (e = 0; e < t; e++)
              (dt.childNodes[e].classList &&
                dt.childNodes[e].classList.contains(
                  "cylindo-dismiss-on-zoom"
                )) ||
                N(dt.childNodes[e], n);
            return n;
          }
          function O() {
            var e,
              t = 0,
              n = 0;
            if (Bt && ct)
              for (Nt++, t = 0; t < ct[0].length; t++)
                for (n = 0; n < ct.length; n++)
                  if (
                    ct[n][t] &&
                    ct[n][t].isFinishedDownloading &&
                    ct[n][t].drawIteration < Nt
                  )
                    try {
                      (e = ct[n][t]),
                        I(
                          e,
                          e.screenRect.x,
                          e.screenRect.y,
                          e.screenRect.w,
                          e.screenRect.h
                        ),
                        (ct[n][t].drawIteration = Nt),
                        (e = null);
                    } catch (i) {
                      e = null;
                      continue;
                    }
          }
          function S(e) {
            e.preventDefault(),
              e.type === fn.MOUSE_DOWN
                ? ((En.initialX = e.clientX),
                  (En.initialY = e.clientY),
                  (En.startX = e.clientX),
                  (En.startY = e.clientY))
                : ((En.initialX = e.touches[0].screenX),
                  (En.initialY = e.touches[0].screenY),
                  (En.startX = e.touches[0].screenX),
                  (En.startY = e.touches[0].screenY)),
              (vn = 1);
          }
          function M(e) {
            var t,
              n,
              i,
              o,
              r = et && !Ht ? nt : tt,
              s = e ? (e.type === fn.MOUSE_MOVE ? 1.1 : 1.25) : 0;
            0 !== vn &&
              (e.type === fn.MOUSE_MOVE
                ? ((t = e.clientX - En.startX), (n = e.clientY - En.startY))
                : ((t = e.touches[0].screenX - En.startX),
                  (n = e.touches[0].screenY - En.startY)),
              (rn && Date.now() - rn < sn) ||
                ((rn = Date.now()),
                Me(e),
                "undefined" != typeof En.startX &&
                  "undefined" != typeof En.startY &&
                  ((mt -= t * s),
                  (ht -= n * s),
                  (mt = F(mt, r)),
                  (ht = P(ht, r)),
                  H(mt, ht),
                  e.type === fn.MOUSE_MOVE
                    ? ((En.startX = e.clientX), (En.startY = e.clientY))
                    : ((En.startX = e.touches[0].screenX),
                      (En.startY = e.touches[0].screenY)),
                  (i = -1 * t * s),
                  (o = -1 * n * s),
                  (Be = Ot.x !== mt ? Be + i / (ln.width - ut.width) : Be),
                  (Ue = Ot.y !== ht ? Ue + o / (ln.height - ut.height) : Ue),
                  (Ot.x = mt),
                  (Ot.y = ht),
                  Bt
                    ? Ge.trigger(Ge.events.ZOOM, {
                        index: Qt,
                        files: je,
                        x: be(),
                        y: Ie(),
                      })
                    : Ge.trigger(Ge.events.ZOOM, {
                        index: Qt,
                        url: qe.resolveProtocol(
                          dt.dataset
                            ? dt.dataset.zoomImage
                            : dt.getAttribute("data-zoom-image")
                        ),
                        x: be(),
                        y: Ie(),
                      }),
                  V(bn))));
          }
          function x(e) {
            var t,
              n,
              i = !0;
            (vn = 0),
              e && e.type === gn.TOUCH_END
                ? Ft
                  ? (clearTimeout(Ft), (Ft = !1), te())
                  : (Ft = setTimeout(function () {
                      Ft = !1;
                    }, 300))
                : ((n = e.clientX - En.initialX),
                  (t = e.clientY - En.initialY),
                  Math.abs(n) < 5 && Math.abs(t) < 5 && Q(e, i));
          }
          function F(e, t) {
            var n = ln.width - t.width;
            return (e = Math.max(e, 0)), (e = Math.min(e, n));
          }
          function P(e, t) {
            var n = ln.height - t.height;
            return (e = Math.max(e, 0)), (e = Math.min(e, n));
          }
          function k() {
            return et && !Ht ? ut.left - nt.left : (tt.width - ut.width) / 2;
          }
          function U() {
            return et && !Ht ? ut.top - nt.top : (tt.height - ut.height) / 2;
          }
          function B() {
            return !et || le || Ht ? ln.width - ut.width : ln.width - nt.width;
          }
          function G() {
            return !et || le || Ht
              ? ln.height - ut.height
              : ln.height - nt.height;
          }
          function H(e, t) {
            e > 0 ? (e *= -1) : e < 0 && (e = (e * -1) / 2),
              t > 0 ? (t *= -1) : t < 0 && (t = (t * -1) / 2),
              (e = Math.round(e).toString()),
              (t = Math.round(t).toString()),
              Xt
                ? (an.style[Xt] = "translate(" + e + "px, " + t + "px)")
                : window.XDomainRequest
                ? (an.style["-ms-transform"] =
                    "translate(" + e + "px, " + t + "px)")
                : (an.style.transform = "translate(" + e + "px, " + t + "px)");
          }
          function z(e) {
            var t = et && !Ht ? nt : tt,
              n = {};
            if (!(rn && Date.now() - rn < sn)) {
              rn = Date.now();
              var i = { x: e.clientX - ut.left, y: e.clientY - ut.top };
              (n = ie(i, t)),
                (mt = n.leftOffset),
                (ht = n.topOffset),
                (Ot.x === mt && Ot.y === ht) ||
                  ((Ot.x = mt),
                  (Ot.y = ht),
                  H(mt, ht),
                  V(bn),
                  Bt
                    ? Ge.trigger(Ge.events.ZOOM, {
                        index: Qt,
                        files: je,
                        x: be(),
                        y: Ie(),
                      })
                    : Ge.trigger(Ge.events.ZOOM, {
                        index: Qt,
                        url: qe.resolveProtocol(
                          dt.dataset
                            ? dt.dataset.zoomImage
                            : dt.getAttribute("data-zoom-image")
                        ),
                        x: be(),
                        y: Ie(),
                      }));
            }
          }
          function V(e) {
            Bt && (b(Dt, v()) || Zt(e));
          }
          function q(e) {
            f(e), O();
          }
          function Y(e) {
            (Ge.isPanning = !Ge.disabled),
              clearTimeout(qt),
              z(e),
              (qt = setTimeout(X, 100));
          }
          function X() {
            Ge.isPanning = !1;
          }
          function Z() {
            var e = s();
            e.addEventListener("touchstart", S),
              e.addEventListener("touchmove", M),
              e.addEventListener("touchend", x),
              Te() === pn.MOUSE_MOVE || (et && !Et && !ae())
                ? (!et ||
                    Et ||
                    ae() ||
                    Te() !== pn.MOUSE_DRAG ||
                    ((An = !0),
                    Ze.warning(
                      "'mouseDrag' value assigned to zoomMode property dismissed because zoom contanier is not overlapping the viewer container."
                    )),
                  e.addEventListener("mousemove", Y),
                  an.addEventListener("mouseup", Q),
                  et &&
                    !Et &&
                    (document.body.addEventListener("mousedown", Me, !0),
                    document.body.addEventListener("mouseup", Q, !0)))
                : (e.addEventListener("mousedown", S),
                  e.addEventListener("mousemove", M),
                  document.addEventListener("mouseup", x)),
              tn && document.addEventListener("keyup", j),
              (mn = !0);
          }
          function W() {
            var e = s();
            e.removeEventListener("touchstart", S),
              e.removeEventListener("touchmove", M),
              e.removeEventListener("touchend", x),
              an.removeEventListener("mouseup", Q),
              e.removeEventListener("mousemove", Y),
              et &&
                !Et &&
                (document.body.removeEventListener("mousedown", Me, !0),
                document.body.removeEventListener("mouseup", Q, !0)),
              e.removeEventListener("mousedown", S),
              e.removeEventListener("mousemove", M),
              document.removeEventListener("mouseup", x),
              document.removeEventListener("keyup", j),
              (mn = !1);
          }
          function j(e) {
            var t = !1;
            try {
              (e = e || window.event),
                (t =
                  "key" in e
                    ? "Escape" == e.key || "Esc" == e.key
                    : 27 == e.keyCode),
                t && te();
            } catch (n) {
              Ze.error(
                "Something went wrong while trying to exit from zoom using ESC button."
              );
            }
          }
          function K(e) {
            lt = e;
          }
          function Q(e, t) {
            var n;
            Me(e),
              (n = _e()),
              (tn = !1),
              "mixed" === Xe.get("maxZoom") && zt !== Pe
                ? ((n = n || {}),
                  (n.currentX = n.startX = e.clientX),
                  (n.currentY = n.startY = e.clientY),
                  (n.startTime = e.timeStamp),
                  t &&
                    ((n.useFractions = !0),
                    (n.startXFraction = be()),
                    (n.startYFraction = Ie())),
                  (an.style.display = "none"),
                  a(n, Ht, Ut))
                : te();
          }
          function J(e, t) {
            var n = {},
              i = _e();
            Me(e, t),
              "mixed" === Xe.get("maxZoom") && zt !== Pe
                ? ((n = i ? i : n),
                  (tn = !1),
                  (an.style.display = "none"),
                  He &&
                    He.browser.isMobile() &&
                    ((n.withoutCoords = !1),
                    (n.useFractions = !0),
                    (n.startXFraction = be()),
                    (n.startYFraction = Ie())),
                  a(n, Ht, Ut))
                : te();
          }
          function $(e, t) {
            var n = {},
              i = _e();
            Me(e, t),
              "mixed" === Xe.get("maxZoom") && zt === Pe
                ? ((n = i ? i : n),
                  (tn = !1),
                  (zt = 0),
                  (an.style.display = "none"),
                  He &&
                    He.browser.isMobile() &&
                    ((n.withoutCoords = !1),
                    (n.useFractions = !0),
                    (n.startXFraction = be()),
                    (n.startYFraction = Ie())),
                  a(n, Ht, Ut))
                : te();
          }
          function ee() {
            ue(an),
              se(Ht, it, !1),
              (je = []),
              W(),
              Qe.detachEvent
                ? Qe.detachEvent("onresize", o)
                : Qe.removeEventListener
                ? Qe.removeEventListener("resize", o)
                : Ze.warning(
                    "The browser does not support Javascript event binding"
                  ),
              jt.removeEventListener("touchend", J),
              Kt.removeEventListener("touchend", $),
              (Qe.innerHTML = ""),
              Ve.destroy();
          }
          function te(e) {
            var t,
              n,
              i = lt ? lt.querySelector(".active") : null;
            i &&
              ((t = i.dataset
                ? i.dataset.isAlternateImage
                : i.getAttribute("is-alternate-image")),
              (n = i && 1 === parseInt(t, 10)),
              (zt = 0),
              Ae(),
              et && (xt || (Et ? (Qe.style.display = "none") : ze.fadeOut(Qe))),
              (rt = null),
              se(Ht, it, !1),
              Me(e),
              W(),
              (an.style.display = "none"),
              (an.style.willChange = ""),
              (an.style.transition = ""),
              (Ge.disabled = !0),
              Ge && Ge.tooltip && Ge.tooltip.el && Ge.tooltip.hide(!0),
              Ge.trigger(Ge.events.DISABLED, { index: Qt, li: Jt }),
              ce());
          }
          function ne(e, t, n) {
            var i,
              o = 0,
              r = 0,
              s = {};
            (i = tn
              ? { x: Re(nn, !0), y: Re(on, !1) }
              : {
                  x: e.useFractions ? e.currentX : e.currentX - t.left,
                  y: e.useFractions ? e.currentY : e.currentY - t.top,
                }),
              (s = ie(i, n)),
              (mt = s.leftOffset),
              (ht = s.topOffset),
              mt > 0
                ? (o = (mt * -1).toString())
                : mt < 0 && (o = ((mt * -1) / 2).toString()),
              ht > 0
                ? (r = (ht * -1).toString())
                : ht < 0 && (r = ((ht * -1) / 2).toString()),
              Xt
                ? (an.style[Xt] =
                    "translate(" +
                    Math.round(o) +
                    "px, " +
                    Math.round(r) +
                    "px)")
                : (an.style.transform =
                    "translate(" +
                    Math.round(o) +
                    "px, " +
                    Math.round(r) +
                    "px)"),
              (Ot = R(mt, ht));
          }
          function ie(e, t) {
            var n, i, o, r, s, a, l, d;
            return (
              (l = e.x / ut.width),
              (d = e.y / ut.height),
              (Be = l),
              (Ue = d),
              !et || it || Ht
                ? ((o = k()),
                  (r = U()),
                  (s = B()),
                  (a = G()),
                  (n = s * l - o),
                  (i = a * d - r))
                : ((l < 0 || l > 1) &&
                    ((l = Math.max(l, 0)), (l = Math.min(l, 1))),
                  (d < 0 || d > 1) &&
                    ((d = Math.max(d, 0)), (d = Math.min(d, 1))),
                  (tt = Qe.getBoundingClientRect()),
                  (n = l * ln.width - tt.width / 2),
                  (i = d * ln.height - tt.height / 2),
                  (n < 0 || n > ln.width) &&
                    ((n = Math.max(n, 0)), (n = Math.min(n, ln.width))),
                  (i < 0 || i > ln.height) &&
                    ((i = Math.max(i, 0)), (i = Math.min(i, ln.height)))),
              (n = F(n, t)),
              (i = P(i, t)),
              { leftOffset: n, topOffset: i }
            );
          }
          function oe(e, t, n, r) {
            var s,
              a,
              l,
              d = He.promise.create(),
              c = et && !Ht ? nt : tt,
              h = !0;
            if (
              ((t = t.parentNode),
              (ot = Date.now()),
              (!e ||
                (e && e.withoutCoords) ||
                (e && (isNaN(e.currentX) || isNaN(e.currentY)))) &&
                (e = {
                  currentX: tt.left + tt.width / 2,
                  currentY: tt.top + tt.height / 2,
                }),
              o(),
              Bt && !Gt && i(),
              ne(e, n, c),
              !Gt)
            )
              if ((ue(dn), ue(cn), Bt)) {
                for (
                  Dt = v(),
                    Dt.compress(pt),
                    Dt.print("init grid: "),
                    s = Dt.minX;
                  s <= Dt.maxX;
                  s++
                )
                  for (a = Dt.minY; a <= Dt.maxY; a++)
                    (l = A(s, a, s, a)), u(l, r, h);
                cn.classList.add(wn);
              } else m(e, n, c, d);
            L(),
              Z(),
              Gt && (Bt ? b(Dt, v()) || f(r) : m(e, n, c, d)),
              Bt && d.resolve(),
              d.then(
                function () {
                  (this.self.disabled = !1),
                    (this.zoomImagery.style.display = ""),
                    this.zoomImagery.focus();
                }.bind({ self: Ge, zoomImagery: an })
              );
          }
          function re(t) {
            et &&
              (an.parentNode.removeChild(an),
              t ? e.el.appendChild(an) : Qe.appendChild(an));
          }
          function se(e, t, n) {
            e ||
              t ||
              !lt ||
              (n
                ? lt.classList.add("cylindo-zoom-notcustom-container")
                : lt.classList.remove("cylindo-zoom-notcustom-container"));
          }
          function ae() {
            return it;
          }
          function le(e, t) {
            var n,
              i = Je.querySelector(".cylindo-viewer-container"),
              r = e ? e : t ? i : Je,
              s = document.createElement("div"),
              a = ["width", "height"],
              l = ["top", "left"],
              d = a.length,
              c = l.length,
              u = ze.getRect(r),
              h = { top: e ? ze.position(r).top : 0, left: 0 },
              m = new Date().getTime();
            if (!et || Et) {
              for (
                Et
                  ? (s = Qe)
                  : (s.setAttribute("id", yt + "-" + m),
                    (s.style.position = "absolute"),
                    (s.style.overflow = "hidden"),
                    (s.style.display = "none"),
                    (xt = !1),
                    ze.insertAfter(s, i),
                    (Et = !0)),
                  n = 0;
                n < d;
                n++
              )
                s.style[a[n]] = u[a[n]] + "px";
              for (n = 0; n < c; n++) s.style[l[n]] = h[l[n]] + "px";
              (et = !0), (e || t) && ($e = r), (Qe = s), o();
            }
          }
          function de(e, t, n, i) {
            var o = i ? { frame: i } : null;
            (tn = !0), (nn = e), (on = t), a(o, n, 4);
          }
          function ce() {
            tn && ((tn = !1), (nn = 0), (on = 0));
          }
          function ue(e) {
            e && (e.innerHTML = "");
          }
          function he(e, t) {
            isNaN(e) ||
              isNaN(t) ||
              ((ln = { width: e, height: t }),
              me(an, e, t),
              me(dn, e, t),
              me(cn, e, t),
              w());
          }
          function me(e, t, n) {
            e.setAttribute("data-width", t),
              e.setAttribute("data-height", n),
              (e.style.width = t + "px"),
              (e.style.height = n + "px");
          }
          function pe() {
            return Ge.disabled ? null : Qt;
          }
          function fe() {
            var e = this.evt,
              t = this.data,
              n = this.list360,
              i = this.viewer,
              o = this.customImageClass,
              r = this.preventAllEvents,
              s = this.isStackedAndNotFS,
              a = this.customImgZoom,
              l = Xe.get("zoom"),
              d = Xe.get("alternateContentZoom"),
              c = n.querySelector("li.active"),
              u = t && t.frame ? t.frame : c,
              h = u ? u.getAttribute("data-index") : null,
              m =
                "custom" === i.viewerPresentation ||
                1 ===
                  (u.getAttribute("data-is-alternate-image")
                    ? +u.getAttribute("data-is-alternate-image")
                    : 0),
              p = u.classList.contains(o),
              f = !isNaN(h),
              g = u.dataset
                ? u.dataset.zoomImage
                : u.getAttribute("data-zoom-image"),
              v = u.childNodes[0],
              E = v
                ? v.src ||
                  (v.dataset ? v.dataset.src : v.getAttribute("data-src"))
                : null,
              y = s ? u : n,
              A = y.getBoundingClientRect();
            return (
              !(m && u && u.classList && u.classList.contains("hidden")) &&
              (l === !0 || d === !0) &&
              !u.classList.contains("cylindo-img-not-found") &&
              !u.classList.contains("cylindo-video") &&
              !((e && r.status) || (f && !l) || (p && !a) || (m && !d)) &&
              !(p && d !== !0 && !a) &&
              (g.indexOf("data:image") === -1 && (g = "//" + g.split("//")[1]),
              !(
                g &&
                E &&
                g === E.replace(/^http(s)*:/i, "") &&
                (v.naturalHeight <= A.height || v.naturalWidth <= A.width)
              ) ||
                (Ge.noZoomTooltip &&
                  (Ge.noZoomTooltip.show(),
                  setTimeout(function () {
                    Ge.noZoomTooltip.hide();
                  }, 4e3)),
                !1))
            );
          }
          function ge(e, t) {
            function n() {
              try {
                ++v,
                  v >= u ||
                  "undefined" == typeof a ||
                  "undefined" == typeof r ||
                  "undefined" == typeof l ||
                  "undefined" == typeof s
                    ? Ae(!0)
                    : ((d = Ye.easeOutQuad(v, a, r - a, u)),
                      (c = Ye.easeOutQuad(v, l, s - l, u)),
                      (c = Math.round(100 * c) / 100),
                      (d = Math.round(100 * d) / 100),
                      (mt = d),
                      (ht = c),
                      (Ot.x = mt),
                      (Ot.y = ht),
                      H(d, c),
                      V(bn));
              } catch (e) {
                Ze.error("Cannot move finish zoom animation", e), Ae();
              }
            }
            var i;
            (e = Re(e, !0)), (t = Re(t, !1)), (vn = 1), (i = { x: e, y: t });
            var o,
              r,
              s,
              a,
              l,
              d,
              c,
              u,
              h,
              m,
              p,
              f,
              g = et && !Ht ? nt : tt,
              v = 0,
              E = 16.7;
            (a = mt),
              (l = ht),
              (o = ie(i, g)),
              (r = o.leftOffset),
              (s = o.topOffset),
              (m = Math.abs(r - a)),
              (p = Math.abs(s - l)),
              (f = Math.max(m, p)),
              0 === f &&
                Ze.warning(
                  "Requested coordinates to move zoom are the same coordinates displayed at zoom."
                ),
              (h = 20),
              (u = Math.floor(f / h)),
              (u = Math.max(u, 2)),
              Ae(),
              W(),
              ve(),
              (hn = setInterval(n, E));
          }
          function ve() {
            var e = s();
            Te() === pn.MOUSE_DRAG &&
              (ye(),
              e.addEventListener("touchend", Ee),
              e.addEventListener("mouseup", Ee));
          }
          function Ee(e) {
            ye(),
              Ge.disabled ||
                (e && (e.preventDefault(), e.stopPropagation()), Ae());
          }
          function ye() {
            var e = s();
            e.removeEventListener("touchend", Ee),
              e.removeEventListener("mouseup", Ee);
          }
          function Ae(e) {
            (vn = 0),
              ye(),
              hn && (clearInterval(hn), (hn = null)),
              mn || Z(),
              e &&
                (Bt
                  ? Ge.trigger(Ge.events.ZOOM, {
                      index: Qt,
                      files: je,
                      x: be(),
                      y: Ie(),
                    })
                  : Ge.trigger(Ge.events.ZOOM, {
                      index: Qt,
                      url: qe.resolveProtocol(
                        dt.dataset
                          ? dt.dataset.zoomImage
                          : dt.getAttribute("data-zoom-image")
                      ),
                      x: be(),
                      y: Ie(),
                    }));
          }
          function Te() {
            return Xe.get("zoomMode");
          }
          function Re(e, t) {
            var n = t ? " X " : " Y ";
            return "number" != typeof e
              ? 0
              : ((e < 0 || e > 1) &&
                  Ze.warning(
                    "Invalid value assigned for " +
                      n +
                      " axis (" +
                      e +
                      "). Programatic zoom will be executed at the nearest point."
                  ),
                (e = Math.max(0, e)),
                (e = Math.min(1, e)),
                (e *= t ? ut.width : ut.height));
          }
          function be() {
            return Le(!0);
          }
          function Ie() {
            return Le(!1);
          }
          function Le(e) {
            return we(
              e ? Math.round(100 * Be) / 100 : Math.round(100 * Ue) / 100
            );
          }
          function we(e) {
            return (e = Math.max(0, e)), (e = Math.min(1, e));
          }
          function Ce(e) {
            var t = null;
            return (t = getComputedStyle(e)), t && t.display ? t.display : null;
          }
          function _e() {
            var e;
            return (
              (null !== kt &&
                "object" !==
                  ("undefined" == typeof kt ? "undefined" : _typeof(kt))) ||
                ((kt = kt || null),
                (e = JSON.parse(JSON.stringify(kt)) || {}),
                kt && kt.frame && (e.frame = kt.frame),
                (e = He.object.isEmptyObject(e) ? null : e)),
              e
            );
          }
          function Ne(e) {
            e.setAttribute("aria-label", yn.texts.ENTER_ZOOM),
              e.classList.remove("cylindo-icon-zoom-on"),
              e.classList.remove("cylindo-icon-zoom-out"),
              e.classList.add("cylindo-icon-zoom-off");
          }
          function De(e) {
            e.setAttribute("aria-label", yn.texts.EXIT_ZOOM),
              e.classList.add("cylindo-icon-zoom-on"),
              e.classList.add("cylindo-icon-zoom-out"),
              e.classList.remove("cylindo-icon-zoom-off");
          }
          function Oe() {
            De(jt), (Kt.style.display = "none");
          }
          function Se() {
            Ne(jt), (Kt.style.display = "block"), De(Kt);
          }
          function Me(e, t) {
            "string" == typeof e &&
            "object" === ("undefined" == typeof t ? "undefined" : _typeof(t))
              ? ((e = t), e.preventDefault(), e.stopPropagation())
              : e && (e.preventDefault(), e.stopPropagation());
          }
          var xe,
            Fe,
            Pe,
            ke,
            Ue,
            Be,
            Ge = this,
            He = cylindo.getModule("cylindo.core.util"),
            ze = e.dom,
            Ve = cylindo.getModule("cylindo.util.pubsub").create(),
            qe = cylindo.getModule("cylindo.core.network"),
            Ye =
              (He.browser.browser.ios && "8.0" === He.browser.browser.version,
              cylindo.getModule("cylindo.helpers.easing")),
            Xe = e.model,
            Ze = Xe.getLogger(),
            We = e.tags,
            je = [],
            Ke = Xe.get("customZoomContainer"),
            Qe = e.el,
            Je = Qe.parentNode,
            $e = e.el,
            et = !1,
            tt = $e.getBoundingClientRect(),
            nt = null,
            it = !1,
            ot = 0,
            rt = null,
            st = Xe.get("thumbs"),
            at = Xe.get("zoomOverlapsThumbs"),
            lt = e.list,
            dt = null,
            ct = null,
            ut = null,
            ht = null,
            mt = null,
            pt = null,
            ft = null,
            gt = null,
            vt = null,
            Et = !1,
            yt = "cylindo-custom-zoom-forced",
            At = "Arial",
            Tt = "cylindo-zoom-imagery",
            Rt = "cylindo-zoom-background",
            bt = "cylindo-zoom-images",
            It = "cylindo-zoom-grid-",
            Lt = Xe.get("drawImageBackground") || !0,
            wt = Xe.get("gridSize") || 1024,
            Ct = Xe.get("zoomMargin") || 256,
            _t = 1,
            Nt = 0,
            Dt = null,
            Ot = R(0, 0),
            St = {},
            Mt = [],
            xt = !1,
            Ft = !1,
            Pt = {
              "2k": { value: 2048, code: "2k" },
              "4k": { value: 4096, code: "4k" },
            },
            kt = null,
            Ut = 0,
            Bt = !0,
            Gt = !1,
            Ht = !1,
            zt = 0,
            Vt = 0,
            qt = null,
            Yt = [
              "transform",
              "msTransform",
              "WebkitTransform",
              "MozTransform",
              "OTransform",
            ],
            Xt = ze.getSupportedPropertyName(Yt),
            Zt = He.debounce_throttle.debounce(q, 100, {
              leading: !0,
              trailing: !0,
            }),
            Wt = document.createElement("div"),
            jt = document.createElement("a"),
            Kt = document.createElement("a"),
            Qt = null,
            Jt = null,
            $t = Xe.get("showGrid") || !1,
            en = Xe.get("showGridCoordinates") || !1,
            tn = !1,
            nn = 0,
            on = 0,
            rn = 0,
            sn = 8,
            an = null,
            ln = { width: 0, height: 0 },
            dn = null,
            cn = null,
            un = null,
            hn = null,
            mn = !1,
            pn = { MOUSE_MOVE: "mouseMove", MOUSE_DRAG: "mouseDrag" },
            fn = {
              MOUSE_DOWN: "mousedown",
              MOUSE_MOVE: "mousemove",
              MOUSE_UP: "mouseup",
            },
            gn = {
              TOUCH_START: "touchstart",
              TOUCH_MOVE: "touchmove",
              TOUCH_END: "touchend",
            },
            vn = 0,
            En = {},
            yn = (e.framesHandler, e.ariaLabel),
            An = !1,
            Tn = !1,
            Rn = [],
            bn = 0,
            In = 0,
            Ln = [],
            wn = "has-pending-grids";
          Wt.classList.add("cylindo-action-button-group", "right"),
            jt.classList.add(
              "threesixty-button",
              "cylindo-action-button-icon",
              "cylindo-icon-zoom-on",
              "cylindo-icon-zoom-out"
            ),
            Kt.classList.add(
              "temporarily-hidden",
              "threesixty-button-secondary",
              "cylindo-action-button-icon",
              "cylindo-icon-zoom-on",
              "cylindo-icon-zoom-out"
            ),
            (Kt.style.display = "none"),
            jt.setAttribute("href", "javascript:void(0)"),
            Kt.setAttribute("href", "javascript:void(0)"),
            jt.setAttribute("role", "link"),
            Kt.setAttribute("role", "link"),
            jt.setAttribute("aria-label", yn.texts.ENTER_ZOOM),
            Kt.setAttribute("aria-label", yn.texts.EXIT_ZOOM),
            Wt.appendChild(jt),
            Wt.appendChild(Kt),
            (ke = Xe.get("maxZoom")),
            (Pe = Pt[ke] ? Pt[ke].value : Pt["2k"].value),
            (Vt = Pe),
            (St.urls = []),
            (St.totalTime = 0),
            (St.totalImages = 0),
            (Ke =
              Ke && "string" == typeof Ke ? document.getElementById(Ke) : null),
            (et = null !== Ke),
            et &&
              ((Qe = Ke),
              (Qe.style.overflow = "hidden"),
              (xt = "none" !== Ce(Qe)),
              o()),
            (this.id = null),
            (this.initialized = !1),
            (this.disabled = !0),
            (this.off = Ve.off),
            (this.on = Ve.on),
            (this.trigger = Ve.trigger),
            (this.disable = te),
            (this.destroy = ee),
            (this.startZoom = a),
            (this.zoomIn = J),
            (this.zoomOut = $),
            (this.autoZoom = de),
            (this.setViewerList = K),
            (this.isPanning = !1),
            (this.getFrameIndex = pe),
            (this.canZoom = fe),
            (this.moveAutoZoom = ge),
            (this.isOverlappingViewer = ae),
            (this.cleanUp = re),
            e.model.get("tooltipZoomText") &&
              (this.tooltip = cylindo
                .getModule("tooltip.zoom")
                .create({ text: Xe.get("tooltipZoomText"), dom: ze })),
            Xe.get("tooltipNoZoomText") &&
              ((this.noZoomTooltip = cylindo
                .getModule("tooltip.not.available")
                .create({
                  parent: $e,
                  text: Xe.get("tooltipNoZoomText"),
                  dom: ze,
                })),
              this.noZoomTooltip && this.noZoomTooltip.render()),
            t();
        };
        (e.counter = 0),
          (e.prototype.events = {
            READY: "zoom:ready",
            ZOOM: "zoom:move",
            ENABLED: "zoom:enabled",
            DISABLED: "zoom:disabled",
          });
        var t = {
          create: function (t) {
            return new e(t);
          },
        };
        window.cylindo.addModule("zoom", t);
      }.call(this),
      function () {
        var e = function n(e, t, i) {
          function o() {
            return (
              We(Ht.GENERIC.INITIALIZING),
              (yt.id = ++n.counter),
              It && !It.initialized && It.initialize(wt),
              wt.get("cylindoContent") === !0 &&
                (wt.once(wt.events.FEATURES_CHANGED, yt.render),
                wt.once(wt.events.FEATURES_ERROR, d),
                wt.on(wt.events.FEATURES_ERROR, rt)),
              wt.on(wt.events.CHANGED, r),
              (Tt =
                En === vn.TOP || En === vn.LEFT
                  ? Rt.concat(bt, Tt)
                  : Rt.concat(Tt, bt)),
              (qt = Tt.join("")),
              (zt = document.getElementById(wt.get("containerID")))
                ? (zt.setAttribute("role", "region"),
                  zt.setAttribute("aria-label", At.texts.TITLE),
                  zt.setAttribute("title", wt.get("title")),
                  (ht = function (e) {
                    return zt ? zt.querySelector(e) : null;
                  }),
                  (mt = function (e) {
                    return zt ? Mt.querySelectorAll(zt, e) : null;
                  }),
                  s(),
                  wt.prepareToFetchFeatures(),
                  wt.fetchFeatures(),
                  void window.addEventListener("resize", m))
                : void Vt.error(
                    wt.get("containerID") + " element doesn't exist"
                  )
            );
          }
          function r(e, t) {
            "title" === t.prop && zt.setAttribute("title", t.value),
              It &&
                It.initialized &&
                It.propsToValidateOrder.indexOf(t.prop) !== -1 &&
                (Dt.initialized && !Dt.disabled && Dt.disable(),
                It.validateOrder(e, t)),
              "ARBannerConfig" === t.prop && fn && fn.tryToShow();
          }
          function s() {
            var e = St.browser.isMobile(),
              t = wt.get("thumbLocation"),
              n = "thumb-location-";
            if (
              St.browser.equalOrLessThanIE10() ||
              St.browser.equalOrLessThanSafari6()
            )
              throw Error(
                "This browser version is no longer supported by the Cylindo HD 360 Viewer."
              );
            Mt.height(zt) > 0
              ? zt.classList.add("has-height")
              : (zt.style.height = "512px"),
              zt.classList.add("cylindo-wrapper"),
              (zt.innerHTML = qt),
              (Et = ht(".cylindo-thumbnail-bar")),
              (Kt = ht(".cylindo-loader")),
              (Jt = ht(".cylindo-viewer-container")),
              ($t = ht(".cylindo-action-button-group")),
              Jt &&
                (wt.get("thumbs") === !0 &&
                  (Jt.classList.add("has-thumbs"), Jt.classList.add(n + t)),
                0 === Mt.height(Jt) &&
                  zt.classList.contains("has-height") &&
                  (zt.classList.remove("has-height"),
                  (zt.style.height = "512px"))),
              Ae(),
              Ee(),
              ((Ut.isAvailable() || Yt.isAvailable()) &&
                "stacked" !== wt.get("presentation")) ||
                ((nn = !0), nt(!0, yn)),
              e && wt.get("focusOnFeatureChange") === !0 && (on = !0),
              wt.get("cylindoContent") !== !0 && yt.render();
          }
          function a(e) {
            var t, n, i, o, r;
            if (
              !(
                e &&
                ((o = e.target),
                (o && "VIDEO" === o.tagName) ||
                  (o &&
                    "LI" === o.tagName &&
                    o.classList &&
                    o.classList.contains("cylindo-video")))
              )
            )
              return e && e.touches && e.touches.length > 1
                ? void Yt.addBlinkClass()
                : void (
                    Dt.initialized &&
                    (cn
                      ? (e.preventDefault(),
                        e.stopPropagation(),
                        de(),
                        clearTimeout(cn),
                        (cn = !1),
                        Xe()
                          ? Dt.disabled
                            ? ((an = 2),
                              (r =
                                "IMG" === o.tagName
                                  ? o.parentElement
                                  : "LI" === o.tagName
                                  ? o
                                  : null),
                              (i = !Ut.isEnabled() && r ? r : null),
                              (t = i
                                ? i.querySelector(
                                    ".cylindo-action-button-group .threesixty-button"
                                  )
                                : null),
                              (n = i
                                ? i.querySelector(
                                    ".cylindo-action-button-group .threesixty-button-secondary"
                                  )
                                : null),
                              z(null, {
                                frame: i,
                                btnZoom: t,
                                btnZoom2: n,
                                withoutCoords: !0,
                              }))
                            : Dt.disable()
                          : Dt.disabled
                          ? ((an = 2), L())
                          : Dt.disable())
                      : (cn = setTimeout(function () {
                          cn = !1;
                        }, 300)))
                  );
          }
          function l() {
            Yt.removeBlinkClass();
          }
          function d() {
            var e = wt.get("fallbackImage");
            (gn = !0), (nn = !0), nt(!0, yn), g(e);
          }
          function c() {
            fn && fn.onFeaturesError(), null !== Ln && Ln.hide && Ln.hide(!0);
          }
          function u(e, t) {
            Mt.fadeIn(Kt, e, t);
          }
          function h(e, t) {
            Mt.fadeOut(Kt, e, t);
          }
          function m() {
            function e() {
              s ||
                ((i = c > 0 && c < t ? c * o : n ? n : 512),
                Jt && (Jt.style.height = i + "px"),
                (zt.style.height = ""),
                Ct && Ct.initialized && Ct.ready && !tt()
                  ? ((i += Ct.thumbsHeight()),
                    (zt.style.height = i + "px"),
                    Jt && (Jt.style.height = ""),
                    zt.classList.add("has-height"))
                  : (!wt.get("thumbs") || (wt.get("thumbs") && tt())) &&
                    ((zt.style.height = i + "px"),
                    Jt && (Jt.style.height = ""),
                    zt.classList.add("has-height")));
            }
            if (zt && 0 !== zt.length && jt && 0 !== jt.length)
              try {
                var t,
                  n,
                  i,
                  o,
                  r,
                  s = zt.classList.contains("has-height"),
                  a = jt.childNodes[0].childNodes[0],
                  l = a ? a.parentNode : null,
                  d = new Image(),
                  c = Jt ? Jt.clientWidth : 0;
                if (!jt) return;
                a instanceof Image
                  ? ((d = a),
                    (t = d.naturalWidth),
                    (n = d.naturalHeight),
                    (o = n / t),
                    e())
                  : l &&
                    l.classList &&
                    l.classList.contains("cylindo-video") &&
                    ((r = a.getBoundingClientRect()),
                    (t = r.width),
                    (n = r.height),
                    (o = n / t),
                    e());
              } catch (u) {
                Vt.error(u);
              }
          }
          function p(e, t) {
            function n() {
              var e = {
                el: Jt,
                alternateContent: i.ALTERNATE.LIST,
                frameCount: i.THREESIXTY.TO_BE_LOADED,
                currentFeatures: en,
                model: wt,
                logger: Vt,
                tags: Lt,
                hideZoomBtn: !Yt.isAvailable(),
                hideFullScreenBtn: !Ut.isAvailable(),
                dom: Mt,
                framesHandler: It,
                ariaLabel: At,
                initializedWithError: !(!t || !t.firstFeaturesFailed),
              };
              if (
                !(
                  (Nt && Nt.initialized) ||
                  (t && t.firstFeaturesFailed && ot(t.firstSetOfFeatures),
                  (Nt = Nt.create(e)),
                  Nt.prepareViewerCreator(),
                  It.validateOrder(),
                  Wt && Wt.initialized)
                )
              )
                if (
                  ((ft = Nt.createViewerInstance()),
                  (Wt = ft.instance),
                  null !== ft.instance && null !== ft.presentation)
                )
                  switch (
                    ((gt = Pt.getContent(It, ft)),
                    (vt = Pt.getContentTypes()),
                    (Ht = kt.getAllPossibleStates(ft.presentation)),
                    ft.presentation)
                  ) {
                    case Ft.THREESIXTY.NAME:
                      D(ft.instance);
                      break;
                    case Ft.CAROUSEL.NAME:
                      x(ft.instance);
                      break;
                    case Ft.STACKED.NAME:
                      U(ft.instance);
                      break;
                    case Ft.SINGLE.NAME:
                      M(ft.instance);
                      break;
                    case Ft.CUSTOM.NAME:
                      V(ft.instance);
                  }
                else Vt.log("Cannot suscribe to viewer instance events.");
            }
            var i = It.getAllFramesToBeLoaded(),
              o = null;
            if (
              (!St.browser.isMobile() &&
                St.browser.isSafari() &&
                parseFloat(St.browser.browser.version, 10) < 11 &&
                zt.classList.add("is-safari-desktop"),
              (St.browser.isSafari() || St.browser.isIOS()) &&
                zt.classList.add("is-safari-or-ios"),
              wt.off(wt.events.FEATURES_ERROR, d),
              (en = wt.get("currentFeatures")),
              0 === i.THREESIXTY.TO_BE_LOADED && 0 === i.ALTERNATE.LEN)
            )
              return void g(wt.get("fallbackImage"));
            if (
              (n(),
              wt.get("thumbs") === !0 && se(),
              wt.get("progressBar") === !0)
            )
              try {
                (o = f()),
                  o.startLoading(),
                  Wt.on(Wt.events.IMG_LOADED, o.updateBar),
                  Wt.on(Wt.events.ALT_CONTENT_LOADED, o.updateBar),
                  Ct &&
                    Ct.initialized &&
                    Ct.on(Ct.events.IMG_LOADED, o.updateBar);
              } catch (r) {
                Vt.info(r);
              }
            Wt.on(Wt.events.ALT_CONTENT_LOADED, ut),
              E(),
              (yt.initialized = !0),
              yt.trigger(yt.events.READY);
          }
          function f() {
            var e = { model: wt, container: zt, dom: Mt, framesHandler: It };
            return Ot.create(e);
          }
          function g(e) {
            var t = wt.get("fallbackImage"),
              n = e === t;
            n &&
              null === e &&
              Vt.error("Valid image must be provided as fallback image."),
              (pt = new Image()),
              pt.addEventListener("load", v, !1),
              (pt.onerror = St.fallback.loadFallbackImage.bind({
                img: pt,
                model: wt,
                errorText: "Fallback image not found: ",
              })),
              (pt.alt = "Placeholder image"),
              (pt.src = n ? "" : e ? e : ""),
              pt.classList.add("cylindo-placeholder", "opacity-one"),
              wt.get("thumbs") === !0 && pt.classList.add("has-thumbs");
          }
          function v() {
            Qt
              ? ((Qt.src = prepareImgSrc(pt.src)),
                tn && Mt.remove(Qt),
                setTimeout(function () {
                  pt.removeEventListener("load", v, !1), (pt = null);
                }, 0))
              : h(400, function () {
                  wt.get("thumbs") === !0 &&
                    Jt &&
                    Jt.classList.add("has-thumbs"),
                    St.browser.isIE() &&
                      ((pt.style.width = pt.naturalWidth + "px"),
                      (pt.style.height = pt.naturalHeight + "px")),
                    Jt && Jt.appendChild(pt),
                    (Qt = ht(".cylindo-placeholder")),
                    tn && Qt && (Qt.style.display = "none"),
                    setTimeout(function () {
                      pt &&
                        (pt.removeEventListener("load", v, !1), (pt = null));
                    }, 0);
                });
          }
          function E() {
            var e = {
              el: Jt,
              list: jt,
              model: wt,
              tags: Lt,
              dom: Mt,
              framesHandler: It,
              ariaLabel: At,
            };
            Dt.initialized || (Dt = Dt.create(e)),
              Dt.on(Dt.events.ENABLED, y),
              Dt.on(Dt.events.DISABLED, A),
              Dt.on(Dt.events.ZOOM, R);
          }
          function y(e, t) {
            var n = wt.get("zoomOverlapsThumbs");
            T(t, !1),
              n &&
                Ct &&
                Ct.initialized &&
                !Ct.isHidden &&
                (sn && !Dt.isOverlappingViewer()
                  ? Vt.log(
                      "Thumb bar not hidden when custom zoom container is not overlapping the viewer"
                    )
                  : Ct.hide()),
              Je(t.index, t.li, !0),
              delete t.index,
              delete t.li,
              yt.trigger(yt.events.ZOOM_ENTER, t),
              Wt && Wt.initialized && Wt.hideTooltip();
          }
          function A(e, t) {
            var n = wt.get("zoomOverlapsThumbs");
            T(t, !0),
              n &&
                Ct &&
                Ct.initialized &&
                Ct.isHidden &&
                !Ct.featuresChanging &&
                (sn && !Dt.isOverlappingViewer()
                  ? Vt.log(
                      "Thumb bar not hidden when custom zoom container is not overlapping the viewer"
                    )
                  : Ct.show()),
              I(),
              Yt.removeEventsToBtn(),
              Yt.off(Yt.events.CLICK, Dt.zoomIn),
              Yt.off(Yt.events.TOUCHSTART, ye),
              Yt.off(Yt.events.TOUCHEND, Dt.zoomIn),
              Xt.removeEventsToBtn(),
              Xt.off(Xt.events.CLICK, Dt.zoomOut),
              Xt.off(Xt.events.TOUCHSTART, ye),
              Xt.off(Xt.events.TOUCHEND, Dt.zoomOut),
              Xt.hide(),
              Ze() || Ie(),
              Je(t.index, t.li, !1),
              delete t.index,
              delete t.li,
              yt.trigger(yt.events.ZOOM_EXIT, t);
          }
          function T(e, t) {
            var n = null,
              i = null,
              o = t ? "" : "hidden";
            Ze() &&
              e &&
              e.li &&
              ((n = e.li.querySelector("img")),
              (i = e.li.querySelector(".cylindo-drag-tooltip")),
              n && (n.style.visibility = o),
              i && (i.style.visibility = o));
          }
          function R(e, t) {
            yt.trigger(yt.events.ZOOM, t);
          }
          function b(e) {
            Wt && Wt.initialized && (!sn || Ut.isEnabled())
              ? Wt.disable(e)
              : Wt &&
                Wt.initialized &&
                !Dt.isOverlappingViewer() &&
                !Ut.isEnabled() &&
                Wt.preventRotation(),
              Wt.hideTooltip();
          }
          function I() {
            Wt &&
              Wt.initialized &&
              h(0, function () {
                (Wt.mouseState = 0),
                  Wt.enable(),
                  Yt.setZoomInIcon(),
                  Wt.tooltip &&
                    !Wt.tooltip.el.classList.contains(
                      "cylindo-tooltip-empty-text"
                    ) &&
                    Wt.showTooltip(),
                  mn && (Ne(), Ze() || Wt.removeMouseCallbacks());
              });
          }
          function L(e, t) {
            var n = jt.querySelector("li.active"),
              i = t && t.frame ? t.frame : n,
              o =
                "custom" === Wt.viewerPresentation ||
                1 ===
                  (i && i.getAttribute("data-is-alternate-image")
                    ? +i.getAttribute("data-is-alternate-image")
                    : 0),
              r = i.classList.contains(pn);
            w(e, t) &&
              (!e ||
                (e !== Wt.events.CLICKED &&
                  e !== Wt.events.CUSTOM_IMG_CLICKED) ||
                (an = 1),
              Qt && Mt.remove(Qt),
              Dt &&
                Dt.initialized &&
                (b(t),
                (o || r) &&
                  (!Xe() || (Xe() && Ut && Ut.initialized && Ut.isEnabled())) &&
                  u(200, null),
                Dt.startZoom(t, Ut.isEnabled(), an),
                C(t)),
              (an = null));
          }
          function w(e, t) {
            return (
              !(!Dt || !Dt.initialized) &&
              Dt.canZoom.call({
                preventAllEvents: dn,
                evt: e,
                data: t,
                list360: jt,
                viewer: Wt,
                customImageClass: pn,
                isStackedAndNotFS: Ze(),
                customImgZoom: mn,
              })
            );
          }
          function C(e) {
            var t,
              n,
              i,
              o,
              r,
              s =
                e && e.frame
                  ? e.frame
                  : jt
                  ? jt.querySelector("li.active")
                  : null;
            s &&
              ((t =
                s && s.dataset
                  ? s.dataset.index
                  : s.getAttribute("data-index")),
              (n =
                "custom" === Wt.viewerPresentation ||
                1 ===
                  (s.getAttribute("data-is-alternate-image")
                    ? +s.getAttribute("data-is-alternate-image")
                    : 0)),
              (i = s.classList.contains(pn)),
              (o = wt.get("alternateContentZoom")),
              (r = !1),
              St.browser.isMobile() &&
                ((n && o) ||
                  (i && o) ||
                  (ft && Ft && ft.presentation !== Ft.THREESIXTY.NAME)) &&
                (r = !0),
              Yt && Xt && "mixed" === wt.get("maxZoom") && It.is360Frame(t)
                ? (Xt.setZoomOutIcon(!0),
                  Xt.isAvailable() && Xt.show(),
                  Le(),
                  Yt.addEventsToBtn(),
                  Yt.on(Yt.events.CLICK, Dt.zoomIn),
                  Yt.on(Yt.events.TOUCHSTART, ye),
                  Yt.on(Yt.events.TOUCHEND, Dt.zoomIn),
                  Xt.addEventsToBtn(),
                  Xt.on(Xt.events.CLICK, Dt.zoomOut),
                  Xt.on(Xt.events.TOUCHSTART, ye),
                  Xt.on(Xt.events.TOUCHEND, Dt.zoomOut))
                : Yt.setZoomOutIcon(r));
          }
          function _() {
            function e() {
              function e(e, t) {
                wt.get("arMode") === In.QR &&
                  (Ln.remove(),
                  Ln.setParent(Ut.isEnabled() ? l : l.parentElement),
                  Ln.render()),
                  Ln.show(null, !0);
              }
              function a(e, t) {
                Ln.hide(!0);
              }
              var l = zt ? zt.querySelector(".cylindo-viewer-container") : null,
                d = s ? wt.get("QRCodeTxt") : wt.get("ARLoadingTxt"),
                c = s ? wt.get("QRCodeTitleTxt") : "",
                u = s ? wt.get("ARBackToViewTxt") : "",
                h = wt.get("ARNotAvailableTxt");
              (Ln = cylindo
                .getModule("ar.modal")
                .create({
                  parent: s ? l.parentElement : document.body,
                  ARBackToViewTxt: u,
                  title: c,
                  text: d,
                  errorText: h,
                  dom: Mt,
                  preventEvents: de,
                  util: St,
                  type: s
                    ? cylindo.getModule("ar.modal").types.QR
                    : cylindo.getModule("ar.modal").types.AR,
                })),
                Ln.render(),
                fn.render(),
                fn.on(fn.events.AR_BUTTON_READY, t),
                fn.on(fn.events.AR_BUTTON_ERROR, i),
                fn.on(fn.events.AR_LAUNCHED, o),
                fn.on(fn.events.AR_SHOW_MODAL, e),
                fn.on(fn.events.AR_HIDE_MODAL, a),
                fn.on(fn.events.AR_ACTION_BTN_TAPPED, r),
                fn.on(fn.events.AR_SHOW_ERROR_MODAL, n);
            }
            function t(e, t) {
              s && Ln.updateCode(t), yt.trigger(yt.events.AR_BUTTON_READY, t);
            }
            function n() {
              Ln.showError();
            }
            function i(e, t) {
              yt.trigger(yt.events.AR_BUTTON_ERROR, t);
            }
            function o(e, t) {
              Ut.isEnabled() && wt.get("arMode") !== In.QR && Ut.close();
            }
            function r(e, t) {
              yt.trigger(yt.events.AR_ACTION_BTN_TAPPED, t);
            }
            var s = wt.get("arMode") === In.QR,
              a = {
                parent: Jt,
                text: "",
                dom: Mt,
                model: wt,
                preventEvents: de,
                settings: _t,
                linkButton: !0,
                tags: Lt,
                util: St,
                ariaLabel: At,
              };
            wt.get("ARQuickLook") &&
              !fn &&
              ((fn = cylindo.getModule("cylindo.button.ar").create(a)), e());
          }
          function N(e) {
            return "function" != typeof e
              ? void Vt.error(
                  "getArQuickLookUrl method must receive a function as callback."
                )
              : wt.get("ARQuickLook") && fn
              ? void (wt.get("ARQuickLook") && fn && e(fn.getArQuickLookUrl()))
              : void Vt.error("ARQuickLook not enabled or it doesn't exist.");
          }
          function D(e) {
            e.on(e.events.FIRST_FRAME_COMPLETE, ee),
              e.on(e.events.READY_TO_BE_SHOWN, W),
              e.on(e.events.READY, j),
              e.on(e.events.DOWNLOAD_COMPLETE, te),
              e.on(e.events.START, O),
              e.on(e.events.END, S),
              e.on(e.events.IMG_LOADED, K),
              e.on(e.events.ALT_CONTENT_LOADED, ie),
              e.on(e.events.FRAME_ACTIVATED, oe),
              e.on(e.events.FEATURES_CHANGED, Q),
              e.on(e.events.CURRENT, $),
              e.on(e.events.CONTENT_TYPE_COMPLETE, Z),
              e.on(e.events.FEATURES_CANCELED, ne),
              e.on(e.events.FEATURES_ERROR, c),
              wt.on(wt.events.FEATURES_NO_WARNING, J),
              e.on(e.events.ALT_CONTENT_REMOVED, X);
          }
          function O(e, t) {
            yt.trigger(yt.events.START_SPIN, t), xe();
          }
          function S(e, t) {
            yt.trigger(yt.events.END_SPIN, t), xe();
          }
          function M(e) {
            e.on(e.events.FIRST_FRAME_COMPLETE, ee),
              e.on(e.events.READY_TO_BE_SHOWN, W),
              e.on(e.events.READY, j),
              e.on(e.events.DOWNLOAD_COMPLETE, te),
              e.on(e.events.IMG_LOADED, K),
              e.on(e.events.ALT_CONTENT_LOADED, ie),
              e.on(e.events.FRAME_ACTIVATED, oe),
              e.on(e.events.FEATURES_CHANGED, Q),
              e.on(e.events.CURRENT, $),
              e.on(e.events.CONTENT_TYPE_COMPLETE, Z),
              e.on(e.events.FEATURES_CANCELED, ne),
              e.on(e.events.FEATURES_ERROR, c),
              wt.on(wt.events.FEATURES_NO_WARNING, J),
              e.on(e.events.ALT_CONTENT_REMOVED, X);
          }
          function x(e) {
            e.on(e.events.FIRST_FRAME_COMPLETE, ee),
              e.on(e.events.READY_TO_BE_SHOWN, W),
              e.on(e.events.READY, j),
              e.on(e.events.DOWNLOAD_COMPLETE, te),
              e.on(e.events.PREV, P),
              e.on(e.events.NEXT, k),
              e.on(e.events.IMG_LOADED, F),
              e.on(e.events.ALT_CONTENT_LOADED, ie),
              e.on(e.events.FRAME_ACTIVATED, oe),
              e.on(e.events.FEATURES_CHANGED, Q),
              e.on(e.events.CURRENT, $),
              e.on(e.events.CONTENT_TYPE_COMPLETE, Z),
              e.on(e.events.FEATURES_CANCELED, ne),
              e.on(e.events.FEATURES_ERROR, c),
              wt.on(wt.events.FEATURES_NO_WARNING, J),
              e.on(e.events.ALT_CONTENT_REMOVED, X);
          }
          function F(e, t) {
            yt.trigger(yt.events.IMG_LOADED), re(e, t);
          }
          function P(e, t) {
            yt.trigger(yt.events.PREV, t), Qe();
          }
          function k(e, t) {
            yt.trigger(yt.events.NEXT, t), Qe();
          }
          function U(e) {
            e.on(e.events.FIRST_FRAME_COMPLETE, ee),
              e.on(e.events.READY_TO_BE_SHOWN, W),
              e.on(e.events.READY, j),
              e.on(e.events.DOWNLOAD_COMPLETE, te),
              e.on(e.events.IMG_LOADED, F),
              e.on(e.events.ALT_CONTENT_LOADED, ie),
              e.on(e.events.FRAME_ACTIVATED, oe),
              e.on(e.events.FEATURES_CHANGED, Q),
              e.on(e.events.CURRENT, $),
              e.on(e.events.CONTENT_TYPE_COMPLETE, Z),
              e.on(e.events.TOGGLE_ZOOM, z),
              e.on(e.events.FULLSCREEN_BTN_ADDED, B),
              e.on(e.events.FULLSCREEN_BTN_REMOVED, G),
              e.on(e.events.FEATURES_CANCELED, ne),
              e.on(e.events.FEATURES_ERROR, c),
              wt.on(wt.events.FEATURES_NO_WARNING, J),
              e.on(e.events.ALT_CONTENT_REMOVED, X);
          }
          function B(e, t) {
            t && t.btnFullScreen && Te(t.btnFullScreen);
          }
          function G(e, t) {
            t && t.btnFullScreen && Re(t.btnFullScreen);
          }
          function H(e) {
            Wt &&
              Wt.initialized &&
              Xe() &&
              (e
                ? (Ut.setBtn(it(".fullscreen-button")),
                  Yt.setBtn(it(".threesixty-button")),
                  Xt.setBtn(it(".threesixty-button-secondary")),
                  Yt.isAvailable() || Ut.isAvailable()
                    ? ((nn = !1), nt(!1, yn))
                    : nt(!0, yn))
                : (nt(!0, yn), (nn = !0)),
              ge(),
              Wt.enableFullScreen(e));
          }
          function z(e, t) {
            function n() {
              i(),
                o && Dt.off(Dt.events.DISABLED, n),
                Dt.disabled
                  ? (t && Ut.isEnabled() && (t.reloadZoomContainer = !0),
                    L(e, t))
                  : Dt.disable();
            }
            function i() {
              var e, n;
              (e = Ut.isEnabled() ? Yt.btn : t.btnZoom),
                (n = Ut.isEnabled() ? Xt.btn : t.btnZoom2),
                Yt.setBtn(e),
                Xt.setBtn(n);
            }
            var o = !1;
            if (Dt && Dt.initialized) {
              if (
                Yt.btn === t.btnZoom &&
                !Dt.disabled &&
                "mixed" === wt.get("maxZoom") &&
                It.is360Frame(Dt.getFrameIndex())
              )
                return;
              Yt.btn === t.btnZoom || Dt.disabled
                ? n()
                : ((o = !0), Dt.on(Dt.events.DISABLED, n), Dt.disable());
            }
          }
          function V(e) {
            e.on(e.events.FIRST_FRAME_COMPLETE, ee),
              e.on(e.events.READY_TO_BE_SHOWN, q),
              e.on(e.events.READY, Y),
              e.on(e.events.ALT_CONTENT_LOADED, ie),
              e.on(e.events.FRAME_ACTIVATED, oe),
              e.on(e.events.ALT_CONTENT_REMOVED, X),
              e.on(e.events.DOWNLOAD_COMPLETE, te),
              e.on(e.events.CONTENT_TYPE_COMPLETE, Z);
          }
          function q(e, t) {
            var n, i;
            (jt = zt.querySelector(".cylindo-custom-list")),
              (n = et()),
              n &&
                n.li &&
                (n.li.classList.contains("cylindo-video")
                  ? (nt(!0, An), Wt.hideTooltip(!0))
                  : (nt(!1, An),
                    "undefined" == typeof Wt.tooltip ||
                      n.li.classList.contains("cylindo-img-not-found") ||
                      Wt.showTooltip())),
              (i = Ke(n.index, n.li)),
              i && We(i.FRAME),
              h(400, null);
          }
          function Y() {
            var e = zt ? zt.querySelector(".cylindo-viewer-container") : null;
            e &&
              (e.addEventListener("touchstart", a),
              e.addEventListener("touchend", l)),
              (jt = zt.querySelector(".cylindo-custom-list")),
              h(400, function () {
                Qt
                  ? (Mt.remove(Qt), jt.classList.add("opacity-one"))
                  : ((tn = !0), jt.classList.add("opacity-one")),
                  Dt.initialized && Dt.setViewerList(jt),
                  Wt.initialized &&
                    (Wt.off(Wt.events.CLICKED, L), Wt.on(Wt.events.CLICKED, L)),
                  Ct && Ct.initialized && Ct.render(),
                  ge();
              }),
              st();
          }
          function X() {
            ft && ft.presentation === Ft.CUSTOM.NAME && u(0, null),
              Ct && Ct.initialized && Ct.render();
          }
          function Z(e, t) {
            function n() {
              gt.dowanloaded ||
                (Lt.send(Lt.events.LOADED, a), at(), (gt.dowanloaded = !0));
            }
            var i,
              o = t && t.contentType ? t.contentType : null,
              r = !0,
              s = gt.dowanloaded ? gt.contentToUpdate : gt.contentToLoad,
              a = { c: gt.totalFrames },
              l = Wt && Wt.initialized ? Wt.getThumbsDetails() : {},
              d = Wt && Wt.initialized ? Wt.viewerUpdatedStartTime : 0;
            if (((l.acc = l.ac), delete l.ac, null !== o)) {
              for (i = 0; i < s.length; i++)
                s[i].type === o &&
                  ((s[i].downloaded = !0),
                  (s[i].elapsed = t.elapsed || Date.now() - d)),
                  s[i].downloaded === !1 && (r = !1);
              if (r && s.length) {
                for (i = 0; i < s.length; i++)
                  (a[s[i].type] = s[i].elapsed),
                    gt.dowanloaded &&
                      ((s[i].elapsed = 0), (s[i].downloaded = !1));
                (a = St.object.extend({}, a, l)),
                  fn && fn.initialized
                    ? fn.btnExistsPromise.then(
                        function () {
                          (a = St.object.extend({}, a, { ar: !0 })),
                            n(),
                            fn.sendInitialTags();
                        },
                        function () {
                          n();
                        }
                      )
                    : n();
              }
            }
          }
          function W(e, t) {
            var n,
              i,
              o = Ze() ? 500 : 0;
            (jt = zt ? zt.querySelector(".cylindo-threesixty-list") : null),
              (i = et()),
              gn &&
                !Xe() &&
                i &&
                i.li &&
                i.li.classList &&
                !i.li.classList.contains("cylindo-img-not-found") &&
                ((gn = !1),
                nn &&
                  (Ut.isAvailable() || Yt.isAvailable()) &&
                  ((nn = !1), nt(!1, yn))),
              St.browser.isMobile() &&
                wt.get("zoomButton") &&
                !Xe() &&
                Wt.handleZoomButton(i.li, i.index, null),
              h(o, function () {
                function e(e) {
                  try {
                    e();
                  } catch (t) {}
                }
                e(m),
                  wt.get("ARQuickLook") && !fn && _(),
                  Qt
                    ? (Mt.remove(Qt), jt.classList.add("opacity-one"))
                    : (jt.classList.add("opacity-one"), (tn = !0)),
                  i &&
                    i.li &&
                    (i.li.classList.contains("cylindo-video")
                      ? (nt(!0, An), Wt.hideTooltip(!0))
                      : nt(!1, An)),
                  (n = Ke(i.index, i.li)),
                  n && We(n.FRAME);
              });
          }
          function j() {
            var e = Ze() ? 500 : 0,
              t = zt ? zt.querySelector(".cylindo-viewer-container") : null;
            t &&
              (t.addEventListener("touchstart", a),
              t.addEventListener("touchend", l),
              (jt = zt ? zt.querySelector(".cylindo-threesixty-list") : null),
              h(e, function () {
                Qt ? Mt.remove(Qt) : (tn = !0),
                  jt.classList.add("opacity-one"),
                  Dt.initialized && Dt.setViewerList(jt),
                  Wt &&
                    Wt.initialized &&
                    (Ze()
                      ? (Wt.off(Wt.events.CLICKED, z),
                        Wt.on(Wt.events.CLICKED, z))
                      : (Wt.off(Wt.events.CLICKED, L),
                        Wt.on(Wt.events.CLICKED, L))),
                  Ct && Ct.initialized && Ct.render(),
                  ge(),
                  st();
              }));
          }
          function K() {
            yt.trigger(yt.events.IMG_LOADED);
          }
          function Q() {
            Dt.initialized && !Dt.disabled && Dt.disable(),
              on && zt && Mt.scrollTo(zt),
              null !== Ln && Ln.hide && Ln.hide(!0);
          }
          function J() {
            fn && fn.tryToShow();
          }
          function $(e, t) {
            Ct && Ct.initialized && Ct.setActive(t.current);
          }
          function ee(e, t) {
            yt.trigger(yt.events.FIRST_FRAME_COMPLETE, t);
          }
          function te(e, t) {
            yt.trigger(yt.events.DOWNLOAD_COMPLETE, t);
          }
          function ne(e, t) {
            yt.trigger(yt.events.FEATURES_CANCELED, t);
          }
          function ie(e, t) {
            re(e, t);
          }
          function oe(e, t) {
            var n = jt ? jt.querySelector("li.active") : null,
              i = t && t.index ? t.index : null;
            Ze() ||
              (n &&
              n.classList &&
              n.classList.contains("hidden") &&
              (Ye() || It.isAltId(i))
                ? u(0, null)
                : h(0, null));
          }
          function re(e, t) {
            var n,
              i = jt ? jt.querySelector("li.active") : null,
              o = t && t.secuence ? t.secuence : "";
            i &&
              t &&
              t.secuence &&
              ((n = i.dataset ? i.dataset.index : i.getAttribute("data-index")),
              (n = "" + n),
              (o = "" + o),
              n === o &&
                (Wt &&
                  Wt.initialized &&
                  (Wt.handleTooltip(i, n, n),
                  Wt.handleZoomButton(i, n, n),
                  Wt.handleActionBtns(i, index, isCustomImage)),
                h(0, null)));
          }
          function se() {
            var e = {
              model: wt,
              el: Et,
              url: en ? en.paths : null,
              tags: Lt,
              dom: Mt,
              framesHandler: It,
              ariaLabel: At,
            };
            Ct.initialized ||
              ((Ct = Ct.create(e)),
              Ct.on(Ct.events.CLICK, le),
              Ct.on(Ct.events.READY, ae),
              Ct.on(Ct.events.CONTENT_TYPE_COMPLETE, Z),
              zt.classList.add("has-thumbs"));
          }
          function ae() {
            var e,
              t = Jt ? Jt.getBoundingClientRect() : null;
            Et &&
              t &&
              tt() &&
              ((e = Et.parentElement || null),
              e &&
                (e.classList && e.classList.contains("has-scroll")
                  ? (Et.style.height = t.height - 60 + "px")
                  : (Et.style.height = t.height + "px"))),
              Ct &&
                Ct.isHidden &&
                (Dt && Dt.disabled === !1
                  ? Vt.log(
                      "Can not show thumbnails because zoom is currently enabled."
                    )
                  : Ct.show(!0)),
              m(),
              yt.trigger(yt.events.THUMBS_READY);
          }
          function le(e, t) {
            var n = !0;
            Wt &&
              Wt.initialized &&
              (ue(), Wt.customImageOn && Me(), Wt.goToIndex(t.index)),
              t.alternateIndex
                ? (yt.trigger(yt.events.ALT_THUMBS_CLICKED, {
                    index: t.alternateIndex,
                    contentType: t.contentType,
                  }),
                  ut(e, t, n))
                : yt.trigger(yt.events.THUMB_CLICKED, { index: t.index }),
              Wt.addMouseCallbacks(),
              Qe();
          }
          function de() {
            (dn.status = !0),
              setTimeout(
                function () {
                  dn.status = !1;
                }.bind(yt),
                300
              );
          }
          function ce(e, t) {
            e &&
              ("string" != typeof e ||
                (e !== Yt.events.CLICK && e !== Yt.events.TOUCHEND) ||
                (e = t),
              e.preventDefault(),
              e.stopPropagation(),
              de(),
              e.target &&
                e.target.classList.contains("cylindo-icon-zoom-on") &&
                (an = 3)),
              Dt.initialized &&
                (e && Xe() && Ut.isEnabled()
                  ? Dt.disabled
                    ? z(null, {
                        frame: null,
                        btnZoom: Yt.btn,
                        btnZoom2: Xt.btn,
                        withoutCoords: !0,
                      })
                    : Dt.disable()
                  : Dt.disabled
                  ? L()
                  : Dt.disable()),
              mn && !Ze() && Wt.removeMouseCallbacks();
          }
          function ue() {
            try {
              Dt.disabled || Dt.disable();
            } catch (e) {
              Vt.error("Can not disable zoom.", e);
            } finally {
              Wt.enabled || Wt.enable();
            }
          }
          function he(e, t) {
            null !== Ln && Ln.hide && Ln.hide(!0),
              Ut.processFullScreenEvent(),
              document[Ut.fullscreenElement] ? me() : pe();
          }
          function me() {
            yt.trigger(yt.events.ENTER_FULLSCREEN),
              Lt.send(Lt.events.FULLSCREEN),
              $e();
          }
          function pe() {
            function e() {
              t && Dt.off(Dt.events.DISABLED, e),
                H(!1),
                Ut.off(Ut.events.FULLSCREEN_CHANGED, he),
                Ut.cancelSubscriptionToFullScreenChangeEvt(),
                yt.trigger(yt.events.EXIT_FULLSCREEN),
                Ut.setStatus(!1),
                $e();
            }
            var t = !1;
            Dt.disabled ? e() : ((t = !0), Dt.on(Dt.events.DISABLED, e), ce());
          }
          function fe(e) {
            function t() {
              i && Dt.off(Dt.events.DISABLED, t),
                Xe() &&
                  e &&
                  e.target &&
                  (Ut.setBtn(e.target),
                  (n = Ut.btn.getAttribute("data-index"))),
                Ut.toggleFullScreen(),
                Ut.off(Ut.events.FULLSCREEN_CHANGED, he),
                Ut.on(Ut.events.FULLSCREEN_CHANGED, he),
                mn &&
                  (Ze() || Wt.removeMouseCallbacks(),
                  setTimeout(function () {
                    Dt && !Dt.disabled && Dt.disable();
                  }, 100)),
                Ut.setStatus(!Ut.isEnabled()),
                Xe() &&
                  (Ut.isEnabled() && H(Ut.isEnabled()),
                  n && n !== pn && Wt.goToIndex(n));
            }
            var n = null,
              i = !1;
            e && (e.preventDefault(), e.stopPropagation(), de()),
              Dt.disabled
                ? t()
                : ((i = !0), Dt.on(Dt.events.DISABLED, t), ce());
          }
          function ge() {
            nn ||
              (Mt.fadeIn($t),
              Ut.isAvailable() && (Ut.show(), Te()),
              Yt.isAvailable() && (Yt.show(), Ie()));
          }
          function ve() {
            Mt.fadeOut($t, 0), Le(), Re();
          }
          function Ee() {
            var e = St.browser.isMobile();
            (Yt = Bt.create({
              model: wt,
              viewerContainer: Jt,
              btn: it(".threesixty-button"),
              isMobile: e,
              ariaLabel: At,
            })),
              (Xt = Bt.create({
                model: wt,
                viewerContainer: Jt,
                btn: it(".threesixty-button-secondary"),
                isMobile: e,
                ariaLabel: At,
              }));
          }
          function ye(e, t) {
            "string" == typeof e &&
            "object" === ("undefined" == typeof t ? "undefined" : _typeof(t))
              ? ((e = t), e.preventDefault(), e.stopPropagation())
              : e && (e.preventDefault(), e.stopPropagation());
          }
          function Ae() {
            Ut = Ut.create({
              model: wt,
              viewerContainer: Jt,
              btn: it(".fullscreen-button"),
              ariaLabel: At,
            });
          }
          function Te(e) {
            (e = e || Ut.btn),
              e &&
                (be(e),
                e.addEventListener("click", fe),
                e.addEventListener("touchstart", ye),
                e.addEventListener("touchend", fe));
          }
          function Re(e) {
            (e = e || Ut.btn), e && be(e);
          }
          function be(e) {
            e &&
              (e.removeEventListener("click", fe),
              e.removeEventListener("touchstart", ye),
              e.removeEventListener("touchend", fe));
          }
          function Ie(e) {
            Yt &&
              (Yt.addEventsToBtn(e),
              we(),
              Yt.on(Yt.events.CLICK, ce),
              Yt.on(Yt.events.TOUCHSTART, ye),
              Yt.on(Yt.events.TOUCHEND, ce));
          }
          function Le() {
            Yt && (Yt.removeEventsToBtn(), we());
          }
          function we() {
            Yt.off(Yt.events.CLICK, ce),
              Yt.off(Yt.events.TOUCHSTART, ye),
              Yt.off(Yt.events.TOUCHEND, ce);
          }
          function Ce() {
            var e = zt ? zt.querySelector(".cylindo-viewer-container") : null;
            e &&
              (e.removeEventListener("touchstart", a),
              e.removeEventListener("touchend", l)),
              ve(),
              xt.destroy(),
              Wt && Wt.initialized && Wt.destroy(),
              Ct && Ct.initialized && Ct.destroy(),
              Ut && Ut.initialized && Ut.destroy(),
              fn && fn.initialized && fn.destroy(),
              Yt && Yt.initialized && Yt.destroy(),
              Xt && Xt.initialized && Xt.destroy(),
              Dt && Dt.initialized && Dt.destroy(),
              Ln && Ln.initialized && Ln.destroy(),
              (Wt = null),
              (Ct = null),
              zt && (zt.innerHTML = ""),
              (Kt = null),
              (Qt = null),
              (e = null),
              (jt = null),
              (zt = null),
              window.removeEventListener("resize", m);
          }
          function _e(e, t) {
            var n = wt.get("tooltipAltImgText");
            if (!e)
              throw new Error(
                "There must be a URL specified for the custom image."
              );
            if (!(Wt && Wt.initialized && Zt))
              throw new Error("Viewer is not initialized or ready");
            "string" == typeof n && n.length > 0
              ? Wt.showTooltip(wt.get("tooltipAltImgText"))
              : Wt.hideTooltip(),
              t &&
              "string" == typeof t &&
              t.length > 0 &&
              wt.get("alternateContentZoom") === !0
                ? (mn = !0)
                : ((mn = !1), (t = null)),
              ue(),
              (hn = Wt.showImage.call(Wt, e, t)),
              (!Xe() || (Xe() && Ut && Ut.initialized && Ut.isEnabled())) &&
                u(0),
              Ne(),
              Ze() || Wt.removeMouseCallbacks();
          }
          function Ne() {
            var e = hn ? hn : Jt;
            e.addEventListener("mousedown", Oe),
              e.addEventListener("mouseup", Se),
              e !== Jt &&
                (e.addEventListener("touchstart", a),
                e.addEventListener("touchend", l));
          }
          function De() {
            var e = hn ? hn : Jt;
            e.removeEventListener("mousedown", Oe),
              e.removeEventListener("mouseup", Se),
              e !== Jt &&
                (e.removeEventListener("touchstart", a),
                e.removeEventListener("touchend", l));
          }
          function Oe(e) {
            e && (e.preventDefault(), e.stopPropagation()),
              (un.x = e.clientX),
              (un.y = e.clientY);
          }
          function Se(e) {
            var t, n, i, o, r, s;
            e && (e.preventDefault(), e.stopPropagation(), (s = e.target)),
              (e &&
                e.target &&
                e.target.classList.contains("fullscreen-button")) ||
                Math.abs(e.clientX - un.x) > 10 ||
                Math.abs(e.clientY - un.y) > 10 ||
                ((n = { currentX: un.x, currentY: un.y }),
                Dt && Dt.initialized && mn && De(),
                Xe()
                  ? ((i =
                      "IMG" === s.tagName
                        ? s.parentElement
                        : "LI" === s.tagName
                        ? s
                        : null),
                    (o = i
                      ? i.querySelector(
                          ".cylindo-action-button-group .threesixty-button"
                        )
                      : null),
                    (r = i
                      ? i.querySelector(
                          ".cylindo-action-button-group .threesixty-button-secondary"
                        )
                      : null),
                    (t = { frame: i, btnZoom: o, btnZoom2: r }),
                    Ze() && St.object.extend(n, t),
                    z(Wt.events.CUSTOM_IMG_CLICKED, n))
                  : L(Wt.events.CUSTOM_IMG_CLICKED, n));
          }
          function Me() {
            Wt &&
              Wt.initialized &&
              (ue(),
              De(),
              (mn = !1),
              Ze() || Wt.addMouseCallbacks(),
              h(0),
              Wt.hideImage());
          }
          function xe() {
            return (ln = !ln);
          }
          function Fe() {
            return ln;
          }
          function Pe() {
            return Dt.isPanning;
          }
          function ke() {
            var e = jt.getBoundingClientRect(),
              t = e.width,
              n = e.height;
            return (t = Math.round(t)), (n = Math.round(n)), Math.max(n, t);
          }
          function Ue() {
            return Wt ? Wt.getCurrentThreesixtyIndex() : 1;
          }
          function Be() {
            return !(!Dt || Dt.disabled) && (Dt.disable(), !0);
          }
          function Ge(e, t) {
            "number" != typeof e ||
            ("number" != typeof t && "undefined" != typeof t)
              ? Vt.warning(
                  "You must pass the degrees and milliseconds value as an integer to rotate the viewer.",
                  angle,
                  t
                )
              : Wt && Wt.initialized && "function" == typeof Wt.autoRotate
              ? Wt.autoRotate(e, t)
              : Vt.warning(
                  "Viewer instance is not initialized or it may not support autoRotate function"
                );
          }
          function He(e) {
            "number" == typeof e
              ? Wt && Wt.initialized && "function" == typeof Wt.goToAngle
                ? Wt.goToAngle(e)
                : Vt.warning(
                    "Viewer instance is not initialized or it may not support goToAngle function"
                  )
              : Vt.warning(
                  "You must pass the angle value as an integer to rotate the viewer.",
                  e
                );
          }
          function ze() {
            var e = !1;
            Wt && Wt.initialized && "function" == typeof Wt.autoSlideCarousel
              ? Wt.autoSlideCarousel(e)
              : Vt.warning(
                  "Viewer instance is not initialized or it may not support previousSlide function"
                );
          }
          function Ve() {
            var e = !0;
            Wt && Wt.initialized && "function" == typeof Wt.autoSlideCarousel
              ? Wt.autoSlideCarousel(e)
              : Vt.warning(
                  "Viewer instance is not initialized or it may not support nextSlide function"
                );
          }
          function qe(e, t, n) {
            function i() {
              s && Dt.off(Dt.events.DISABLED, i),
                Yt.btn !== l && Yt.setBtn(l),
                Xt.btn !== d && Xt.setBtn(d),
                Ze()
                  ? r
                    ? (b(), Dt.autoZoom(e, t, Ut.isEnabled(), r))
                    : Vt.error(
                        "Zoom function needs a valid index parameter to open zoom for this type of viewer."
                      )
                  : (b(), Dt.autoZoom(e, t, Ut.isEnabled())),
                C(a);
            }
            function o() {
              Dt.moveAutoZoom(e, t);
            }
            var r =
                Ze() && n
                  ? jt.querySelector("li.cylindo-viewer-frame-" + n)
                  : null,
              s = !1,
              a = r ? { frame: r } : null,
              l = r
                ? r.querySelector(
                    ".cylindo-action-button-group .threesixty-button"
                  )
                : it(".threesixty-button"),
              d = r
                ? r.querySelector(
                    ".cylindo-action-button-group .threesixty-button-secondary"
                  )
                : it(".threesixty-button-secondary");
            Dt &&
              Dt.initialized &&
              (Dt.disabled
                ? i()
                : n && String(n) !== String(Dt.getFrameIndex())
                ? ((s = !0), Dt.on(Dt.events.DISABLED, i), Dt.disable())
                : o());
          }
          function Ye() {
            return ft && ft.presentation === Ft.CAROUSEL.NAME;
          }
          function Xe() {
            return ft && ft.presentation === Ft.STACKED.NAME;
          }
          function Ze() {
            return Xe() && !Ut.isEnabled();
          }
          function We(e) {
            e && e !== yt.currentState
              ? (Vt.log("State changed from: " + yt.currentState + " to: " + e),
                (yt.currentState = e))
              : e || Vt.error("State cannot be modified.");
          }
          function je() {
            return yt.currentState;
          }
          function Ke(e, t) {
            var n;
            return (
              (t || e) &&
                (t &&
                t.classList &&
                (t.classList.contains("cylindo-img-not-found") ||
                  t.classList.contains("cylindo-video-not-found"))
                  ? (n = Ht.FALLBACK)
                  : t && t.classList.contains(pn)
                  ? (n = Ht.CUSTOM)
                  : e &&
                    (It.is360Frame(e)
                      ? (n = Ht.FRAME)
                      : It.isAltId(e) && (n = Ht.ALT_CONT))),
              n
            );
          }
          function Qe() {
            var e, t;
            (e = et()), (t = Ke(e.index, e.li)), t && We(t.FRAME);
          }
          function Je(e, t, n) {
            var i,
              o = Ke(e, t);
            o &&
              (i = n
                ? Ut.isEnabled()
                  ? o.ZOOM_FULLSCREEN
                  : o.ZOOM
                : Ut.isEnabled()
                ? o.FULLSCREEN
                : o.FRAME),
              We(i);
          }
          function $e() {
            var e,
              t = et(),
              n = Ke(t.index, t.li);
            n && (e = Ut.isEnabled() ? n.FULLSCREEN : n.FRAME), We(e);
          }
          function et() {
            var e,
              t = jt ? jt.querySelector("li.active") : null,
              n = t ? t : null;
            return (
              n &&
                (e = n.dataset
                  ? n.dataset.index
                  : n.getAttribute("data-index")),
              { li: n, index: e }
            );
          }
          function tt() {
            return En === vn.LEFT || En === vn.RIGHT;
          }
          function nt(e, t) {
            $t &&
              $t.classList &&
              (e ? $t.classList.add(t) : $t.classList.remove(t));
          }
          function it(e) {
            return $t ? $t.querySelector(e) : null;
          }
          function ot(e) {
            yt.trigger(yt.events.FEATURES_ERROR, {
              features: e instanceof Array ? e : null,
            });
          }
          function rt() {
            var e = wt ? wt.get("features") : [];
            yt.trigger(yt.events.FEATURES_ERROR, { features: e });
          }
          function st() {
            Vt.event(ft.presentation.toUpperCase() + " viewer ready"),
              (Zt = !0),
              yt.trigger(yt.events.VIEWER_READY);
          }
          function at() {
            lt() ||
              (Rn && dt(),
              window.addEventListener
                ? (window.addEventListener("scroll", lt, !1),
                  window.addEventListener("resize", lt, !1),
                  (Rn = !0))
                : window.attachEvent &&
                  (window.attachEvent("onscroll", lt),
                  window.attachEvent("onresize", lt),
                  (Rn = !0)));
          }
          function lt() {
            if (!(bn && Date.now() - bn < 250))
              return (
                (bn = Date.now()),
                !(Tn || !ct()) &&
                  ((Tn = !0), Lt.send(Lt.events.SEEN), Rn && dt(), !0)
              );
          }
          function dt() {
            window.removeEventListener
              ? (window.removeEventListener("scroll", lt, !1),
                window.removeEventListener("resize", lt, !1),
                (Rn = !1))
              : window.attachEvent &&
                (window.detachEvent("onscroll", lt),
                window.detachEvent("onresize", lt),
                (Rn = !1));
          }
          function ct() {
            var e,
              t,
              n,
              i,
              o = Jt && Jt.getBoundingClientRect();
            return (
              !!o &&
              ((e =
                window.innerHeight || document.documentElement.clientHeight),
              (t = window.innerWidth || document.documentElement.clientWidth),
              (n = o.top <= e && o.top + o.height >= 0),
              (i = o.left <= t && o.left + o.width >= 0),
              n && i)
            );
          }
          function ut(e, t, n) {
            var i,
              o,
              r,
              s = /(cylindev.com|cylindo.com)/gi,
              a = t && t.image ? Gt.resolveProtocol(t.image) : "",
              l = (a && s.test(a)) || !1,
              d = l ? new URL(a) : null,
              c = d && d.pathname ? d.pathname.split("/") : null,
              u = "",
              h = "",
              m = "",
              p = [],
              f = [],
              g = n ? Lt.events.ALT_IMAGE_VIEWED : Lt.events.ALT_IMAGE_LOADED;
            for (
              c &&
                c.length > 0 &&
                ((u = c[5]),
                (h = c[7]),
                (m = c[8]),
                (p = d.searchParams.getAll("feature")),
                (r = d.searchParams.get("version"))),
                i = 0;
              i < p.length;
              i++
            )
              (o = p[i].split(":")),
                2 === o.length &&
                  (f.push(p[i].split(":")[0]), f.push(p[i].split(":")[1]));
            Lt.send(g, {
              image: a || "",
              isCylindoImage: l,
              frameNumber: h,
              productCode: u,
              imageName: m,
              features: f,
              version: r,
            });
          }
          var ht,
            mt,
            pt,
            ft,
            gt,
            vt,
            Et,
            yt = this,
            At = cylindo.getModule("cylindo.aria.label").create({ model: e }),
            Tt = [
              '<div class="cylindo-viewer-container">',
              '<ul style="display: none;"></ul>',
              '<div class="cylindo-action-button-group right" style="display: none;" aria-label="' +
                At.texts.ACTION_BUTTONS_GROUP +
                '" role="group">',
              '<a style="display: none" href="javascript:void(0)" class="fullscreen-button cylindo-action-button-icon cylindo-icon-fullscreen-off" aria-label="' +
                At.texts.ENTER_FULLSCREEN +
                '" role="link"></a>',
              '<a style="display: none" href="javascript:void(0)" class="threesixty-button cylindo-action-button-icon cylindo-icon-zoom-off" aria-label="' +
                At.texts.ENTER_ZOOM +
                '" role="link"></a>',
              '<a style="display: none" href="javascript:void(0)" class="threesixty-button-secondary cylindo-action-button-icon cylindo-icon-zoom-off" aria-label="' +
                At.texts.EXIT_ZOOM +
                '" role="link"></a>',
              "</div>",
              '<div class="cylindo-loader" role="progresbar"></div>',
              "</div>",
            ],
            Rt = ['<div class="cylindo-loading-bar" role="progressbar"></div>'],
            bt = [
              '<div class="cylindo-thumbnail-wrapper" style="display: none;">',
              '<div class="cylindo-thumbnail-slider left"><a href="javascript:void(0)" class="glyphicon glyphicon-menu-left prev" aria-label="' +
                At.texts.THUMBS_LEFT +
                '" role="link"></a></div>',
              '<div class="cylindo-thumbnail-bar" role="presentation"></div>',
              '<div class="cylindo-thumbnail-slider right"><a href="javascript:void(0)" class="glyphicon glyphicon-menu-right next" aria-label="' +
                At.texts.THUMBS_RIGHT +
                '" role="link"></a></div>',
              "</div>",
            ],
            It = i,
            Lt = t,
            wt = e,
            Ct = cylindo.getModule("thumbnails"),
            _t = cylindo.getModule("cylindo.core.config"),
            Nt = cylindo.getModule("cylindo.classes.viewer.factory"),
            Dt = cylindo.getModule("zoom"),
            Ot = cylindo.getModule("loadingBar"),
            St = cylindo.getModule("cylindo.core.util"),
            Mt = cylindo.getModule("cylindo.dom").create(),
            xt = cylindo.getModule("cylindo.util.pubsub").create(),
            Ft = cylindo.getModule("cylindo.helpers.viewer.presentations"),
            Pt = cylindo.getModule("cylindo.helpers.content.to.load"),
            kt = cylindo.getModule("cylindo.helpers.viewer.states"),
            Ut = cylindo.getModule("cylindo.fullscreen.btn"),
            Bt = cylindo.getModule("cylindo.zoom.btn"),
            Gt = cylindo.getModule("cylindo.core.network"),
            Ht = kt.getInitialStates(),
            zt = null,
            Vt = wt.getLogger(),
            qt = null,
            Yt = null,
            Xt = null,
            Zt = !1,
            Wt = null,
            jt = null,
            Kt = null,
            Qt = null,
            Jt = null,
            $t = null,
            en = null,
            tn = !1,
            nn = !1,
            on = !1,
            rn = wt.get("customZoomContainer"),
            sn = "string" == typeof rn && null !== document.getElementById(rn),
            an = null,
            ln = !1,
            dn = { status: !1 },
            cn = !1,
            un = {},
            hn = null,
            mn = !1,
            pn = "cylindo-custom-image",
            fn = null,
            gn = !1,
            vn = wt.getThumbLocations(),
            En = wt.get("thumbLocation"),
            yn = "permanently-hidden",
            An = "temporarily-hidden",
            Tn = !1,
            Rn = !1,
            bn = 0,
            In = cylindo.getModule("cylindo.helpers.ar.modes"),
            Ln = null;
          (this.id = null),
            (this.initialized = !1),
            (this.currentState = null),
            (this.render = p),
            (this.destroy = Ce),
            (this.showImage = _e),
            (this.hideImage = Me),
            (this.on = xt.on),
            (this.off = xt.off),
            (this.trigger = xt.trigger),
            (this.isRotating = Fe),
            (this.isPanning = Pe),
            (this.getThreesixtyMaxSize = ke),
            (this.getCurrentThreesixtyIndex = Ue),
            (this.exitZoom = Be),
            (this.rotate = Ge),
            (this.goToAngle = He),
            (this.previousSlide = ze),
            (this.nextSlide = Ve),
            (this.getState = je),
            (this.zoom = qe),
            (this.getArQuickLookUrl = N),
            We(Ht.GENERIC.UINITIALIZED),
            o(),
            (this.printGrid = function () {
              Dt.initialized && Dt.printGrid();
            });
        };
        (e.counter = 0),
          (e.prototype.events = {
            READY: "view:ready",
            ZOOM: "view:zoom",
            ZOOM_ENTER: "view:zoom:enter",
            ZOOM_EXIT: "view:zoom:exit",
            VIEWER_READY: "view:threesixty:ready",
            DOWNLOAD_COMPLETE: "view:download:complete",
            THUMBS_READY: "view:thumbs:ready",
            THUMB_CLICKED: "view:thumbs:clicked",
            ALT_THUMBS_CLICKED: "view:alt:thumbs:clicked",
            FIRST_FRAME_COMPLETE: "view:firstframe:complete",
            IMG_LOADED: "view:image:loaded",
            ENTER_FULLSCREEN: "view:fullscreen:enter",
            EXIT_FULLSCREEN: "view:fullscreen:exit",
            START_SPIN: "view:spin:start",
            END_SPIN: "view:spin:end",
            PREV: "view:prev",
            NEXT: "view:next",
            FEATURES_CANCELED: "view:features:canceled",
            FEATURES_ERROR: "view:features:error",
            AR_BUTTON_READY: "view:ar:button:ready",
            AR_BUTTON_ERROR: "view:ar:button:error",
          });
        var t = {
          create: function (t, n, i) {
            return new e(t, n, i);
          },
        };
        window.cylindo.addModule("view", t);
      }.call(this));
  }
  if ("undefined" != typeof window.cylindo)
    try {
      console.warn
        ? console.warn(
            "Cylindo.Logger/warning : The variable 'window.cylindo' is already defined in this scope, please do not use that variable name."
          )
        : console.log(
            "Cylindo.Logger/log: The variable 'window.cylindo' is already defined in this scope, please do not use that variable name."
          );
    } catch (t) {}
  (window.cylindo = function () {
    var e = {},
      t = [],
      n = !1,
      i = function () {};
    return (
      (i.prototype.addModule = function (t, n, o) {
        (e[t] = n), o && (i.prototype[t] = n);
      }),
      (i.prototype.getModule = function (t) {
        return e[t] || null;
      }),
      (i.prototype.updateModule = function (e, t, n) {
        this.addModule.apply(this, arguments);
      }),
      (i.prototype.on = function (e, i) {
        return n ? void i.apply() : void ("ready" === e && t.push(i));
      }),
      (i.prototype.trigger = function (e) {
        if ("ready" === e) {
          for (var i = 0; i < t.length; i += 1)
            t[i] && (t[i].apply(), (t[i] = null));
          n = !0;
        }
      }),
      new i()
    );
  }.call(this)),
    e(),
    cylindo.trigger("ready");
}.call(void 0));
//# sourceMappingURL=viewer.min.js.map
